/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 108);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(31)('wks');
var uid = __webpack_require__(22);
var Symbol = __webpack_require__(1).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(68), __esModule: true };

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var core = __webpack_require__(0);
var ctx = __webpack_require__(14);
var hide = __webpack_require__(9);
var has = __webpack_require__(10);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(12)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(42);
var toPrimitive = __webpack_require__(27);
var dP = Object.defineProperty;

exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(8);
var createDesc = __webpack_require__(18);
module.exports = __webpack_require__(6) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(47);
var defined = __webpack_require__(29);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(21);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(46);
var enumBugKeys = __webpack_require__(32);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(29);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(8).f;
var has = __webpack_require__(10);
var TAG = __webpack_require__(2)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(96), __esModule: true };

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(75)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(44)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var document = __webpack_require__(1).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(5);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(31)('keys');
var uid = __webpack_require__(22);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(0);
var global = __webpack_require__(1);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(15) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79);
var global = __webpack_require__(1);
var hide = __webpack_require__(9);
var Iterators = __webpack_require__(13);
var TO_STRING_TAG = __webpack_require__(2)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(21);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(2);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var core = __webpack_require__(0);
var LIBRARY = __webpack_require__(15);
var wksExt = __webpack_require__(36);
var defineProperty = __webpack_require__(8).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(7);
var dPs = __webpack_require__(57);
var enumBugKeys = __webpack_require__(32);
var IE_PROTO = __webpack_require__(30)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(26)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(48).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(28);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(17);
var TAG = __webpack_require__(2)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(6) && !__webpack_require__(12)(function () {
  return Object.defineProperty(__webpack_require__(26)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 43 */
/***/ (function(module, exports) {



/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(15);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(45);
var hide = __webpack_require__(9);
var Iterators = __webpack_require__(13);
var $iterCreate = __webpack_require__(76);
var setToStringTag = __webpack_require__(23);
var getPrototypeOf = __webpack_require__(58);
var ITERATOR = __webpack_require__(2)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(9);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(10);
var toIObject = __webpack_require__(11);
var arrayIndexOf = __webpack_require__(77)(false);
var IE_PROTO = __webpack_require__(30)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(17);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(1).document;
module.exports = document && document.documentElement;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(41);
var ITERATOR = __webpack_require__(2)('iterator');
var Iterators = __webpack_require__(13);
module.exports = __webpack_require__(0).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(7);
var aFunction = __webpack_require__(21);
var SPECIES = __webpack_require__(2)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(14);
var invoke = __webpack_require__(85);
var html = __webpack_require__(48);
var cel = __webpack_require__(26);
var global = __webpack_require__(1);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(17)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var isObject = __webpack_require__(5);
var newPromiseCapability = __webpack_require__(34);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(22)('meta');
var isObject = __webpack_require__(5);
var has = __webpack_require__(10);
var setDesc = __webpack_require__(8).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(12)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(46);
var hiddenKeys = __webpack_require__(32).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(20);
var createDesc = __webpack_require__(18);
var toIObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(27);
var has = __webpack_require__(10);
var IE8_DOM_DEFINE = __webpack_require__(42);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(8);
var anObject = __webpack_require__(7);
var getKeys = __webpack_require__(16);

module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(10);
var toObject = __webpack_require__(19);
var IE_PROTO = __webpack_require__(30)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(7);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(13);
var ITERATOR = __webpack_require__(2)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(2)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(63);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(64);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(102), __esModule: true };

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(103), __esModule: true };

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(1);
var has = __webpack_require__(10);
var DESCRIPTORS = __webpack_require__(6);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(45);
var META = __webpack_require__(54).KEY;
var $fails = __webpack_require__(12);
var shared = __webpack_require__(31);
var setToStringTag = __webpack_require__(23);
var uid = __webpack_require__(22);
var wks = __webpack_require__(2);
var wksExt = __webpack_require__(36);
var wksDefine = __webpack_require__(37);
var enumKeys = __webpack_require__(104);
var isArray = __webpack_require__(105);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(5);
var toObject = __webpack_require__(19);
var toIObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(27);
var createDesc = __webpack_require__(18);
var _create = __webpack_require__(39);
var gOPNExt = __webpack_require__(66);
var $GOPD = __webpack_require__(56);
var $GOPS = __webpack_require__(35);
var $DP = __webpack_require__(8);
var $keys = __webpack_require__(16);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(55).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(20).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(15)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(9)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(11);
var gOPN = __webpack_require__(55).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global $ */
/* global _ */
/* global moment */
/* global angular */
(function (module) {
  "use strict";

  module.config(["$compileProvider", "$stateProvider", "$urlRouterProvider", "$qProvider", "toastrConfig", "ngIntlTelInputProvider", function ($compileProvider, $stateProvider, $urlRouterProvider, $qProvider, toastrConfig, ngIntlTelInputProvider) {
    $compileProvider.preAssignBindingsEnabled(true);
    angular.extend(toastrConfig, {
      autoDismiss: false,
      containerId: "toast-container",
      maxOpened: 0,
      newestOnTop: true,
      positionClass: "toast-top-left",
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: "body"
    });

    $qProvider.errorOnUnhandledRejections(false);

    $urlRouterProvider.otherwise("/");

    $stateProvider.state("closepage", {
      url: "/close",
      templateUrl: "closepage.html"
    }).state("login", {
      url: "/login",
      templateUrl: "login.html"
    }).state("signup", {
      url: "/signup",
      templateUrl: "signup.html"
    }).state("activate", {
      url: "/activate/{guid}",
      templateUrl: "activate.html"
    }).state("resetpassword", {
      url: "/resetpassword/{guid}",
      templateUrl: "activate.html"
    }).state("forgot", {
      url: "/forgot",
      templateUrl: "forgot.html"
    }).state("logout", {
      url: "/logout",
      controller: "LogoutCtrl"
    }).state("app", {
      url: "/",
      views: {
        "@": {
          templateUrl: "layout.html",
          controller: "IndexCtrl"
        },
        "topBar@app": {
          templateUrl: "/templates/partials/topBar.html"
        },
        "sideBar@app": {
          templateUrl: "/templates/partials/sideBar.html"
        },
        "chatForm@app": {
          templateUrl: "/templates/partials/chatForm.html"
        },
        "breadCrumb@app": {
          templateUrl: "/templates/partials/breadCrumb.html"
        },
        "content@app": {
          templateUrl: "/templates/partials/tripsDashboard.html",
          controller: "tripsDashBoardController"
        },
        "footer@app": {
          templateUrl: "/templates/partials/footer.html"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelManager", "TravelAgencyAdmin", "TravelAgent"],
      data: {
        pageTitle: "Home"
      }
    }).state("app.dashboard", {
      url: "dashboard",
      views: {
        "content@app": {
          templateUrl: "/templates/partials/tripsDashboard.html",
          controller: "tripsDashBoardController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelManager", "TravelAgencyAdmin", "TravelAgent"],
      data: {
        pageTitle: "Trips Dashboard"
      }
    }).state("app.viewTripDetails", {
      url: "viewTripDetails",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/viewTripDetails.html",
          controller: "TripsDashBoardController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelManager"],
      data: {
        pageTitle: "Booking Details"
      }
    }).state("app.travelSpend", {
      url: "travelSpend",
      views: {
        "content@app": {
          templateUrl: "templates/partials/travelSpend.html",
          controller: "travelSpendController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelManager", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Travel Spend"
      }
    }).state("app.travelerTrack", {
      url: "travelerTrack",
      views: {
        "content@app": {
          templateUrl: "templates/partials/travelerTrack.html",
          controller: "travelerTrackController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelManager", "TravelAgencyAdmin", "TravelAgent"],
      data: {
        pageTitle: "Traveler Track"
      }
    }).state("app.clientManagement", {
      url: "clients",
      views: {
        "content@app": {
          templateUrl: "templates/partials/clientManagement.html",
          controller: "clientManagementController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelAgent", "TravelManager"],
      data: {
        pageTitle: "Clients"
      }
    }).state("app.agencyManagement", {
      url: "agencyManagement",
      views: {
        "content@app": {
          templateUrl: "templates/partials/agencyManagement.html",
          controller: "agencyManagementController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Agency Management"
      }
    }).state("app.addAgency", {
      url: "agency/add",
      views: {
        "content@app": {
          templateUrl: "templates/partials/addAgency.html",
          controller: "agencyManagementController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Add Agency"
      }
    }).state("app.editAgency", {
      url: "agency/edit",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/addAgency.html",
          controller: "agencyManagementController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Edit Agency"
      }
    }).state("app.agents", {
      url: "agents",
      views: {
        "content@app": {
          templateUrl: "templates/partials/agents.html",
          controller: "membersController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Agents"
      }
    }).state("app.addAgent", {
      url: "agent/add",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/addAgent.html",
          controller: "membersController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Add Agent"
      }
    }).state("app.editAgent", {
      url: "agent/edit",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/editAgent.html",
          controller: "membersController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Edit Agent"
      }
    }).state("app.gdsSettings", {
      url: "gdsSettings",
      views: {
        "content@app": {
          templateUrl: "templates/partials/gdsSettings.html",
          controller: "gdsSettingsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Gds Settings"
      }
    }).state("app.addGdsSetting", {
      url: "gdsSetting/add",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/addGdsSetting.html",
          controller: "gdsSettingsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Add Gds Setting"
      }
    }).state("app.editGdsSetting", {
      url: "gdsSetting/edit",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/editGdsSetting.html",
          controller: "gdsSettingsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Edit Gds Setting"
      }
    }).state("app.changePassword", {
      url: "changepassword",
      views: {
        "content@app": {
          templateUrl: "templates/partials/changepassword.html",
          controller: "passwordController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelManager", "TravelAgencyAdmin", "TravelAgent"],
      data: {
        pageTitle: "Change Your Password"
      }
    }).state("app.sms-notif", {
      url: "live",
      views: {
        "content@app": {
          templateUrl: "templates/partials/smsNotification.html"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["TravelAgencyAdmin", "TravelAgent"],
      data: {
        pageTitle: "Live"
      },
      params: {
        status: null
      }
    })
    /*.state('app.phone-notif', {
      url: 'phonenotif',
      views: {
        'content@app': {
          templateUrl: 'templates/partials/phoneNotification.html',
          controller: 'SmsNotificationController'
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ['TravelAgencyAdmin', 'TravelAgent'],
      data: {
        pageTitle: 'Phone Notifications'
      }
    })*/
    .state("app.sms", {
      url: "sms",
      views: {
        "content@app": {
          templateUrl: "templates/partials/sms.html"
        }
      },
      onEnter: ["alertService", function (alert) {
        console.log("onEnter app.sms");
      }],
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelAgent"],
      data: {
        pageTitle: "Sms"
      },
      params: {
        fromNumber: null,
        travelerFirstName: null,
        travelerLastName: null,
        travelerOrganizationName: null,
        organizationId: null,
        travelerId: null,
        topic: null,
        status: null,
        conversation: null,
        fromDatabase: null,
        channel: null
      }
    }).state("app.followup", {
      url: "followup",
      views: {
        "content@app": {
          templateUrl: "templates/partials/sms.html"
        }
      },
      onEnter: ["alertService", function (alert) {
        console.log("onEnter app.followup");
      }],
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelAgent"],
      data: {
        pageTitle: "On-Hold"
      },
      params: {
        fromNumber: null,
        travelerFirstName: null,
        travelerLastName: null,
        travelerOrganizationName: null,
        organizationId: null,
        travelerId: null,
        topic: null,
        status: null,
        conversation: null,
        fromDatabase: null,
        channel: null
      }
    }).state("app.smsHistory", {
      url: "smsHistory",
      views: {
        "content@app": {
          templateUrl: "templates/partials/smsHistory.html",
          controller: "smsHistoryController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelAgent"],
      data: {
        pageTitle: "SMS History"
      }
    })
    /*.state('app.phoneHistory', {
      url: 'phoneHistory',
      views: {
        'content@app': {
          templateUrl: 'templates/partials/phoneHistory.html',
          controller: 'phoneHistoryController'
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ['ObexAdmin', 'TravelAgencyAdmin', 'TravelAgent'],
      data: {
        pageTitle: 'Phone History'
      }
    })*/
    .state("app.phone", {
      url: "Phone",
      views: {
        "content@app": {
          templateUrl: "templates/partials/phone.html"
        }
      },
      onEnter: ["alertService", function (alert) {
        console.log("onEnter app.phone");
      }],

      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelAgent"],
      data: {
        pageTitle: "Phone"
      },
      params: {
        fromNumber: null,
        travelerFirstName: null,
        travelerLastName: null,
        travelerOrganizationName: null,
        travelerId: null,
        topic: null
      }
    }).state("app.addClient", {
      url: "client/add",
      views: {
        "content@app": {
          templateUrl: "templates/partials/addClient.html",
          controller: "clientManagementController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Add Client"
      }
    }).state("app.editClient", {
      url: "client/edit",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/addClient.html",
          controller: "clientManagementController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelManager"],
      data: {
        pageTitle: "Edit Client"
      }
    }).state("app.tripField", {
      url: "tripFields",
      views: {
        "content@app": {
          templateUrl: "templates/partials/tripFields.html",
          controller: "tripFieldsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["TravelAgencyAdmin", "TravelManager", "ObexAdmin", "TravelAgent"],
      data: {
        pageTitle: "Trip Fields"
      }
    }).state("app.addTripField", {
      url: "tripField/add",
      views: {
        "content@app": {
          templateUrl: "templates/partials/addTripField.html",
          controller: "tripFieldsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["TravelAgencyAdmin", "TravelManager", "ObexAdmin", "TravelAgent"],
      data: {
        pageTitle: "Add Trip Field"
      }
    }).state("app.editTripField", {
      url: "tripField/edit",
      params: {
        id: null,
        orgId: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/addTripField.html",
          controller: "tripFieldsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["TravelAgencyAdmin", "TravelManager", "ObexAdmin", "TravelAgent"],
      data: {
        pageTitle: "Edit Trip Field"
      }
    }).state("app.profileField", {
      url: "profileFields",
      views: {
        "content@app": {
          templateUrl: "templates/partials/profileFields.html",
          controller: "profileFieldsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelManager", "TravelAgencyAdmin", "TravelAgent"],
      data: {
        pageTitle: "Profile Fields"
      }
    }).state("app.addProfileField", {
      url: "profileFields/add",
      views: {
        "content@app": {
          templateUrl: "templates/partials/addProfileField.html",
          controller: "profileFieldsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelManager", "TravelAgencyAdmin", "TravelAgent"],
      data: {
        pageTitle: "Add Profile Field"
      }
    }).state("app.editProfileField", {
      url: "profileFields/edit",
      views: {
        "content@app": {
          templateUrl: "templates/partials/editProfileField.html",
          controller: "profileFieldsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelManager", "TravelAgencyAdmin", "TravelAgent"],
      data: {
        pageTitle: "Edit Profile Field"
      }
    }).state("app.customerAccountNumbers", {
      url: "customeraccountnumbers",
      views: {
        "content@app": {
          templateUrl: "templates/partials/customerAccountNumbers.html",
          controller: "customerAccountController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelManager", "TravelAgent"],
      data: {
        pageTitle: "Customer Account Numbers"
      }
    }).state("app.addCustomerAccoNum", {
      url: "addcustomeraccountnumbers",
      views: {
        "content@app": {
          templateUrl: "templates/partials/addCustomerAccoNum.html",
          controller: "customerAccountController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelManager", "TravelAgent"],
      data: {
        pageTitle: "Add Customer Account Number"
      }
    }).state("app.editCustomerAccoNum", {
      url: "editcustomeraccountnumbers",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/addCustomerAccoNum.html",
          controller: "customerAccountController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelManager", "TravelAgent"],
      data: {
        pageTitle: "Edit Customer Account Number"
      }
    }).state("app.clientSettings", {
      url: "client/clientsettings",
      views: {
        "content@app": {
          templateUrl: "templates/partials/clientSettings.html",
          controller: "clientSettingController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Client's My Agency"
      }
    }).state("app.singleSignOn", {
      url: "client/singleSignOn",
      views: {
        "content@app": {
          templateUrl: "templates/partials/singleSignOn.html",
          controller: "singleSignOnController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Single Sign On"
      }
    }).state("app.ssoOrganizations", {
      url: "client/ssoOrganizations",
      views: {
        "content@app": {
          templateUrl: "templates/partials/ssoOrganizations.html",
          controller: "ssoOrganizationsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "SSO Organization"
      }
    }).state("app.addSsoOrganization", {
      url: "addSsoOrganization",
      views: {
        "content@app": {
          templateUrl: "templates/partials/addSsoOrganization.html",
          controller: "ssoOrganizationsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Add SSO Organization"
      }
    }).state("app.editSsoOrganization", {
      url: "editSsoOrganization",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/addSsoOrganization.html",
          controller: "ssoOrganizationsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Edit SSO Organization"
      }
    }).state("app.travelers", {
      url: "traveler",
      views: {
        "content@app": {
          templateUrl: "templates/partials/traveler.html",
          controller: "travelerController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelManager", "TravelAgent"],
      data: {
        pageTitle: "Employees/Travelers"
      }
    }).state("app.addTraveler", {
      url: "addTraveler",
      views: {
        "content@app": {
          templateUrl: "templates/partials/addTraveler.html",
          controller: "travelerController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelManager", "TravelAgent"],
      data: {
        pageTitle: "Add Traveler"
      }
    }).state("app.uploadHrFile", {
      url: "uploadHrFile",
      views: {
        "content@app": {
          templateUrl: "templates/partials/uploadHrFile.html",
          controller: "travelerController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Upload HR File"
      }
    }).state("app.editTraveler", {
      url: "editTraveler",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/editTraveler.html",
          controller: "travelerController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelManager", "TravelAgent"],
      data: {
        pageTitle: "Edit Traveler"
      }
    }).state("app.processPnr", {
      url: "processPnr",
      views: {
        "content@app": {
          templateUrl: "templates/partials/processPnr.html",
          controller: "pnrController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Process PNR"
      }
    }).state("app.providers", {
      url: "admin/providers",
      views: {
        "content@app": {
          templateUrl: "templates/partials/provider.html",
          controller: "providerController",
          permissions: ["ObexAdmin"]
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Providers"
      }
    }).state("app.addProvider", {
      url: "admin/providers/add",
      views: {
        "content@app": {
          templateUrl: "templates/partials/addProvider.html",
          controller: "providerController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Add Provider"
      }
    }).state("app.editProvider", {
      url: "admin/providers/edit",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/addProvider.html",
          controller: "providerController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Edit Provider"
      }
    }).state("app.categories", {
      url: "admin/categories",
      views: {
        "content@app": {
          templateUrl: "templates/partials/categories.html",
          controller: "categoriesController",
          permissions: ["ObexAdmin"]
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Categories"
      }
    }).state("app.addCategory", {
      url: "admin/categories/add",
      views: {
        "content@app": {
          templateUrl: "templates/partials/addCategory.html",
          controller: "categoriesController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Add Category"
      }
    }).state("app.editCategory", {
      url: "admin/categories/edit",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/addCategory.html",
          controller: "categoriesController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Edit Category"
      }
    }).state("app.apps", {
      url: "admin/apps",
      views: {
        "content@app": {
          templateUrl: "templates/partials/apps.html",
          controller: "appsController",
          permissions: ["ObexAdmin"]
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Apps"
      }
    }).state("app.addApp", {
      url: "admin/apps/add",
      views: {
        "content@app": {
          templateUrl: "templates/partials/addApp.html",
          controller: "appsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Add App"
      }
    }).state("app.editApp", {
      url: "admin/apps/edit",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/addApp.html",
          controller: "appsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Edit App"
      }
    }).state("app.reports", {
      url: "reports",
      views: {
        "content@app": {
          templateUrl: "templates/partials/reports.html",
          controller: "reportController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelManager", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Reports"
      }
    }).state("app.myAgency", {
      url: "myAgency",
      views: {
        "content@app": {
          templateUrl: "templates/partials/myAgency.html",
          controller: "myAgencyController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["TravelManager"],
      data: {
        pageTitle: "My Agency"
      }
    }).state("app.agentAssignment", {
      url: "agentAssignments",
      views: {
        "content@app": {
          templateUrl: "templates/partials/agentAssignment.html",
          controller: "agentAssignmentController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Agent Assignments"
      }
    })
    /*.state('app.travelManagerAssignment', {
      url: 'travelManagerAssignments',
      views: {
        'content@app': {
          templateUrl: 'templates/partials/travelManagerAssignment.html',
          controller: 'travelManagerAssignmentController'
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ['ObexAdmin', 'TravelAgencyAdmin'],
      data: {
        pageTitle: 'Travel Manager Assignments'
      }
    })*/
    .state("app.agencySettings", {
      url: "agencySettings",
      views: {
        "content@app": {
          templateUrl: "templates/partials/agencySettings.html",
          controller: "agencySettingsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
      data: {
        pageTitle: "Agency Defaults"
      }
    }).state("app.hrFeed", {
      url: "hrFeed",
      views: {
        "content@app": {
          templateUrl: "templates/partials/hrFeed.html"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelManager", "TravelAgent"],
      data: {
        pageTitle: "HR Feed"
      }
    }).state("app.organizationProviders", {
      url: "organizationProviders",
      views: {
        "content@app": {
          templateUrl: "templates/partials/organizationProviders.html",
          controller: "organizationProvidersController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelManager"],
      data: {
        pageTitle: "My Providers"
      }
    }).state("app.allowIntegrations", {
      url: "allowIntegrations",
      views: {
        "content@app": {
          templateUrl: "templates/partials/allowIntegrations.html",
          controller: "allowIntegrationsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin", "TravelAgent", "TravelManager"],
      data: {
        pageTitle: "Allow Integration"
      }
    }).state("app.addAllowIntegration", {
      url: "allowIntegrations/add",
      views: {
        "content@app": {
          templateUrl: "templates/partials/addAllowIntegration.html",
          controller: "allowIntegrationsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["ObexAdmin"],
      data: {
        pageTitle: "Add Allow Integration"
      }
    }).state("app.editAllowIntegration", {
      url: "allowIntegrations/edit",
      params: {
        id: null
      },
      views: {
        "content@app": {
          templateUrl: "templates/partials/addAllowIntegration.html",
          controller: "allowIntegrationsController"
        }
      },
      requiresAuthentication: true,
      allowedPermissions: ["TravelAgencyAdmin", "ObexAdmin", "TravelManager"],
      data: {
        pageTitle: "Edit Allow Integration"
      }
    }).state("travelprogram", {});
    ngIntlTelInputProvider.set({
      defaultCountry: "us",
      utilsScript: "helpers/intl-tel-input/build/js/utils.js"
    });
  }]).run(["$rootScope", "$state", "$stateParams", "authService", "Carousel", function ($rootScope, $state, $stateParams, authService, Carousel) {
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
      if (toState.requiresAuthentication && !authService.isAuthenticated()) {
        event.preventDefault();
        $state.go("login");
      } else if (toState.requiresAuthentication && authService.isAuthenticated()) {
        var permissions = toState.allowedPermissions;
        if (!authService.userHasPermission(permissions)) {
          event.preventDefault();
        }
      }
    });

    /*
    Carousel.setOptions({
      arrows: true,
      autoplay: false,
      autoplaySpeed: 3000,
      cssEase: 'ease',
      dots: false,
              easing: 'linear',
      fade: false,
      infinite: true,
      initialSlide: 0,
              slidesToShow: 1,
      slidesToScroll: 1,
      speed: 500,
    });*/

    window.setInterval(function () {
      $(".alert").not(".no-fade-alert").addClass("fade out");
    }, 10000);
    // BEGIN BACK TO TOP
    $(window).scroll(function () {
      if ($(this).scrollTop() < 200) {
        $("#totop").fadeOut();
      } else {
        $("#totop").fadeIn();
      }
    });
    $rootScope.scrollToTop = function () {
      $("html, body").animate({
        scrollTop: 0
      }, "fast");
      return false;
    };
    window.onbeforeunload = function () {
      console.log("state ", $state);
      if ($state.$current.path["0"].url.sourcePath !== "/login" && $state.$current.path["0"].url.sourcePath !== "/signup" && !$state.$current.path["0"].url.sourcePath.includes("/activate/") && !$state.$current.path["0"].url.sourcePath.includes("/resetpassword/")) {
        return "Please consider NOT reloading/refreshing the page.  Your conversation will be archived and you will no longer be able to assist the traveler";
      }
    };
    // END BACK TO TOP
  }]).controller("IndexCtrl", function () {}).controller("LogoutCtrl", ["$state", "authService", "socket", "socketLogin", function ($state, authService, socket, socketLogin) {
    socket.sendClientDisconnect(socketLogin.getSocketId(), socketLogin.getLoginMember());
    authService.clear();
    $state.go("login");
  }]);
})(angular.module("obex", ["ui.router", "ngProgress", "ngDialog", "ngAnimate", "ngAria", "ngMaterial", "ngMessages", "mdPickers", "toastr", "ui.grid", "ui.grid.pagination", "ui.grid.selection", "ngSanitize", "permission", "ui.grid.resizeColumns", "angularResizable", "ngCsv", "ui.grid.treeView", "ui.grid.autoResize", "ui.grid.exporter", "ui.bootstrap", "angularRipple", "angular-intro", "ngIntlTelInput", "ui.carousel", "ngFileUpload"]));

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69);
module.exports = __webpack_require__(0).Number.isInteger;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(4);

$export($export.S, 'Number', { isInteger: __webpack_require__(70) });


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(5);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(131);


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(73);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(74), __esModule: true };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43);
__webpack_require__(25);
__webpack_require__(33);
__webpack_require__(82);
__webpack_require__(90);
__webpack_require__(91);
module.exports = __webpack_require__(0).Promise;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(28);
var defined = __webpack_require__(29);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(39);
var descriptor = __webpack_require__(18);
var setToStringTag = __webpack_require__(23);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(9)(IteratorPrototype, __webpack_require__(2)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(11);
var toLength = __webpack_require__(40);
var toAbsoluteIndex = __webpack_require__(78);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(28);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(80);
var step = __webpack_require__(81);
var Iterators = __webpack_require__(13);
var toIObject = __webpack_require__(11);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(44)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(15);
var global = __webpack_require__(1);
var ctx = __webpack_require__(14);
var classof = __webpack_require__(41);
var $export = __webpack_require__(4);
var isObject = __webpack_require__(5);
var aFunction = __webpack_require__(21);
var anInstance = __webpack_require__(83);
var forOf = __webpack_require__(84);
var speciesConstructor = __webpack_require__(50);
var task = __webpack_require__(51).set;
var microtask = __webpack_require__(86)();
var newPromiseCapabilityModule = __webpack_require__(34);
var perform = __webpack_require__(52);
var userAgent = __webpack_require__(87);
var promiseResolve = __webpack_require__(53);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(2)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(88)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(23)($Promise, PROMISE);
__webpack_require__(89)(PROMISE);
Wrapper = __webpack_require__(0)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(61)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(14);
var call = __webpack_require__(59);
var isArrayIter = __webpack_require__(60);
var anObject = __webpack_require__(7);
var toLength = __webpack_require__(40);
var getIterFn = __webpack_require__(49);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var macrotask = __webpack_require__(51).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(17)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(9);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(1);
var core = __webpack_require__(0);
var dP = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(6);
var SPECIES = __webpack_require__(2)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(4);
var core = __webpack_require__(0);
var global = __webpack_require__(1);
var speciesConstructor = __webpack_require__(50);
var promiseResolve = __webpack_require__(53);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(4);
var newPromiseCapability = __webpack_require__(34);
var perform = __webpack_require__(52);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(93);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(94), __esModule: true };

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperty: __webpack_require__(8).f });


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(0);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(98), __esModule: true };

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99);
module.exports = __webpack_require__(0).Object.assign;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(4);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(100) });


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(6);
var getKeys = __webpack_require__(16);
var gOPS = __webpack_require__(35);
var pIE = __webpack_require__(20);
var toObject = __webpack_require__(19);
var IObject = __webpack_require__(47);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(12)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(145), __esModule: true };

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(25);
__webpack_require__(33);
module.exports = __webpack_require__(36).f('iterator');


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(65);
__webpack_require__(43);
__webpack_require__(106);
__webpack_require__(107);
module.exports = __webpack_require__(0).Symbol;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(16);
var gOPS = __webpack_require__(35);
var pIE = __webpack_require__(20);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(17);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37)('asyncIterator');


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37)('observable');


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67);
__webpack_require__(109);
__webpack_require__(110);
__webpack_require__(111);
__webpack_require__(112);
__webpack_require__(113);
__webpack_require__(114);
__webpack_require__(115);
__webpack_require__(116);
__webpack_require__(117);
__webpack_require__(118);
__webpack_require__(119);
__webpack_require__(120);
__webpack_require__(121);
__webpack_require__(122);
__webpack_require__(123);
__webpack_require__(124);
__webpack_require__(125);
__webpack_require__(126);
__webpack_require__(127);
__webpack_require__(128);
__webpack_require__(129);
__webpack_require__(130);
__webpack_require__(133);
__webpack_require__(134);
__webpack_require__(135);
__webpack_require__(136);
__webpack_require__(137);
__webpack_require__(138);
__webpack_require__(139);
__webpack_require__(140);
__webpack_require__(151);
__webpack_require__(152);
__webpack_require__(154);
__webpack_require__(155);
__webpack_require__(156);
__webpack_require__(157);
__webpack_require__(158);
__webpack_require__(159);
__webpack_require__(160);
__webpack_require__(161);
__webpack_require__(162);
__webpack_require__(163);
__webpack_require__(164);
__webpack_require__(165);
__webpack_require__(166);
__webpack_require__(167);
__webpack_require__(168);
__webpack_require__(169);
__webpack_require__(170);
__webpack_require__(171);
__webpack_require__(172);
__webpack_require__(173);
__webpack_require__(174);
__webpack_require__(175);
__webpack_require__(176);
__webpack_require__(177);
__webpack_require__(178);
__webpack_require__(179);
__webpack_require__(180);
__webpack_require__(181);
__webpack_require__(182);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(185);
__webpack_require__(186);
__webpack_require__(187);
__webpack_require__(188);
__webpack_require__(189);
__webpack_require__(190);
__webpack_require__(191);
__webpack_require__(192);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(195);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(211);
__webpack_require__(212);
__webpack_require__(213);
__webpack_require__(214);
__webpack_require__(215);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(219);
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);
module.exports = __webpack_require__(226);


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  'use strict';

  angular.module('obex').factory('commonDialog', ['ngDialog', function (ngDialog) {
    return {
      confirmDialog: '<div class="ngdialog-buttons"> ' + '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>' + '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>' + '</div>',
      openDialog: '<div class="ngdialog-buttons">' + '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Ok </button>' + '</div>'
    };
  }]);
})();

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This (Constant.js) file is used for maintaining constants variable through out the application
(function (module) {
  'use strict';

  module.constant('commonDialogMessage', {
    confirmMessage: 'Are you sure you want to delete?',
    accountDeleteMessage: 'Account successfully deleted.',
    accountAdminAccessMessage: 'Admin access updated successfully.',
    orgDeleteEmailMessage: 'You can not delete this blank email address entry.',
    orgDuplicateEmailMessage: 'Entered email address is duplicate for this organization.',
    orgDeleteMessage: 'Organization successfully deleted',
    orgUpdatedMessage: 'Organization successfully updated.',
    orgSavedMessage: 'Organization successfully created.',
    tripDashStatusUpdatedMessage: 'Notes sucessfully created.',
    fieldOptionDeletedMessage: 'Field option successfully deleted.',
    fieldNameSavedMessage: 'Field name successfully created.',
    fieldNameUpdatedMessage: 'Field name successfully updated.',
    fieldNameDeletedMessage: 'Field name successfully deleted.',
    travelerTrackNoResultMessage: 'No travelers found. Please select another search criteria.',
    tripsDashBoardNoResultMessage: 'No trips found. Please select another search criteria.',
    smsHistoryNoResultMessage: 'No SMS history with respective dates. Please select another search criteria.',
    phoneHistoryNoResultMessage: 'No phone history with respective dates. Please select another search criteria.',
    profileFieldsNoResultMessage: 'No profile fields found for this criteria.',
    providerUpdatedMessage: 'Provider successfully updated.',
    providerSavedMessage: 'Provider successfully created.',
    providerDeleteMessage: 'Provider successfully deleted',
    agencySettingsAddMessage: 'Travel agents added successfully.',
    agencySettingsDeletedMessage: 'Travel agent association deleted successfully.',
    iataCodeError: 'Please enter required fields.',
    tripFieldRequiredMessage: 'Please enter all required field',
    dateErrorMessage: 'Please select valid date range',
    duplicateDomainError: 'Entered domain name is duplicate for this organization',
    blankDomainError: 'You can not delete this blank domain name entry',
    checkEmailPassMessage: 'Valid trip link account details must be entered, before adding new entry.Password must contain minimum 8 characters, and must include 1 uppercase letter and 1 digit',
    memberUpdatedMessage: 'Member successfully updated.',
    customerAccountNoResultMessage: 'No customer account found for this criteria.',
    tripFieldNoResultMessage: 'No trip field found for this criteria.'
  });
})(angular.module('obex'));

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.controller('ActivateController', ['$scope', '$stateParams', '$http', '$state', 'ngDialog', 'authService', function ($scope, $stateParams, $http, $state, ngDialog, authService) {
    var passwordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,})$/;
    $scope.user = {};
    $scope.validate = { //'valid', 'invalid', 'not-validated'          
      passwordValidity: 'not-validated',
      confirmValidity: 'not-validated'
    };

    $scope.passwordKeypress = function () {
      var isValid = passwordRegex.test($scope.user.password);
      $scope.validate.passwordValidity = isValid ? 'valid' : 'not-validated';
    };

    $scope.confirmKeypress = function () {
      if ($scope.user.confirm) {
        var isValid = passwordRegex.test($scope.user.confirm);
        $scope.validate.confirmValidity = $scope.user.password === $scope.user.confirm && $scope.user.confirm.length > 0 && isValid ? 'valid' : 'not-validated';
      } else {
        $scope.validate.confirmValidity = 'not-validated';
      }
    };

    $scope.signup = function () {
      $scope.ajaxload = true;

      var isPasswordValid = passwordRegex.test($scope.user.password);
      if (!isPasswordValid) {
        $scope.validate.passwordValidity = 'invalid';
      }

      if ($scope.user.password !== $scope.user.confirm) {
        $scope.validate.confirmValidity = 'invalid';
      }

      var passwordInvalid = $scope.validate.passwordValidity === 'invalid',
          confirmInvalid = $scope.validate.confirmValidity === 'invalid';
      if (passwordInvalid || confirmInvalid) {
        $scope.ajaxload = false;
        var dialog = ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '';
            if (passwordInvalid) {
              $scope.errMsg += '<p>Password must contain minimum 8 characters, and must include at least 1 uppercase letter and 1 digit.</p>';
            }
            if (confirmInvalid) {
              $scope.errMsg += '<p>Password and Confirm Password fields do not match.</p>';
            }
            $scope.errTitle = 'Signing Up Error';
          }]
        });
        dialog.closePromise.then(function (data) {});
      } else {
        authService.completeActivation($scope.user.password, $stateParams.guid).then(function (result) {
          $scope.ajaxload = false;
          var dialog = ngDialog.open({
            template: 'templates/partials/viewSuccessMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.successMsg = 'You have successfully activated your account.';
              $scope.strTitle = 'Activate Account Success';
            }]
          });
          dialog.closePromise.then(function (data) {
            if (isMobile.any()) {
              $state.go('closepage');
            } else {
              $state.go('login');
            }
          });
        }, function (error) {
          $scope.ajaxload = false;
          var dialog = ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + error.data + '</p>';
              $scope.errTitle = 'Signing Up Error';
            }]
          });
          dialog.closePromise.then(function (data) {});
        });
      }
    };

    var isMobile = {
      Android: function Android() {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function BlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function iOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function Opera() {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function Windows() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
      },
      any: function any() {
        return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
      }
    };

    console.log($stateParams);
    console.log($stateParams.guid);
  }]);
})(angular.module('obex'));

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('agencyManagementController', ['$scope', 'agencyManagement', '$stateParams', 'progressBar', 'ngDialog', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state', 'authService', '$q', 'fileReader', 'providers', function ($scope, agencyManagement, $stateParams, progressBar, ngDialog, uiGridConstants, commonDialog, commonDialogMessage, $state, authService, $q, fileReader, providers) {
    var readyToUpload = false;
    var selectedFilename = null;
    $scope.showAllAgencies = agencyManagement.getShowAll();
    var progress = progressBar.getProgressBar();
    var gridData = void 0;
    $scope.organization = {
      Name: null,
      AddressLine1: null,
      AddressLine2: null,
      City: null,
      PostalCode: null,
      Country: null,
      StateProv: null,
      IsTravelAgency: true,
      Id: 0,
      TravelAgencyId: 0,
      HasConcur: false,
      Domains: {
        Id: 0,
        OrganizationId: 0,
        Name: null
      },
      TripLinkAccounts: {
        Id: 0,
        OrganizationId: 0,
        Login: null,
        Password: null,
        ProviderId: 20,
        DataFetched: null
      },
      AcceptEmails: {
        Id: 0,
        Email: null,
        OrganizationId: 0,
        IsAdmin: false
      },
      LogoImageLink: '//:0'
    };
    $scope.isEdit = false;
    $scope.isNew = false;
    $scope.currentDate = new Date();
    $scope.domainList = [{
      Id: 0,
      Name: '',
      OrganizationId: 0
    }];
    $scope.acceptEmailList = [{
      Id: 0,
      Email: '',
      OrganizationId: 0,
      IsAdmin: false
    }];
    $scope.travelAgencySelId = 0;
    $scope.searchAgencies = function () {
      agencyManagement.setShowAll($scope.showAllAgencies);
      setGridData();
    };
    agencyManagement.getCountries().then(function (responseData) {
      $scope.countryList = responseData.data;
    }, function (err) {
      ngDialog.open({
        template: 'templates/partials/viewErrorMsg.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.errMsg = '<p>' + err.statusText + '</p>';
          $scope.errTitle = 'Organization Error';
        }]
      });
    });
    $scope.countryName = 'United States';
    agencyManagement.getStates().then(function (responseData) {
      $scope.stateList = responseData.data;
    }, function (err) {
      ngDialog.open({
        template: 'templates/partials/viewErrorMsg.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.errMsg = '<p>' + err.statusText + '</p>';
          $scope.errTitle = 'Organization Error';
        }]
      });
    });
    $scope.stateName = '';
    //Call this code while Edit organization
    var id = $stateParams.id;
    if (!!id) {
      getOrganizationById(id);
      $scope.isEdit = true;
    } else {
      agencyManagement.getAgencies($scope.showAllAgencies).then(function (response) {
        var agencies = response.data;
        $scope.travelAgencyList = agencies.map(function (organization) {
          return {
            Id: organization.Id,
            Name: organization.Name
          };
        });
      });
    }

    function uploadImage(img) {
      if (img != null) {
        return providers.uploadImage(img).then(function (result) {
          var cloudinaryObj = result.data;
          //console.log(cloudinaryObj);
          var public_filename = cloudinaryObj.public_id + '.' + cloudinaryObj.format; // e.g. 'filename.jpg'
          return providers.transformImage(public_filename).then(function (result) {
            //console.log(result);
            return result.data;
          });
        });
      }
    };

    function deletePreviousImage(img) {
      if (img != null) {
        return providers.deleteImage(img).then(function (result) {
          return result.data;
        });
      }
    };

    // Validate trip link account , domian , accept email
    function validateEmailPass(addUpdate, addDomain, addEmail, addAccount) {
      var validateMessage = '';
      var inValidDomainList = null;
      var inValidEmailList = null;
      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var domainRegex = /(^(https?):\/\/|^)(([^\.]+)\.([^\.]+\.[^\/$]+)|([^\.]+\.[^\/$]+))\/?$/;
      // Validate domain name and email address details while save /update.
      if (addUpdate) {
        if (!$scope.domainList[0].Name && !$scope.acceptEmailList[0].Email) {
          validateMessage = 'Either one domain name or one email address must be entered.';
          return validateMessage;
        };
        // validate domain name
        inValidDomainList = $scope.domainList.filter(function (domainlist) {
          return !domainRegex.test(domainlist.Name) && !!domainlist.Name;
        });
        if (!!inValidDomainList.length) {
          validateMessage = 'Entered domain name is invalid.';
          return validateMessage;
        };
        // validate accept email list
        inValidEmailList = $scope.acceptEmailList.filter(function (emailList) {
          return !emailRegex.test(emailList.Email) && !!emailList.Email;
        });
        if (!!inValidEmailList.length) {
          validateMessage = 'Entered email address is invalid.';
          return validateMessage;
        };
      };
      // validate domain name while adding new entry
      if (addDomain) {
        inValidDomainList = $scope.domainList.filter(function (domainlist) {
          return !domainRegex.test(domainlist.Name);
        });
        if (!!inValidDomainList.length) {
          validateMessage = 'Valid domain name must be entered, before adding new entry.';
          return validateMessage;
        }
      };
      // validate email while adding new entry
      if (addEmail) {
        inValidEmailList = $scope.acceptEmailList.filter(function (emailList) {
          return !emailRegex.test(emailList.Email);
        });
        if (!!inValidEmailList.length) {
          validateMessage = 'Valid email address must be entered, before adding new entry.';
          return validateMessage;
        }
      };
      return validateMessage;
    };

    function addAgency(agency) {
      agencyManagement.addOrganization(agency).then(function () {
        var dialogPost = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Add Agency Success';
            $scope.successMsg = 'The Agency has been added succesfully.';
          }]
        });
        dialogPost.closePromise.then(function (data) {
          $state.go('app.agencyManagement');
        });
      }, function (err) {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Agency Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    };

    function getOrganizationById(id) {
      progress.start();
      var promiseClient = agencyManagement.getOrganizationById(id);
      var promiseAgency = agencyManagement.getAgencies($scope.showAllAgencies);
      $q.all([promiseClient, promiseAgency]).then(function (response) {
        $scope.isEdit = true;
        $scope.isNew = false;
        $scope.message = null;
        $scope.organization = response[0].data;
        //console.log($scope.organization);
        var agencies = response[1].data;
        $scope.travelAgencyList = agencies.map(function (agency) {
          return {
            Id: agency.Id,
            Name: agency.Name
          };
        });
        $scope.domainList = !!response[0].data.Domains.length ? response[0].data.Domains : [{
          Id: 0,
          Name: '',
          OrganizationId: 0
        }];
        $scope.countryName = response[0].data.Country;
        $scope.logoImageLink = response[0].data.LogoImageLink;
        $scope.stateName = response[0].data.StateProv;
        $scope.travelAgencySelId = response[0].data.TravelAgencyId;
        $scope.acceptEmailList = !!response[0].data.AcceptEmails.length ? response[0].data.AcceptEmails : [{
          Id: 0,
          Email: '',
          OrganizationId: 0,
          IsAdmin: false
        }];
      }, function (err) {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Agency Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    };

    function updateAgency(agency) {
      agencyManagement.updateOrganization(agency.Id, agency).then(function () {
        var dialogPut = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Update Agency Success';
            $scope.successMsg = 'The Agency has been updated succesfully.';
          }]
        });
        dialogPut.closePromise.then(function (data) {
          $state.go('app.agencyManagement');
        });
      }, function (err) {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Update Agency Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    };
    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope).then(function (result) {
        $scope.organization.LogoImageLink = result;
      });
    };
    $scope.setFile = function (event) {
      selectedFilename = event.target.files[0];
      readyToUpload = true;
      fileReader.readAsDataUrl(selectedFilename, $scope).then(function (result) {
        $scope.organization.LogoImageLink = result;
      });
      $scope.$apply();
    };
    $scope.clearFile = function () {
      readyToUpload = false;
      selectedFilename = null;
      $scope.organization.LogoImageLink = '//:0';
      //$scope.$apply();
    };
    $scope.saveOrganization = function () {
      if ($scope.orgForm.$valid) {
        var _validateEmailPassChk = validateEmailPass(true, false, false, true);
        if (!_validateEmailPassChk) {
          var domainList = $scope.domainList.filter(function (domain) {
            return !!domain.Name;
          });
          $scope.organization.Domains = !!domainList.length ? domainList : [];
          $scope.organization.Country = $scope.countryName;
          $scope.organization.StateProv = $scope.stateName;
          var acceptEmailList = $scope.acceptEmailList.filter(function (acceptEmail) {
            return !!acceptEmail.Email;
          });
          $scope.organization.AcceptEmails = !!acceptEmailList.length ? acceptEmailList : [];
          progress.start();
          if (readyToUpload) {
            // pipe raw to cloudinary, retrieve transformed cloudinary url and replace LogoImageLink
            uploadImage(selectedFilename).then(function (result) {
              if (result != null) {
                if ($scope.logoImageLink !== null) {
                  var str = $scope.logoImageLink;
                  var arrResult = str.split("/");
                  var len = arrResult.length - 1;
                  str = arrResult[len];
                  var deletedFileName = str.substring(0, str.indexOf("."));
                  deletePreviousImage(deletedFileName).then(function (result) {
                    console.log(result);
                  });
                }
                $scope.organization.LogoImageLink = result;
                addAgency($scope.organization);
              }
            });
          } else {
            $scope.organization.LogoImageLink = $scope.logoImageLink;
            addAgency($scope.organization);
          }
        } else {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + _validateEmailPassChk + '</p>';
              $scope.errTitle = 'Agency Warning';
            }]
          });
        }
      }
    };
    $scope.updateOrganization = function (id) {
      if ($scope.orgForm.$valid) {
        var _validateEmailPassChk2 = validateEmailPass(true, false, false, true);
        if (!_validateEmailPassChk2) {
          var domainList = $scope.domainList.filter(function (domain) {
            return !!domain.Name;
          });
          $scope.organization.Domains = !!domainList.length ? domainList : [];
          $scope.organization.Country = $scope.countryName;
          $scope.organization.StateProv = $scope.stateName;
          var acceptEmailList = $scope.acceptEmailList.filter(function (acceptEmail) {
            return !!acceptEmail.Email;
          });
          $scope.organization.AcceptEmails = !!acceptEmailList.length ? acceptEmailList : [];
          progress.start();
          if (readyToUpload) {
            // pipe raw to cloudinary, retrieve transformed cloudinary url and replace LogoImageLink
            uploadImage(selectedFilename).then(function (result) {
              if (result != null) {
                if ($scope.logoImageLink !== null) {
                  var str = $scope.logoImageLink;
                  var arrResult = str.split("/");
                  var len = arrResult.length - 1;
                  str = arrResult[len];
                  var deletedFileName = str.substring(0, str.indexOf("."));
                  deletePreviousImage(deletedFileName).then(function (result) {
                    console.log(result);
                  });
                }
                $scope.organization.LogoImageLink = result;
                updateAgency($scope.organization);
              }
            });
          } else {
            $scope.organization.LogoImageLink = $scope.logoImageLink;
            updateAgency($scope.organization);
          }
        } else {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + _validateEmailPassChk2 + '</p>';
              $scope.errTitle = 'Agency Warning';
            }]
          });
        }
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + validateEmailPassChk + '</p>';
            $scope.errTitle = 'Update Agency Warning';
          }]
        });
      }
    };
    //add new domain entry for organization
    $scope.addDomain = function () {
      var checkDomain = validateEmailPass(false, true, false, false);
      if (!checkDomain) {
        $scope.domainList.push({
          Id: 0,
          Name: '',
          OrganizationId: $scope.organization.Id
        });
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + checkDomain + '</p>';
            $scope.errTitle = 'Add Domain Warning';
          }]
        });
      }
    };
    //check duplicate domain entry for organization
    $scope.checkDuplicateDomain = function (index, domainName) {
      var domainList = $scope.domainList.filter(function (domain) {
        return domain.Name == domainName;
      });
      if (domainList.length > 1) {
        var dialogDup = ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + commonDialogMessage.duplicateDomainError + '</p>';
            $scope.errTitle = 'Update Traveler Error';
          }]
        });
        dialogDup.closePromise.then(function (data) {
          $scope.domainList[index].Name = '';
        });
      }
    };
    //Remove domain for organization
    $scope.removeDomain = function (index, domainId) {
      if (!domainId) {
        if ($scope.domainList.length > 1) {
          $scope.domainList.splice(index, 1);
        } else {
          if (!!$scope.domainList[0].Name) {
            $scope.domainList.splice(index, 1);
            $scope.domainList.push({
              Id: 0,
              Name: '',
              OrganizationId: $scope.organization.Id
            });
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + commonDialogMessage.blankDomainError + '</p>';
                $scope.errTitle = 'Remove Domain Warning';
              }]
            });
          }
        }
      } else {
        var confirm = ngDialog.open({
          template: 'templates/partials/viewConfirm.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Delete Domain?';
            $scope.strMsg = 'Do you really want to delete this domain?';
          }]
        });
        confirm.closePromise.then(function (data) {
          if (data.value === 1) {
            if ($scope.domainList.length > 1) {
              $scope.domainList.splice(index, 1);
            } else {
              if (!!$scope.domainList[0].Name) {
                $scope.domainList.splice(index, 1);
                $scope.domainList.push({
                  Id: 0,
                  Name: '',
                  OrganizationId: $scope.organization.Id
                });
              } else {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '<p>' + commonDialogMessage.blankDomainError + '</p>';
                    $scope.errTitle = 'Remove Domain Warning';
                  }]
                });
              }
            }
          }
        });
      }
    };
    //add new email entry for organization
    $scope.addEmail = function () {
      var checkAcceptEmail = validateEmailPass(false, false, true, false);
      if (!checkAcceptEmail) {
        $scope.acceptEmailList.push({
          Id: 0,
          Email: '',
          OrganizationId: $scope.organization.Id,
          IsAdmin: false
        });
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + checkAcceptEmail + '</p>';
            $scope.errTitle = 'Add Email Warning';
          }]
        });
      }
    };
    // ui-grid code
    var gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: false,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      columnDefs: [{
        name: 'Name',
        displayName: 'Agency Name',
        enableHiding: false,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250,
        sort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }
      }, {
        name: 'AddressLine1',
        displayName: 'Address Line 1',
        visible: false,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'AddressLine2',
        displayName: 'Address Line 2',
        visible: false,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'City',
        visible: true,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'StateProv',
        displayName: 'State',
        visible: true,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'PostalCode',
        displayName: 'Postal Code',
        visible: true,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Inactive',
        displayName: 'Inactive',
        visible: false,
        enableSorting: false,
        maxWidth: 250,
        enableColumnResizing: true,
        cellTemplate: ' <span ng-show="row.entity.Inactive" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.Inactive" style="padding-left: 5px;">No</span>',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: [{
            value: 'true',
            label: 'Yes'
          }, {
            value: 'false',
            label: 'No'
          }]
        }
      }, {
        name: 'Country',
        visible: true,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'HasConcur',
        displayName: 'Has Concur',
        visible: false,
        enableSorting: false,
        maxWidth: 250,
        enableColumnResizing: true,
        cellTemplate: ' <span ng-show="row.entity.HasConcur" style="padding-left: 5px;">{{row.entity.HasConcur}}eeeeeYes</span> <span ng-hide="row.entity.HasConcur" style="padding-left: 5px;">{{row.entity.HasConcur}}kkkkkNo</span>',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: [{
            value: 'true',
            label: 'Yes'
          }, {
            value: 'false',
            label: 'No'
          }]
        }
      }],
      rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>'
    };

    $scope.gridDetails = _.cloneDeep(gridOptions);
    $scope.gridDetails.onRegisterApi = function (gridApi) {
      $scope.gridApi = gridApi;
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        setGridData();
      });
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        $scope.rowSelectingId = row.entity.Id;
        if (row.isSelected) {
          $scope.rowSelecting = true;
          if (row.entity.Inactive === true) {
            $scope.disabledDeleteBtn = false;
          } else {
            $scope.disabledDeleteBtn = true;
          }
        } else {
          $scope.rowSelecting = false;
          $scope.disabledDeleteBtn = false;
        }
      });
    };
    $scope.gridDetails.columnDefs[1].visible = authService.getLoginMember().Role === 4 ? true : false;
    $scope.onDblClick = function (row) {
      $scope.rowSelectingId = row.entity.Id;
      $scope.view();
      // Override default rowSelection action
      row.isSelected = true;
      $scope.rowSelecting = true;
    };

    function setGridData() {
      progress.start();
      var promiseAgency = null;
      if (authService.getLoginMember().Role === 4) {
        promiseAgency = agencyManagement.getAgencies($scope.showAllAgencies);
      } else {
        promiseAgency = agencyManagement.getOrganizations();
      }

      promiseAgency.then(function (response) {
        var agencyData = response.data;
        var agencies = [];
        if ($scope.showAllAgencies === false) {
          agencyData.forEach(function (agency) {
            if (agency.Inactive === false) {
              agencies.push(agency);
            }
          });
        } else {
          agencies = response.data;
        }
        gridData = agencies;
        updateGridPagination(gridData);
      }, function (err) {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Agency Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    };
    setGridData();

    function updateGridPagination(gridData) {
      $scope.gridDetails.data = gridData;
      $scope.gridDetails.totalItems = gridData.length;
    };
    $scope.view = function () {
      if (!!$scope.rowSelectingId) {
        getOrganizationById($scope.rowSelectingId);
      }
      ngDialog.open({
        template: 'templates/partials/viewAgency.html',
        className: 'ngdialog-theme-plain',
        scope: $scope
      });
    };
    $scope.deleteOrganization = function () {
      var confirm = ngDialog.open({
        template: 'templates/partials/viewConfirm.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.strTitle = 'Delete Account?';
          $scope.strMsg = 'Do you really want to delete this account?';
        }]
      });
      confirm.closePromise.then(function (data) {
        if ($scope.rowSelectingId && data.value === 1) {
          progress.start();
          agencyManagement.deleteOrganization($scope.rowSelectingId).then(function (response) {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete Account Success';
                $scope.successMsg = 'Your account has been deleted successfully';
              }]
            });
            dialog.closePromise.then(function (data) {});
          }, function (err) {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + '</p>';
                $scope.errTitle = 'Delete Organization Error';
              }]
            });
            dialog.closePromise.then(function (data) {});
          }).finally(function () {
            progress.complete();
            $scope.gridApi.core.clearAllFilters();
            setGridData();
          });
        }
      });
    };
    $scope.edit = function () {
      $state.go('app.editAgency', {
        id: $scope.rowSelectingId
      });
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (module) {
  'use strict';

  module.controller('agencySettingsController', ['$scope', 'progressBar', 'clientSelectService', 'agencySelectService', 'agencySettings', 'toastFactory', 'ngDialog', 'authService', '$q', '$mdpTimePicker', 'fileReader', 'providers', function ($scope, progressBar, clientSelectService, agencySelectService, agencySettings, toastFactory, ngDialog, authService, $q, $mdpTimePicker, fileReader, providers) {
    var progress = progressBar.getProgressBar();
    var readyToUpload = false;
    var selectedFilename = null;
    $scope.isUpdate = false;
    $scope.agencySettings = {};
    $scope.startBusinessHours = {};
    $scope.endBusinessHours = {};
    // List of Days
    $scope.dayList = [{
      id: 1,
      name: 'Sunday'
    }, {
      id: 2,
      name: 'Monday'
    }, {
      id: 3,
      name: 'Tuesday'
    }, {
      id: 4,
      name: 'Wednesday'
    }, {
      id: 5,
      name: 'Thursday'
    }, {
      id: 6,
      name: 'Friday'
    }, {
      id: 7,
      name: 'Saturday'
    }];
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id)
      };
    }
    // Get Agency by ID
    function getAgencyById() {
      $scope.agencySettings.LogoImageLink = null;
      $scope.agencySettings = {};
      $scope.startBusinessHours = {};
      $scope.endBusinessHours = {};
      $scope.defaultOrgDayFrom = 0;
      $scope.defaultOrgDayTo = 0;
      $scope.selTimeZoneId = 0;
      $scope.isUpdate = false;
      if (authService.getLoginMember().Role === 4) {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid) {
          var organization = agencySelectService.getSelectedAgency();
          getAgencyDetails(organization.id);
        } else {
          if (valid.agencyValid === false) {
            //toastFactory.toast_info('Please select an agency.');
          }
        }
      } else {
        getAgencyDetails(authService.getLoginMember().OrganizationId);
      }
    };

    function getAgencyDetails(organizationId) {
      progress.start();
      $scope.agencySettings.LogoImageLink = null;
      $scope.startBusinessHours = new Date(0, 0, 0, 0, 0);
      $scope.endBusinessHours = new Date(0, 0, 0, 0, 0);
      var promiseTimeZone = agencySettings.getWindowsTimeZones();
      var promiseAgencySettings = agencySettings.getAgencyById(organizationId);
      $q.all([promiseTimeZone, promiseAgencySettings]).then(function (response) {
        $scope.timeZones = response[0].data;
        $scope.selTimeZoneId = 0;
        $scope.agencySettings = response[1].data;
        $scope.defaultOrgDayFrom = response[1].data.DefaultServiceStartDay;
        $scope.defaultOrgDayTo = response[1].data.DefaultServiceEndDay;
        $scope.selTimeZoneId = !!response[1].data.DefaultWindowsTimeZone ? response[1].data.DefaultWindowsTimeZone.Id : '';

        if ($scope.agencySettings.DefaultStartRegularHours === null && $scope.agencySettings.DefaultEndRegularHours === null) {
          $scope.startBusinessHours = new Date(0, 0, 0, 0, 0);
          $scope.endBusinessHours = new Date(0, 0, 0, 0, 0);
        } else {
          var startHourDate = !!$scope.agencySettings.DefaultStartRegularHours ? $scope.agencySettings.DefaultStartRegularHours.split(':') : '';
          var endHourDate = !!$scope.agencySettings.DefaultEndRegularHours ? $scope.agencySettings.DefaultEndRegularHours.split(':') : '';
          var startHour = startHourDate[0];
          var startMin = startHourDate[1];
          var endHour = endHourDate[0];
          var endMin = endHourDate[1];
          $scope.startBusinessHours = new Date(0, 0, 0, startHour, startMin);
          $scope.endBusinessHours = new Date(0, 0, 0, endHour, endMin);
        }
        var agency = $scope.agencySettings;
        if (!!agency.DefaultStartRegularHours || !!agency.DefaultEndRegularHours || !!agency.DefaultServiceStartDay || !!agency.DefaultServiceEndDay || !!agency.DefaultWindowsTimeZoneId || !!agency.DefaultPhone || !!agency.DefaultAfterHoursPhone || !!agency.DefaultEmail || !!agency.WebSite || !!agency.LogoImageLink) {
          $scope.isUpdate = true;
        }
      }, function (err) {

        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Agency Settings Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    }
    // code for upload image
    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope).then(function (result) {
        $scope.agencySettings.LogoImageLink = result;
      });
    };

    $scope.setFile = function (event) {
      selectedFilename = event.target.files[0];
      readyToUpload = true;
      fileReader.readAsDataUrl(selectedFilename, $scope).then(function (result) {
        $scope.agencySettings.LogoImageLink = result;
      });

      $scope.$apply();
    };

    $scope.clearFile = function () {
      readyToUpload = false;
      selectedFilename = null;
      $scope.agencySettings.LogoImageLink = '//:0';
    };

    function uploadImage(img) {
      if (img != null) {
        return providers.uploadImage(img).then(function (result) {
          var cloudinaryObj = result.data;
          var public_filename = cloudinaryObj.public_id + '.' + cloudinaryObj.format; // e.g. 'filename.jpg'
          return providers.transformImage(public_filename).then(function (result) {
            return result.data;
          });
        });
      }
    };
    // Update agency
    $scope.updateAgency = function () {
      var startHour = $scope.startBusinessHours.getHours();
      var startMin = $scope.startBusinessHours.getMinutes();
      var endHour = $scope.endBusinessHours.getHours();
      var endMin = $scope.endBusinessHours.getMinutes();
      $scope.agencySettings.DefaultStartRegularHours = startHour + ':' + startMin;
      $scope.agencySettings.DefaultEndRegularHours = endHour + ':' + endMin;
      var agencySetting = $scope.agencySettings;
      agencySetting.DefaultServiceStartDay = $scope.defaultOrgDayFrom;
      agencySetting.DefaultServiceEndDay = $scope.defaultOrgDayTo;
      agencySetting.DefaultWindowsTimeZoneId = !!$scope.selTimeZoneId ? $scope.selTimeZoneId : 0;
      if (readyToUpload) {
        // pipe raw to cloudinary, retrieve transformed cloudinary url and replace LogoImageLink
        uploadImage(selectedFilename).then(function (result) {
          if (result != null) {
            $scope.agencySettings.LogoImageLink = result;
            UpdateDefaultAgency($scope.agencySettings);
          }
        });
      } else {
        $scope.agencySettings.LogoImageLink = null;
        UpdateDefaultAgency($scope.agencySettings);
      }
    };

    function UpdateDefaultAgency(agencyDefault) {
      progress.start();
      agencySettings.updateAgency(agencyDefault.Id, agencyDefault).then(function (agencyDefault) {
        if (!!$scope.isUpdate) {
          ngDialog.open({
            template: 'templates/partials/viewSuccessMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Update Agency Setting Successfully';
              $scope.successMsg = 'Agency has been updated succesfully.';
            }]
          });
        } else {
          ngDialog.open({
            template: 'templates/partials/viewSuccessMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Save Agency Setting Successfully';
              $scope.successMsg = 'Agency has been Saved succesfully.';
            }]
          });
        }
      }, function (err) {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Update Agency Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    };

    getAgencyById();
    // Watch orgFilterService for changes to getFilteredOrganization() output
    // expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return agencySelectService.getSelectedAgency();
    }, function (newValue, oldValue) {

      if (newValue !== oldValue) {
        $scope.agencySettings.LogoImageLink = null;
        getAgencyById();
      } else {
        $scope.agencySettings.LogoImageLink = null;
        $scope.agencySettings = {};
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('agentAssignmentController', ['$scope', 'agentAssignment', 'progressBar', 'ngDialog', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', 'organizations', 'members', '$q', 'orgFilterService', 'toastr', 'authService', 'clientSelectService', 'agencySelectService', 'toastFactory', '$window', function ($scope, agentAssignment, progressBar, ngDialog, uiGridConstants, commonDialog, commonDialogMessage, organizations, members, $q, orgFilterService, toastr, authService, clientSelectService, agencySelectService, toastFactory, $window) {
    //variable declaration
    var progress = progressBar.getProgressBar();
    var _addTravelAgentList = [];
    var _deleteTravelAgentList = [];
    var _unassignedSnapshot = [];
    var _assignedSnapshot = [];
    $scope.ownOrgName = authService.getLoginMember().Organization.Name;
    var storage = $window.localStorage;

    function dialogBox(dialogMessage) {
      ngDialog.open({
        template: 'templates/partials/viewErrorMsg.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.errMsg = '<p>' + dialogMessage + '</p>';
          $scope.errTitle = 'Agent Assignment Error';
        }],
        plain: true
      });
    }
    // Validate that filtered organization id is defined
    function validateOrganization() {
      var organization = clientSelectService.getSelectedClient();
      return organization.id != null && (0, _isInteger2.default)(organization.id);
    };
    // Watch orgFilterService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        clearGrids();
        setGridData();
      }
    }, true);

    function clearGrids() {
      $scope.gridUnassignedTravelAgents.data = [];
      $scope.gridUnassignedTravelAgents.totalItems = 0;
      $scope.gridAssignedTravelAgents.data = [];
      $scope.gridAssignedTravelAgents.totalItems = 0;
      $scope.unassignedGridApi.grid.selection.selectAll = false;
      $scope.assignedGridApi.grid.selection.selectAll = false;
    };

    function getTravelAgencyId(filterOrgId) {
      return organizations.getOrganizationById(filterOrgId).then(function (organization) {
        return organization.data.TravelAgencyId;
      });
    };
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }
    // Sets both grids' data
    function setGridData() {
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && valid.clientValid) {
        if (validateOrganization()) {
          progress.start();
          // Organization to assign/unassign travel agents to/from
          var selectedAgency = void 0;
          if (storage.getItem('selectedClient')) {
            selectedAgency = JSON.parse(storage.getItem('selectedAgency'));
          }
          var filterOrg = clientSelectService.getSelectedClient();
          var filterOrgId = filterOrg.id;
          $scope.filterOrgName = filterOrg.name;
          // All agent from loginMember's travel agency
          var promiseAll = members.getAllAgentsByAdmin(selectedAgency.id);
          // Travel Agent Organizations for filtered organization
          var promiseAssigned = agentAssignment.getTravelAgentOrganizationsById(filterOrgId);
          var promiseTravelAgencyId = getTravelAgencyId(filterOrgId);
          $q.all([promiseAll, promiseAssigned, promiseTravelAgencyId]).then(function (responses) {
            if (responses[0].data.length > 0) {
              var travelAgencyId = responses[2];
              // Processing
              var assignedContext = processAssignedAgents(responses[1].data);
              var unassignedContext = processUnassignedAgents(responses[0].data, assignedContext, travelAgencyId);
              // Populate grids
              clearGrids();
              $scope.gridUnassignedTravelAgents.data = unassignedContext;
              $scope.gridUnassignedTravelAgents.totalItems = unassignedContext.length;
              $scope.gridAssignedTravelAgents.data = assignedContext;
              $scope.gridAssignedTravelAgents.totalItems = assignedContext.length;
              // Save snapshots of initial grid data
              _unassignedSnapshot = $scope.gridUnassignedTravelAgents.data.slice(0);
              _assignedSnapshot = $scope.gridAssignedTravelAgents.data.slice(0);
            } else {
              toastr.warning('No content received.', 'Alert');
            }
          }, function (err) {
            dialogBox(err.statusText);
          }).finally(function () {
            progress.complete();
          });
        } else {
          $scope.filterOrgName = null;
        }
      } else if (valid.agencyValid) {
        //toastFactory.toast_info('Please select a client.');
      } else {
          //toastFactory.toast_info('Please select an agency and then client.');
        }
    };
    // Filter out assigned agents from all agents
    function processUnassignedAgents(membersInfo, assignedInfo, travelAgencyId) {
      if (!!membersInfo && !!assignedInfo) {
        // Grab MemberId's of assigned agents
        var assignedIds = _.map(assignedInfo, 'MemberId');
        return membersInfo.filter(function (member) {
          // Select members whose MemberId's are not in the assignedIds array
          return assignedIds.indexOf(member.Id) < 0 && member.OrganizationId === travelAgencyId;
        }).map(function (member) {
          return {
            MemberId: member.Id,
            MemberName: member.DisplayName,
            OrganizationId: member.OrganizationId
          };
        });
      }
    };
    // Only returns a projection
    function processAssignedAgents(assignedInfo) {
      if (!!assignedInfo) {
        return assignedInfo.map(function (travelAgent) {
          return {
            MemberId: travelAgent.Member.Id,
            MemberName: travelAgent.Member.DisplayName,
            OrganizationId: travelAgent.OrganizationId,
            TravelAgentOrganizationId: travelAgent.Id
          };
        });
      }
    };
    // addTravelAgent and deleteTravelAgent should only act as purely visual functions --
    // the values sent to server will depend on diff from snapshotted data at time of action.
    $scope.addTravelAgent = function () {

      var unassignedTravelAgents = $scope.gridUnassignedTravelAgents.data.filter(function (travelAgent) {
        return _addTravelAgentList.indexOf(travelAgent) === -1;
      });

      $scope.gridUnassignedTravelAgents.data = unassignedTravelAgents;
      $scope.gridUnassignedTravelAgents.totalItems = unassignedTravelAgents.length;

      var assignedAgents = $scope.gridAssignedTravelAgents.data.concat(_addTravelAgentList);
      $scope.gridAssignedTravelAgents.data = assignedAgents;
      $scope.gridAssignedTravelAgents.totalItems = assignedAgents.length;

      // Clear _addTravelAgentList
      _addTravelAgentList.length = 0;
      // Deselect left-side selectAll checkbox
      $scope.unassignedGridApi.grid.selection.selectAll = false;
    };
    $scope.deleteTravelAgent = function () {
      _deleteTravelAgentList.forEach(function (delAgent) {
        // Remove row from right
        $scope.gridAssignedTravelAgents.data.splice($scope.gridAssignedTravelAgents.data.indexOf(delAgent), 1);
        $scope.gridAssignedTravelAgents.totalItems--;
        // Push row to left
        $scope.gridUnassignedTravelAgents.data.push(delAgent);
        $scope.gridUnassignedTravelAgents.totalItems++;
      });
      // Clear _deleteTravelAgentList
      _deleteTravelAgentList.length = 0;
      // Deselect right-side selectAll checkbox
      $scope.assignedGridApi.grid.selection.selectAll = false;
    };
    // Send changes to API
    $scope.saveTravelAgents = function () {
      if (validateOrganization()) {
        var orgId = clientSelectService.getSelectedClient().id;
        // Check diffs against snapshots
        var toAdd = _.differenceWith($scope.gridAssignedTravelAgents.data, _assignedSnapshot, _.isEqual).map(function (travelAgent) {
          return {
            Id: 0,
            MemberId: travelAgent.MemberId,
            OrganizationId: orgId
          };
        });
        var toDelete = _.differenceWith($scope.gridUnassignedTravelAgents.data, _unassignedSnapshot, _.isEqual).map(function (travelAgent) {
          return {
            TravelAgentOrganizationId: travelAgent.TravelAgentOrganizationId
          };
        });
        var promiseAdd = agentAssignment.addTravelAgentOrganizations(toAdd).then(function (response) {
          return !!response;
        });
        var promiseDel = agentAssignment.deleteTravelAgentOrganizations(toDelete).then(function (response) {
          return !!response;
        });
        var promises = [];
        if (toAdd.length > 0) {
          promises.push(promiseAdd);
        }
        if (toDelete.length > 0) {
          promises.push(promiseDel);
        }
        if (promises.length > 0) {
          progress.start();
          $q.all(promises).then(function (responses) {
            progress.complete();
            if (responses.length === 2 && responses[0] && responses[1] || responses.length === 1 && responses[0]) {
              toastr.success('Changes were successfully made.', 'Success');
              setGridData();
            } else {
              toastr.error('An error occurred while making changes.', 'Error');
            }
          });
        } else {
          toastr.info('No changes were made.', 'Info');
        }
      }
    };
    // Resync grid data with server
    $scope.reset = function () {
      clearGrids();
      setGridData();
      _addTravelAgentList.length = 0;
      _deleteTravelAgentList.length = 0;
      if (validateOrganization()) {
        toastr.info('Grids were reset.', 'Reset');
      }
    };
    // ui-grid below        
    var columnDefs = [{
      name: 'MemberName',
      displayName: 'Travel Agent',
      visible: true,
      enableHiding: false,
      enableSorting: true,
      sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
      enableFiltering: true,
      enableColumnResizing: true,
      sort: {
        direction: uiGridConstants.ASC,
        priority: 0
      }
    }];
    var gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: false,
      paginationPageSize: 25,
      useExternalPagination: false,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: true,
      enableRowHeaderSelection: true,
      multiSelect: true,
      enableSelectionBatchEvent: true,
      columnDefs: columnDefs
    };
    /* TODO: enableFullRowSelection not working as intended -
    see https://github.com/angular-ui/ui-grid/issues/2254, https://github.com/angular-ui/ui-grid/commit/679b615bd19ff71ff1e835d7f6066e7a919f279a
    */
    // Left grid (Unassigned Agents)
    $scope.gridUnassignedTravelAgents = _.cloneDeep(gridOptions);
    $scope.gridUnassignedTravelAgents.onRegisterApi = function (gridApi) {
      $scope.unassignedGridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        if (row.isSelected) {
          _addTravelAgentList.push(row.entity);
        } else {
          _addTravelAgentList.splice(_addTravelAgentList.indexOf(row.entity), 1);
        }
      });
      // Handle mass selection events
      gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
        _addTravelAgentList = gridApi.selection.getSelectedRows();
      });
    };
    // Right grid (Assigned Agents)
    $scope.gridAssignedTravelAgents = _.cloneDeep(gridOptions);
    $scope.gridAssignedTravelAgents.onRegisterApi = function (gridApi) {
      $scope.assignedGridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        if (row.isSelected) {
          _deleteTravelAgentList.push(row.entity);
        } else {
          _deleteTravelAgentList.splice(_deleteTravelAgentList.indexOf(row.entity), 1);
        }
      });
      // Handle mass selection events
      gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
        _deleteTravelAgentList = gridApi.selection.getSelectedRows();
      });
    };
    // End ui-grid
    setGridData();
  }]);
})(angular.module('obex'));

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.service('myService', function () {}).controller('AlertController', ['$rootScope', '$scope', '$state', 'socket', 'socketLogin', 'alertService', 'smsHistory', 'socketEvent', function ($rootScope, $scope, $state, socket, socketLogin, alertService, smsHistory, socketEvent) {}]);
})(angular.module('obex'));

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('allowIntegrationsController', ['$scope', 'authService', 'agencySelectService', 'clientSelectService', '$sce', 'allowIntegrations', 'apps', '$stateParams', 'progressBar', 'ngDialog', 'uiGridConstants', '$state', function ($scope, authService, agencySelectService, clientSelectService, $sce, allowIntegrations, apps, $stateParams, progressBar, ngDialog, uiGridConstants, $state) {
    var progress = progressBar.getProgressBar();
    $scope.allowIntegration = {
      Id: 0,
      CategoryApp: null,
      OrganizationId: null,
      Allowed: false
    };
    $scope.isEdit = false;
    $scope.userRole = authService.getLoginMember().Role;
    apps.getApps().then(function (response) {
      var arr1 = response.data;
      arr1.sort(function (a, b) {
        return a.CategoryName.localeCompare(b.CategoryName);
      });
      $scope.apps = arr1;
    });

    var id = $stateParams.id;
    if (!!id) {
      allowIntegrationDetailsById(id);
    }

    $scope.clientId = clientSelectService.getSelectedClient().id;
    $scope.appId = 0;
    // Validate that filtered organization id is defined
    function validateOrganization() {
      var organization = clientSelectService.getSelectedClient();
      return organization.id != null && (0, _isInteger2.default)(organization.id);
    }

    function allowIntegrationDetailsById(id) {
      progress.start();
      allowIntegrations.getAllowIntegrationById(id).then(function (response) {
        $scope.isEdit = true;
        var AllowIntegrationContext = response.data;
        bindAllowIntegration(AllowIntegrationContext[0]);
      });
    };

    function bindAllowIntegration(AllowIntegrationContext) {
      if (!!AllowIntegrationContext) {
        $scope.appId = AllowIntegrationContext.CategoryApp;
        $scope.allowIntegration.Id = AllowIntegrationContext.Id;
        $scope.allowIntegration.OrganizationId = AllowIntegrationContext.OrganizationId;
        $scope.allowIntegration.Name = AllowIntegrationContext.Name;
        $scope.allowIntegration.Category = AllowIntegrationContext.Category;
        $scope.allowIntegration.Allowed = AllowIntegrationContext.Allowed;
      }
    };

    $scope.saveAllowIntegration = function () {
      var clientId = clientSelectService.getSelectedClient().id;
      if ($scope.allowIntegrationForm.$valid && !!clientId) {
        var allowIntegrationData = $scope.allowIntegration;
        allowIntegrationData.OrganizationId = clientId;
        allowIntegrationData.CategoryApp = $scope.appId;
        var promisePost = allowIntegrations.addAllowIntegration(allowIntegrationData);

        progress.start();
        promisePost.then(function (allowIntegrationData) {
          var dialogPost = ngDialog.open({
            template: 'templates/partials/viewSuccessMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.successMsg = "Integration added successfully.";
              $scope.strTitle = 'Add Allow Integration Success';
            }]
          });
          dialogPost.closePromise.then(function (data) {
            $scope.clearAll();
            $state.go('app.allowIntegrations');
          });
        }, function (err) {
          console.log("eeee", err);
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = err.statusText + ' ' + err.data;
                $scope.errTitle = 'Add Allow Integration Error';
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = "Please enter all required fields.";
            $scope.errTitle = 'Allow Integration Error';
          }]
        });
      }
    };
    $scope.updateAllowIntegration = function () {
      var clientId = clientSelectService.getSelectedClient().id;
      if ($scope.allowIntegrationForm.$valid && !!clientId) {
        var allowIntegrationData = $scope.allowIntegration;
        allowIntegrationData.OrganizationId = clientId;
        allowIntegrationData.CategoryApp = $scope.appId;
        progress.start();
        var promisePut = allowIntegrations.updateAllowIntegration(allowIntegrationData.Id, allowIntegrationData);
        promisePut.then(function () {
          var dialogPut = ngDialog.open({
            template: 'templates/partials/viewSuccessMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.successMsg = "Integration updated successfully.";
              $scope.strTitle = 'Update Allow Integration Success';
            }]
          });
          dialogPut.closePromise.then(function (data) {
            $state.go('app.allowIntegrations');
          });
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = err.statusText + ' ' + err.data;
                $scope.errTitle = 'Update Allow Integration Error';
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = "Please enter all required fields.";
            $scope.errTitle = 'Allow Integration Required Message';
          }]
        });
      }
    };
    $scope.clearAll = function () {
      $scope.allowIntegration = {};
      $scope.isEdit = false;
      $scope.clientId = null;
      $scope.appId = null;
      $scope.allowIntegrationForm.$setPristine();
    };

    // ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    $scope.gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: false,
      paginationPageSize: 25,
      useExternalPagination: true,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      columnDefs: [{
        name: 'Name',
        visible: true,
        enableHiding: false,
        displayName: 'Name',
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250,
        sort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }
      }, {
        name: 'Category',
        visible: true,
        displayName: 'Category',
        enableHiding: false,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Allowed',
        displayName: 'Allowed',
        visible: true,
        enableSorting: false,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        maxWidth: 250,
        enableColumnResizing: true,
        cellTemplate: ' <span ng-show="row.entity.Allowed" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.Allowed" style="padding-left: 5px;">No</span>',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: [{
            value: 'true',
            label: 'Yes'
          }, {
            value: 'false',
            label: 'No'
          }]
        }
      }],
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (!sortColumns.length) {
            paginationOptions.sort = null;
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction;
          }
        });
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          setGridData();
        });
        // Show organization details on grid row selection.
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.rowSelectingId = row.entity.Id;
          if (row.isSelected) {
            $scope.rowSelecting = true;
          } else {
            $scope.rowSelecting = false;
          }
        });
      }
    };
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }

    function setGridData() {
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && valid.clientValid) {
        var selectedClientId = clientSelectService.getSelectedClient().id;
        if (!!selectedClientId) {
          getAllowIntegrations(selectedClientId);
        }
      }
    };

    function getAllowIntegrations(clientId) {
      progress.start();
      allowIntegrations.getAllowIntegrationsByOrganizationId(clientId).then(function (response) {
        var allowIntegration = response.data;
        var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
        $scope.gridOptions.data = allowIntegration.slice(firstRow, firstRow + paginationOptions.pageSize);
        $scope.gridOptions.totalItems = allowIntegration.length;
      }).finally(function () {
        progress.complete();
      });
    }
    setGridData();

    $scope.view = function () {
      if (!!$scope.rowSelectingId) {
        allowIntegrationDetailsById($scope.rowSelectingId);
      }
      ngDialog.open({
        template: 'templates/partials/viewAllowIntegration.html',
        className: 'ngdialog-theme-plain',
        scope: $scope
      });
    };
    $scope.deleteAllowIntegration = function () {
      var confirm = ngDialog.open({
        template: 'templates/partials/viewConfirm.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.strTitle = 'Delete Allow Integration?';
          $scope.strMsg = 'Do you really want to delete this allow integration?';
        }]
      });
      confirm.closePromise.then(function (data) {
        if ($scope.rowSelectingId && data.value === 1) {
          progress.start();
          allowIntegrations.deleteAllowIntegration($scope.rowSelectingId).then(function (response) {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.successMsg = 'The allow integration has been succesfully deleted.';
                $scope.strTitle = 'Delete Allow Integration Success';
              }]
            });
            dialog.closePromise.then(function (data) {});
          }, function (err) {
            if (err.status != 401) {
              var dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = err.statusText + ' ' + err.data;
                  $scope.errTitle = 'Delete Allow Integration Error';
                }]
              });
              dialog.closePromise.then(function (data) {});
            }
          }).finally(function () {
            progress.complete();
            setGridData();
          });
        }
      });
    };
    $scope.edit = function () {
      $state.go('app.editAllowIntegration', {
        id: $scope.rowSelectingId
      });
    };
    // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        $scope.clientId = null;
        $scope.gridOptions.data = [];
        $scope.gridOptions.totalItems = 0;
        setGridData();
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('appsController', ['$scope', 'authService', '$sce', 'apps', 'categories', '$stateParams', 'progressBar', 'ngDialog', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state', function ($scope, authService, $sce, apps, categories, $stateParams, progressBar, ngDialog, uiGridConstants, commonDialog, commonDialogMessage, $state) {
    var progress = progressBar.getProgressBar();
    $scope.viewData = {};
    $scope.appDetails = {
      Id: 0,
      CategoryId: 0,
      Name: ''
    };
    $scope.isEdit = false;
    $scope.categoryId = 0;

    var id = $stateParams.id;

    categories.getCategories().then(function (arrCategories) {
      $scope.categories = arrCategories.data;
    });

    if (!!id) {
      progress.start();
      apps.getAppById(id).then(function (appDetails) {
        $scope.appDetails = appDetails.data[0];
        $scope.categoryId = $scope.appDetails.CategoryId;
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
              $scope.errTitle = 'Get App Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });

      $scope.isEdit = true;
    };

    $scope.saveApp = function () {
      if ($scope.appForm.$valid) {
        $scope.appDetails.CategoryId = $scope.categoryId;
        addApp($scope.appDetails);
      }
    };

    function addApp(appDetails) {
      apps.addApp(appDetails).then(function () {
        var dialogPost = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Add App Success';
            $scope.successMsg = 'The app has been added succesfully.';
          }]
        });
        dialogPost.closePromise.then(function (data) {
          $scope.clearAll();
          $state.go('app.apps');
        });
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
              $scope.errTitle = 'Save App Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };

    $scope.clearAll = function () {
      $scope.isEdit = false;
      $scope.isNew = false;
      $scope.appDetails = {};
      $scope.appForm.$setPristine();
    };

    $scope.updateApp = function (id) {
      if ($scope.appForm.$valid) {
        $scope.appDetails.CategoryId = $scope.categoryId;
        var appDetails = $scope.appDetails;
        putApp(appDetails);
      };
    };

    function putApp(appDetails) {
      apps.updateApp(appDetails.Id, appDetails).then(function (appDetails) {
        var dialogPost = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Update App Success';
            $scope.successMsg = 'The app has been updated succesfully';
          }]
        });
        dialogPost.closePromise.then(function (data) {
          $scope.clearAll();
          $state.go('app.apps');
        });
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'dlg-template-app',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.appError = err.statusText + ' ' + err.data;
              $scope.messageTitle = 'Update App Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    }

    //ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    $scope.gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: true,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      columnDefs: [{
        name: 'Name',
        visible: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250,
        sort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }
      }, {
        name: 'CategoryName',
        displayName: 'Category Name',
        visible: true,
        enableSorting: true,
        enableColumnResizing: true
      }],
      rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (!sortColumns.length) {
            paginationOptions.sort = null;
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction;
          }
        });
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          setGridData();
        });
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.rowSelectingId = row.entity.Id;
          if (row.isSelected) {
            $scope.rowSelecting = true;
          } else {
            $scope.rowSelecting = false;
          }
        });
      }
    };

    $scope.onDblClick = function (row) {
      $scope.rowSelectingId = row.entity.Id;
      $scope.view(row.entity);
      // Override default rowSelection action
      row.isSelected = true;
      $scope.rowSelecting = true;
    };

    function setGridData() {
      progress.start();
      apps.getApps().then(function (arrApps) {
        var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
        $scope.gridOptions.data = arrApps.data.slice(firstRow, firstRow + paginationOptions.pageSize);;
        $scope.gridOptions.totalItems = arrApps.data.length;
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
              $scope.errTitle = 'App Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };
    setGridData();
    $scope.view = function (rowEntity) {
      var selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
      if (!!selectedRow) {
        $scope.viewData.name = selectedRow.Name;
        $scope.viewData.id = selectedRow.Id;
        $scope.viewData.category = selectedRow.CategoryName;

        var view = ngDialog.open({
          template: 'templates/partials/viewApp.html',
          className: 'ngdialog-theme-plain',
          scope: $scope
        });
        view.closePromise.then(function (data) {
          $scope.viewData = {};
        });
      }
    };
    $scope.deleteApp = function () {
      var confirm = ngDialog.open({
        template: 'templates/partials/viewConfirm.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.strTitle = 'Delete App?';
          $scope.strMsg = 'Do you really want to delete this app?';
        }]
      });
      confirm.closePromise.then(function (data) {
        if ($scope.rowSelectingId && data.value === 1) {
          progress.start();
          apps.deleteApp($scope.rowSelectingId).then(function (response) {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete App Success';
                $scope.successMsg = 'The app has been succesfully deleted.';
              }]
            });
            dialog.closePromise.then(function (data) {});
          }, function (err) {
            if (err.status != 401) {
              var dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                  $scope.errTitle = 'Delete App Error';
                }]
              });
              dialog.closePromise.then(function (data) {});
            }
          }).finally(function () {
            progress.complete();
            setGridData();
          });
        }
      });
    };
    $scope.edit = function () {
      $state.go('app.editApp', {
        id: $scope.rowSelectingId
      });
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('categoriesController', ['$scope', 'authService', '$sce', 'categories', '$stateParams', 'progressBar', 'ngDialog', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state', function ($scope, authService, $sce, categories, $stateParams, progressBar, ngDialog, uiGridConstants, commonDialog, commonDialogMessage, $state) {
    var progress = progressBar.getProgressBar();
    $scope.viewData = {};
    $scope.category = {
      Id: 0,
      Name: ''
    };
    $scope.isEdit = false;

    var id = $stateParams.id;
    if (!!id) {

      progress.start();
      categories.getCategoryById(id).then(function (categoryDetails) {

        $scope.category = categoryDetails.data[0];
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
              $scope.errTitle = 'Get Category Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });

      $scope.isEdit = true;
    };

    $scope.saveCategory = function () {
      if ($scope.categoryForm.$valid) {
        addCategory($scope.category);
      }
    };

    function addCategory(category) {
      categories.addCategory(category).then(function () {
        var dialogPost = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Add Category Success';
            $scope.successMsg = 'The category has been added succesfully.';
          }]
        });
        dialogPost.closePromise.then(function (data) {
          $scope.clearAll();
          $state.go('app.categories');
        });
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
              $scope.errTitle = 'Save Category Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };

    $scope.clearAll = function () {
      $scope.isEdit = false;
      $scope.isNew = false;
      $scope.category = {};
      $scope.categoryForm.$setPristine();
    };

    $scope.updateCategory = function (id) {
      if ($scope.categoryForm.$valid) {
        var category = $scope.category;
        putCategory(category);
      };
    };

    function putCategory(category) {
      categories.updateCategory(category.Id, category).then(function (category) {
        var dialogPost = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Update Category Success';
            $scope.successMsg = 'The category has been updated succesfully.';
          }]
        });
        dialogPost.closePromise.then(function (data) {
          $scope.clearAll();
          $state.go('app.categories');
        });
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'dlg-template-category',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.categoryError = err.statusText + ' ' + err.data;
              $scope.messageTitle = 'Update Category Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    }

    //ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    $scope.gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: true,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      columnDefs: [{
        name: 'Name',
        visible: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250,
        sort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }
      }],
      rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (!sortColumns.length) {
            paginationOptions.sort = null;
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction;
          }
        });
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          setGridData();
        });
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.rowSelectingId = row.entity.Id;
          if (row.isSelected) {
            $scope.rowSelecting = true;
          } else {
            $scope.rowSelecting = false;
          }
        });
      }
    };

    $scope.onDblClick = function (row) {
      $scope.rowSelectingId = row.entity.Id;
      $scope.view(row.entity);
      // Override default rowSelection action
      row.isSelected = true;
      $scope.rowSelecting = true;
    };

    function setGridData() {
      progress.start();
      categories.getCategories().then(function (arrCategories) {
        var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
        $scope.gridOptions.data = arrCategories.data.slice(firstRow, firstRow + paginationOptions.pageSize);;
        $scope.gridOptions.totalItems = arrCategories.data.length;
      }).finally(function () {
        progress.complete();
      });
    };
    setGridData();
    $scope.view = function (rowEntity) {
      var selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
      if (!!selectedRow) {
        $scope.viewData.name = selectedRow.Name;
        $scope.viewData.id = selectedRow.Id;

        var view = ngDialog.open({
          template: 'templates/partials/viewCategory.html',
          className: 'ngdialog-theme-plain',
          scope: $scope
        });
        view.closePromise.then(function (data) {
          $scope.viewData = {};
        });
      }
    };
    $scope.deleteCategory = function () {
      var confirm = ngDialog.open({
        template: 'templates/partials/viewConfirm.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.strTitle = 'Delete Category?';
          $scope.strMsg = 'Do you really want to delete this category?';
        }]
      });
      confirm.closePromise.then(function (data) {
        if ($scope.rowSelectingId && data.value === 1) {
          progress.start();
          categories.deleteCategory($scope.rowSelectingId).then(function (response) {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete Category Success';
                $scope.successMsg = 'The category has been succesfully deleted.';
              }]
            });
            dialog.closePromise.then(function (data) {});
          }, function (err) {
            if (err.status != 401) {
              var dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                  $scope.errTitle = 'Delete Category Error';
                }]
              });
              dialog.closePromise.then(function (data) {});
            }
          }).finally(function () {
            progress.complete();
            setGridData();
          });
        }
      });
    };
    $scope.edit = function () {
      $state.go('app.editCategory', {
        id: $scope.rowSelectingId
      });
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('clientManagementController', ['$scope', 'organizations', '$stateParams', 'progressBar', 'ngDialog', 'uiGridConstants', 'commonDialogMessage', '$state', 'authService', '$q', 'fileReader', 'providers', 'clientSelectService', function ($scope, organizations, $stateParams, progressBar, ngDialog, uiGridConstants, commonDialogMessage, $state, authService, $q, fileReader, providers, clientSelectService) {
    var readyToUpload = false;
    var selectedFilename = null;
    var gridData = void 0;
    $scope.showAllClients = organizations.getShowAll();
    var progress = progressBar.getProgressBar();
    $scope.organization = {
      Name: null,
      AddressLine1: null,
      AddressLine2: null,
      City: null,
      PostalCode: null,
      Country: null,
      StateProv: null,
      IsTravelAgency: false,
      Id: 0,
      TravelAgencyId: 0,
      AllowOpenBookings: false,
      AllowFbChat: false,
      Domains: {
        Id: 0,
        OrganizationId: 0,
        Name: null
      },
      TripLinkAccounts: {
        Id: 0,
        OrganizationId: 0,
        Login: null,
        Password: null,
        ProviderId: 20,
        DataFetched: null
      },
      AcceptEmails: {
        Id: 0,
        Email: null,
        OrganizationId: 0,
        IsAdmin: false
      },
      LogoImageLink: '//:0'
    };
    $scope.isEdit = false;
    $scope.isNew = false;
    $scope.isTripLink = false;
    $scope.currentDate = new Date();
    $scope.domainList = [{
      Id: 0,
      Name: '',
      OrganizationId: 0
    }];
    $scope.tripLinkAccountList = [{
      Id: 0,
      OrganizationId: 0,
      Login: '',
      Password: '',
      ProviderId: 20,
      DataFetched: $scope.currentDate
    }];
    $scope.acceptEmailList = [{
      Id: 0,
      Email: '',
      OrganizationId: 0,
      IsAdmin: false
    }];
    $scope.travelAgencySelId = 0;
    $scope.searchClients = function () {
      organizations.setShowAll($scope.showAllClients);
      setGridData();
    };

    organizations.getCountries().then(function (responseData) {
      $scope.countryList = responseData.data;
    }, function (err) {
      ngDialog.open({
        template: 'templates/partials/viewErrorMsg.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.errMsg = '<p>' + err.statusText + '</p>';
          $scope.errTitle = 'Client Error';
        }]
      });
    });

    $scope.countryName = 'United States';
    organizations.getStates().then(function (responseData) {
      $scope.stateList = responseData.data;
    }, function (err) {
      ngDialog.open({
        template: 'templates/partials/viewErrorMsg.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.errMsg = '<p>' + err.statusText + '</p>';
          $scope.errTitle = 'Client Error';
        }]
      });
    });

    $scope.stateName = '';
    //Call this code while Edit organization
    var id = $stateParams.id;
    if (!!id) {
      getOrganizationById(id);
      $scope.isEdit = true;
    } else {
      organizations.getAgencies().then(function (response) {
        var agencies = response.data;
        $scope.travelAgencyList = agencies.map(function (organization) {
          return {
            Id: organization.Id,
            Name: organization.Name
          };
        });
      });
    }

    $scope.bookingToolList = ['None', 'Obex Form', 'Concur', 'Deem'];

    function uploadImage(img) {
      if (img != null) {
        return providers.uploadImage(img).then(function (result) {
          var cloudinaryObj = result.data;
          var public_filename = cloudinaryObj.public_id + '.' + cloudinaryObj.format; // e.g. 'filename.jpg'
          return providers.transformImage(public_filename).then(function (result) {
            return result.data;
          });
        });
      }
    };

    function deletePreviousImage(img) {
      if (img != null) {
        return providers.deleteImage(img).then(function (result) {
          return result.data;
        });
      }
    };

    // Validate trip link account , domian , accept email
    function validateEmailPass(addUpdate, addDomain, addEmail, addAccount) {
      var validateMessage = '';
      var inValidDomainList = null;
      var inValidEmailList = null;
      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var passwordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,})$/;
      var domainRegex = /(^(https?):\/\/|^)(([^\.]+)\.([^\.]+\.[^\/$]+)|([^\.]+\.[^\/$]+))\/?$/;
      // Validate domain name and email address details while save /update.
      if (addUpdate) {
        if (!$scope.domainList[0].Name && !$scope.acceptEmailList[0].Email) {
          validateMessage = 'Either one domain name or one email address must be entered.';
          return validateMessage;
        };
        // validate domain name
        inValidDomainList = $scope.domainList.filter(function (domainlist) {
          return !domainRegex.test(domainlist.Name) && !!domainlist.Name;
        });

        if (!!inValidDomainList.length) {
          validateMessage = 'Entered domain name is invalid.';
          return validateMessage;
        };
        // validate accept email list
        inValidEmailList = $scope.acceptEmailList.filter(function (emailList) {
          return !emailRegex.test(emailList.Email) && !!emailList.Email;
        });

        if (!!inValidEmailList.length) {
          validateMessage = 'Entered email address is invalid.';
          return validateMessage;
        };
      };
      // validate domain name while adding new entry
      if (addDomain) {
        inValidDomainList = $scope.domainList.filter(function (domainlist) {
          return !domainRegex.test(domainlist.Name);
        });

        if (!!inValidDomainList.length) {
          validateMessage = 'Valid domain name must be entered, before adding new entry.';
          return validateMessage;
        }
      };
      // validate email while adding new entry
      if (addEmail) {
        inValidEmailList = $scope.acceptEmailList.filter(function (emailList) {
          return !emailRegex.test(emailList.Email);
        });

        if (!!inValidEmailList.length) {
          validateMessage = 'Valid email address must be entered, before adding new entry.';
          return validateMessage;
        }
      };
      // Validate trip link account details if added any new row
      if (addAccount) {
        if ($scope.isTripLink) {
          var inValidTripEmailList = $scope.tripLinkAccountList.filter(function (tripLinkEmail) {
            return !emailRegex.test(tripLinkEmail.Login) || !passwordRegex.test(tripLinkEmail.Password);
          });

          if (!!inValidTripEmailList.length) {
            validateMessage = 'Valid trip link account details must be entered,when trip link account entry added. Password must contain minimum 8 characters, and must include 1 uppercase letter and 1 digit.';
            return validateMessage;
          };
        };
      };

      return validateMessage;
    };
    // code for upload image
    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope).then(function (result) {
        $scope.organization.LogoImageLink = result;
      });
    };

    $scope.setFile = function (event) {
      selectedFilename = event.target.files[0];
      readyToUpload = true;
      fileReader.readAsDataUrl(selectedFilename, $scope).then(function (result) {
        $scope.organization.LogoImageLink = result;
      });

      $scope.$apply();
    };

    $scope.clearFile = function () {
      readyToUpload = false;
      selectedFilename = null;
      $scope.organization.LogoImageLink = '//:0';
    };

    $scope.saveOrganization = function () {
      if ($scope.orgForm.$valid) {
        var validateEmailPassChk = validateEmailPass(true, false, false, true);
        if (!validateEmailPassChk) {
          var organization = $scope.organization;
          var domainList = $scope.domainList.filter(function (domain) {
            return !!domain.Name;
          });

          organization.Domains = !!domainList.length ? domainList : [];
          organization.Country = $scope.countryName;
          organization.StateProv = $scope.stateName;
          var acceptEmailList = $scope.acceptEmailList.filter(function (acceptEmail) {
            return !!acceptEmail.Email;
          });

          organization.AcceptEmails = !!acceptEmailList.length ? acceptEmailList : [];
          var tripLinkEmailList = $scope.tripLinkAccountList.filter(function (tripLinkEmail) {
            return !!tripLinkEmail.Login && !!tripLinkEmail.Password;
          });

          organization.BookingToolName = $scope.organization.BookingToolName === 'None' ? '' : $scope.organization.BookingToolName;

          organization.TripLinkAccounts = !!tripLinkEmailList.length && $scope.isTripLink ? tripLinkEmailList : [];
          organization.TravelAgencyId = authService.getLoginMember().Role === 2 ? authService.getLoginMember().OrganizationId : $scope.travelAgencySelId;
          if (readyToUpload) {
            // pipe raw to cloudinary, retrieve transformed cloudinary url and replace LogoImageLink
            uploadImage(selectedFilename).then(function (result) {
              if (result != null) {
                $scope.organization.LogoImageLink = result;
                addClient($scope.organization);
              }
            });
          } else {
            //$scope.organization.LogoImageLink = null;
            $scope.organization.LogoImageLink = $scope.PrevLogoImageLink;
            addClient($scope.organization);
          }
        } else {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + validateEmailPassChk + '</p>';
              $scope.errTitle = 'Client Warning';
            }]
          });
        }
      }
    };

    function addClient(client) {
      progress.start();
      organizations.addOrganization(client).then(function () {
        var dialogPost = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.successMsg = 'The Client has been added succesfully.';
            $scope.strTitle = 'Add Client Success';
          }]
        });
        dialogPost.closePromise.then(function (data) {
          $state.go('app.clientManagement');
        });
      }, function (err) {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + ': ' + err.data + '</p>';
            $scope.errTitle = 'Organization Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    }

    function getOrganizationById(id) {
      progress.start();
      var promiseClient = organizations.getOrganizationById(id);
      var promiseAgency = organizations.getAgencies();
      $q.all([promiseClient, promiseAgency]).then(function (response) {
        $scope.isEdit = true;
        $scope.isNew = false;
        $scope.message = null;
        $scope.organization = response[0].data;
        console.log('organization ', $scope.organization);
        var agencies = response[1].data;
        $scope.travelAgencyList = agencies.map(function (agency) {
          return {
            Id: agency.Id,
            Name: agency.Name
          };
        });

        $scope.domainList = !!response[0].data.Domains.length ? response[0].data.Domains : [{
          Id: 0,
          Name: '',
          OrganizationId: 0
        }];
        $scope.countryName = response[0].data.Country;
        $scope.PrevLogoImageLink = response[0].data.LogoImageLink;
        $scope.stateName = response[0].data.StateProv;
        $scope.travelAgencySelId = response[0].data.TravelAgencyId;
        $scope.acceptEmailList = !!response[0].data.AcceptEmails.length ? response[0].data.AcceptEmails : [{
          Id: 0,
          Email: '',
          OrganizationId: 0,
          IsAdmin: false
        }];
        if (!!response[0].data.TripLinkAccounts.length) {
          $scope.isTripLink = true;
          $scope.tripLinkAccountList = response[0].data.TripLinkAccounts;
        } else {
          $scope.isTripLink = false;
        }

        $scope.organization.LogoImageLink = response[0].data.LogoImageLink;
      }, function (err) {

        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Client Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    };

    $scope.updateOrganization = function () {
      if ($scope.orgForm.$valid) {
        var validateEmailPassChk = validateEmailPass(true, false, false, true);
        if (!validateEmailPassChk) {
          var organization = $scope.organization;
          var domainList = $scope.domainList.filter(function (domain) {
            return !!domain.Name;
          });

          organization.Domains = !!domainList.length ? domainList : [];
          organization.Country = $scope.countryName;
          organization.StateProv = $scope.stateName;
          var acceptEmailList = $scope.acceptEmailList.filter(function (acceptEmail) {
            return !!acceptEmail.Email;
          });

          organization.AcceptEmails = !!acceptEmailList.length ? acceptEmailList : [];
          var tripLinkEmailList = $scope.tripLinkAccountList.filter(function (tripLinkEmail) {
            return !!tripLinkEmail.Login && !!tripLinkEmail.Password;
          });

          organization.BookingToolName = $scope.organization.BookingToolName === 'None' ? '' : $scope.organization.BookingToolName;

          organization.TripLinkAccounts = !!tripLinkEmailList.length && $scope.isTripLink ? tripLinkEmailList : [];
          organization.TravelAgencyId = !organization.IsTravelAgency ? $scope.travelAgencySelId : 0;
          if (readyToUpload) {
            // pipe raw to cloudinary, retrieve transformed cloudinary url and replace LogoImageLink
            uploadImage(selectedFilename).then(function (result) {
              if (result != null) {
                if ($scope.PrevLogoImageLink !== null) {
                  var str = $scope.PrevLogoImageLink;
                  var arrResult = str.split("/");
                  var len = arrResult.length - 1;
                  str = arrResult[len];
                  var deletedFileName = str.substring(0, str.indexOf("."));
                  deletePreviousImage(deletedFileName).then(function (result) {
                    console.log(result);
                  });
                }
                $scope.organization.LogoImageLink = result;
                updateClient($scope.organization);
              }
            });
          } else {
            $scope.organization.LogoImageLink = $scope.PrevLogoImageLink;
            updateClient($scope.organization);
          }
        } else {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + validateEmailPassChk + '</p>';
              $scope.errTitle = 'Update Client Warning';
            }]
          });
        }
      }
    };

    function updateClient(client) {
      progress.start();
      organizations.updateOrganization(client.Id, client).then(function (client) {
        clientSelectService.setSelectedClient(client.config.data.Id, client.config.data.Name, client.config.data.AllowOpenBookings);
        var dialogPut = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.successMsg = 'The Client has been updated succesfully.';
            $scope.strTitle = 'Update Client Success';
          }]
        });
        dialogPut.closePromise.then(function (data) {
          $state.go('app.clientManagement');
        });
      }, function (err) {

        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + ': ' + err.data + '</p>';
            $scope.errTitle = 'Update Client Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    }
    //add new domain entry for organization
    $scope.addDomain = function () {
      var checkDomain = validateEmailPass(false, true, false, false);
      if (!checkDomain) {
        $scope.domainList.push({
          Id: 0,
          Name: '',
          OrganizationId: $scope.organization.Id
        });
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + checkDomain + '</p>';
            $scope.errTitle = 'Add Domain Warning';
          }]
        });
      }
    };
    //check duplicate domain entry for organization
    $scope.checkDuplicateDomain = function (index, domainName) {
      var domainList = $scope.domainList.filter(function (domain) {
        return domain.Name == domainName;
      });

      if (domainList.length > 1) {
        var dialogDup = ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + commonDialogMessage.duplicateDomainError + '</p>';
            $scope.errTitle = 'Domain Error';
          }]
        });
        dialogDup.closePromise.then(function (data) {
          $scope.domainList[index].Name = '';
        });
      }
    };
    //Remove domain for organization
    $scope.removeDomain = function (index, domainId) {
      if (!domainId) {
        if ($scope.domainList.length > 1) {
          $scope.domainList.splice(index, 1);
        } else {
          if (!!$scope.domainList[0].Name) {
            $scope.domainList.splice(index, 1);
            $scope.domainList.push({
              Id: 0,
              Name: '',
              OrganizationId: $scope.organization.Id
            });
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + commonDialogMessage.blankDomainError + '</p>';
                $scope.errTitle = 'Remove Domain Warning';
              }]
            });
          }
        }
      } else {
        var confirm = ngDialog.open({
          template: 'templates/partials/viewConfirm.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Delete Domain?';
            $scope.strMsg = 'Do you really want to delete this domain?';
          }]
        });
        confirm.closePromise.then(function (data) {
          if (data.value === 1) {
            if ($scope.domainList.length > 1) {
              $scope.domainList.splice(index, 1);
            } else {
              if (!!$scope.domainList[0].Name) {
                $scope.domainList.splice(index, 1);
                $scope.domainList.push({
                  Id: 0,
                  Name: '',
                  OrganizationId: $scope.organization.Id
                });
              } else {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '<p>' + commonDialogMessage.blankDomainError + '</p>';
                    $scope.errTitle = 'Remove Domain Warning';
                  }]
                });
              }
            }
          }
        });
      }
    };
    //add new trip link account entry for organization
    $scope.addAccount = function () {
      if ($scope.isTripLink) {
        var checkEmailPass = validateEmailPass(false, false, false, true);
        if (!checkEmailPass) {
          $scope.isTripLink = true;
          $scope.tripLinkAccountList.push({
            Id: 0,
            OrganizationId: $scope.organization.Id,
            Login: '',
            Password: '',
            ProviderId: 20,
            DataFetched: $scope.currentDate
          });
        } else {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + commonDialogMessage.checkEmailPassMessage + '</p>';
              $scope.errTitle = 'Add Account Warning';
            }]
          });
        }
      } else {
        $scope.isTripLink = true;
        if (!$scope.tripLinkAccountList.length) {
          $scope.tripLinkAccountList.push({
            Id: 0,
            OrganizationId: $scope.organization.Id,
            Login: '',
            Password: '',
            ProviderId: 20,
            DataFetched: $scope.currentDate
          });
        }
      }
    };
    //Remove trip link account for organization
    $scope.removeAccount = function (index, triplinkId) {
      if (!triplinkId) {
        if ($scope.tripLinkAccountList.length > 1) {
          $scope.tripLinkAccountList.splice(index, 1);
        } else {
          $scope.tripLinkAccountList.splice(index, 1);
          $scope.isTripLink = false;
        }
      } else {
        var confirm = ngDialog.open({
          template: 'templates/partials/viewConfirm.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Delete Account?';
            $scope.strMsg = 'Do you really want to delete this account?';
          }]
        });
        confirm.closePromise.then(function (data) {
          if (data.value === 1) {
            if ($scope.tripLinkAccountList.length > 1) {
              $scope.tripLinkAccountList.splice(index, 1);
            } else {
              $scope.tripLinkAccountList.splice(index, 1);
              $scope.isTripLink = false;
            }
          }
        });
      }
    };
    //chcek duplicate trip link login entry for organization
    $scope.checkDuplicatelogin = function (index, login) {
      var triplinklistData = $scope.tripLinkAccountList.filter(function (triplinklist) {
        return triplinklist.Login == login;
      });

      if (triplinklistData.length > 1) {
        var dialogDup = ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>Entered login name is duplicate in trip link account for this organization</p>';
            $scope.errTitle = 'Duplicate Login Name Error';
          }]
        });
        dialogDup.closePromise.then(function (data) {
          $scope.tripLinkAccountList[index].login = '';
        });
      }
    };
    //add new email entry for organization
    $scope.addEmail = function () {
      var checkAcceptEmail = validateEmailPass(false, false, true, false);
      if (!checkAcceptEmail) {
        $scope.acceptEmailList.push({
          Id: 0,
          Email: '',
          OrganizationId: $scope.organization.Id,
          IsAdmin: false
        });
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + checkAcceptEmail + '</p>';
            $scope.errTitle = 'Add Email Warning';
          }]
        });
      }
    };
    //check duplicate email entry for organization
    $scope.checkDuplicateEmail = function (index, email) {
      var acceptEmailData = $scope.acceptEmailList.filter(function (emaillist) {
        return emaillist.Email == email;
      });

      if (acceptEmailData.length > 1) {
        var dialogDup = ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + commonDialogMessage.orgDuplicateEmailMessage + '</p>';
            $scope.errTitle = 'Duplicate Email Error';
          }]
        });
        dialogDup.closePromise.then(function (data) {
          $scope.acceptEmailList[index].Email = '';
          $scope.acceptEmailList[index].IsAdmin = false;
        });
      }
    };
    //Remove email for organization
    $scope.removeEmail = function (index, acceptEmailId) {
      if (!acceptEmailId) {
        if ($scope.acceptEmailList.length > 1) {
          $scope.acceptEmailList.splice(index, 1);
        } else {
          if (!!$scope.acceptEmailList[0].Email) {
            $scope.acceptEmailList.splice(index, 1);
            $scope.acceptEmailList.push({
              Id: 0,
              Email: '',
              OrganizationId: $scope.organization.Id,
              IsAdmin: false
            });
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + commonDialogMessage.orgDeleteEmailMessage + '</p>';
                $scope.errTitle = 'Remove Email Warning';
              }]
            });
          }
        }
      } else {
        var confirm = ngDialog.open({
          template: 'templates/partials/viewConfirm.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Delete Accept Email?';
            $scope.strMsg = 'Do you really want to delete this accept email?';
          }]
        });
        confirm.closePromise.then(function (data) {
          if (data.value === 1) {
            if ($scope.acceptEmailList.length > 1) {
              $scope.acceptEmailList.splice(index, 1);
            } else {
              if (!!$scope.acceptEmailList[0].Email) {
                $scope.acceptEmailList.splice(index, 1);
                $scope.acceptEmailList.push({
                  Id: 0,
                  Email: '',
                  OrganizationId: $scope.organization.Id,
                  IsAdmin: false
                });
              } else {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '<p>' + commonDialogMessage.orgDeleteEmailMessage + '</p>';
                    $scope.errTitle = 'Remove Email Warning';
                  }]
                });
              }
            }
          }
        });
      }
    };
    // ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    $scope.gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: false,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      columnDefs: [{
        name: 'Name',
        displayName: 'Client Name',
        enableHiding: false,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250,
        sort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }
      }, {
        name: 'TravelAgencyName',
        displayName: 'Agency Name',
        enableSorting: false,
        maxWidth: 250,
        enableColumnResizing: true
      }, {
        name: 'AddressLine1',
        displayName: 'Address Line 1',
        visible: false,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'AddressLine2',
        displayName: 'Address Line 2',
        visible: false,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'City',
        visible: false,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'StateProv',
        displayName: 'State',
        visible: false,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'PostalCode',
        displayName: 'Postal Code',
        visible: false,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Inactive',
        displayName: 'Inactive',
        visible: false,
        enableSorting: false,
        maxWidth: 250,
        enableColumnResizing: true,
        cellTemplate: ' <span ng-show="row.entity.Inactive" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.Inactive" style="padding-left: 5px;">No</span>',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: [{
            value: 'true',
            label: 'Yes'
          }, {
            value: 'false',
            label: 'No'
          }]
        }
      }, {
        name: 'Country',
        visible: false,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'AllowOpenBookings',
        displayName: 'Allow Open Booking',
        visible: true,
        enableSorting: false,
        maxWidth: 250,
        enableColumnResizing: true,
        cellTemplate: ' <span ng-show="row.entity.AllowOpenBookings" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.AllowOpenBookings" style="padding-left: 5px;">No</span>',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: [{
            value: 'true',
            label: 'Yes'
          }, {
            value: 'false',
            label: 'No'
          }]
        }
      }, {
        name: 'AllowFbChat',
        displayName: 'Allow Fb Chat',
        visible: true,
        enableSorting: false,
        maxWidth: 250,
        enableColumnResizing: true,
        cellTemplate: ' <span ng-show="row.entity.AllowFbChat" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.AllowFbChat" style="padding-left: 5px;">No</span>',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: [{
            value: 'true',
            label: 'Yes'
          }, {
            value: 'false',
            label: 'No'
          }]
        }
      }, {
        name: 'BookingToolName',
        displayName: 'Booking Tool',
        visible: true,
        enableSorting: true
      }],
      rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (!sortColumns.length) {
            paginationOptions.sort = null;
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction;
          }
          updateGridPagination(gridData);
        });

        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.rowSelectingId = row.entity.Id;
          if (row.isSelected) {
            $scope.rowSelecting = true;
            if (row.entity.Inactive === true) {
              $scope.disabledDeleteBtn = false;
            } else {
              $scope.disabledDeleteBtn = true;
            }
          } else {
            $scope.rowSelecting = false;
            $scope.disabledDeleteBtn = false;
          }
        });

        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          updateGridPagination();
        });
      }
    };
    $scope.gridOptions.columnDefs[1].visible = authService.getLoginMember().Role === 4 ? true : false;
    $scope.onDblClick = function (row) {
      $scope.rowSelectingId = row.entity.Id;
      $scope.view();
      // Override default rowSelection action
      row.isSelected = true;
      $scope.rowSelecting = true;
    };

    function setGridData() {
      if (authService.getLoginMember().Role === 3) {
        getClientByTravelMangr();
      } else {
        progress.start();
        organizations.getClients($scope.showAllClients).then(function (response) {
          gridData = response.data;
          updateGridPagination(gridData);
        }, function (err) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Client Error';
            }]
          });
        }).finally(function () {
          progress.complete();
        });
      }
    };

    function updateGridPagination(gridData) {
      $scope.gridOptions.data = gridData;
      $scope.gridOptions.totalItems = gridData.length;
    };

    function getClientByTravelMangr() {
      progress.start();
      organizations.getOrganizations().then(function (response) {
        var clientsData = response.data;
        var clients = [];
        if ($scope.showAllClients === false) {
          clients = clientsData.filter(function (client) {
            return client.Inactive === false;
          });
        } else {
          clients = response.data;
        }
        gridData = clients;
        updateGridPagination(gridData);
      }, function (err) {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Client Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    }

    setGridData();
    $scope.view = function () {
      if (!!$scope.rowSelectingId) {
        getOrganizationById($scope.rowSelectingId);
      }

      ngDialog.open({
        template: 'templates/partials/viewClient.html',
        className: 'ngdialog-theme-plain',
        scope: $scope
      });
    };

    $scope.deleteOrganization = function () {
      var confirm = ngDialog.open({
        template: 'templates/partials/viewConfirm.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.strTitle = 'Delete Client?';
          $scope.strMsg = 'Do you really want to delete this client?';
        }]
      });
      confirm.closePromise.then(function (data) {
        if ($scope.rowSelectingId && data.value === 1) {
          progress.start();
          organizations.deleteOrganization($scope.rowSelectingId).then(function (response) {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.successMsg = 'The client has been succesfully deleted.';
                $scope.strTitle = 'Delete Client Success';
              }]
            });
            dialog.closePromise.then(function (data) {});
          }, function (err) {

            var dialog = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + '</p>';
                $scope.errTitle = 'Delete Client Error'; //PLACE HOLDER
              }]
            });
            dialog.closePromise.then(function (data) {});
          }).finally(function () {
            progress.complete();
            $scope.gridApi.core.clearAllFilters();
            setGridData();
          });
        }
      });
    };

    $scope.edit = function () {
      $state.go('app.editClient', {
        id: $scope.rowSelectingId
      });
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (module) {
  'use strict';

  module.controller('clientSettingController', ['$scope', 'progressBar', 'clientSelectService', 'agencySelectService', 'clientSettings', 'toastFactory', 'ngDialog', '$q', '$mdpTimePicker', function ($scope, progressBar, clientSelectService, agencySelectService, clientSettings, toastFactory, ngDialog, $q, $mdpTimePicker) {
    var progress = progressBar.getProgressBar();
    $scope.timeZones = {};
    $scope.agency = {};
    $scope.startBusinessHours = {};
    $scope.endBusinessHours = {};

    // List of Days
    $scope.dayList = [{
      id: 1,
      name: 'Sunday'
    }, {
      id: 2,
      name: 'Monday'
    }, {
      id: 3,
      name: 'Tuesday'
    }, {
      id: 4,
      name: 'Wednesday'
    }, {
      id: 5,
      name: 'Thursday'
    }, {
      id: 6,
      name: 'Friday'
    }, {
      id: 7,
      name: 'Saturday'
    }];

    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }

    function getOrganizationById() {
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && valid.clientValid) {
        progress.start();
        var promiseTimeZone = clientSettings.getWindowsTimeZones();
        var promiseClientSettings = clientSettings.getOrganizationById(clientSelectService.getSelectedClient().id);
        $q.all([promiseTimeZone, promiseClientSettings]).then(function (response) {
          $scope.timeZones = response[0].data;
          $scope.agency = response[1].data;
          console.log($scope.agency);

          if ($scope.agency.TravelAgencyStartRegularHours) {
            var startHourDate = $scope.agency.TravelAgencyStartRegularHours.split(':');
            var startHour = startHourDate[0];
            var startMin = startHourDate[1];
            $scope.startBusinessHours = new Date(0, 0, 0, startHour, startMin);
          } else {
            $scope.startBusinessHours = new Date(0, 0, 0, 0, 0);
          }

          if ($scope.agency.TravelAgencyEndRegularHours) {
            var endHourDate = $scope.agency.TravelAgencyEndRegularHours.split(':');
            var endHour = endHourDate[0];
            var endMin = endHourDate[1];
            $scope.endBusinessHours = new Date(0, 0, 0, endHour, endMin);
          } else {
            $scope.endBusinessHours = new Date(0, 0, 0, 0, 0);
          }
        }, function (err) {

          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Client Settings Error';
            }]
          });
        }).finally(function () {
          progress.complete();
        });
      } else if (valid.agencyValid) {
        // toastFactory.toast_info('Please select a client.');
      } else {
          // toastFactory.toast_info('Please select an agency and then client.');
        }
    };

    $scope.updateOrganization = function () {
      console.log($scope.agency);

      progress.start();
      if ($scope.startBusinessHours) {
        var startHour = $scope.startBusinessHours.getHours();
        var startMin = $scope.startBusinessHours.getMinutes();
        $scope.agency.TravelAgencyStartRegularHours = startHour + ':' + startMin;
      } else {
        $scope.agency.TravelAgencyStartRegularHours = '0:0';
      }

      if ($scope.endBusinessHours) {
        var endHour = $scope.endBusinessHours.getHours();
        var endMin = $scope.endBusinessHours.getMinutes();
        $scope.agency.TravelAgencyEndRegularHours = endHour + ':' + endMin;
      } else {
        $scope.agency.TravelAgencyEndRegularHours = '0:0';
      }

      console.log($scope.agency.TravelAgencyStartRegularHours);
      console.log($scope.agency.TravelAgencyEndRegularHours);

      clientSettings.updateOrganization($scope.agency.Id, $scope.agency).then(function (clientSetting) {
        ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Client Settings Success';
            $scope.successMsg = 'The client settings has been saved succesfully.';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    };

    getOrganizationById();

    // Watch orgFilterService for changes to getFilteredOrganization() output
    // expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {

      if (newValue !== oldValue) {
        getOrganizationById();
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (module) {
  'use strict';

  module.controller('customerAccountController', ['$scope', 'progressBar', 'clientSelectService', 'agencySelectService', 'customerAccount', 'ngDialog', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state', '$stateParams', 'toastFactory', 'authService', function ($scope, progressBar, clientSelectService, agencySelectService, customerAccount, ngDialog, uiGridConstants, commonDialog, commonDialogMessage, $state, $stateParams, toastFactory, authService) {
    var progress = progressBar.getProgressBar();
    var id = $stateParams.id;
    if (!!id) {
      getCustomerAccoutsById(id);
      $scope.isEdit = true;
    };

    function getCustomerAccoutsById(id) {
      progress.start();
      customerAccount.getCustomerAccoutsById(id).then(function (customerAccount) {
        $scope.isEdit = true;
        $scope.customerAccount = customerAccount.data;
      }, function (err) {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Get Customer Account Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    };
    // Begin ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    // ui-grid options
    $scope.gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: true,
      useExternalSorting: false,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      visible: true,
      enableColumnResizing: true,
      columnDefs: [{
        name: 'Name',
        displayName: 'Name',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Number',
        displayName: 'Number',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'IsDefaultAccount',
        visible: true,
        displayName: 'Default Account',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 450
      }],
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (!sortColumns.length) {
            paginationOptions.sort = null;
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction;
          }
        });
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          setGridData();
        });
        // Show organization details on grid row selection.
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.rowSelectingId = row.entity.Id;
          if (row.isSelected) {
            $scope.rowSelecting = true;
          } else {
            $scope.rowSelecting = false;
          }
        });
      }
    };
    $scope.edit = function () {
      $state.go('app.editCustomerAccoNum', {
        id: $scope.rowSelectingId
      });
    };
    $scope.saveCustomerAccount = function () {
      var organization = clientSelectService.getSelectedClient();
      progress.start();
      customerAccount.addCustomerAccount($scope.customerAccount, organization.id).then(function () {
        var dialogPost = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Add Customer Account Success';
            $scope.successMsg = 'The Customer Account has been added succesfully.';
          }]
        });
        dialogPost.closePromise.then(function (data) {
          $state.go('app.customerAccountNumbers');
        });
      }, function (err) {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Customer Account Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    };
    $scope.updateCustomerAccount = function (id) {
      progress.start();
      customerAccount.updateCustomerAccount($scope.customerAccount.Id, $scope.customerAccount, $scope.customerAccount.OrganizationId).then(function (organization) {
        var dialogPut = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Update Customer Account Success';
            $scope.successMsg = 'The Customer Account has been updated succesfully.';
          }]
        });
        dialogPut.closePromise.then(function (data) {
          $state.go('app.customerAccountNumbers');
        });
      }, function (err) {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Update Customer Account Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    };
    $scope.deleteCustomerAccount = function () {
      var confirm = ngDialog.open({
        template: 'templates/partials/viewConfirm.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.strTitle = 'Delete Customer Account?';
          $scope.strMsg = 'Do you really want to delete this Customer Account?';
        }]
      });
      confirm.closePromise.then(function (data) {
        if ($scope.rowSelectingId && data.value === 1) {
          progress.start();
          customerAccount.deleteCustomerAccount($scope.rowSelectingId).then(function (response) {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Customer Account Deleted Successfully';
                $scope.successMsg = 'The Customer Account has been succesfully deleted.';
              }]
            });
            dialog.closePromise.then(function (data) {});
          }, function (err) {
            if (err.status != 401) {
              var dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + '</p>';
                  $scope.errTitle = 'Delete Customer Account Error';
                }]
              });
              dialog.closePromise.then(function (data) {});
            }
          }).finally(function () {
            progress.complete();
            setGridData();
          });
        }
      });
    };
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }

    function setGridData() {
      if (authService.getLoginMember().Role === 3) {
        progress.start();
        customerAccount.getCustomerAccouts().then(function (customerAccount) {
          var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
          $scope.gridOptions.data = customerAccount.data.slice(firstRow, firstRow + paginationOptions.pageSize);;
          $scope.gridOptions.totalItems = customerAccount.data.length;
          if (!customerAccount.data.length) {
            //\\toastFactory.toast_warn(commonDialogMessage.customerAccountNoResultMessage);
          }
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + '</p>';
                $scope.errTitle = 'Customer Account Error';
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      } else {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid && valid.clientValid) {
          progress.start();
          var organization = clientSelectService.getSelectedClient();
          var organizationId = !!organization.id ? organization.id : 0;
          customerAccount.getCustomerAccountByOrgId(organizationId).then(function (customerAccount) {
            var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
            $scope.gridOptions.data = customerAccount.data.slice(firstRow, firstRow + paginationOptions.pageSize);;
            $scope.gridOptions.totalItems = customerAccount.data.length;
            if (!customerAccount.data.length) {
              //\\toastFactory.toast_warn(commonDialogMessage.customerAccountNoResultMessage);
            }
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + '</p>';
                $scope.errTitle = 'Customer Account Error';
              }]
            });
          }).finally(function () {
            progress.complete();
          });
        } else {
          if (valid.agencyValid === false) {
            //toastFactory.toast_info('Please select an agency and a client.');
          } else {
              //toastFactory.toast_info('Please select a client.');
            }
        }
      }
    };
    $scope.view = function (rowEntity) {
      var selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
      if (!!selectedRow) {
        $scope.acctName = selectedRow.Name;
        $scope.acctNumber = selectedRow.Number;
        $scope.isDefaultAccount = selectedRow.IsDefaultAccount;
        var view = ngDialog.open({
          template: 'templates/partials/viewCustomerAccoNum.html',
          className: 'ngdialog-theme-plain',
          scope: $scope
        });
        view.closePromise.then(function (data) {
          $scope.viewData = {};
        });
      }
    };

    setGridData();
    // Watch clientSelectService for changes to getFilteredOrganization() output
    // expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        $scope.gridOptions.data = [];
        $scope.gridOptions.totalItems = 0;
        setGridData();
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.controller('FooterController', ['$rootScope', '$scope', '$q', '$http', 'ngDialog', function ($rootScope, $scope, $q, $http, ngDialog) {
    var vm = this;
    $scope.version = "version";
    $scope.build = "build";

    $scope.showVersionBuild = function () {
      getBuild().then(function (response) {
        $scope.version = response.data.version;
        $scope.build = response.data.build;
        ngDialog.open({
          template: 'dlg-template-builldversion',
          className: 'ngdialog-theme-plain',
          scope: $scope
        });
      });
    };

    var getBuild = function getBuild() {
      return $http.get('/build');
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (module) {
  'use strict';

  module.controller('gdsSettingsController', ['$scope', 'progressBar', 'agencySelectService', 'gdsSettings', 'ngDialog', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state', '$stateParams', 'authService', function ($scope, progressBar, agencySelectService, gdsSettings, ngDialog, uiGridConstants, commonDialog, commonDialogMessage, $state, $stateParams, authService) {
    var progress = progressBar.getProgressBar();
    var id = $stateParams.id;

    $scope.gdsArr = [{
      id: 0,
      name: 'Sabre'
    }, {
      id: 1,
      name: 'Apollo'
    }, {
      id: 2,
      name: 'Worldspan'
    }, {
      id: 3,
      name: 'Galileo'
    }, {
      id: 4,
      name: 'Axess'
    }, {
      id: 5,
      name: 'Amadeus'
    }];
    $scope.confirmPassword = null;
    $scope.gdsSetting = {
      Id: 0,
      GDS: null,
      IPCC: null,
      OrganizationId: 0,
      Password: null,
      QueueId: null,
      QueueModifier: null,
      Username: null,
      CIDBNumber: null,
      OriginApplication: null,
      PseudoCityCode: null,
      TargetBranch: null,
      Category: null
    };

    if (!!id) {
      console.log("Id: ", id);
      getGdsSettingById(id);
      $scope.isEdit = true;
    };

    function getGdsSettingById(id) {
      progress.start();
      gdsSettings.getGdsSettingById(id).then(function (responseData) {
        console.log(responseData);
        $scope.isEdit = true;
        var gdsSetting = responseData.data;
        $scope.gdsSetting = gdsSetting;
        console.log($scope.gdsSetting, "gds setting");
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Get Gds Setting Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };
    // Begin ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    // ui-grid options
    $scope.gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: true,
      useExternalSorting: false,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      visible: true,
      enableColumnResizing: true,
      columnDefs: [{
        name: 'GDS',
        displayName: 'GDS',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250,
        cellTemplate: '<span ng-if="(row.entity.GDS==0)" style="padding: 0px 2px 2px 5px;">Sabre</span>' + '<span ng-if="(row.entity.GDS==1)" style="padding: 0px 2px 2px 5px;">Apollo</span>' + '<span ng-if="(row.entity.GDS==2)" style="padding: 0px 2px 2px 5px;">Worldspan</span>' + '<span ng-if="(row.entity.GDS==3)" style="padding: 0px 2px 2px 5px;">Galileo</span>' + '<span ng-if="(row.entity.GDS==4)" style="padding: 0px 2px 2px 5px;">Axess</span>' + '<span ng-if="(row.entity.GDS==5)" style="padding: 0px 2px 2px 5px;">Amadeus</span>'
      }, {
        name: 'IPCC',
        displayName: 'IPCC',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Username',
        displayName: 'Username',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'QueueId',
        displayName: 'Queue Id',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'QueueModifier',
        displayName: 'Queue Modifier',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'CIDBNumber',
        displayName: 'CIDB Number',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'OriginApplication',
        displayName: 'Origin Application',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'PseudoCityCode',
        displayName: 'Pseudo City Code',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'TargetBranch',
        displayName: 'Target Branch',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Category',
        displayName: 'Category',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }],
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (!sortColumns.length) {
            paginationOptions.sort = null;
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction;
          }
        });
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          setGridData();
        });
        // Show organization details on grid row selection.
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.rowSelectingId = row.entity.Id;
          if (row.isSelected) {
            $scope.rowSelecting = true;
          } else {
            $scope.rowSelecting = false;
          }
        });
      }
    };

    $scope.edit = function () {
      $state.go('app.editGdsSetting', {
        id: $scope.rowSelectingId
      });
    };

    $scope.saveGdsSetting = function () {
      var agency = agencySelectService.getSelectedAgency();
      var orgId = agency.id;
      $scope.gdsSetting.OrganizationId = orgId;
      if (!!$scope.gdsSetting.OrganizationId) {
        var passwordInvalid = !$scope.gdsSetting.Password ? true : false;
        var gdsInvalid = $scope.gdsSetting.GDS === null ? true : false;
        var userNameInvalid = !$scope.gdsSetting.Username ? true : false;
        var queueIdInvalid = !$scope.gdsSetting.QueueId ? true : false;
        var confirmPasswordInvalid = $scope.gdsSetting.Password !== $scope.confirmPassword ? true : false;
        if (gdsInvalid || userNameInvalid || passwordInvalid || queueIdInvalid || confirmPasswordInvalid) {
          var dialog = ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '';
              $scope.errTitle = 'Add GDS setting error';
              if (gdsInvalid) {
                $scope.errMsg += '<p>GDS must be entered.</p>';
              }
              if (userNameInvalid) {
                $scope.errMsg += '<p>Username must be entered.</p>';
              }
              if (passwordInvalid) {
                $scope.errMsg += '<p>Password must be entered.</p>';
              }
              if (queueIdInvalid) {
                $scope.errMsg += '<p>QueueId must be entered.</p>';
              }
              if (confirmPasswordInvalid) {
                $scope.errMsg += '<p>Password and Confirm Password do not match.</p>';
              }
            }]
          });
          dialog.closePromise.then(function (data) {});
        } else {
          progress.start();
          gdsSettings.addGdsSetting($scope.gdsSetting, orgId).then(function () {
            var dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Add GDS setting Success';
                $scope.successMsg = 'The GDS setting has been added succesfully.';
              }]
            });
            dialogPost.closePromise.then(function (data) {
              $state.go('app.gdsSettings');
            });
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                $scope.errTitle = 'GDS Setting Error';
              }]
            });
          }).finally(function () {
            progress.complete();
          });
        }
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>Please select agency</p>';
            $scope.errTitle = 'GDS Setting Error';
          }]
        });
      }
    };
    $scope.updateGdsSetting = function () {
      if (!!$scope.gdsSetting.OrganizationId) {
        var passwordInvalid = !$scope.gdsSetting.Password ? true : false;
        //need to add like this because for sabre value is 0 and if we add !$scope.gdsSetting.GDS it fails for sabre
        var gdsInvalid = $scope.gdsSetting.GDS === null ? true : false;
        var userNameInvalid = !$scope.gdsSetting.Username ? true : false;
        var queueIdInvalid = !$scope.gdsSetting.QueueId ? true : false;
        var confirmPasswordInvalid = $scope.gdsSetting.Password !== $scope.confirmPassword ? true : false;
        if (gdsInvalid || userNameInvalid || passwordInvalid || queueIdInvalid || confirmPasswordInvalid) {
          var dialog = ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '';
              $scope.errTitle = 'Edit GDS setting error';
              if (gdsInvalid) {
                $scope.errMsg += '<p>GDS must be entered.</p>';
              }
              if (userNameInvalid) {
                $scope.errMsg += '<p>Username must be entered.</p>';
              }
              if (passwordInvalid) {
                $scope.errMsg += '<p>Password must be entered.</p>';
              }
              if (queueIdInvalid) {
                $scope.errMsg += '<p>QueueId must be entered.</p>';
              }
              if (confirmPasswordInvalid) {
                $scope.errMsg += '<p>Password and Confirm Password do not match.</p>';
              }
            }]
          });
          dialog.closePromise.then(function (data) {});
        } else {
          progress.start();
          gdsSettings.updateGdsSetting($scope.gdsSetting.Id, $scope.gdsSetting).then(function (response) {
            var dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Edit GDS setting Success';
                $scope.successMsg = 'The GDS setting has been updated succesfully.';
              }]
            });
            dialogPost.closePromise.then(function (data) {
              $state.go('app.gdsSettings');
            });
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                $scope.errTitle = 'Update GDS setting Error';
              }]
            });
          }).finally(function () {
            progress.complete();
          });
        }
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>Please select an agency</p>';
            $scope.errTitle = 'GDS Setting Error';
          }]
        });
      }
    };

    $scope.deleteGdsSetting = function () {
      var confirm = ngDialog.open({
        template: 'templates/partials/viewConfirm.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.strTitle = 'Delete GDS setting?';
          $scope.strMsg = 'Do you really want to delete this GDS setting?';
        }]
      });
      confirm.closePromise.then(function (data) {
        if ($scope.rowSelectingId && data.value === 1) {
          progress.start();
          gdsSettings.deleteGdsSetting($scope.rowSelectingId).then(function (del) {
            var dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete GDS Setting Success';
                $scope.successMsg = 'Gds setting deleted successfully';
              }]
            });
            dialogPost.closePromise.then(function (data) {
              setGridData();
            });
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + '</p>';
                  $scope.errTitle = 'Delete GDS Setting Error';
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
        }
      });
    };

    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();

      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id)

      };
    }

    function setGridData() {
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid) {
        progress.start();
        var agency = agencySelectService.getSelectedAgency();
        gdsSettings.getGdsSettingsByAgencyId(agency.id).then(function (gdsSettings) {
          var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
          $scope.gridOptions.data = gdsSettings.data.slice(firstRow, firstRow + paginationOptions.pageSize);;
          $scope.gridOptions.totalItems = gdsSettings.data.length;
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                $scope.errTitle = 'GDS Setting Error';
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      }
    };

    $scope.view = function (rowEntity) {
      var selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
      if (!!selectedRow) {
        $scope.gdsSetting = selectedRow;
        $scope.gdsName = $scope.gdsArr[selectedRow.GDS].name;
        var view = ngDialog.open({
          template: 'templates/partials/viewGdsSetting.html',
          className: 'ngdialog-theme-plain',
          scope: $scope
        });
        view.closePromise.then(function (data) {
          $scope.viewData = {};
        });
      }
    };
    setGridData();
    // Watch clientSelectService for changes to getFilteredOrganization() output
    // expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return agencySelectService.getSelectedAgency();
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        $scope.gridOptions.data = [];
        $scope.gridOptions.totalItems = 0;
        setGridData();
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.controller('HistoryController', ['$scope', 'alertService', function ($scope, alert) {}]);
})(angular.module('obex'));

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.controller('LoginController', ['$scope', '$state', '$stateParams', 'ngDialog', 'authService', 'members', 'obexConstant', 'obexRoles', 'clientSelectService', 'agencySelectService', function ($scope, $state, $stateParams, ngDialog, authService, members, obexConstant, obexRoles, clientSelectService, agencySelectService) {
    $scope.user = {};
    $scope.login = function () {
      if ($scope.user.email && $scope.user.password) {
        $scope.ajaxload = true;
        var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRegex.test($scope.user.email)) {
          authService.getTokenFromCredential($scope.user.email, $scope.user.password).then(function (response) {
            authService.setToken(response.data);
            return members.gerMemberAccount($scope.user.email);
          }, function (error) {

            $scope.ajaxload = false;
            var dialog = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '';
                if (error.data.error === 'invalid_grant') {
                  $scope.errMsg += '<p>You have entered invalid login credentials.</p> <p> Please try again.</p>';
                } else if (error.data.message) {
                  $scope.errMsg += error.data.message;
                } else {
                  $scope.errMsg += '<p>Invalid email/password. Please try again.</p>';
                }
                $scope.errTitle = 'Login Error';
              }]
            });
            dialog.closePromise.then(function (data) {});
          }).then(function (response) {
            $scope.ajaxload = false;
            if (response) {
              //Account for case if previous chained promise is rejected
              if (response.status === 200) {
                var loginMember = response.data;
                if (loginMember.Role === obexRoles.roleTravelAgent) {
                  var _dialog = ngDialog.open({
                    template: "templates/partials/viewErrorMsg.html",
                    className: "ngdialog-theme-plain",
                    controller: ["$scope", function ($scope) {
                      $scope.errMsg = '<p>Please log in to the new <a href=\'' + obexConstant.urlAgentPortal + '\' target=\'_blank\'>Advisor Chat Platform</a> using the same credentials to begin chatting with travelers.</p>';
                      $scope.errTitle = "Login Error";
                    }]
                  });
                  _dialog.closePromise.then(function (data) {});
                } else if (loginMember.Role === obexRoles.roleUser) {
                  var _dialog2 = ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = '<p>You are not authorized. This is only for admin.</p>';
                      $scope.errTitle = 'Login Error';
                    }]
                  });
                  _dialog2.closePromise.then(function (data) {});
                } else {
                  var permission = obexConstant.permissions[loginMember.Role];
                  authService.setPermission(permission);
                  authService.setLoginMember(loginMember);
                  clientSelectService.clearSelectedClient();
                  agencySelectService.clearSelectedAgency();
                  $state.go('app');
                }
              } else if (response.status === 204 || response.data === '') {
                //Account exists in AAD but not in DB
                var _dialog3 = ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '<p>We are unable to fully locate your account. Please contact Obex Customer Support. </p> <p>Please try again.</p>';
                    $scope.errTitle = 'Login Error';
                  }]
                });
                _dialog3.closePromise.then(function (data) {});
              } else {
                var _dialog4 = ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '<p>' + err.statusText + '.</p> <p>Please try again.</p>';
                    $scope.errTitle = 'Login Error';
                  }]
                });
                _dialog4.closePromise.then(function (data) {});
              }
            }
          }, function (error) {
            console.log('error ', error);
          });
        } else {
          $scope.ajaxload = false;
          var dialog = ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>Please enter a valid email address.</p> <p>Ex: user@company.com</p>';
              $scope.errTitle = 'Login Error';
            }]
          });
          dialog.closePromise.then(function (data) {});
        }
      } else {
        $scope.ajaxload = false;
        var dialog = ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>Please enter both email and password.</p>';
            $scope.errTitle = 'Login Error';
          }]
        });
        dialog.closePromise.then(function (data) {});
      }
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('membersController', ['$scope', 'members', 'progressBar', 'ngDialog', 'commonDialog', 'commonDialogMessage', '$stateParams', '$state', 'uiGridConstants', 'agencySelectService', 'clientSelectService', 'toastFactory', 'authService', '$timeout', function ($scope, members, progressBar, ngDialog, commonDialog, commonDialogMessage, $stateParams, $state, uiGridConstants, agencySelectService, clientSelectService, toastFactory, authService, $timeout) {
    var progress = progressBar.getProgressBar();
    $scope.showAllAgents = members.getShowAll();
    var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var passwordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,})$/;
    $scope.validate = { //'valid', 'invalid', 'not-validated'
      emailValidity: 'not-validated',
      firstNameValidity: 'not-validated',
      lastNameValidity: 'not-validated',
      passwordValidity: 'not-validated',
      confirmValidity: 'not-validated'
    };

    var agency = agencySelectService.getSelectedAgency();

    $scope.confirmPassword = null;
    var gridData = void 0;
    $scope.member = {
      Id: 0,
      FirstName: null,
      LastName: null,
      Email: null,
      OrganizationId: 0,
      IsAdmin: false,
      AccountEnabled: false,
      DisableSMS: false,
      AllowAgentAccess: true,
      Phone: null,
      CustomerAccountNumber: null,
      Password: null,
      TripLinkEmail: null
    };
    $scope.edit = function () {
      $state.go('app.editAgent', {
        id: $scope.rowSelectingId
      });
    };
    $scope.searchAgents = function () {
      members.setShowAll($scope.showAllAgents);
      setGridData();
    };
    //Call this code while edit member
    var id = $stateParams.id;
    if (!!id) {
      getMemberById(id);
    };
    // ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    // ui-grid options
    var gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: false,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      exporterMenuPdf: false,
      exporterMenuCsv: false,
      multiSelect: false,
      columnDefs: [{
        name: 'FirstName',
        enableHiding: false,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250,
        sort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }
      }, {
        name: 'LastName',
        displayName: 'Last Name',
        enableHiding: false,
        enableFiltering: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Email',
        visible: true,
        enableHiding: true,
        enableFiltering: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Phone',
        displayName: 'Phone',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'IsAdmin',
        displayName: 'Admin Access',
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'AccountEnabled',
        displayName: 'Account Enabled',
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }],
      rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>'
    };

    $scope.gridDetails = _.cloneDeep(gridOptions);
    $scope.gridDetails.onRegisterApi = function (gridApi) {
      $scope.gridApi = gridApi;
      $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (!sortColumns.length) {
          paginationOptions.sort = null;
        } else {
          paginationOptions.sort = sortColumns[0].sort.direction;
        }
        updateGridPagination(gridData);
      });
      // Row Selection
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        $scope.rowSelectingId = row.entity.Id;
        if (row.isSelected) {
          $scope.rowSelecting = true;
          if (row.entity.AccountEnabled === 'No') {
            $scope.disabledDeleteBtn = false;
          } else {
            $scope.disabledDeleteBtn = true;
          }
        } else {
          $scope.rowSelecting = false;
          $scope.disabledDeleteBtn = false;
        }
      });
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        paginationOptions.pageNumber = newPage;
        paginationOptions.pageSize = pageSize;
        updateGridPagination(gridData);
      });
    };

    $scope.onDblClick = function (row) {
      $scope.rowSelectingId = row.entity.Id;
      $scope.view();
      // Override default rowSelection action
      row.isSelected = true;
      $scope.rowSelecting = true;
    };

    var allAgentsData = [];
    function updateGridPagination(gridData) {
      $scope.isExportData = !!gridData.length ? true : false;
      allAgentsData = gridData;
      $scope.gridDetails.data = gridData;
      $scope.gridDetails.totalItems = gridData.length;
    };

    function setGridData() {
      if (authService.getLoginMember().Role === 4) {
        getAgentsByObexAdmin();
      } else {
        getAgentsByAgencyAdmin();
      }
    };

    function getAgentsByObexAdmin() {
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid) {
        progress.start();
        members.getMembersByOrgId(agencySelectService.getSelectedAgency().id).then(function (response) {
          var agentsData = response.data;
          var agents = [];
          if ($scope.showAllAgents !== true) {
            agents = agentsData.filter(function (agent) {
              return agent.AccountEnabled;
            }).map(function (agent) {
              return {
                Id: agent.Id,
                FirstName: agent.FirstName,
                LastName: agent.LastName,
                Phone: agent.Phone,
                Email: agent.Email,
                AccountEnabled: agent.AccountEnabled ? 'Yes' : 'No',
                IsAdmin: agent.IsAdmin ? 'Yes' : 'No'
              };
            });
          } else {
            agents = agentsData.map(function (agent) {
              return {
                Id: agent.Id,
                FirstName: agent.FirstName,
                LastName: agent.LastName,
                Phone: agent.Phone,
                Email: agent.Email,
                AccountEnabled: agent.AccountEnabled ? 'Yes' : 'No',
                IsAdmin: agent.IsAdmin ? 'Yes' : 'No'
              };
            });
          }
          gridData = agents;
          updateGridPagination(gridData);
        }, function (err) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Agent Error';
            }]
          });
        }).finally(function () {
          progress.complete();
        });
      }
    };

    function getAgentsByAgencyAdmin() {
      progress.start();
      members.getMembers().then(function (response) {
        var agentsData = response.data;
        var agents = [];
        if ($scope.showAllAgents !== true) {
          agents = agentsData.filter(function (agent) {
            return agent.AccountEnabled;
          }).map(function (agent) {
            return {
              Id: agent.Id,
              FirstName: agent.FirstName,
              LastName: agent.LastName,
              Phone: agent.Phone,
              Email: agent.Email,
              AccountEnabled: agent.AccountEnabled ? 'Yes' : 'No',
              IsAdmin: agent.IsAdmin ? 'Yes' : 'No'
            };
          });
        } else {
          agents = agentsData.map(function (agent) {
            return {
              Id: agent.Id,
              FirstName: agent.FirstName,
              LastName: agent.LastName,
              Phone: agent.Phone,
              Email: agent.Email,
              AccountEnabled: agent.AccountEnabled ? 'Yes' : 'No',
              IsAdmin: agent.IsAdmin ? 'Yes' : 'No'
            };
          });
        }
        gridData = agents;
        updateGridPagination(gridData);
      }, function (err) {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Agent Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    };
    setGridData();

    function getMemberById(id) {
      progress.start();
      members.getMemberById(id).then(function (member) {
        $scope.member = member.data;
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Get Member Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };
    //update First and Last Name
    function updateName() {
      var member = $scope.member;
      members.updateName(member.Id, member).then(function (member) {
        var dialogPost = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Edit Agent Success';
            $scope.successMsg = 'The Agent has been edited succesfully.';
          }]
        });
        dialogPost.closePromise.then(function (data) {
          $state.go('app.agents');
        });
      }, function (err) {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + '</p>';
            $scope.errTitle = 'Update Agent Error';
          }]
        });
      }).finally(function () {
        progress.complete();
      });
    };
    //Enable Disable Account and Delete the account
    $scope.deleteAccount = function () {
      var confirm = ngDialog.open({
        template: 'templates/partials/viewConfirm.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.strTitle = 'Delete Agent?';
          $scope.strMsg = 'Do you really want to delete this agent?';
        }]
      });
      confirm.closePromise.then(function (data) {
        if ($scope.rowSelectingId && data.value === 1) {
          progress.start();
          members.deleteAccount($scope.rowSelectingId).then(function (del) {
            var dialogDel = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete Agent Success';
                $scope.successMsg = 'Agent deleted successfully';
              }]
            });
            dialogDel.closePromise.then(function (data) {
              $scope.gridApi.core.clearAllFilters();
              setGridData();
            });
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + '</p>';
                  $scope.errTitle = 'Delete Agent Error';
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
        }
      });
    };

    $scope.exportReport = function () {
      $scope.gridDetails.data = allAgentsData;
      $scope.gridDetails.exporterCsvFilename = agency.name + '_Agents.csv';
      $timeout(function () {
        $scope.gridApi.exporter.csvExport('all', 'all');

        updateGridPagination(allAgentsData);
      }, 100);
    };

    //Set/reset admin access to user
    function setAdmin() {
      progress.start();
      members.setAdmin($scope.member.Id, $scope.member.IsAdmin).then(function (del) {
        enableAccount();
      }, function (err) {
        progress.complete();
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
            $scope.errTitle = 'Agent Error';
          }]
        });
      });
    };
    //Enable Disable Account and Delete the account
    function enableAccount() {
      members.setEnableDisableAccount($scope.member.Id, $scope.member.AccountEnabled).then(function (del) {
        updateName();
      }, function (err) {
        progress.complete();
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
            $scope.errTitle = 'Delete Agent Error';
          }]
        });
      });
    };
    //Save function
    $scope.updateAgent = function () {
      setAdmin();
    };
    $scope.view = function (rowId) {
      var selectId = !!rowId ? rowId : $scope.rowSelectingId;
      if (selectId) {
        getMemberById(selectId);
      }
      ngDialog.open({
        template: 'templates/partials/viewAgent.html',
        className: 'ngdialog-theme-plain',
        scope: $scope
      });
    };
    $scope.saveAgent = function () {
      if (!!agencySelectService.getSelectedAgency().id) {
        var member = $scope.member;
        var isEmailValid = emailRegex.test(member.Email);
        var isPasswordValid = passwordRegex.test(member.Password);
        !isEmailValid ? $scope.validate.emailValidity = 'invalid' : $scope.validate.emailValidity = 'valid';
        !member.FirstName ? $scope.validate.firstNameValidity = 'invalid' : $scope.validate.firstNameValidity = 'valid';
        !member.LastName ? $scope.validate.lastNameValidity = 'invalid' : $scope.validate.lastNameValidity = 'valid';
        !isPasswordValid ? $scope.validate.passwordValidity = 'invalid' : $scope.validate.passwordValidity = 'valid';
        member.Password !== $scope.confirmPassword ? $scope.validate.confirmValidity = 'invalid' : $scope.validate.confirmValidity = 'valid';
        var emailInvalid = $scope.validate.emailValidity === 'invalid',
            firstNameInvalid = $scope.validate.firstNameValidity === 'invalid',
            lastNameInvalid = $scope.validate.lastNameValidity === 'invalid',
            passwordInvalid = $scope.validate.passwordValidity === 'invalid',
            confirmInvalid = $scope.validate.confirmValidity === 'invalid';
        if (emailInvalid || firstNameInvalid || lastNameInvalid || passwordInvalid || confirmInvalid) {
          $scope.ajaxload = false;
          var dialog = ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '';
              if (firstNameInvalid) {
                $scope.errMsg += '<p>First name must be entered.</p>';
              }
              if (lastNameInvalid) {
                $scope.errMsg += '<p>Last name must be entered.</p>';
              }
              if (emailInvalid) {
                $scope.errMsg += '<p>Email is invalid.</p>';
              }
              if (passwordInvalid) {
                $scope.errMsg += '<p>Password must contain minimum 8 characters, and must include at least 1 uppercase letter and 1 digit.</p>';
              }
              if (confirmInvalid) {
                $scope.errMsg += '<p>Password and Confirm Password fields do not match.</p>';
              }
              $scope.errTitle = 'Add Agent Error';
            }]
          });
          dialog.closePromise.then(function (data) {});
        } else {
          progress.start();
          member.OrganizationId = agencySelectService.getSelectedAgency().id;
          members.saveAgent(member).then(function (data) {
            var dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Add Agent Success';
                $scope.successMsg = 'The Agent has been created succesfully.';
              }]
            });
            dialogPost.closePromise.then(function (data) {
              $state.go('app.agents');
            });
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                $scope.errTitle = 'Save Agent Error';
              }]
            });
          }).finally(function () {
            progress.complete();
          });
        }
      } else {
        //toastFactory.toast_info('Please select an agency.');
      }
    };
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id)
      };
    }
    // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return agencySelectService.getSelectedAgency();
    }, function (newValue, oldValue) {
      if (authService.getLoginMember().Role === 4) {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid) {
          if (newValue !== oldValue) {
            members.setShowAll(false);
            $scope.showAllAgents = false;
            $scope.gridDetails.data = [];
            $scope.gridDetails.totalItems = 0;
            setGridData();
          }
        } else {
          if (valid.agencyValid === false) {
            $scope.gridDetails.data = [];
            $scope.gridDetails.totalItems = 0;
            //toastFactory.toast_info('Please select an agency.');
          }
        }
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.controller('myAgencyController', ['$scope', 'progressBar', 'myAgencyService', 'orgFilterService', 'organizations', 'authService', 'agencySettings', '$q', function ($scope, progressBar, myAgencyService, orgFilterService, organizations, authService, agencySettings, $q) {
    var progress = progressBar.getProgressBar();

    //executes when controller loads
    (function init() {
      getAgency();
    })();

    function getAgency() {
      $scope.agency = null;
      $scope.isNoAgency = false;
      $scope.isFiltered = true;
      progress.start();
      var promiseTimeZone = agencySettings.getWindowsTimeZones();
      var promiseAgencySettings = myAgencyService.getAgency(authService.getLoginMember().OrganizationId);
      $q.all([promiseTimeZone, promiseAgencySettings]).then(function (response) {
        $scope.timeZones = response[0].data;
        var agencyContext = response[1];
        if (!!agencyContext && !!agencyContext.TravelAgencyId) {
          $scope.isNoAgency = true;
          $scope.agency = {
            name: agencyContext.TravelAgency.Name,
            addressLine1: agencyContext.TravelAgency.AddressLine1,
            addressLine2: agencyContext.TravelAgency.AddressLine2,
            city: agencyContext.TravelAgency.City,
            stateProv: agencyContext.TravelAgency.StateProv,
            postalCode: agencyContext.TravelAgency.PostalCode,
            country: agencyContext.Country,
            phone: !!agencyContext.TravelAgencyPhone ? agencyContext.TravelAgencyPhone : agencyContext.TravelAgency.DefaultPhone,
            afterHoursPhone: !!agencyContext.TravelAgencyAfterHoursPhone ? agencyContext.TravelAgencyAfterHoursPhone : agencyContext.TravelAgency.DefaultAfterHoursPhone,
            email: !!agencyContext.TravelAgencyEmail ? agencyContext.TravelAgencyEmail : agencyContext.TravelAgency.DefaultEmail,
            webSite: agencyContext.TravelAgency.WebSite,
            logoImageLink: agencyContext.TravelAgency.LogoImageLink,
            startRegularHours: !!agencyContext.TravelAgencyStartRegularHours ? moment(agencyContext.TravelAgencyStartRegularHours, 'HH:mm').format('hh:mm a') : moment(agencyContext.TravelAgency.DefaultStartRegularHours, 'HH:mm').format('hh:mm a'),
            endRegularHours: !!agencyContext.TravelAgencyEndRegularHours ? moment(agencyContext.TravelAgencyEndRegularHours, 'HH:mm').format('hh:mm a') : moment(agencyContext.TravelAgency.DefaultEndRegularHours, 'HH:mm').format('hh:mm a'),
            windowsTimeZone: !!agencyContext.TravelAgency.TravelAgencyWindowsTimeZoneId ? agencyContext.TravelAgency.TravelAgencyWindowsTimeZoneId : agencyContext.TravelAgency.DefaultWindowsTimeZone.Id,
            serviceStartDay: !!agencyContext.TravelAgencyServiceStartDay ? agencyContext.TravelAgencyServiceStartDay : agencyContext.TravelAgency.DefaultServiceStartDay,
            serviceEndDay: !!agencyContext.TravelAgencyServiceEndDay ? agencyContext.TravelAgencyServiceEndDay : agencyContext.TravelAgency.DefaultServiceEndDay,
            internationalPhone: 'not available',
            timezone: ''
          };
        } else {
          $scope.isNoAgency = false;
          $scope.agency = null;
        }
      }).finally(function () {
        progress.complete();
      });
    }

    $scope.checkAddress = function () {
      if ($scope.agency != null) {
        var agency = $scope.agency;
        return (!!agency.addressLine1 || !!agency.addressLine2) && !!agency.city && !!agency.stateProv && !!agency.postalCode && !!agency.country;
      } else {
        return false;
      }
    };

    $scope.checkAgencyDetails = function () {
      if ($scope.agency != null) {
        var agency = $scope.agency;
        return !!agency.phone || !!agency.afterHoursPhone || !!agency.email || !!agency.webSite || !!agency.logoImageLink || !!agency.startRegularHours || !!agency.windowsTimeZone || !!agency.serviceStartDay || !!agency.serviceEndDay;
      } else {
        return false;
      }
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (module) {
  'use strict';

  module.controller('myProvidersController', ['$scope', 'organizationProviders', 'organizations', 'providers', '$stateParams', 'progressBar', 'ngDialog', 'uiGridConstants', 'commonDialogMessage', '$filter', '$q', 'clientSelectService', 'agencySelectService', 'toastr', 'orgFilterService', 'currency', 'toastFactory', 'authService', function ($scope, organizationProviders, organizations, providers, $stateParams, progressBar, ngDialog, uiGridConstants, commonDialogMessage, $filter, $q, clientSelectService, agencySelectService, toastr, orgFilterService, currency, toastFactory, authService) {

    //variable declaration
    var progress = progressBar.getProgressBar();

    var _addProviderList = [];
    var _deleteProviderList = [];
    var _unassignedProviderSnapshot = [];
    var _assignedProviderSnapshot = [];

    function dialogBox(dialogMessage, dialogType) {
      ngDialog.open({
        template: dialogMessage + dialogType,
        className: 'ngdialog-theme-plain',
        plain: true
      });
    }

    // Validate that filtered organization id is defined
    function validateOrganization() {
      var organization = clientSelectService.getSelectedClient();
      return organization.id != null && (0, _isInteger2.default)(organization.id);
    };

    // Watch orgFilterService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {

      if (newValue !== oldValue) {
        clearGrids();
        setGridData();
      }
    }, true);

    function clearGrids() {
      $scope.gridUnassignedProviders.data = [];
      $scope.gridUnassignedProviders.totalItems = 0;
      $scope.gridAssignedProviders.data = [];
      $scope.gridAssignedProviders.totalItems = 0;
      $scope.unassignedGridApi.grid.selection.selectAll = false;
      $scope.assignedGridApi.grid.selection.selectAll = false;
    };

    // function getTravelAgencyId(filterOrgId) {
    // return organizations.getOrganizationById(filterOrgId).then(function (organization) {
    //    return organization.data.TravelAgencyId;
    //  });
    //};

    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }

    // Sets both grids' data
    function setGridData() {
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && valid.clientValid) {
        if (validateOrganization()) {
          progress.start();

          // Organization to assign/unassign travel agents to/from
          var filterOrg = clientSelectService.getSelectedClient();
          var filterOrgId = filterOrg.id;
          $scope.filterOrgName = filterOrg.name;

          // All agent from loginMember's travel agency
          var promiseAll = providers.getProviders();

          // Travel Agent Organizations for filtered organization
          var promiseAssigned = organizationProviders.getOrganizationProvidersByOrganizationId(filterOrgId);
          var clientId = filterOrgId;
          $q.all([promiseAll, promiseAssigned]).then(function (responses) {
            if (responses[0].data.length > 0) {
              // const travelAgencyId = responses[2];

              // Processing
              var assignedContext = processAssignedProviders(responses[0].data, responses[1].data);
              var unassignedContext = processUnassignedProviders(responses[0].data, assignedContext, clientId);

              // Populate grids
              clearGrids();
              $scope.gridUnassignedProviders.data = unassignedContext;
              $scope.gridUnassignedProviders.totalItems = unassignedContext.length;
              $scope.gridAssignedProviders.data = assignedContext;
              $scope.gridAssignedProviders.totalItems = assignedContext.length;

              // Save snapshots of initial grid data
              _unassignedProviderSnapshot = $scope.gridUnassignedProviders.data.slice(0);
              _assignedProviderSnapshot = $scope.gridAssignedProviders.data.slice(0);
            } else {
              toastr.warning('No content received.', 'Alert');
            }
          }, function (err) {

            dialogBox(err.statusText, commonDialog.openDialog);
          }).finally(function () {
            progress.complete();
          });
        } else {
          $scope.filterOrgName = null;
        }
      } else if (valid.agencyValid) {
        //toastFactory.toast_info('Please select a client.');
      } else {
          //toastFactory.toast_info('Please select an agency and then client.');
        }
    };

    // Filter out assigned agents from all agents
    function processUnassignedProviders(allProvidersInfo, assignedProvidersInfo, clientId) {
      if (!!allProvidersInfo && !!assignedProvidersInfo) {
        // Grab MemberId's of assigned agents
        var assignedIds = _.map(assignedProvidersInfo, 'providerId');
        return allProvidersInfo.filter(function (provider) {
          // Select members whose MemberId's are not in the assignedIds array
          if (assignedIds.length === 0) {
            return allProvidersInfo;
          } else {
            return assignedIds.indexOf(provider.Id) < 0 && provider.OrganizationId === clientId;
          }
        }).map(function (provider) {
          return {
            ProviderId: provider.Id,
            ProviderName: provider.Name
          };
        });
      }
    };

    // Only returns a projection
    function processAssignedProviders(allProvidersInfo, assignedProvidersInfo) {
      if (!!allProvidersInfo && !!assignedProvidersInfo) {
        allProvidersInfo.forEach(function (allProviderObj) {
          assignedProvidersInfo.forEach(function (assignProviderObj) {
            if (allProviderObj.Id === assignProviderObj.ProviderId) {
              assignProviderObj.Name = allProviderObj.Name;
            }
          });
        });
        return assignedProvidersInfo.map(function (provider) {
          return {
            Id: provider.Id,
            ProviderId: provider.ProviderId,
            ProviderName: provider.Name,
            OrganizationId: provider.OrganizationId
          };
        });
      }
    };

    // addTravelAgent and deleteTravelAgent should only act as purely visual functions --
    // the values sent to server will depend on diff from snapshotted data at time of action.
    $scope.addProvider = function () {
      _addProviderList.forEach(function (addProvider) {
        // Remove row from left
        $scope.gridUnassignedProviders.data.splice($scope.gridUnassignedProviders.data.indexOf(addProvider), 1);
        $scope.gridUnassignedProviders.totalItems--;

        // Push row to right
        $scope.gridAssignedProviders.data.push(addProvider);
        $scope.gridAssignedProviders.totalItems++;
      });

      // Clear _addTravelAgentList
      _addProviderList.length = 0;

      // Deselect left-side selectAll checkbox
      $scope.unassignedGridApi.grid.selection.selectAll = false;
    };

    $scope.deleteProvider = function () {
      _deleteProviderList.forEach(function (delProvider) {
        // Remove row from right
        $scope.gridAssignedProviders.data.splice($scope.gridAssignedProviders.data.indexOf(delProvider), 1);
        $scope.gridAssignedProviders.totalItems--;

        // Push row to left
        $scope.gridUnassignedProviders.data.push(delProvider);
        $scope.gridUnassignedProviders.totalItems++;
      });

      // Clear _deleteTravelAgentList
      _deleteProviderList.length = 0;

      // Deselect right-side selectAll checkbox
      $scope.assignedGridApi.grid.selection.selectAll = false;
    };

    // Send changes to API
    $scope.saveProviders = function () {
      if (validateOrganization()) {
        var orgId = clientSelectService.getSelectedClient().id;

        // Check diffs against snapshots
        var toAdd = _.differenceWith($scope.gridAssignedProviders.data, _assignedProviderSnapshot, _.isEqual).map(function (provider) {
          return {
            OrganizationId: orgId,
            ProviderId: provider.ProviderId
          };
        });

        var toDelete = _.differenceWith($scope.gridUnassignedProviders.data, _unassignedProviderSnapshot, _.isEqual).map(function (provider) {
          console.log(provider);
          console.log("lolololo");
          return {
            //Id: provider.Id,
          };
        });

        var promiseAdd = organizationProviders.addOrganizationProviders(toAdd).then(function (response) {
          return !!response;
        });

        var promiseDel = organizationProviders.deleteOrganizationProvider(toDelete).then(function (response) {
          return !!response;
        });

        var promises = [];
        if (toAdd.length > 0) {
          promises.push(promiseAdd);
        }

        if (toDelete.length > 0) {
          promises.push(promiseDel);
        }

        if (promises.length > 0) {
          progress.start();
          $q.all(promises).then(function (responses) {
            progress.complete();
            if (responses.length === 2 && responses[0] && responses[1] || responses.length === 1 && responses[0]) {
              toastr.success('Changes were successfully made.', 'Success');
              setGridData();
            } else {
              toastr.error('An error occurred while making changes.', 'Error');
            }
          });
        } else {
          toastr.info('No changes were made.', 'Info');
        }
      }
    };

    // Resync grid data with server
    $scope.reset = function () {
      clearGrids();
      setGridData();
      _addProviderList.length = 0;
      _deleteProviderList.length = 0;
      if (validateOrganization()) {
        toastr.info('Grids were reset.', 'Reset');
      }
    };

    // ui-grid below        
    var columnDefs = [{
      name: 'ProviderName',
      displayName: 'Provider',
      visible: true,
      enableHiding: false,
      enableSorting: true,
      enableFiltering: true,
      enableColumnResizing: true,
      sort: {
        direction: uiGridConstants.ASC,
        priority: 0
      }
    }];
    var gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: false,
      paginationPageSize: 10,
      useExternalPagination: false,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: true,
      enableRowHeaderSelection: true,
      multiSelect: true,
      enableSelectionBatchEvent: true,
      columnDefs: columnDefs
    };
    /* TODO: enableFullRowSelection not working as intended:
    see https://github.com/angular-ui/ui-grid/issues/2254, https://github.com/angular-ui/ui-grid/commit/679b615bd19ff71ff1e835d7f6066e7a919f279a
    */

    // Left grid (Unassigned Agents)
    $scope.gridUnassignedProviders = _.cloneDeep(gridOptions);
    $scope.gridUnassignedProviders.onRegisterApi = function (gridApi) {
      $scope.unassignedGridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        if (row.isSelected) {
          _addProviderList.push(row.entity);
        } else {
          _addProviderList.splice(_addProviderList.indexOf(row.entity), 1);
        }
      });

      // Handle mass selection events
      gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
        _addProviderList = gridApi.selection.getSelectedRows();
      });
    };

    // Right grid (Assigned Agents)
    $scope.gridAssignedProviders = _.cloneDeep(gridOptions);
    $scope.gridAssignedProviders.onRegisterApi = function (gridApi) {
      $scope.assignedGridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        if (row.isSelected) {
          _deleteProviderList.push(row.entity);
        } else {
          _deleteProviderList.splice(_deleteProviderList.indexOf(row.entity), 1);
        }
      });

      // Handle mass selection events
      gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
        _deleteProviderList = gridApi.selection.getSelectedRows();
      });
    };
    // End ui-grid
    setGridData();
  }]);
})(angular.module('obex'));

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (module) {
  'use strict';

  module.controller('organizationProvidersController', ['$scope', 'organizationProviders', 'organizations', 'providers', '$stateParams', 'progressBar', 'ngDialog', 'uiGridConstants', 'commonDialogMessage', '$filter', '$q', 'clientSelectService', 'agencySelectService', 'toastr', 'orgFilterService', 'currency', 'toastFactory', 'authService', function ($scope, organizationProviders, organizations, providers, $stateParams, progressBar, ngDialog, uiGridConstants, commonDialogMessage, $filter, $q, clientSelectService, agencySelectService, toastr, orgFilterService, currency, toastFactory, authService) {
    //variable declaration
    var progress = progressBar.getProgressBar();
    var _addOrganizationProvidersList = [];
    var _deleteOrganizationProvidersList = [];
    var _unassignedProvidersSnapshot = [];
    var _assignedProvidersSnapshot = [];
    var _tempOrganizationProvidersList = [];

    function dialogBox(dialogMessage) {
      ngDialog.open({
        template: 'templates/partials/viewErrorMsg.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.errMsg = '<p>' + dialogMessage + '</p>';
          $scope.errTitle = 'Organization Provider Error';
        }]
      });
    }
    // Validate that filtered organization id is defined
    function validateOrganization() {
      var organization = clientSelectService.getSelectedClient();
      return organization.id != null && (0, _isInteger2.default)(organization.id);
    };
    // Watch orgFilterService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        clearGrids();
        setGridData();
      }
    }, true);

    function clearGrids() {
      $scope.gridUnassignedProviders.data = [];
      $scope.gridUnassignedProviders.totalItems = 0;
      $scope.gridAssignedProviders.data = [];
      $scope.gridAssignedProviders.totalItems = 0;
      $scope.unassignedGridApi.grid.selection.selectAll = false;
      $scope.assignedGridApi.grid.selection.selectAll = false;
    };
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      $scope.allowOpenBookings = false;
      if (!!client.id) {
        $scope.allowOpenBookings = client.allowOpenBookings;
      }
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }
    // Sets both grids' data
    function setGridData() {
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && valid.clientValid) {
        if (validateOrganization()) {

          progress.start();
          // Organization to assign/unassign provider to/from
          var selectedClient = clientSelectService.getSelectedClient();
          var selectedClientId = selectedClient.id;
          $scope.selectedClientName = selectedClient.name;
          // All Providers
          var promiseAllProviders = providers.getProvidersByAdmin();

          // provider for filtered organization
          var promiseAssignedProviders = organizationProviders.getOrganizationProvidersByOrganizationId(selectedClientId);
          $q.all([promiseAllProviders, promiseAssignedProviders]).then(function (responses) {
            if (responses[0].data.length > 0) {
              var assignedProvidersContext = processAssignedProviders(responses[0].data, responses[1].data);
              var unassignedProvidersContext = processUnassignedProviders(responses[0].data, assignedProvidersContext, selectedClientId);
              // Populate grids
              clearGrids();
              $scope.gridUnassignedProviders.data = unassignedProvidersContext;
              $scope.gridUnassignedProviders.totalItems = unassignedProvidersContext.length;
              $scope.gridAssignedProviders.data = assignedProvidersContext;
              $scope.gridAssignedProviders.totalItems = assignedProvidersContext.length;
              // Save snapshots of initial grid data
              _unassignedProvidersSnapshot = $scope.gridUnassignedProviders.data.slice(0);
              _assignedProvidersSnapshot = $scope.gridAssignedProviders.data.slice(0);
            } else {
              toastr.warning('No content received.', 'Alert');
            }
          }, function (err) {
            dialogBox(err.statusText);
          }).finally(function () {
            progress.complete();
          });
        } else {
          $scope.selectedClientName = null;
        }
      } else if (valid.agencyValid) {
        //toastFactory.toast_info('Please select a client.');
      } else {
          //toastFactory.toast_info('Please select an agency and then client.');
        }
    };
    // Filter out assigned providers
    function processUnassignedProviders(allProvidersInfo, assignedProvidersInfo, selectedClientId) {
      if (!!allProvidersInfo && !!assignedProvidersInfo) {
        // Grab providers of selected client
        var assignedProvidersIds = _.map(assignedProvidersInfo, 'ProviderId');
        return allProvidersInfo.filter(function (provider) {
          // Select providers not assigned to selected client            
          return assignedProvidersIds.indexOf(provider.Id) < 0;
        }).map(function (provider) {
          return {
            ProviderId: provider.Id,
            Name: provider.Name
          };
        });
      }
    };

    function processAssignedProviders(allProvidersInfo, assignedProvidersInfo) {
      if (!!allProvidersInfo && !!assignedProvidersInfo) {
        assignedProvidersInfo.map(function (assignProviderObj, index) {
          allProvidersInfo.forEach(function (allProviderObj) {
            if (allProviderObj.Id === assignProviderObj.ProviderId) {
              assignProviderObj.Name = allProviderObj.Name;
            }
          });
        });
        return assignedProvidersInfo;
      }
    };

    function setAssignedOrganizationProvidersListForGrid(DataList) {
      DataList.forEach(function (provider) {
        // Remove row from left
        $scope.gridUnassignedProviders.data.splice($scope.gridUnassignedProviders.data.indexOf(provider), 1);
        $scope.gridUnassignedProviders.totalItems--;
        // Push row to right
        $scope.gridAssignedProviders.data.push(provider);
        $scope.gridAssignedProviders.totalItems++;
      });
    }

    function showMessage(promises) {
      if (promises.length > 0) {
        progress.start();
        $q.all(promises).then(function (responses) {
          progress.complete();
          if (responses.length === 2 && responses[0] && responses[1] || responses.length === 1 && responses[0]) {
            toastr.success('Changes were successfully made.', 'Success');
            setGridData();
          } else {
            toastr.error('An error occurred while making changes.', 'Error');
          }
        });
      } else {
        toastr.info('No changes were made.', 'Info');
      }
    }
    // addOrganizationProvider and deleteProvider should only act as purely visual functions --
    // the values sent to server will depend on diff from snapshotted data at time of action.
    $scope.addOrganizationProviders = function () {
      setAssignedOrganizationProvidersListForGrid(_addOrganizationProvidersList);
      // Clear _addOrganizationProvidersList
      _addOrganizationProvidersList.length = 0;
      // Deselect left-side selectAll checkbox
      $scope.unassignedGridApi.grid.selection.selectAll = false;
    };
    $scope.deleteOrganizationProviders = function () {
      _deleteOrganizationProvidersList.forEach(function (delOrganizationProvider) {
        // Remove row from right
        $scope.gridAssignedProviders.data.splice($scope.gridAssignedProviders.data.indexOf(delOrganizationProvider), 1);
        $scope.gridAssignedProviders.totalItems--;
        // Push row to left
        $scope.gridUnassignedProviders.data.push(delOrganizationProvider);
        $scope.gridUnassignedProviders.totalItems++;
      });
      // Clear _deleteOrganizationProvidersList
      _deleteOrganizationProvidersList.length = 0;
      // Deselect right-side selectAll checkbox
      $scope.assignedGridApi.grid.selection.selectAll = false;
    };
    // Send changes to API
    $scope.saveOrganizationProviders = function () {
      if (validateOrganization()) {
        var orgId = clientSelectService.getSelectedClient().id;
        // Check diffs against snapshots
        var toAddOrganizationProviders = _.differenceWith($scope.gridAssignedProviders.data, _assignedProvidersSnapshot, _.isEqual).map(function (provider) {
          return {
            OrganizationId: orgId,
            ProviderId: provider.ProviderId
          };
        });
        _tempOrganizationProvidersList = [];
        var toDeleteOrganizationProviders = _.differenceWith($scope.gridUnassignedProviders.data, _unassignedProvidersSnapshot, _.isEqual).map(function (provider) {
          _tempOrganizationProvidersList.push(provider);
          return {
            Id: provider.Id
          };
        });
        var promiseAddOrganizationProviders = organizationProviders.addOrganizationProviders(toAddOrganizationProviders).then(function (response) {
          return !!response;
        });
        var promises = [];

        if (toDeleteOrganizationProviders.length > 0) {
          var confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Unassigned Providers?';
              $scope.strMsg = 'Do you really want to unassign these providers?';
            }]
          });
          confirm.closePromise.then(function (data) {
            if (data.value === 1) {
              var promiseDelOrganizationProviders = organizationProviders.deleteOrganizationProviders(toDeleteOrganizationProviders).then(function (response) {
                return !!response;
              });
              promises.push(promiseDelOrganizationProviders);
              var dialog = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.successMsg = 'The providers has been succesfully unassigned.';
                  $scope.strTitle = 'Unassign Providers Success';
                }]
              });
              dialog.closePromise.then(function (data) {});
            }
            if (data.value === 0) {
              setAssignedOrganizationProvidersListForGrid(_tempOrganizationProvidersList);
              _tempOrganizationProvidersList.length = 0;
              $scope.assignedGridApi.grid.selection.selectAll = false;
            }
            if (toAddOrganizationProviders.length > 0) {
              promises.push(promiseAddOrganizationProviders);
            }
            showMessage(promises);
          });
        } else {
          if (toAddOrganizationProviders.length > 0) {
            promises.push(promiseAddOrganizationProviders);
          }
          showMessage(promises);
        } //else
      }
    };
    // Resync grid data with server
    $scope.reset = function () {
      clearGrids();
      setGridData();
      _addOrganizationProvidersList.length = 0;
      _deleteOrganizationProvidersList.length = 0;
      if (validateOrganization()) {
        toastr.info('Grids were reset.', 'Reset');
      }
    };
    // ui-grid below    
    var columnDefs = [{
      name: 'Name',
      displayName: 'Provider',
      visible: true,
      enableHiding: false,
      enableSorting: true,
      sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
      enableFiltering: true,
      enableColumnResizing: true,
      sort: {
        direction: uiGridConstants.ASC,
        priority: 0
      }
    }];
    var gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: false,
      paginationPageSize: 25,
      useExternalPagination: false,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: true,
      enableRowHeaderSelection: true,
      multiSelect: true,
      enableSelectionBatchEvent: true,
      columnDefs: columnDefs
    };
    // Left grid (Unassigned Agents)
    $scope.gridUnassignedProviders = _.cloneDeep(gridOptions);
    $scope.gridUnassignedProviders.onRegisterApi = function (gridApi) {
      $scope.unassignedGridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        if (row.isSelected) {
          _addOrganizationProvidersList.push(row.entity);
        } else {
          _addOrganizationProvidersList.splice(_addOrganizationProvidersList.indexOf(row.entity), 1);
        }
      });
      // Handle mass selection events
      gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
        _addOrganizationProvidersList = gridApi.selection.getSelectedRows();
      });
    };
    // Right grid (Assigned Agents)
    $scope.gridAssignedProviders = _.cloneDeep(gridOptions);
    $scope.gridAssignedProviders.onRegisterApi = function (gridApi) {
      $scope.assignedGridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        if (row.isSelected) {
          _deleteOrganizationProvidersList.push(row.entity);
        } else {
          _deleteOrganizationProvidersList.splice(_deleteOrganizationProvidersList.indexOf(row.entity), 1);
        }
      });
      // Handle mass selection events
      gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
        _deleteOrganizationProvidersList = gridApi.selection.getSelectedRows();
      });
    };
    // End ui-grid
    setGridData();
  }]);
})(angular.module('obex'));

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(71);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;(function (module) {
  'use strict';

  module.controller('passwordController', ['$scope', '$http', '$state', 'ngDialog', 'authService', 'members', function ($scope, $http, $state, ngDialog, authService, members) {
    var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
    var passwordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,})$/;
    $scope.user = {};
    $scope.validate = {
      //'valid', 'invalid', 'not-validated'
      emailValidity: 'not-validated',
      passwordValidity: 'not-validated',
      confirmValidity: 'not-validated'

      //Change user password
    };$scope.changePassword = function () {
      var isPasswordValid = passwordRegex.test($scope.user.password);
      if (!isPasswordValid) {
        $scope.validate.passwordValidity = 'invalid';
      }

      if ($scope.user.password !== $scope.user.confirm) {
        $scope.validate.confirmValidity = 'invalid';
      }

      var passwordInvalid = $scope.validate.passwordValidity === 'invalid',
          confirmInvalid = $scope.validate.confirmValidity === 'invalid';

      if (passwordInvalid || confirmInvalid) {
        var dialog = ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '';
            if (passwordInvalid) {
              $scope.errMsg += '<p>Password must contain minimum 8 characters, and must include at least 1 uppercase letter and 1 digit.</p>';
            }
            if (confirmInvalid) {
              $scope.errMsg += '<p>Password and Confirm Password fields do not match.</p>';
            }
            $scope.errTitle = 'Error';
          }]
        });
        dialog.closePromise.then(function (data) {});
      } else {
        $scope.ajaxload = true;
        var member = authService.getLoginMember();
        member.Password = $scope.user.password;
        members.changePassword(member.Id, member).then(function (result) {
          member.Password = null;
          $scope.ajaxload = false;

          // Clean form after successful submission
          $scope.user.password = $scope.user.confirm = null;
          $scope.validate.passwordValidity = $scope.validate.confirmValidity = 'not-validated';
          var dialog = ngDialog.open({
            template: 'templates/partials/viewSuccessMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.successMsg = 'Your password was successfully changed.';
              $scope.strTitle = 'Password Changed';
            }]
          });
          dialog.closePromise.then(function (data) {});
        }, function (error) {
          member.Password = null;
          $scope.ajaxload = false;
          console.log(error);
          var dialog = ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>You have made an invalid request. Please try again.</p>';
              $scope.errTitle = 'Error';
            }]
          });
          dialog.closePromise.then(function (data) {});
        });
      }
    };

    $scope.forgot = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var isEmailValid, dialog, email, memberInfo;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isEmailValid = emailRegex.test($scope.user.email);

              if (isEmailValid) {
                _context.next = 6;
                break;
              }

              dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>Email address is invalid.</p>';
                  $scope.errTitle = 'Error';
                }]
              });

              dialog.closePromise.then(function (data) {});
              _context.next = 11;
              break;

            case 6:
              email = $scope.user.email;
              _context.next = 9;
              return $http.get('/getMemberInfo/' + email);

            case 9:
              memberInfo = _context.sent;

              if (!memberInfo.data.AllowAgentAccess && !memberInfo.data.IsAdmin) {
                $scope.ajaxload = false;
                dialog = ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '<p> You are not authorized. This is only for agents. </p>';
                    $scope.errTitle = 'Reset Password Error';
                  }]
                });

                dialog.closePromise.then(function (data) {
                  if (isMobile.any()) {
                    $state.go('closepage');
                  } else {
                    $state.go('login');
                  }
                });
              } else {
                $scope.ajaxload = true;
                authService.forgotPassword($scope.user.email).then(function (result) {
                  $scope.ajaxload = false;
                  var dialog = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.strTitle = 'Password Reset Status';
                      $scope.successMsg = result.data;
                    }]
                  });
                  dialog.closePromise.then(function (data) {
                    if (isMobile.any()) {
                      $state.go('closepage');
                    } else {
                      $state.go('login');
                    }
                  });
                }, function (error) {
                  $scope.ajaxload = false;
                  var dialog = ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = '<p> ' + error.data + '</p>';
                      $scope.errTitle = 'Reset Password Error';
                    }]
                  });
                  dialog.closePromise.then(function (data) {
                    if (isMobile.any()) {
                      $state.go('closepage');
                    } else {
                      $state.go('login');
                    }
                  });
                });
              }

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    var isMobile = {
      Android: function Android() {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function BlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function iOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function Opera() {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function Windows() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
      },
      any: function any() {
        return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
      }
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(132);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 132 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(function (module) {
  'use strict';

  module.controller('PhoneController', ['$scope', '$http', '$state', '$stateParams', 'socket', 'socketLogin', 'authService', 'conversationService', 'tripsDashBoard', 'progressBar', 'ngDialog', 'commonDialog', 'commonDialogMessage', 'currency', function ($scope, $http, $state, $stateParams, socket, socketLogin, authService, conversationService, tripsDashBoard, progressBar, ngDialog, commonDialog, commonDialogMessage, currency) {
    var progress = progressBar.getProgressBar();
    //Helper private functions
    function getFlightContext(bookingId) {
      tripsDashBoard.getFlightsDashById(bookingId).then(function (flights) {
        var contextData = flights.data;
        var statusColor = '#000000'; //black
        var flightStatus = 'scheduled';
        var dateTime = new Date();
        var arrivalTime = moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss');
        var currentDateTime = moment(dateTime).format('MM-DD-YYYY h:mm:ss');
        if (contextData.FlightStat !== null) {
          var departureTime = moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss');
          var estimatedDeparuteTime = moment(contextData.FlightStat.EstimatedDeparture).format('MM-DD-YYYY h:mm:ss');
          var estimatedArrival = moment(contextData.FlightStat.EstimatedArrival).format('MM-DD-YYYY h:mm:ss');
          statusColor = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? '#3d9400' : estimatedDeparuteTime > departureTime ? '#cc0000' : statusColor;
          flightStatus = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? 'on time' : estimatedDeparuteTime > departureTime ? 'delayed' : currentDateTime > estimatedArrival ? 'past flight' : flightStatus;
        }
        if (contextData.Cancelled === true) {
          statusColor = '#cc0000'; //red
          flightStatus = 'cancelled';
        }
        if (contextData.FlightStat === null && currentDateTime > arrivalTime) {
          flightStatus = 'past flight';
        }
        $scope.flightContext = {
          statusColor: statusColor,
          flightStatus: flightStatus,
          estimatedDeparture: contextData.FlightStat !== null && contextData.FlightStat.EstimatedDeparture !== null ? contextData.FlightStat.EstimatedDeparture : contextData.DepartureDateTime,
          estimatedArrival: contextData.FlightStat !== null && contextData.FlightStat.EstimatedArrival !== null ? contextData.FlightStat.EstimatedArrival : contextData.ArrivalDateTime,
          pnr: contextData.Pnr,
          depart: contextData.DepartureName + ' (' + contextData.DepartureAirport + ')',
          arrival: contextData.ArrivalName + ' (' + contextData.ArrivalAirport + ')',
          departureName: contextData.DepartureName,
          departureAirport: contextData.DepartureAirport,
          departureDateTime: moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss'),
          departureGate: contextData.FlightStat !== null && contextData.FlightStat.DepartureGate !== null ? contextData.FlightStat.DepartureGate : '-',
          departureTerminal: contextData.FlightStat !== null && contextData.FlightStat.DepartureTerminal !== null ? contextData.FlightStat.DepartureTerminal : '-',
          startDate: contextData.DepartureDateTime,
          endDate: contextData.ArrivalDateTime,
          arrivalName: contextData.ArrivalName,
          arrivalAirport: contextData.ArrivalAirport,
          arrivalDateTime: moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss'),
          arrivalGate: contextData.FlightStat !== null && contextData.FlightStat.ArrivalGate !== null ? contextData.FlightStat.ArrivalGate : '-',
          arrivalTerminal: contextData.FlightStat !== null && contextData.FlightStat.ArrivalTerminal !== null ? contextData.FlightStat.ArrivalTerminal : '-',
          operatingAirline: contextData.OperatingAirline,
          flightNumber: contextData.FlightNumber,
          duration: contextData.Duration,
          bookingSource: contextData.BookingSource,
          confirmation: contextData.ConfirmationNumber,
          cabin: contextData.Cabin,
          bookingClass: contextData.BookingClass,
          numberInParty: contextData.NumberInParty,
          airTravelers: contextData.AirReservation.AirTravelers,
          comment: contextData.AirReservation.Comment,
          seats: contextData.Seats,
          totalCharge: currency.getCurrencySymbol(contextData.AirReservation.CurrencyCode) + contextData.AirReservation.TotalFare,
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted ? 'Yes' : 'No',
          vendor: contextData.Vendor
        };
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Phone History Error';
            }]
          });
        }
      });
    }

    function getHotelContext(bookingId) {
      var promiseGetHotel = tripsDashBoard.getHotelsDashById(bookingId);
      promiseGetHotel.then(function (hotels) {
        console.log(hotels);
        var contextData = hotels.data;$scope.hotelContext = {
          pnr: contextData.Pnr,
          hotelName: contextData.HotelName,
          address: contextData.Address,
          checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
          checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          guestNames: contextData.GuestNames,
          numberOfRooms: contextData.NumberOfRooms,
          roomType: contextData.RoomType,
          totalCharge: contextData.Total + ' ' + (contextData.CurrencyCode === null ? '' : contextData.CurrencyCode),
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted === true ? 'Yes' : 'No'
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: '<p>' + err.statusText + '</p>' + '<div class="ngdialog-buttons">' + '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Ok' + '</button>' + '</div>',
              className: 'ngdialog-theme-plain',
              plain: true
            });
          }
        };
      });
    }

    function getCarContext(bookingId) {
      var promiseGetCar = tripsDashBoard.getCarsDashById(bookingId);
      promiseGetCar.then(function (cars) {
        console.log(cars);
        var contextData = cars.data;$scope.carContext = {
          pnr: contextData.Pnr,
          rentalCompany: contextData.RentalCompany,
          pickupDateTime: moment(contextData.PickUpDateTime).format('MM-DD-YYYY h:mm'),
          pickupLocation: contextData.PickUpLocation,
          pickupLocationIsAirport: contextData.PickUpAtAirport === true ? 'Yes' : 'No',
          pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
          pickupLocationCode: contextData.PickUpLocationCode,
          dropoffDateTime: moment(contextData.DropOffDateTime).format('MM-DD-YYYY h:mm'),
          dropoffLocation: contextData.DropOffLocation,
          dropoffLocationIsAirport: contextData.DropOffAtAirport === true ? 'Yes' : 'No',
          dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
          dropoffLocationCode: contextData.DropOffLocationCode,
          carModel: contextData.CarModel,
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          totalCharge: contextData.TotalCharge + ' ' + (contextData.CurrencyCode === null ? '' : contextData.CurrencyCode),
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted === true ? 'Yes' : 'No'
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: '<p>' + err.statusText + '</p>' + '<div class="ngdialog-buttons">' + '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Ok' + '</button>' + '</div>',
              className: 'ngdialog-theme-plain',
              plain: true
            });
          }
        };
      });
    }

    function generateFlightContext(flightContext) {
      return flightContext.map(function (contextData) {
        var statusColor = '#000000'; //black
        var flightStatus = 'scheduled';
        var currentDateTime = new Date();
        var arrivalTime = moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss');
        currentDateTime = moment(currentDateTime).format('MM-DD-YYYY h:mm:ss');
        if (contextData.FlightStat !== null) {
          var departureTime = moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss');
          var estimatedDeparuteTime = moment(contextData.FlightStat.EstimatedDeparture).format('MM-DD-YYYY h:mm:ss');
          var estimatedArrival = moment(contextData.FlightStat.EstimatedArrival).format('MM-DD-YYYY h:mm:ss');
          statusColor = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? '#3d9400' : estimatedDeparuteTime > departureTime ? '#cc0000' : statusColor;
          flightStatus = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? 'on time' : estimatedDeparuteTime > departureTime ? 'delayed' : currentDateTime > estimatedArrival ? 'past flight' : flightStatus;
        }
        if (contextData.Cancelled === true) {
          statusColor = '#cc0000'; //red
          flightStatus = 'cancelled';
        }
        if (contextData.FlightStat === null && currentDateTime > arrivalTime) {
          flightStatus = 'past flight';
        }
        return {
          statusColor: statusColor,
          flightStatus: flightStatus,
          estimatedDeparture: contextData.FlightStat !== null && contextData.FlightStat.EstimatedDeparture !== null ? contextData.FlightStat.EstimatedDeparture : contextData.DepartureDateTime,
          estimatedArrival: contextData.FlightStat !== null && contextData.FlightStat.EstimatedArrival !== null ? contextData.FlightStat.EstimatedArrival : contextData.ArrivalDateTime,
          pnr: contextData.Pnr,
          bookingTypeName: 'A',
          bookingType: 'Airline Reservation',
          depart: contextData.DepartureName + ' (' + contextData.DepartureAirport + ')',
          arrival: contextData.ArrivalName + ' (' + contextData.ArrivalAirport + ')',
          departureName: contextData.DepartureName,
          departureAirport: contextData.DepartureAirport,
          departureDateTime: moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss'),
          departureGate: contextData.FlightStat !== null && contextData.FlightStat.DepartureGate !== null ? contextData.FlightStat.DepartureGate : '-',
          departureTerminal: contextData.FlightStat !== null && contextData.FlightStat.DepartureTerminal !== null ? contextData.FlightStat.DepartureTerminal : '-',
          startDate: contextData.DepartureDateTime,
          endDate: contextData.ArrivalDateTime,
          arrivalName: contextData.ArrivalName,
          arrivalAirport: contextData.ArrivalAirport,
          arrivalDateTime: moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss'),
          arrivalGate: contextData.FlightStat !== null && contextData.FlightStat.ArrivalGate !== null ? contextData.FlightStat.ArrivalGate : '-',
          arrivalTerminal: contextData.FlightStat !== null && contextData.FlightStat.ArrivalTerminal !== null ? contextData.FlightStat.ArrivalTerminal : '-',
          operatingAirline: contextData.OperatingAirline,
          flightNumber: contextData.FlightNumber,
          duration: contextData.Duration,
          bookingSource: contextData.BookingSource,
          confirmation: contextData.ConfirmationNumber,
          cabin: contextData.Cabin,
          bookingClass: contextData.BookingClass,
          numberInParty: contextData.NumberInParty,
          airTravelers: contextData.AirReservation.AirTravelers,
          comment: contextData.AirReservation.Comment,
          seats: contextData.Seats,
          totalCharge: currency.getCurrencySymbol(contextData.AirReservation.CurrencyCode) + contextData.AirReservation.TotalFare,
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted ? 'Yes' : 'No',
          vendor: contextData.Vendor
        };
      });
    }

    function generateCarContext(carContext) {
      return carContext.map(function (contextData) {
        return {
          bookingTypeName: 'C',
          bookingType: 'Car Reservation',
          pnr: contextData.Pnr,
          startDate: contextData.PickUpDateTime,
          rentalCompany: contextData.RentalCompany,
          pickupDateTime: moment(contextData.PickUpDateTime).format('MM-DD-YYYY h:mm'),
          pickupLocation: contextData.PickUpLocation,
          pickupLocationIsAirport: contextData.PickUpAtAirport === true ? 'Yes' : 'No',
          pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
          pickupLocationCode: contextData.PickUpLocationCode,
          dropoffDateTime: moment(contextData.DropOffDateTime).format('MM-DD-YYYY h:mm'),
          dropoffLocation: contextData.DropOffLocation,
          dropoffLocationIsAirport: contextData.DropOffAtAirport === true ? 'Yes' : 'No',
          dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
          dropoffLocationCode: contextData.DropOffLocationCode,
          carModel: contextData.CarModel,
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          totalCharge: contextData.TotalCharge + ' ' + (contextData.CurrencyCode === null ? '' : contextData.CurrencyCode),
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted === true ? 'Yes' : 'No'
        };
      });
    }

    function generateHotelContext(hotelContext) {
      return hotelContext.map(function (contextData) {
        return {
          bookingTypeName: 'H',
          bookingType: 'Hotel Reservation',
          pnr: contextData.Pnr,
          startDate: contextData.CheckInDate,
          hotelName: contextData.HotelName,
          address: contextData.Address,
          checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
          checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          guestNames: contextData.GuestNames,
          numberOfRooms: contextData.NumberOfRooms,
          roomType: contextData.RoomType,
          totalCharge: contextData.Total + ' ' + (contextData.CurrencyCode === null ? '' : contextData.CurrencyCode),
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted === true ? 'Yes' : 'No'
        };
      });
    }

    function getAllContexts(bookingId) {
      $scope.contextList = [];
      var tripFlightContext = [];
      var tripCarContext = [];
      var tripHotelContext = [];
      tripsDashBoard.getTripsDashbyId(topic.bookingId).then(function (trips) {
        tripFlightContext = trips.data.Flights;
        tripCarContext = trips.data.Cars;
        tripHotelContext = trips.data.Hotels;
        var flightList = [];
        var hotelList = [];
        var carList = [];
        if (!!tripFlightContext.length) {
          flightList = generateFlightContext(tripFlightContext);
        }
        if (!!tripCarContext.length) {
          carList = generateCarContext(tripCarContext);
        }
        if (!!tripHotelContext.length) {
          hotelList = generateHotelContext(tripHotelContext);
        }
        $scope.contextList = [flightList, carList, hotelList].reduce(function (prevData, currData) {
          return prevData.concat(currData);
        }, []);
        var sortByDateAsc = function sortByDateAsc(a, b) {
          var firstStartDate = moment(a.startDate).format('MM-DD-YYYY');
          var secondStartDate = moment(b.startDate).format('MM-DD-YYYY');
          if (firstStartDate > secondStartDate) {
            return 1;
          } else if (firstStartDate < secondStartDate) {
            return -1;
          } else if (firstStartDate === secondStartDate) {
            if (a.bookingTypeName === 'A') {
              return -1;
            } else if (b.bookingTypeName === 'A') {
              return 1;
            } else if (a.bookingTypeName === 'H' && b.bookingTypeName === 'C') {
              return -1;
            } else if (a.bookingTypeName === 'C' && b.bookingTypeName === 'H') {
              return 1;
            } else {
              return 0;
            }
          }
        };
        $scope.contextList.sort(sortByDateAsc);
      });
    }
    //init of page
    console.log($stateParams); //{fromNumber: fromNumber, firstName: firstName, lastName: lastName}
    console.log($state.params); //{fromNumber:"13462764357"}
    console.log(authService.getLoginMember());
    var fromNumber = $state.params.fromNumber;
    var firstName = $state.params.travelerFirstName;
    var lastName = $state.params.travelerLastName;
    var organizationName = $state.params.travelerOrganizationName;
    var topic = $state.params.topic;
    if (fromNumber) {
      $scope.isInConversation = true;
      $scope.conversationTitle = 'Assisting ' + firstName + ' ' + lastName + ' (' + fromNumber + ')' + ' ' + organizationName;
      $scope.firstName = firstName;
      $scope.lastName = lastName;
      $scope.fromNumber = fromNumber;
      $scope.organizationName = organizationName;
      //context
      if (topic) {
        if (topic.bookingType === 'FlightViewModel') {
          $scope.bookingType = 'Airline Reservation';
          getFlightContext(topic.bookingId);
        } else if (topic.bookingType === 'HotelViewModel') {
          $scope.bookingType = 'Hotel Reservation';
          getHotelContext(topic.bookingId);
        } else if (topic.bookingType === 'CarViewModel') {
          $scope.bookingType = 'Car Reservation';
          getCarContext(topic.bookingId);
        } else if (topic.bookingType === 'TripViewModel') {
          $scope.bookingType = 'Trip';
          getAllContexts(topic.bookingId);
        }
      }
    } else {
      $scope.isInConversation = false;
      $scope.conversationTitle = 'You are not assisting';
    }
    //on socket event
    //on user's action
    $scope.finishConversation = function () {
      var confirmMessage = 'This is to confirm that you finish assisting the traveler. If so, you can click on the Yes button.  This tab will be closed and future messages from the traveler will not show up here.';
      ngDialog.openConfirm({
        template: confirmMessage + commonDialog.confirmDialog,
        className: 'ngdialog-theme-plain',
        plain: true
      }).then(function (value) {
        var loginMember = authService.getLoginMember();
        progress.start();
        $http.post('/finish', {
          fromNumber: fromNumber,
          travelAgentEmail: loginMember.Email
        });
        $state.go('app', {}, {
          reload: true
        });
        progress.complete();
      });
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__(92);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;(function (module) {
  'use strict';

  module.controller('phoneHistoryController', ['$scope', 'progressBar', 'ngDialog', 'historyPhone', 'members', '$filter', 'tripsDashBoard', 'commonDialogMessage', 'toastr', 'currency', 'uiGridConstants', 'clientSelectService', 'agencySelectService', 'toastFactory', 'authService', '$timeout', function ($scope, progressBar, ngDialog, historyPhone, members, $filter, tripsDashBoard, commonDialogMessage, toastr, currency, uiGridConstants, clientSelectService, agencySelectService, toastFactory, authService, $timeout) {
    var progress = progressBar.getProgressBar();
    var gridData = [];
    $scope.dateFrom = new Date();
    $scope.dateTo = addMonth($scope.dateFrom);
    var memberId = null;
    var memberIds = [];
    var priorityData = ['Low', 'Medium', 'High', 'Critical'];

    function addMonth(startDate) {
      // Does not handle end-of-month edge case, e.g. Oct 31 + 1 month = Dec 01
      return new Date(new Date(startDate).setMonth(startDate.getMonth() + 1));
    }
    // Validate that filtered organization id is defined
    function validateOrganization() {
      var organization = clientSelectService.getSelectedClient();
      return organization.id != null && (0, _isInteger2.default)(organization.id);
    }
    //to set travelerName autoSearch data
    function getTravelers() {
      $scope.dataSource = [];
      if (authService.getLoginMember().Role === 3) {
        members.getMembers().then(function (response) {
          var memberInfo = response.data;
          $scope.dataSource = memberInfo.map(function (member) {
            return {
              name: member.FirstName + '' + member.LastName,
              id: member.Id
            };
          });
          memberIds = _.map($scope.dataSource, 'id');
        });
      } else {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid && valid.clientValid) {
          var organization = clientSelectService.getSelectedClient();
          members.getMembersByOrgId(organization.id).then(function (response) {
            var memberInfo = response.data;
            $scope.dataSource = memberInfo.map(function (member) {
              return {
                name: member.FirstName + '' + member.LastName,
                id: member.Id
              };
            });
            memberIds = _.map($scope.dataSource, 'id');
          });
        } else if (valid.agencyValid) {
          //toastFactory.toast_info('Please select a client.');
        } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
      }
    }
    getTravelers();

    function getFlightContext(bookingId) {
      tripsDashBoard.getFlightsDashById(bookingId).then(function (flights) {
        var contextData = flights.data;
        var statusColor = '#000000'; //black
        var flightStatus = 'scheduled';
        var dateTime = new Date();
        var arrivalTime = moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss');
        var currentDateTime = moment(dateTime).format('MM-DD-YYYY h:mm:ss');
        if (contextData.FlightStat !== null) {
          var departureTime = moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss');
          var estimatedDeparuteTime = moment(contextData.FlightStat.EstimatedDeparture).format('MM-DD-YYYY h:mm:ss');
          var estimatedArrival = moment(contextData.FlightStat.EstimatedArrival).format('MM-DD-YYYY h:mm:ss');
          statusColor = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? '#3d9400' : estimatedDeparuteTime > departureTime ? '#cc0000' : statusColor;
          flightStatus = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? 'on time' : estimatedDeparuteTime > departureTime ? 'delayed' : currentDateTime > estimatedArrival ? 'past flight' : flightStatus;
        }
        if (contextData.Cancelled === true) {
          statusColor = '#cc0000'; //red
          flightStatus = 'cancelled';
        }
        if (contextData.FlightStat === null && currentDateTime > arrivalTime) {
          flightStatus = 'past flight';
        }
        $scope.flightContext = {
          statusColor: statusColor,
          flightStatus: flightStatus,
          estimatedDeparture: contextData.FlightStat !== null && contextData.FlightStat.EstimatedDeparture !== null ? contextData.FlightStat.EstimatedDeparture : contextData.DepartureDateTime,
          estimatedArrival: contextData.FlightStat !== null && contextData.FlightStat.EstimatedArrival !== null ? contextData.FlightStat.EstimatedArrival : contextData.ArrivalDateTime,
          pnr: contextData.Pnr,
          depart: contextData.DepartureName + ' (' + contextData.DepartureAirport + ')',
          arrival: contextData.ArrivalName + ' (' + contextData.ArrivalAirport + ')',
          departureName: contextData.DepartureName,
          departureAirport: contextData.DepartureAirport,
          departureDateTime: moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss'),
          departureGate: contextData.FlightStat !== null && contextData.FlightStat.DepartureGate !== null ? contextData.FlightStat.DepartureGate : '-',
          departureTerminal: contextData.FlightStat !== null && contextData.FlightStat.DepartureTerminal !== null ? contextData.FlightStat.DepartureTerminal : '-',
          startDate: contextData.DepartureDateTime,
          endDate: contextData.ArrivalDateTime,
          arrivalName: contextData.ArrivalName,
          arrivalAirport: contextData.ArrivalAirport,
          arrivalDateTime: moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss'),
          arrivalGate: contextData.FlightStat !== null && contextData.FlightStat.ArrivalGate !== null ? contextData.FlightStat.ArrivalGate : '-',
          arrivalTerminal: contextData.FlightStat !== null && contextData.FlightStat.ArrivalTerminal !== null ? contextData.FlightStat.ArrivalTerminal : '-',
          operatingAirline: contextData.OperatingAirline,
          flightNumber: contextData.FlightNumber,
          duration: contextData.Duration,
          bookingSource: contextData.BookingSource,
          confirmation: contextData.ConfirmationNumber,
          cabin: contextData.Cabin,
          bookingClass: contextData.BookingClass,
          numberInParty: contextData.NumberInParty,
          airTravelers: contextData.AirReservation.AirTravelers,
          comment: contextData.AirReservation.Comment,
          seats: contextData.Seats,
          totalCharge: currency.getCurrencySymbol(contextData.AirReservation.CurrencyCode) + contextData.AirReservation.TotalFare,
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted ? 'Yes' : 'No',
          vendor: contextData.Vendor
        };
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Phone History Error';
            }]
          });
        }
      });
    }

    function getHotelContext(bookingId) {
      tripsDashBoard.getHotelsDashById(bookingId).then(function (hotels) {
        var contextData = hotels.data;$scope.hotelContext = {
          pnr: contextData.Pnr,
          hotelName: contextData.HotelName,
          address: contextData.Address,
          checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
          checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          guestNames: contextData.GuestNames,
          numberOfRooms: contextData.NumberOfRooms,
          roomType: contextData.RoomType,
          totalCharge: currency.getCurrencySymbol(contextData.CurrencyCode === null ? '' : contextData.CurrencyCode) + contextData.Total,
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted ? 'Yes' : 'No'
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'dlg-template-phoneHistory',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.phoneHistoryError = err.statusText;
                $scope.additionalInfo = ''; //PLACE HOLDER
                $scope.messageTitle = 'Phone History Error';
              }]
            });
          }
        };
      });
    }

    function getCarContext(bookingId) {
      tripsDashBoard.getCarsDashById(bookingId).then(function (cars) {
        var contextData = cars.data;$scope.carContext = {
          pnr: contextData.Pnr,
          rentalCompany: contextData.RentalCompany,
          pickupDateTime: moment(contextData.PickUpDateTime).format('MM-DD-YYYY h:mm:ss'),
          pickupLocation: contextData.PickUpLocation,
          pickupLocationIsAirport: contextData.PickUpAtAirport === true ? 'Yes' : 'No',
          pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
          pickupLocationCode: contextData.PickUpLocationCode,
          dropoffDateTime: moment(contextData.DropOffDateTime).format('MM-DD-YYYY h:mm:ss'),
          dropoffLocation: contextData.DropOffLocation,
          dropoffLocationIsAirport: contextData.DropOffAtAirport === true ? 'Yes' : 'No',
          dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
          dropoffLocationCode: contextData.DropOffLocationCode,
          carModel: contextData.CarModel,
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          totalCharge: currency.getCurrencySymbol(contextData.CurrencyCode) + contextData.TotalCharge,
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted ? 'Yes' : 'No'
        }, function (err) {
          ngDialog.open({
            template: 'dlg-template-phoneHistory',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.phoneHistoryError = err.statusText;
              $scope.additionalInfo = ''; //PLACE HOLDER
              $scope.messageTitle = 'Phone History Error';
            }]
          });
        };
      });
    }
    // ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    $scope.gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: true,
      useExternalSorting: false,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      enableColumnResizing: true,
      columnDefs: [{
        name: 'Member.DisplayName',
        displayName: 'Traveler',
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250,
        sort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }
      }, {
        name: 'Member.Organization.Name',
        displayName: 'Company',
        visible: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'FromPhoneNumber',
        displayName: 'Traveler Number',
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, (0, _defineProperty3.default)({
        name: 'TimeOfCall',
        displayName: 'Incoming',
        visible: true,
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.getLocalTimeZone(row.entity.TimeOfCall)}}</div>',
        maxWidth: 250,
        enableColumnResizing: true
      }, 'maxWidth', 250), {
        name: 'TimeTurnedOverToAgentSystem',
        displayName: 'Received',
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        cellClass: 'grid-align',
        cellFilter: "date:'MM-dd-yyyy h:mm a'",
        maxWidth: 250,
        enableColumnResizing: true
      }, {
        name: 'Success',
        displayName: 'Success',
        visible: false,
        enableSorting: false,
        maxWidth: 250,
        enableColumnResizing: true,
        cellTemplate: ' <span ng-show="row.entity.Success" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.Success" style="padding-left: 5px;">No</span>',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: [{
            value: 'true',
            label: 'Yes'
          }, {
            value: 'false',
            label: 'No'
          }]
        }
      }, {
        name: 'PriorityName',
        displayName: 'Priority',
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        cellClass: 'grid-align',
        maxWidth: 250,
        enableColumnResizing: true
      }],
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (!sortColumns.length) {
            paginationOptions.sort = null;
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction;
          }
          updateGridPagination(gridData);
        });
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          updateGridPagination(gridData);
        });
        // Show trip booking details on grid row selection.
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.TripContext = false;
          if (!!row.entity.CarId) {
            $scope.bookingType = 'Car Reservation';
            getCarContext(row.entity.CarId); //show booking details for Car
            getCarDetails(row.entity.CarId, row.entity.Member.DisplayName); //Get details for car
          } else if (!!row.entity.FlightId) {
            $scope.bookingType = 'Airline Reservation';
            getFlightContext(row.entity.FlightId); //show booking details for Flight
            getFlightDetails(row.entity.FlightId, row.entity.Member.DisplayName); //Get details for flight
          } else if (!!row.entity.HotelId) {
            $scope.bookingType = 'Hotel Reservation';
            getHotelContext(row.entity.HotelId); //show booking details for Hotel
            getHotelDetails(row.entity.HotelId, row.entity.Member.DisplayName); //Get details for hotel
          }
          if (!!row.entity.TripId) {
            $scope.TripContext = true;
            $scope.contextList = [];
            var tripFlightContext = [];
            var tripCarContext = [];
            var tripHotelContext = [];
            tripsDashBoard.getTripsDashbyId(row.entity.TripId).then(function (trips) {
              tripFlightContext = trips.data.Flights;
              tripCarContext = trips.data.Cars;
              tripHotelContext = trips.data.Hotels;
              var flightList = [];
              var hotelList = [];
              var carList = [];
              if (!!tripFlightContext.length) {
                flightList = generateFlightContext(tripFlightContext);
              }
              if (!!tripCarContext.length) {
                carList = generateCarContext(tripCarContext);
              }
              if (!!tripHotelContext.length) {
                hotelList = generateHotelContext(tripHotelContext);
              }
              $scope.contextList = [flightList, carList, hotelList].reduce(function (prevData, currData) {
                return prevData.concat(currData);
              }, []);
              var sortByDateAsc = function sortByDateAsc(a, b) {
                var firstStartDate = moment(a.startDate).format('MM-DD-YYYY');
                var secondStartDate = moment(b.startDate).format('MM-DD-YYYY');
                if (firstStartDate > secondStartDate) {
                  return 1;
                } else if (firstStartDate < secondStartDate) {
                  return -1;
                } else if (firstStartDate === secondStartDate) {
                  if (a.bookingTypeName === 'A') {
                    return -1;
                  } else if (b.bookingTypeName === 'A') {
                    return 1;
                  } else if (a.bookingTypeName === 'H' && b.bookingTypeName === 'C') {
                    return -1;
                  } else if (a.bookingTypeName === 'C' && b.bookingTypeName === 'H') {
                    return 1;
                  } else {
                    return 0;
                  }
                }
              };
              $scope.contextList.sort(sortByDateAsc);
            });
          }
        });
      }
      //function to set ui-grid data
    };function setGridData() {
      // Clear grid
      getTravelers();
      $scope.tripsList = [];
      $scope.gridOptions.data = [];
      $scope.gridOptions.totalItems = 0;
      updateGridPagination(gridData);
    }

    function updateGridPagination(gridData) {
      var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
      $scope.gridOptions.data = gridData.slice(firstRow, firstRow + paginationOptions.pageSize);
      $scope.gridOptions.totalItems = gridData.length;
      for (var i = 0; i < gridData.length; i++) {
        gridData[i].PriorityName = priorityData[gridData[i].Priority];
        gridData[i].Member.DisplayName = gridData[i].Member.LastName + '/' + gridData[i].Member.FirstName;
      }
    }
    $scope.getLocalTimeZone = function (dateTime) {
      var fullDate = new Date(dateTime);
      var date = fullDate.getDate();
      if (date < 10) {
        date = '0' + date;
      }
      var month = fullDate.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      var year = fullDate.getFullYear();
      var hour = fullDate.getHours();
      if (hour < 10) {
        hour = '0' + hour;
      }
      var minute = fullDate.getMinutes();
      if (minute < 10) {
        minute = '0' + minute;
      }
      var second = fullDate.getSeconds();
      if (second < 10) {
        second = '0' + second;
      }
      fullDate = year + '-' + month + '-' + date + 'T' + hour + ':' + minute + ':' + second + '.000Z';
      var currentTime = new Date(fullDate);
      return moment(currentTime).format('MM-DD-YYYY h:mm:ss a');
    };
    //for getting search by from Date, to Date and travelerName
    $scope.searchPhoneHistory = function () {
      gridData = [];
      $scope.closeDetails();
      $scope.isInDetails = true;
      memberId = $scope.client != null && $scope.client.name.length === 0 ? null : $scope.selectedValue;
      if (validateOrganization()) {
        if (!!$scope.dateFrom && !!$scope.dateTo && !!memberId) {
          progress.start();
          historyPhone.getPhoneLogsForMember(memberId, $filter('date')($scope.dateFrom, 'MM-dd-yyyy'), $filter('date')($scope.dateTo, 'MM-dd-yyyy')).then(function (phoneLogsForMember) {
            gridData = phoneLogsForMember.data;
            if (gridData.length < 1) {
              //\\toastr.warning(commonDialogMessage.phoneHistoryNoResultMessage);
            }
          }, function (err) {
            ngDialog.open({
              template: 'dlg-template-phoneHistory',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.phoneHistoryError = err.statusText;
                $scope.additionalInfo = ''; //PLACE HOLDER
                $scope.messageTitle = 'Phone History Error';
              }]
            });
          }).finally(function () {
            progress.complete();
            setGridData();
          });
        } else if (!!$scope.dateFrom && !!$scope.dateTo) {
          progress.start();
          historyPhone.getPhoneLogsForAllMember($filter('date')($scope.dateFrom, 'MM-dd-yyyy'), $filter('date')($scope.dateTo, 'MM-dd-yyyy')).then(function (phoneLogsForAllMember) {
            var allMemberData = phoneLogsForAllMember.data;
            gridData = allMemberData.filter(function (memberData) {
              return memberIds.indexOf(memberData.MemberId) >= 0;
            });
            if (gridData.length < 1) {
              //\\toastr.warning(commonDialogMessage.phoneHistoryNoResultMessage);
            }
          }, function (err) {
            ngDialog.open({
              template: 'dlg-template-phoneHistory',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.phoneHistoryError = err.statusText;
                $scope.additionalInfo = ''; //PLACE HOLDER
                $scope.messageTitle = 'Phone History Error';
              }]
            });
          }).finally(function () {
            progress.complete();
            setGridData();
          });
        }
      } else {
        // toastr.warning('Please select a client.', 'Alert', {
        // closeButton: true,
        // timeOut: 3500,
        // });
      }
    };
    if (!!$scope.dateFrom && !!$scope.dateTo) {
      progress.start();
      historyPhone.getPhoneLogsForAllMember($filter('date')($scope.dateFrom, 'MM-dd-yyyy'), $filter('date')($scope.dateTo, 'MM-dd-yyyy')).then(function (phoneLogsForAllMember) {
        var allMemberData = phoneLogsForAllMember.data;
        gridData = allMemberData.filter(function (memberData) {
          return memberIds.indexOf(memberData.MemberId) >= 0;
        });
        if (gridData.length < 1) {
          //\\toastr.warning(commonDialogMessage.phoneHistoryNoResultMessage);
        }
      }, function (err) {
        ngDialog.open({
          template: 'dlg-template-phoneHistory',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.phoneHistoryError = err.statusText;
            $scope.additionalInfo = ''; //PLACE HOLDER
            $scope.messageTitle = 'Phone History Error';
          }]
        });
      }).finally(function () {
        progress.complete();
        setGridData();
      });
    }

    function getFlightDetails(flightId, travelerName) {
      progress.start();
      historyPhone.getPhoneLogDetailsForFlight(flightId).then(function (response) {
        if (!!response) {
          $scope.isInDetails = true;
        } else {
          $scope.isInDetails = false;
        }
      }).finally(function () {
        progress.complete();
      });
    }

    function getCarDetails(carId, travelerName) {
      progress.start();
      historyPhone.getPhoneLogDetailsForCar(carId).then(function (response) {
        if (!!response) {
          $scope.isInDetails = true;
        } else {
          $scope.isInDetails = false;
        }
      }).finally(function () {
        progress.complete();
      });
    }

    function getHotelDetails(hotelId, travelerName) {
      progress.start();
      historyPhone.getPhoneLogDetailsForHotel(hotelId).then(function (response) {
        if (!!response) {
          $scope.isInDetails = true;
          var details = response.data;
        } else {
          $scope.isInDetails = false;
        }
      }).finally(function () {
        progress.complete();
      });
    }
    $scope.closeDetails = function () {
      $scope.isInDetails = false;
      $scope.bookingType = null;
      $scope.TripContext = false;
    };
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }

    function generateFlightContext(flightContext) {
      return flightContext.map(function (contextData) {
        var statusColor = '#000000'; //black
        var flightStatus = 'scheduled';
        var currentDateTime = new Date();
        var arrivalTime = moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss');
        currentDateTime = moment(currentDateTime).format('MM-DD-YYYY h:mm:ss');
        if (contextData.FlightStat !== null) {
          var departureTime = moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss');
          var estimatedDeparuteTime = moment(contextData.FlightStat.EstimatedDeparture).format('MM-DD-YYYY h:mm:ss');
          var estimatedArrival = moment(contextData.FlightStat.EstimatedArrival).format('MM-DD-YYYY h:mm:ss');
          statusColor = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? '#3d9400' : estimatedDeparuteTime > departureTime ? '#cc0000' : statusColor;
          flightStatus = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? 'on time' : estimatedDeparuteTime > departureTime ? 'delayed' : currentDateTime > estimatedArrival ? 'past flight' : flightStatus;
        }
        if (contextData.Cancelled === true) {
          statusColor = '#cc0000'; //red
          flightStatus = 'cancelled';
        }
        if (contextData.FlightStat === null && currentDateTime > arrivalTime) {
          flightStatus = 'past flight';
        }
        return {
          statusColor: statusColor,
          flightStatus: flightStatus,
          estimatedDeparture: contextData.FlightStat !== null && contextData.FlightStat.EstimatedDeparture !== null ? contextData.FlightStat.EstimatedDeparture : contextData.DepartureDateTime,
          estimatedArrival: contextData.FlightStat !== null && contextData.FlightStat.EstimatedArrival !== null ? contextData.FlightStat.EstimatedArrival : contextData.ArrivalDateTime,
          pnr: contextData.Pnr,
          bookingTypeName: 'A',
          bookingType: 'Airline Reservation',
          depart: contextData.DepartureName + ' (' + contextData.DepartureAirport + ')',
          arrival: contextData.ArrivalName + ' (' + contextData.ArrivalAirport + ')',
          departureName: contextData.DepartureName,
          departureAirport: contextData.DepartureAirport,
          departureDateTime: moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss'),
          departureGate: contextData.FlightStat !== null && contextData.FlightStat.DepartureGate !== null ? contextData.FlightStat.DepartureGate : '-',
          departureTerminal: contextData.FlightStat !== null && contextData.FlightStat.DepartureTerminal !== null ? contextData.FlightStat.DepartureTerminal : '-',
          startDate: contextData.DepartureDateTime,
          endDate: contextData.ArrivalDateTime,
          arrivalName: contextData.ArrivalName,
          arrivalAirport: contextData.ArrivalAirport,
          arrivalDateTime: moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss'),
          arrivalGate: contextData.FlightStat !== null && contextData.FlightStat.ArrivalGate !== null ? contextData.FlightStat.ArrivalGate : '-',
          arrivalTerminal: contextData.FlightStat !== null && contextData.FlightStat.ArrivalTerminal !== null ? contextData.FlightStat.ArrivalTerminal : '-',
          operatingAirline: contextData.OperatingAirline,
          flightNumber: contextData.FlightNumber,
          duration: contextData.Duration,
          bookingSource: contextData.BookingSource,
          confirmation: contextData.ConfirmationNumber,
          cabin: contextData.Cabin,
          bookingClass: contextData.BookingClass,
          numberInParty: contextData.NumberInParty,
          airTravelers: contextData.AirReservation.AirTravelers,
          comment: contextData.AirReservation.Comment,
          seats: contextData.Seats,
          totalCharge: currency.getCurrencySymbol(contextData.AirReservation.CurrencyCode) + contextData.AirReservation.TotalFare,
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted ? 'Yes' : 'No',
          vendor: contextData.Vendor
        };
      });
    }

    function generateCarContext(carContext) {
      return carContext.map(function (contextData) {
        return {
          pnr: contextData.Pnr,
          bookingTypeName: 'C',
          bookingType: 'Car Reservation',
          startDate: contextData.PickUpDateTime,
          rentalCompany: contextData.RentalCompany,
          pickupDateTime: moment(contextData.PickUpDateTime).format('MM-DD-YYYY h:mm:ss'),
          pickupLocation: contextData.PickUpLocation,
          pickupLocationIsAirport: contextData.PickUpAtAirport === true ? 'Yes' : 'No',
          pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
          pickupLocationCode: contextData.PickUpLocationCode,
          dropoffDateTime: moment(contextData.DropOffDateTime).format('MM-DD-YYYY h:mm:ss'),
          dropoffLocation: contextData.DropOffLocation,
          dropoffLocationIsAirport: contextData.DropOffAtAirport === true ? 'Yes' : 'No',
          dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
          dropoffLocationCode: contextData.DropOffLocationCode,
          carModel: contextData.CarModel,
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          totalCharge: currency.getCurrencySymbol(contextData.CurrencyCode) + contextData.TotalCharge,
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted ? 'Yes' : 'No'
        };
      });
    }

    function generateHotelContext(hotelContext) {
      return hotelContext.map(function (contextData) {
        return {
          pnr: contextData.Pnr,
          bookingTypeName: 'H',
          bookingType: 'Hotel Reservation',
          startDate: contextData.CheckInDate,
          hotelName: contextData.HotelName,
          address: contextData.Address,
          checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
          checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          guestNames: contextData.GuestNames,
          numberOfRooms: contextData.NumberOfRooms,
          roomType: contextData.RoomType,
          totalCharge: currency.getCurrencySymbol(contextData.CurrencyCode) + contextData.Total,
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted ? 'Yes' : 'No'
        };
      });
    }
    // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      $scope.dataSource = [];
      $scope.tripsList = [];
      $scope.gridOptions.data = [];
      $scope.gridOptions.totalItems = 0;
      $scope.isInDetails = false;
      $scope.bookingType = null;
      if (newValue !== oldValue) {
        $scope.client = null;
        $scope.selectedValue = null;
        memberIds = [];
        getTravelers();
        $timeout($scope.searchPhoneHistory, 3000);
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.controller('PhoneNotificationController', ['$rootScope', '$scope', '$state', '$http', 'socket', 'socketTransmit', 'socketLogin', 'alertService', 'authService', function ($rootScope, $scope, $state, $http, socket, socketTransmit, socketLogin, alertService, authService) {
    $scope.groupAlerts = [];

    //init of page
    function updateAlerts() {
      alertService.getUnhandledVoiceAlerts().then(function (response) {
        var unhandledVoiceAlerts = response.data;
        console.log('response ', response);
        console.log('unhandledVoiceAlerts ', unhandledVoiceAlerts);

        //25550624/group-by-multiple-values-underscore-js-but-keep-the-keys-and-values
        var groups = _.groupBy(unhandledVoiceAlerts, function (alert) {
          return alert.fromNumber + '#' + alert.firstName + '#' + alert.lastName;
        });

        console.log('groups ', groups);

        var groupAlerts = _.map(groups, function (group) {
          return {
            fromNumber: group[0].fromNumber,
            firstName: group[0].member.FirstName,
            lastName: group[0].member.LastName,
            email: group[0].member.Email,
            travelerId: group[0].member.Id,
            organizationName: group[0].member.Organization.Name,
            alerts: _.map(group, function (g) {
              return {
                time: moment(g.time).format('MM-DD-YYYY h:mm:ss')
              };
            }),

            topic: group[0].topic
          };
        });

        $scope.groupAlerts = groupAlerts;
        console.log($scope.groupAlerts);
      });
    };

    updateAlerts();

    //on socket event
    $scope.$on('updateAlertCountVoice', function (event, data) {
      updateAlerts();
    });

    //on user's action
    $scope.handleAlert = function (alert) {
      //fromNumber, firstName, lastName) {
      var loginMember = authService.getLoginMember();
      loginMember['SupportsOrganizations'] = [];
      var handleData = {
        fromNumber: alert.fromNumber,
        socketId: socketLogin.getSocketId(),
        travelAgencyId: loginMember.Organization.Id,
        travelAgencyName: loginMember.Organization.Name,
        travelAgentFirstName: loginMember.FirstName,
        travelAgentLastName: loginMember.LastName,
        travelAgentEmail: loginMember.Email,
        travelAgentId: loginMember.Id,
        topic: alert.topic,
        travelerFirstName: alert.firstName,
        travelerLastName: alert.lastName,
        travelerOrganizationName: alert.organizationName
      };
      $rootScope.$broadcast('phoneHandle', handleData);
      if ($state.current.name !== 'app.phone') {
        $http.post('/handlePhone', handleData);
        $state.go('app.phone', {
          fromNumber: alert.fromNumber,
          travelerFirstName: alert.firstName,
          travelerLastName: alert.lastName,
          travelerOrganizationName: alert.organizationName,
          travelerId: alert.travelerId,
          topic: alert.topic
        });
      } else {
        $state.go($state.current, {}, {
          reload: true
        });
      }
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.controller('pnrController', ['$scope', 'progressBar', 'ngDialog', '$state', '$stateParams', 'pnr', function ($scope, progressBar, ngDialog, $state, $stateParams, pnr) {
    var progress = progressBar.getProgressBar();
    $scope.pnrs = '';
    $scope.isProcessing = false;

    $scope.processPnr = function () {
      var isValidPnr = !!$scope.pnrs.length ? true : false;
      var pnrRegex = /^\w+(,\s*\w+){0,2}$/;
      var isValidData = isValidPnr && pnrRegex.test($scope.pnrs) ? true : false;
      var arrPnr = isValidPnr ? $scope.pnrs.split(",") : [$scope.pnrs];
      if (!isValidPnr || arrPnr.length > 3 || !isValidData) {
        var dialog = ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '';
            if (!isValidPnr) {
              $scope.errMsg += '<p>PNR must be entered.</p>';
            }
            if (arrPnr.length > 3 || !isValidData) {
              $scope.errMsg += '<p>Maximum 3 valid PNR seperated by comma(,) allow to process.</p>';
            }
            $scope.errTitle = 'Process PNR Error';
          }]
        });
        dialog.closePromise.then(function (data) {});
      } else {
        $scope.isProcessing = true;
        progress.start();
        pnr.processingPnr(arrPnr).then(function (response) {
          $scope.isProcessing = false;
          var dialogPost = ngDialog.open({
            template: 'templates/partials/viewSuccessMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Process PNR Success';
              $scope.successMsg = 'PNRs process successfully';
            }]
          });
          dialogPost.closePromise.then(function (data) {
            $state.go('app.dashboard');
          });
        }, function (err) {
          $scope.isProcessing = false;
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
              $scope.errTitle = 'Process PNR Error';
            }]
          });
        }).finally(function () {
          progress.complete();
        });
      }
    };

    $scope.cancelProcess = function () {
      $state.go('app.dashboard');
    };
    $scope.$watch(function () {}, function (newValue, oldValue) {}, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _stringify = __webpack_require__(24);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(97);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (module) {
  'use strict';

  module.controller('profileFieldsController', ['$scope', '$filter', '$window', '$state', 'ngDialog', 'toastr', 'progressBar', 'profileFieldService', 'commonDialogMessage', 'clientSelectService', 'agencySelectService', 'uiGridConstants', 'toastFactory', function ($scope, $filter, $window, $state, ngDialog, toastr, progressBar, profileFieldService, commonDialogMessage, clientSelectService, agencySelectService, uiGridConstants, toastFactory) {
    var progress = progressBar.getProgressBar();
    var storage = $window.localStorage;
    $scope.formData = {};
    $scope.profileField = {};
    $scope.viewData = {};
    $scope.validate = {};
    $scope.profileField = {
      Id: 0,
      Name: null,
      AgencyDefinition: null,
      OrganizationId: null,
      IsRequired: false,
      FieldOption: {
        Id: 0,
        ProfileFieldId: 0,
        Name: null
      }
    };
    $scope.formData = {
      Id: 0,
      Name: null,
      AgencyDefinition: null,
      OrganizationId: null,
      IsRequired: false,
      FieldOption: {
        Id: 0,
        ProfileFieldId: 0,
        Name: null
      }
    };
    $scope.fieldOptionList = [{
      Id: 0,
      Name: '',
      ProfileFieldId: 0
    }];
    $scope.isEdit = false;
    $scope.isNew = false;
    $scope.customFieldDefs = [{
      id: 0,
      label: 'Custom Field 1'
    }, {
      id: 1,
      label: 'Custom Field 2'
    }, {
      id: 2,
      label: 'Custom Field 3'
    }, {
      id: 3,
      label: 'Custom Field 4'
    }, {
      id: 4,
      label: 'Custom Field 5'
    }, {
      id: 5,
      label: 'Custom Field 6'
    }, {
      id: 6,
      label: 'Custom Field 7'
    }, {
      id: 7,
      label: 'Custom Field 8'
    }, {
      id: 8,
      label: 'Custom Field 9'
    }, {
      id: 9,
      label: 'Custom Field 10'
    }];
    //executes when controller loads
    (function init() {
      if ($state.current.name === 'app.profileField') {
        setGridData();
        storage.removeItem('editProfileFieldData');
      } else if ($state.current.name === 'app.editProfileField') {
        if (storage.getItem('editProfileFieldData')) {
          $scope.profileField = (0, _assign2.default)($scope.profileField, localLoad());
          $scope.fieldOptionList = $scope.profileField.fieldOptionList;
        } else {
          var warn = ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>No profile field is selected.</p>';
              $scope.errTitle = 'Error';
            }]
          });
          warn.closePromise.then(function (data) {
            $state.go('app.profileField');
          });
        }
      }
    })();
    $scope.localSave = function () {
      var selectedRow = $scope.gridApi.selection.getSelectedRows()[0];
      var saveObject = {
        Id: selectedRow.Id,
        OrganizationId: selectedRow.OrganizationId,
        ProfileFieldName: selectedRow.AgencyDefinition,
        GdsFieldName: selectedRow.Name,
        ProfileColumn: selectedRow.Column,
        IsRequired: selectedRow.IsRequired,
        fieldOptionList: !!selectedRow.ProfileFieldOptions.length ? selectedRow.ProfileFieldOptions : [{
          Id: 0,
          Name: '',
          ProfileFieldId: selectedRow.Id
        }]
      };
      storage.setItem('editProfileFieldData', (0, _stringify2.default)(saveObject));
    };

    function localLoad() {
      return JSON.parse(storage.getItem('editProfileFieldData'));
    }
    $scope.view = function (rowEntity) {
      var selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
      if (!!selectedRow) {
        $scope.viewData.Id = selectedRow.Id;
        $scope.viewData.OrganizationId = selectedRow.OrganizationId;
        $scope.viewData.ProfileFieldName = selectedRow.AgencyDefinition;
        $scope.viewData.GdsFieldName = selectedRow.Name;
        $scope.viewData.ProfileColumn = selectedRow.Column;
        $scope.viewData.IsRequired = selectedRow.IsRequired;
        $scope.fieldOptionList = selectedRow.ProfileFieldOptions;
        var view = ngDialog.open({
          template: 'templates/partials/viewProfileField.html',
          className: 'ngdialog-theme-plain',
          scope: $scope
        });
        view.closePromise.then(function (data) {
          $scope.viewData = {};
          $scope.fieldOptionList = {};
        });
      }
    };
    $scope.selectProfileColumn = function () {
      if ($scope.formData.ProfileColumn) {
        $scope.validate.ProfileColumn = false;
      } else if ($scope.profileField.ProfileColumn) {
        $scope.validate.ProfileColumn = false;
      }
    };
    $scope.addProfileField = function () {
      if ($scope.formData.ProfileFieldName && $scope.formData.GdsFieldName && $scope.formData.ProfileColumn) {
        progress.start();
        $scope.formData.OrganizationId = clientSelectService.getSelectedClient().id;
        var promisePost = profileFieldService.addProfileField($scope.formData);
        var fieldOptionList = $scope.fieldOptionList.filter(function (fieldOption) {
          return !!fieldOption.Name;
        });
        promisePost.then(function (profileFieldData) {
          if (!!fieldOptionList.length) {
            var promisePostFieldOption = profileFieldService.addProfileFieldOption(profileFieldData.data.Id, fieldOptionList);
            promisePostFieldOption.then(function () {
              var dialogPost = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.strTitle = 'Add Profile Field Success';
                  $scope.successMsg = 'Field name successfully created.';
                }]
              });
              dialogPost.closePromise.then(function (data) {
                $scope.clearAll();
                $state.go('app.profileField');
              });
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                    $scope.errTitle = 'Add Profile Field Error';
                  }]
                });
              }
            }).finally(function () {
              progress.complete();
            });
          } else {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Add Profile Field Success';
                $scope.successMsg = 'The profile field has been added succesfully.';
              }]
            });
            dialog.closePromise.then(function (data) {
              $scope.formData.ProfileFieldName = '';
              $scope.formData.GdsFieldName = '';
              $scope.formData.ProfileColumn = '';
              $scope.formData.IsRequired = false;
              $state.go('app.profileField');
            });
          }
        }, function (err) {
          if (err.status != 401) {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                $scope.errTitle = 'Add Profile Field Error';
              }]
            });
            dialog.closePromise.then(function (data) {});
          }
        }).finally(function () {
          progress.complete();
        });
      } else {
        if (!$scope.formData.ProfileFieldName) {
          $scope.validate.ProfileFieldName = true;
        }
        if (!$scope.formData.GdsFieldName) {
          $scope.validate.GdsFieldName = true;
        }
        if (!$scope.formData.ProfileColumn) {
          $scope.validate.ProfileColumn = true;
        }
      }
    };
    // For updateProfileField, check ProfileColumn against null because id of custom field is given as integer --
    // if custom field 1 is chosen, the expression (!0) yields true, which results in a false positive for validation.
    $scope.updateProfileField = function () {
      if ($scope.profileField.ProfileFieldName && $scope.profileField.GdsFieldName && $scope.profileField.ProfileColumn != null) {
        progress.start();
        var promisePut = profileFieldService.updateProfileField($scope.profileField);
        var fieldOptionList = $scope.fieldOptionList.filter(function (fieldOption) {
          return !!fieldOption.Name;
        });
        promisePut.then(function () {
          if (!!fieldOptionList.length) {
            var promisePutFieldOption = profileFieldService.updateProfileFieldOption($scope.profileField.Id, fieldOptionList);
            promisePutFieldOption.then(function () {
              var dialogPut = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.strTitle = 'Update Profile Field Success';
                  $scope.successMsg = 'Field name successfully updated.';
                }]
              });
              dialogPut.closePromise.then(function (data) {
                $state.go('app.profileField');
              });
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                    $scope.errTitle = 'Edit Profile Field Error';
                  }]
                });
              }
            }).finally(function () {
              progress.complete();
            });
          } else {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Edit Profile Field Success';
                $scope.successMsg = 'The profile field has been edited succesfully.';
              }]
            });
            dialog.closePromise.then(function (data) {
              $scope.profileField = {};
              $scope.fieldOptionList = {};
              $state.go('app.profileField');
            });
          }
        }, function (err) {
          if (err.status != 401) {
            $scope.editProfileFieldError = err.statusText + ": " + err.data;
            var dialog = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + editProfileFieldError + '</p>';
                $scope.errTitle = 'Edit Profile Field Errorr';
              }]
            });
            dialog.closePromise.then(function (data) {
              $scope.editProfileFieldError = '';
            });
          }
        }).finally(function () {
          progress.complete();
        });
      } else {
        if (!$scope.profileField.ProfileFieldName) {
          $scope.validate.ProfileFieldName = true;
        }
        if (!$scope.profileField.GdsFieldName) {
          $scope.validate.GdsFieldName = true;
        }
        if ($scope.profileField.ProfileColumn == null) {
          $scope.validate.ProfileColumn = true;
        }
      }
    };
    $scope.deleteProfileField = function () {
      var confirm = ngDialog.open({
        template: 'templates/partials/viewConfirm.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.strTitle = 'Delete Profile Field?';
          $scope.strMsg = 'Do you really want to delete this profile field?';
        }]
      });
      confirm.closePromise.then(function (data) {
        if ($scope.rowSelectingId && data.value === 1) {
          progress.start();
          profileFieldService.deleteProfileField($scope.rowSelectingId).then(function (response) {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete Profile Field Success';
                $scope.successMsg = 'The profile field has been succesfully deleted.';
              }]
            });
            dialog.closePromise.then(function (data) {});
          }, function (err) {
            if (err.status != 401) {
              var dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                  $scope.errTitle = 'Delete Profile Field Error';
                }]
              });
              dialog.closePromise.then(function (data) {});
            }
          }).finally(function () {
            progress.complete();
            setGridData();
          });
        }
      });
    };
    // Begin ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    // ui-grid options
    $scope.gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: true,
      useExternalSorting: false,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      enableColumnResizing: true,
      columnDefs: [{
        name: 'AgencyDefinition',
        visible: true,
        displayName: 'Agency Definition',
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Name',
        visible: true,
        displayName: 'Profile field Name',
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'IsRequired',
        visible: true,
        displayName: 'Required Field',
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Column',
        visible: true,
        displayName: 'Custom Field',
        enableHiding: true,
        enableSorting: false,
        enableFiltering: false,
        cellTemplate: '<div style="padding-left: 5px;"> {{grid.appScope.setCustomField(row.entity.Column)}}</div>',
        enableColumnResizing: true,
        maxWidth: 230
      }, {
        name: 'ProfileFieldOptions',
        visible: true,
        displayName: 'Field Option',
        enableHiding: false,
        enableSorting: false,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: false,
        cellTemplate: '<div style="padding-left: 5px;"> {{grid.appScope.setFieldOptions(row.entity.ProfileFieldOptions)}}</div>',
        enableColumnResizing: true
      }],
      rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (!sortColumns.length) {
            paginationOptions.sort = null;
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction;
          }
        });
        // Row Selection
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.rowSelectingId = row.entity.Id;
          if (row.isSelected) {
            $scope.rowSelecting = true;
          } else {
            $scope.rowSelecting = false;
          }
        });
        // Grid Pagination
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          updateGridPagination();
        });
      }
    }; // End ui-grid option
    $scope.onDblClick = function (row) {
      $scope.rowSelectingId = row.entity.Id;
      $scope.view(row.entity);
      // Override default rowSelection action
      row.isSelected = true;
      $scope.rowSelecting = true;
    };
    // Validate that filtered organization id is defined
    function validateOrganization() {
      var organization = clientSelectService.getSelectedClient();
      return organization.id != null && (0, _isInteger2.default)(organization.id);
    };
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }
    //Begin function to set ui-grid data
    function setGridData() {
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && valid.clientValid) {
        if (validateOrganization()) {
          progress.start();
          // get profile fields data
          getProfileFields().then(function (response) {
            if (response) {
              //assign fields to ui grid
              $scope.gridOptions.data = [];
              $scope.gridOptions.totalItems = 0;
              $scope.gridData = response;
              updateGridPagination();
            }
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + '</p>';
                  $scope.errTitle = 'Profile Field Error';
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
        }
      } else {
        if (valid.agencyValid === false) {
          //toastFactory.toast_info('Please select an agency and a client.');
        } else {
            //toastFactory.toast_info('Please select a client.');
          }
      }
    };
    $scope.setFieldOptions = function (optionList) {
      var optionName = '';
      optionName = optionList.reduce(function (option, name) {
        return option += name.Name + ' , ';
      }, optionName);
      return optionName.substring(0, optionName.length - 2);
    };
    $scope.clearAll = function () {
      $scope.profileField = {};
      $scope.isEdit = false;
      $scope.isNew = false;
      $scope.organizationSelId = null;
      $scope.fieldOptionList = [{
        Id: 0,
        Name: '',
        ProfileFieldId: 0
      }];
    };
    $scope.addFieldOption = function () {
      $scope.fieldOptionList.push({
        Id: 0,
        Name: '',
        ProfileFieldId: $scope.profileField.Id
      });
    };
    $scope.removeFieldOption = function (index, optionId) {
      if (!!optionId) {
        var confirm = ngDialog.open({
          template: 'templates/partials/viewConfirm.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Delete field option?';
            $scope.strMsg = 'Do you really want to delete this field option?';
          }]
        });
        confirm.closePromise.then(function (data) {
          if (data.value === 1) {
            profileFieldService.deleteProfileFieldOption(optionId).then(function (del) {
              var dialogDel = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.strTitle = commonDialogMessage.fieldOptionDeletedMessage;
                  $scope.successMsg = 'Delete Profile Field Success';
                }]
              });
              dialogDel.closePromise.then(function (data) {
                $scope.fieldOptionList.splice(index, 1);
                if ($scope.fieldOptionList.length == 0) {
                  $scope.fieldOptionList.push({
                    Id: 0,
                    Name: '',
                    ProfileFieldId: $scope.profileField.Id
                  });
                }
              });
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                    $scope.errTitle = 'Remove Profile Field Error';
                  }]
                });
              }
            }).finally(function () {
              progress.complete();
            });
          }
        });
      } else {
        if ($scope.fieldOptionList.length > 1) {
          $scope.fieldOptionList.splice(index, 1);
        } else {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>At least 1 field option is required.</p>';
              $scope.errTitle = 'Profile Field Required Message';
            }]
          });
        };
      };
    };
    $scope.setCustomField = function (column) {
      var customField = '';
      switch (column) {
        case 0:
          customField = 'Custom Field 1';
          break;
        case 1:
          customField = 'Custom Field 2';
          break;
        case 2:
          customField = 'Custom Field 3';
          break;
        case 3:
          customField = 'Custom Field 4';
          break;
        case 4:
          customField = 'Custom Field 5';
          break;
        case 5:
          customField = 'Custom Field 6';
          break;
        case 6:
          customField = 'Custom Field 7';
          break;
        case 7:
          customField = 'Custom Field 8';
          break;
        case 8:
          customField = 'Custom Field 9';
          break;
        case 9:
          customField = 'Custom Field 10';
          break;
        case 0:
          customField = 'Custom Field 1';
          break;
      }
      return customField;
    };

    function updateGridPagination() {
      var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
      $scope.gridOptions.data = $scope.gridData.slice(firstRow, firstRow + paginationOptions.pageSize);
      $scope.gridOptions.totalItems = $scope.gridData.length;
      if ($scope.gridOptions.totalItems < 1) {
        //\\toastFactory.toast_warn(commonDialogMessage.profilesDashBoardNoResultMessage);
      }
    };

    function getProfileFields() {
      var organization = clientSelectService.getSelectedClient();
      return profileFieldService.getProfileFieldsByOrgId(organization.id).then(function (response) {
        return response.data;
      }, function (err) {});
    };
    // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        setGridData();
        $scope.gridOptions.data = [];
        $scope.gridOptions.totalItems = 0;
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('progressBarController', ['$scope', 'progressBar', function ($scope, progressBar) {
    progressBar = progressBar.getProgressBar();
    progressBar.setColor('#FFFFFF');
    progressBar.setHeight(10);
  }]);
})(angular.module('obex'));

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('providerController', ['$scope', 'authService', '$sce', 'providers', '$stateParams', 'progressBar', 'ngDialog', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state', 'fileReader', function ($scope, authService, $sce, providers, $stateParams, progressBar, ngDialog, uiGridConstants, commonDialog, commonDialogMessage, $state, fileReader) {
    var readyToUpload = false;
    var selectedFilename = null;
    var progress = progressBar.getProgressBar();
    $scope.viewData = {};
    $scope.provider = {
      Id: 0,
      Code: null,
      IATACode: null,
      ImageLink: '//:0',
      LoginTitle: null,
      Name: null,
      ProviderType: null,
      Login2Code: null,
      Login2Title: null,
      Login3Code: null,
      Login3Title: null
    };
    $scope.isEdit = false;
    $scope.isIATACode = false;
    var gridData = void 0;
    $scope.providerTypeList = [{
      id: 4,
      name: 'Select a Provider Type'
    }, {
      id: 0,
      name: 'All'
    }, {
      id: 1,
      name: 'Flight'
    }, {
      id: 2,
      name: 'Car'
    }, {
      id: 3,
      name: 'Hotel'
    }];
    $scope.typeId = 4;
    var id = $stateParams.id;
    if (!!id) {
      if (id > 1) {
        getProviderById(providers.getProviderById(id));
      } else {
        getProviderById(providers.getProviders());
      }
      $scope.isEdit = true;
    };

    function getProviderById(fn) {
      progress.start();
      fn.then(function (provider) {
        $scope.isEdit = true;
        $scope.provider = provider.data;
        $scope.typeId = provider.data.ProviderType;
        if ($scope.typeId == 1) {
          $scope.isIATACode = true;
        } else {
          $scope.isIATACode = false;
        }
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Get provider Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };
    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope).then(function (result) {
        $scope.provider.ImageLink = result;
      });
    };
    $scope.saveProvider = function () {
      if ($scope.providerForm.$valid) {
        $scope.provider.ProviderType = $scope.typeId;
        if ($scope.provider.ProviderType != 1) {
          $scope.provider.IATACode = '';
        }
        if ($scope.isIATACode && !$scope.provider.IATACode || $scope.typeId == 4 || !$scope.provider.Code) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + commonDialogMessage.iataCodeError + '</p>';
              $scope.errTitle = 'IATA Code Warning';
            }]
          });
        } else {
          progress.start();
          if (readyToUpload) {
            // pipe raw to cloudinary, retrieve transformed cloudinary url and replace ImageLink
            uploadImage(selectedFilename).then(function (result) {
              if (result != null) {
                $scope.provider.ImageLink = result;
                addProvider($scope.provider);
              }
            });
          } else {
            $scope.provider.ImageLink = null;
            addProvider($scope.provider);
          }
        };
      }
    };

    function addProvider(provider) {
      providers.addProvider(provider).then(function () {
        var dialogPost = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Add Provider Success';
            $scope.successMsg = 'The provider has been added succesfully.';
          }]
        });
        dialogPost.closePromise.then(function (data) {
          $scope.clearAll();
          $state.go('app.providers');
        });
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Save provider Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };
    $scope.clearAll = function () {
      $scope.organizations = {};
      $scope.isEdit = false;
      $scope.isNew = false;
      $scope.provider = {};
      $scope.img_url = {};
      $scope.providerForm.$setPristine();
      $scope.typeId = 4;
    };
    $scope.updateProvider = function (id) {
      if ($scope.providerForm.$valid) {
        var provider = $scope.provider;
        provider.ProviderType = $scope.typeId;
        if (provider.ProviderType != 1) {
          provider.IATACode = '';
        }
        console.log($scope.isIATACode, !$scope.provider.IATACode, $scope.typeId, $scope.provider.Code);
        if ($scope.isIATACode && !$scope.provider.IATACode || $scope.typeId == 4 || !$scope.provider.Code) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + commonDialogMessage.iataCodeError + '</p>';
              $scope.errTitle = 'IATA Code Warning';
            }]
          });
        } else {
          progress.start();
          if (readyToUpload) {
            // pipe raw to cloudinary, retrieve transformed cloudinary url and replace ImageLink
            uploadImage(selectedFilename).then(function (result) {
              if (result != null) {
                provider.ImageLink = result;
                putProvider(provider);
              }
            });
          } else {
            provider.ImageLink = null;
            putProvider(provider);
          }
        };
      };
    };

    function putProvider(provider) {
      providers.updateProvider(provider.Id, provider).then(function (provider) {
        var dialogPost = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Update Provider Success';
            $scope.successMsg = 'The provider has been updated succesfully.';
          }]
        });
        dialogPost.closePromise.then(function (data) {
          $scope.clearAll();
          $state.go('app.providers');
        });
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + ' </p>';
              $scope.errTitle = 'Update provider Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    }
    $scope.providerTypeStateChange = function () {
      if ($scope.typeId == 1) {
        $scope.isIATACode = true;
      } else {
        $scope.isIATACode = false;
      }
    };
    $scope.checkExt = function () {
      if (/\.(gif|jpe?g|png|svg)$/i.test($scope.provider.ImageLink)) {
        $scope.validExt = true;
      } else {
        $scope.validExt = false;
      }
    };
    $scope.fetchLogo = function () {
      if ($scope.validExt) {
        $scope.popover = true;
      }
    };
    $scope.setFile = function (event) {
      selectedFilename = event.target.files[0];
      readyToUpload = true;
      $scope.provider.filename = selectedFilename.name;
      fileReader.readAsDataUrl(selectedFilename, $scope).then(function (result) {
        $scope.provider.ImageLink = result;
      });
      $scope.$apply();
    };
    $scope.clearFile = function () {
      readyToUpload = false;
      selectedFilename = null;
      $scope.provider.filename = null;
      $scope.provider.ImageLink = '//:0';
      //$scope.$apply();
    };
    // Attach this method to <button id="save"...> to test Cloudinary chained upload/transform capabilities
    $scope.testUpload = function () {
      uploadImage(selectedFilename).then(function (result) {
        console.log(result);
      });
    };

    function uploadImage(img) {
      if (img != null) {
        return providers.uploadImage(img).then(function (result) {
          var cloudinaryObj = result.data;
          var public_filename = cloudinaryObj.public_id + '.' + cloudinaryObj.format; // e.g. 'filename.jpg'
          return providers.transformImage(public_filename).then(function (result) {
            return result.data;
          });
        });
      }
    };
    //ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    $scope.gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: false,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      columnDefs: [{
        name: 'Name',
        visible: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250,
        cellTemplate: '<div><div ng-if="!!row.entity.ImageLink" style="display: inline-flex;"><div style="padding-left:5px;" ><a><img style="display:inline-block;max-width:18px;max-height:18px;margin:0 5px 0 5px;" ng-src="{{row.entity.ImageLink}}"></a>{{row.entity.Icon}}</div> <div> {{row.entity.Name}}</div></div><div style="padding-left:32px;" ng-if="!row.entity.ImageLink">{{row.entity.Name}}</div></div>',
        sort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }
      }, {
        name: 'Code',
        enableHiding: false,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'IATACode',
        displayName: 'IATA Code',
        enableHiding: false,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'ProviderType',
        visible: true,
        enableSorting: true,
        enableColumnResizing: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        maxWidth: 250,
        cellTemplate: '<span style="padding-left: 5px;"> {{grid.appScope.setProviderType(row.entity.ProviderType)}}</span>',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: [{
            value: '0',
            label: 'All'
          }, {
            value: '1',
            label: 'Flight'
          }, {
            value: '2',
            label: 'Car'
          }, {
            value: '3',
            label: 'Hotel'
          }, {
            value: '4',
            label: 'Expense'
          }, {
            value: '5',
            label: 'Test'
          }, {
            value: '6',
            label: 'Partner'
          }]
        }
      }, {
        name: 'LoginTitle',
        enableSorting: false,
        visible: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Login2Code',
        visible: false,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Login2Title',
        visible: false,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Login3Code',
        visible: false,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Login3Title',
        visible: false,
        enableSorting: false,
        enableColumnResizing: true,
        maxWidth: 250
      }],
      rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (!sortColumns.length) {
            paginationOptions.sort = null;
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction;
          }
          updateGridPagination(gridData);
        });
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          updateGridPagination(gridData);
        });
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.rowSelectingId = row.entity.Id;
          if (row.isSelected) {
            $scope.rowSelecting = true;
          } else {
            $scope.rowSelecting = false;
          }
        });
      }
    };
    $scope.onDblClick = function (row) {
      $scope.rowSelectingId = row.entity.Id;
      $scope.view(row.entity);
      // Override default rowSelection action
      row.isSelected = true;
      $scope.rowSelecting = true;
    };

    function updateGridPagination(gridData) {
      $scope.gridOptions.data = gridData;
      $scope.gridOptions.totalItems = gridData.length;
    };
    function setGridData() {
      progress.start();
      if (authService.getLoginMember().Role === 4) {
        providers.getProvidersByAdmin().then(function (provider) {
          gridData = provider.data;
          updateGridPagination(provider.data);
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + '</p>';
                $scope.errTitle = 'Provider Error';
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      } else {
        providers.getProviders().then(function (provider) {
          gridData = provider.data;
          updateGridPagination(provider.data);
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + '</p>';
                $scope.errTitle = 'Provider Error';
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      }
    };
    setGridData();
    $scope.view = function (rowEntity) {
      var selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
      if (!!selectedRow) {
        $scope.viewData.name = selectedRow.Name;
        $scope.viewData.code = selectedRow.Code;
        $scope.viewData.login2Code = selectedRow.Login2Code;
        $scope.viewData.login3Code = selectedRow.Login3Code;
        $scope.viewData.providerType = $scope.setProviderType(selectedRow.ProviderType);
        $scope.viewData.loginTitle = selectedRow.LoginTitle;
        $scope.viewData.login2Title = selectedRow.Login2Title;
        $scope.viewData.login3Title = selectedRow.Login3Title;
        $scope.viewData.IATACode = selectedRow.IATACode;
        $scope.viewData.imageLink = selectedRow.ImageLink;
        var view = ngDialog.open({
          template: 'templates/partials/viewProvider.html',
          className: 'ngdialog-theme-plain',
          scope: $scope
        });
        view.closePromise.then(function (data) {
          $scope.viewData = {};
        });
      }
    };
    $scope.deleteProvider = function () {
      var confirm = ngDialog.open({
        template: 'templates/partials/viewConfirm.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.strTitle = 'Delete Provider?';
          $scope.strMsg = 'Do you really want to delete this provider?';
        }]
      });
      confirm.closePromise.then(function (data) {
        if ($scope.rowSelectingId && data.value === 1) {
          progress.start();
          providers.deleteProvider($scope.rowSelectingId).then(function (response) {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete Provider Success';
                $scope.successMsg = 'The provider has been succesfully deleted.';
              }]
            });
            dialog.closePromise.then(function (data) {});
          }, function (err) {
            if (err.status != 401) {
              var dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + '</p>';
                  $scope.errTitle = 'Delete Provider Error';
                }]
              });
              dialog.closePromise.then(function (data) {});
            }
          }).finally(function () {
            progress.complete();
            $scope.gridApi.core.clearAllFilters();
            setGridData();
          });
        }
      });
    };
    $scope.edit = function () {
      $state.go('app.editProvider', {
        id: $scope.rowSelectingId
      });
    };
    $scope.setProviderType = function (typeId) {
      var providerType = null;
      switch (typeId) {
        case 0:
          providerType = 'All';
          break;
        case 1:
          providerType = 'Flight';
          break;
        case 2:
          providerType = 'Car';
          break;
        case 3:
          providerType = 'Hotel';
          break;
        default:
          providerType = '';
          break;
      }
      return providerType;
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray2 = __webpack_require__(141);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(147);

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = __webpack_require__(101);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('reportController', ['$scope', 'report', '$stateParams', 'progressBar', 'ngDialog', 'uiGridConstants', 'commonDialogMessage', '$filter', '$q', 'clientSelectService', 'agencySelectService', 'toastr', 'profileFieldService', 'currency', 'toastFactory', 'authService', function ($scope, report, $stateParams, progressBar, ngDialog, uiGridConstants, commonDialogMessage, $filter, $q, clientSelectService, agencySelectService, toastr, profileFieldService, currency, toastFactory, authService) {
    var progress = progressBar.getProgressBar();
    $scope.dateCustFrom = new Date();
    $scope.dateCustTo = addMonth($scope.dateCustFrom); // Look ahead 1 month by default
    $scope.isCustomDate = false;
    $scope.isMonthDate = 'monthYear';
    var profileFields = {};
    var profiles = {};
    var fromdate = null;
    var todate = null;
    var selectedClientId = clientSelectService.getSelectedClient().id;
    var gridData = [];

    function lastDateOfMonth(month, year) {
      return new Date(year, month, 0).toLocaleDateString().replace(/[^ -~]/g, '');
    };

    function firstDateOfMonth(month, year) {
      return new Date(year, month - 1, 1).toLocaleDateString().replace(/[^ -~]/g, '');
    };
    $scope.years = _.range(2010, 2099);

    function validateToDate(fromDate, toDate) {
      return fromDate <= toDate;
    };

    function addMonth(startDate) {
      // Does not handle end-of-month edge case, e.g. Oct 31 + 1 month = Dec 01
      return new Date(new Date(startDate).setMonth(startDate.getMonth() + 1));
    }
    $scope.monthList = [{
      id: 1,
      name: 'January'
    }, {
      id: 2,
      name: 'February'
    }, {
      id: 3,
      name: 'March'
    }, {
      id: 4,
      name: 'April'
    }, {
      id: 5,
      name: 'May'
    }, {
      id: 6,
      name: 'June'
    }, {
      id: 7,
      name: 'July'
    }, {
      id: 8,
      name: 'August'
    }, {
      id: 9,
      name: 'September'
    }, {
      id: 10,
      name: 'October'
    }, {
      id: 11,
      name: 'November'
    }, {
      id: 12,
      name: 'December'
    }];
    $scope.monthDateSelected = function () {
      $scope.isCustomDate = false;
    };
    $scope.reportList = [{
      id: 1,
      name: 'Air activity'
    }, {
      id: 2,
      name: 'Hotel activity'
    }, {
      id: 3,
      name: 'Car activity'
    }, {
      id: 4,
      name: 'All transaction'
    }, {
      id: 5,
      name: 'Active booking user'
    }, {
      id: 6,
      name: 'Active system user'
    }];
    $scope.reportId = 2;
    $scope.columnTypeList = [{
      value: 'all',
      name: 'All'
    }, {
      value: 'visible',
      name: 'Visible'
    }];
    $scope.columnTypeId = 'all';
    $scope.yearName = new Date().getFullYear();
    $scope.monthId = new Date().getMonth() + 1;
    // DRY: function for creating warning toasts
    function toast_warn(errMsg) {
      toastr.warning(errMsg, 'Alert', {
        closeButton: true,
        timeOut: 3500
      });
    };

    function toast_info(infoMsg) {
      toastr.info(infoMsg, 'Info', {
        closeButton: true,
        timeOut: 3500
      });
    };

    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }
    $scope.searchReport = function () {
      if (authService.getLoginMember().Role === 3) {
        selectedClientId = authService.getLoginMember().OrganizationId;
        showReport(selectedClientId);
      } else {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid && valid.clientValid) {
          selectedClientId = clientSelectService.getSelectedClient().id;
          showReport(selectedClientId);
        } else if (valid.agencyValid) {
          //toastFactory.toast_info('Please select a client.');
        } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
      };
      $scope.gridTranOptions = setTranGridOption();
      $scope.gridDetails = _.cloneDeep($scope.gridTranOptions);
    };

    function showReport(selectedClientId) {
      if ($scope.isCustomDate) {
        fromdate = $filter('date')($scope.dateCustFrom, 'yyyy-MM-dd').replace(/[^ -~]/g, '');
        todate = $filter('date')($scope.dateCustTo, 'yyyy-MM-dd').replace(/[^ -~]/g, '');
      } else {
        fromdate = $filter('date')(new Date(firstDateOfMonth($scope.monthId, $scope.yearName)), 'yyyy-MM-dd');
        todate = $filter('date')(new Date(lastDateOfMonth($scope.monthId, $scope.yearName)), 'yyyy-MM-dd');
      };
      if (validateToDate(fromdate, todate)) {
        switch ($scope.reportId) {
          case 1:
            getAirReport(fromdate, todate, selectedClientId);
            break;
          case 2:
            getHotelReport(fromdate, todate, selectedClientId);
            break;
          case 3:
            getCarReport(fromdate, todate, selectedClientId);
            break;
          case 4:
            getTransactionsReport(fromdate, todate, selectedClientId);
            break;
          case 5:
            getBookingActiveUserReport(fromdate, todate, selectedClientId);
            break;
          case 6:
            getActiveUserReport();
            break;
          default:
            getHotelReport(fromdate, todate, selectedClientId);
            break;
        };
      } else {
        toast_warn(commonDialogMessage.dateErrorMessage);
      };
    };

    function transactionGrid() {
      $scope.gridDetails = _.cloneDeep($scope.gridTranOptions);
      $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
    };

    function smsLogGrid() {
      $scope.gridDetails = _.cloneDeep($scope.gridTranOptions);
      $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
    };
    // ui-grid code.
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };

    function setTranGridOption() {
      var data = {
        paginationPageSizes: [5, 10, 25, 50],
        enableFiltering: true,
        enableGridMenu: true,
        paginationPageSize: 25,
        useExternalPagination: false,
        useExternalSorting: false,
        enableColumnResizing: true,
        exporterMenuPdf: false,
        exporterMenuCsv: false,
        exporterCsvFilename: 'Report.csv',
        columnDefs: [{
          name: 'Traveler',
          visible: true,
          displayName: 'Traveler Name',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'TravelerEmail',
          visible: false,
          displayName: 'Traveler Email',
          enableHiding: false,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Source',
          visible: true,
          displayName: 'Source',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Confirmation',
          visible: true,
          displayName: 'Confirmation',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Supplier',
          visible: true,
          displayName: 'Supplier',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'StartDate',
          visible: true,
          enableHiding: true,
          displayName: 'Start Date',
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250,
          sort: {
            direction: uiGridConstants.DESC,
            priority: 0
          },
          cellFilter: 'date:\'MM-dd-yyyy\''
        }, {
          name: 'EndDate',
          visible: true,
          displayName: 'End Date',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250,
          cellFilter: 'date:\'MM-dd-yyyy\''
        }, {
          name: 'AddedOn',
          visible: true,
          displayName: 'Added On',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250,
          cellFilter: 'date:\'MM-dd-yyyy HH:mm:ss\''
        }, {
          name: 'StartLocation',
          visible: true,
          displayName: 'Start Location',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'EndLocation',
          visible: true,
          displayName: 'End Location',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Cancelled',
          visible: false,
          displayName: 'Cancelled',
          enableHiding: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableSorting: true,
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Total',
          visible: true,
          displayName: 'Total',
          enableHiding: true,
          enableSorting: true,
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Agent',
          visible: false,
          displayName: 'Agent',
          enableHiding: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableSorting: true,
          enableFiltering: true,
          exporterSuppressExport: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Type',
          visible: false,
          displayName: 'Type',
          enableHiding: false,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          exporterSuppressExport: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'NumberOfRooms',
          visible: false,
          displayName: 'Number Of Rooms',
          enableHiding: true,
          enableSorting: true,
          exporterSuppressExport: $scope.reportId === 1 || $scope.reportId === 3 ? true : false,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'NumberOfNights',
          visible: false,
          displayName: 'Number Of Nights',
          enableHiding: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableSorting: true,
          exporterSuppressExport: $scope.reportId === 1 || $scope.reportId === 3 ? true : false,
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Phone',
          visible: false,
          displayName: 'Phone',
          enableHiding: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableSorting: true,
          exporterSuppressExport: $scope.reportId === 1 ? true : false,
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'CityName',
          visible: false,
          displayName: 'City Name',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          exporterSuppressExport: $scope.reportId === 1 ? true : false,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'StateProv',
          visible: false,
          displayName: 'State',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          exporterSuppressExport: $scope.reportId === 1 ? true : false,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Country',
          visible: false,
          displayName: 'Country',
          enableHiding: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableSorting: true,
          exporterSuppressExport: $scope.reportId === 1 ? true : false,
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'BookingType',
          visible: false,
          displayName: 'Booking Type',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          exporterSuppressExport: true,
          enableColumnResizing: true,
          maxWidth: 250
        }],
        onRegisterApi: function onRegisterApi(gridApi) {
          $scope.gridApi = gridApi;
          $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
            if (!sortColumns.length) {
              paginationOptions.sort = null;
            } else {
              paginationOptions.sort = sortColumns[0].sort.direction;
            }
            updateGridPagination($scope.gridDetails.data);
            showReport(selectedClientId);
          });
          gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
            paginationOptions.pageNumber = newPage;
            paginationOptions.pageSize = pageSize;
            updateGridPagination($scope.gridDetails.data);
            showReport(selectedClientId);
          });
        }
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(profileFields)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          var i = 0;
          var profileField = {
            name: 'ProfileFieldData[ ' + key + ' ][0].ProfileFieldValue',
            visible: false,
            displayName: value.Name,
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250
          };
          data.columnDefs.push(profileField);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      ;
      return data;
    };

    function setTravelerProfileFields(profileFields, optionList) {
      var travelerProfileFields = profileFields.map(function (profileField) {
        var isProfileFieldExit = false;
        if (!!optionList.length) {
          return optionList.filter(function (option) {
            if (option !== null && option.ProfileFieldId === profileField.Id) {
              isProfileFieldExit = true;
              return option;
            }
          }).map(function (option) {
            var value = option.ProfileFieldValue !== null ? option.ProfileFieldValue : '-';
            return {
              ProfileFieldName: profileField.Name,
              ProfileFieldValue: value
            };
          });
          if (isProfileFieldExit === false) {
            return {
              ProfileFieldName: profileField.Name,
              ProfileFieldValue: "-"
            };
          }
        } else {
          return {
            ProfileFieldName: profileField.Name,
            ProfileFieldValue: "-"
          };
        }
      });
      return travelerProfileFields;
    };

    $scope.gridTranOptions = [];

    function getHotelReport(fromdate, todate, organizationId) {
      progress.start();
      report.getHotelActivity(fromdate, todate, organizationId).then(function (response) {
        var tripHotelsContext = getHotels(response.data);
        $scope.isExportData = !!tripHotelsContext.length ? true : false;
        $scope.gridTranOptions = setTranGridOption();
        $scope.gridTranOptions.data = tripHotelsContext;
        $scope.gridTranOptions.totalItems = tripHotelsContext.length;
        updateGridPagination(tripHotelsContext);
        transactionGrid();
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Report Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };

    function updateGridPagination(gridData) {
      $scope.gridDetails.data = gridData;
      $scope.gridDetails.totalItems = gridData.length;
      $scope.gridApi.grid.options.totalItems = $scope.gridTranOptions.totalItems;
    }
    $scope.getProfiles = function () {
      if (authService.getLoginMember().Role === 3) {
        selectedClientId = authService.getLoginMember().OrganizationId;
      } else {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid && valid.clientValid) {
          selectedClientId = clientSelectService.getSelectedClient().id;
        } else if (valid.agencyValid) {
          //toastFactory.toast_info('Please select a client.');
        } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
      };
      report.getProfiles(selectedClientId).then(function (response) {
        profiles = response.data;
      });
    };
    $scope.getProfileFields = function () {
      if (authService.getLoginMember().Role === 3) {
        selectedClientId = authService.getLoginMember().OrganizationId;
      } else {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid && valid.clientValid) {
          selectedClientId = clientSelectService.getSelectedClient().id;
        } else if (valid.agencyValid) {
          //toastFactory.toast_info('Please select a client.');
        } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
      };
      profileFieldService.getProfileFieldsByOrgId(selectedClientId).then(function (response) {
        profileFields = response.data;
      });
    };

    function getHotels(hotels) {
      return hotels.map(function (hotel) {
        var ProfileFieldData = {};
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(profiles), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var profile = _step2.value;

            if (hotel.Member.Email === profile.Email) {
              ProfileFieldData = setTravelerProfileFields(profileFields, profile.ProfileFieldIdAndValues);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var travelerName = void 0,
            name = void 0;
        if (hotel.GuestNames !== null) {
          name = hotel.GuestNames;
          name = name.split(" ");
          travelerName = name[1] + ', ' + name[0];
        } else if (!!hotel.Member) {
          travelerName = hotel.Member.LastName + ', ' + hotel.Member.FirstName;
        } else {
          travelerName = '';
        }
        return {
          Id: hotel.Id,
          //Traveler: ((!!hotel.Member) ? hotel.Member.LastName + '/' + hotel.Member.FirstName : ''),
          Traveler: travelerName,
          TravelerEmail: !!hotel.Member ? hotel.Member.Email : '',
          CityName: hotel.CityName + '' + hotel.PostalCode,
          StateProv: hotel.StateProv,
          Country: hotel.Country,
          Phone: hotel.PhoneNumber,
          Confirmation: hotel.Confirmation,
          Cancelled: hotel.Cancelled ? 'Yes' : 'No',
          Type: hotel.RoomType,
          NumberOfRooms: hotel.NumberOfRooms,
          NumberOfNights: hotel.NumberOfNights,
          StartDate: hotel.CheckInDate,
          EndDate: hotel.CheckOutDate,
          AddedOn: hotel.AddedDateTime,
          Email: hotel.Member.Email,
          Company: !!hotel.Member ? hotel.Member.Organization.Name : '',
          Supplier: hotel.HotelName,
          Source: !!hotel.BookingSource ? hotel.BookingSource : '',
          ProfileFieldData: ProfileFieldData,
          StartLocation: hotel.CityName,
          EndLocation: hotel.CityName,
          Agent: !!hotel.Member ? hotel.Member.DisplayName : '',
          Total: currency.getCurrencySymbol(hotel.CurrencyCode) + hotel.Total,
          BookingType: !!hotel.TripId ? 'Trip' : 'Booking',
          AgentNotes: !!hotel.AgentNotes.length ? getLatestAgentNote(hotel.AgentNotes) : ''
        };
      });
    };

    function getAirReport(fromdate, todate, organizationId) {
      progress.start();
      report.getAirActivity(fromdate, todate, organizationId).then(function (response) {
        var tripFlightsContext = getFlights(response.data);
        $scope.isExportData = !!tripFlightsContext.length ? true : false;
        $scope.gridTranOptions = setTranGridOption();
        $scope.gridTranOptions.data = tripFlightsContext;
        $scope.gridTranOptions.totalItems = tripFlightsContext.length;
        updateGridPagination(tripFlightsContext);
        transactionGrid();
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Report Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };

    function getFlights(flights) {
      return flights.map(function (flight) {
        var ProfileFieldData = {};
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = (0, _getIterator3.default)(profiles), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var profile = _step3.value;

            if (flight.Member.Email === profile.Email) {
              ProfileFieldData = setTravelerProfileFields(profileFields, profile.ProfileFieldIdAndValues);
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var travelerName = void 0;
        if (flight.AirReservation.AirTravelers.length !== 0 && flight.AirReservation.AirTravelers[0].LastName !== null && flight.AirReservation.AirTravelers[0].GivenName !== null) {
          travelerName = flight.AirReservation.AirTravelers[0].LastName + ', ' + flight.AirReservation.AirTravelers[0].GivenName;
        } else if (!!flight.Member) {
          travelerName = flight.Member.LastName + ', ' + flight.Member.FirstName;
        } else {
          travelerName = '';
        }
        return {
          Id: flight.Id,
          Traveler: travelerName,
          TravelerEmail: !!flight.Member ? flight.Member.Email : '',
          CityName: '',
          StateProv: '',
          Country: '',
          Phone: '',
          Confirmation: flight.ConfirmationNumber,
          Cancelled: flight.Cancelled ? 'Yes' : 'No',
          Type: '',
          NumberOfRooms: '',
          NumberOfNights: '',
          StartDate: flight.DepartureDateTime,
          EndDate: flight.ArrivalDateTime,
          AddedOn: flight.AddedDateTime,
          Company: !!flight.Member ? flight.Member.Organization.Name : '',
          Supplier: flight.OperatingAirline,
          Source: !!flight.BookingSource ? flight.BookingSource : '',
          ProfileFieldData: ProfileFieldData,
          StartLocation: flight.DepartureName,
          EndLocation: flight.ArrivalName,
          Agent: !!flight.Member ? flight.Member.DisplayName : '',
          Total: currency.getCurrencySymbol(flight.AirReservation.CurrencyCode) + flight.AirReservation.TotalFare,
          BookingType: !!flight.TripId ? 'Trip' : 'Booking',
          AgentNotes: !!flight.AgentNotes.length ? getLatestAgentNote(flight.AgentNotes) : ''
        };
      });
    };

    function getCarReport(fromdate, todate, organizationId) {
      progress.start();
      report.getCarActivity(fromdate, todate, organizationId).then(function (response) {
        var tripCarsContext = getCars(response.data);
        $scope.isExportData = !!tripCarsContext.length ? true : false;
        $scope.gridTranOptions = setTranGridOption();
        $scope.gridTranOptions.data = tripCarsContext;
        $scope.gridTranOptions.totalItems = tripCarsContext.length;
        updateGridPagination(tripCarsContext);
        transactionGrid();
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Report Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };

    function getCars(cars) {
      return cars.map(function (car) {
        var ProfileFieldData = {};
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = (0, _getIterator3.default)(profiles), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var profile = _step4.value;

            if (car.Member.Email === profile.Email) {
              ProfileFieldData = setTravelerProfileFields(profileFields, profile.ProfileFieldIdAndValues);
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        var travelerName = void 0,
            name = void 0;
        if (car.Travelers !== null) {
          name = car.Travelers;
          name = name.split(" ");
          travelerName = name[1] + ', ' + name[0];
        } else if (!!car.Member) {
          travelerName = car.Member.LastName + ', ' + car.Member.FirstName;
        } else {
          travelerName = '';
        }
        return {
          Id: car.Id,
          Traveler: travelerName,
          TravelerEmail: !!car.Member ? car.Member.Email : '',
          CityName: '',
          StateProv: '',
          Country: '',
          Phone: '',
          Confirmation: car.Confirmation,
          Cancelled: car.Cancelled ? 'Yes' : 'No',
          Type: car.CarModel,
          NumberOfRooms: '',
          NumberOfNights: '',
          StartDate: car.PickUpDateTime,
          EndDate: car.DropOffDateTime,
          AddedOn: car.AddedDateTime,
          Company: !!car.Member ? car.Member.Organization.Name : '',
          Supplier: car.RentalCompany,
          Source: !!car.BookingSource ? car.BookingSource : '',
          ProfileFieldData: ProfileFieldData,
          StartLocation: car.PickUpLocation,
          EndLocation: car.DropOffLocation,
          Agent: !!car.Member ? car.Member.DisplayName : '',
          Total: currency.getCurrencySymbol(car.CurrencyCode) + car.TotalCharge,
          BookingType: !!car.TripId ? 'Trip' : 'Booking',
          AgentNotes: !!car.AgentNotes.length ? getLatestAgentNote(car.AgentNotes) : ''
        };
      });
    };

    function getLatestAgentNote(agentNotes) {
      var sortByDateDesc = function sortByDateDesc(a, b) {
        return a.LastUpdated < b.LastUpdated ? 1 : a.LastUpdated > b.LastUpdated ? -1 : 0;
      };
      agentNotes.sort(sortByDateDesc);
      return agentNotes[0].Note;
    };

    function getTransactionsReport(fromdate, todate, organizationId) {
      progress.start();
      var promiseFlight = report.getAirActivity(fromdate, todate, organizationId);
      var promiseCar = report.getCarActivity(fromdate, todate, organizationId);
      var promiseHotel = report.getHotelActivity(fromdate, todate, organizationId);
      $q.all([promiseFlight, promiseCar, promiseHotel]).then(function (response) {
        var transactionList = [];
        var flightsContext = response[0].data;
        var carsContext = response[1].data;
        var hotelsContext = response[2].data;
        var flightList = getFlights(flightsContext);
        var carList = getCars(carsContext);
        var hotelList = getHotels(hotelsContext);
        transactionList.push.apply(transactionList, flightList);
        transactionList.push.apply(transactionList, carList);
        transactionList.push.apply(transactionList, hotelList);
        $scope.isExportData = !!transactionList.length ? true : false;
        $scope.gridTranOptions = setTranGridOption();
        $scope.gridTranOptions.data = transactionList;
        $scope.gridTranOptions.totalItems = transactionList.length;
        updateGridPagination(transactionList);
        transactionGrid();
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Report Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };

    function userGridOption() {
      return {
        paginationPageSizes: [5, 10, 25, 50],
        enableFiltering: true,
        enableGridMenu: true,
        paginationPageSize: 25,
        useExternalPagination: false,
        useExternalSorting: false,
        enableColumnResizing: true,
        exporterMenuPdf: false,
        exporterMenuCsv: false,
        exporterCsvFilename: 'Report.csv',
        columnDefs: [{
          name: 'FirstName',
          visible: true,
          displayName: 'First Name',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250,
          sort: {
            direction: uiGridConstants.ASC,
            priority: 0
          }
        }, {
          name: 'LastName',
          visible: true,
          displayName: 'Last Name',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Email',
          visible: true,
          displayName: 'Email',
          enableHiding: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableSorting: true,
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Phone',
          visible: true,
          displayName: 'Phone',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'TripLinkEmail',
          visible: true,
          enableHiding: true,
          displayName: 'TripLink Email',
          enableSorting: true,
          enableFiltering: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'DisableSMS',
          visible: true,
          displayName: 'Disable SMS',
          enableHiding: true,
          enableSorting: true,
          enableFiltering: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'AllowAgentAccess',
          visible: true,
          displayName: 'Agent Access',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'IsAdmin',
          visible: true,
          displayName: 'Admin Access',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }],
        onRegisterApi: function onRegisterApi(gridApi) {
          $scope.gridApi = gridApi;
          $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
            if (!sortColumns.length) {
              paginationOptions.sort = null;
            } else {
              paginationOptions.sort = sortColumns[0].sort.direction;
            }
            updateGridPagination($scope.gridActiveUserOptions.data);
            showReport(selectedClientId);
          });
          gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
            paginationOptions.pageNumber = newPage;
            paginationOptions.pageSize = pageSize;
            updateGridPagination($scope.gridActiveUserOptions.data);
            showReport(selectedClientId);
          });
        }
      };
    };
    $scope.gridActiveUserOptions = [];

    function getActiveUserReport() {
      progress.start();
      report.getActiveUser().then(function (response) {
        progress.complete();
        var activeUserContext = getActivedUser(response.data);
        $scope.isExportData = !!activeUserContext.length ? true : false;
        $scope.gridTranOptions = userGridOption();
        $scope.gridTranOptions.data = activeUserContext;
        gridData = $scope.gridTranOptions.data;
        $scope.gridTranOptions.totalItems = activeUserContext.length;
        updateGridPagination(activeUserContext);
        transactionGrid();
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Report Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };

    function getActivedUser(members) {
      return members.filter(function (member) {
        return member.AccountEnabled;
      }).map(function (member) {
        return {
          Id: member.Id,
          FirstName: member.FirstName,
          LastName: member.LastName,
          Phone: member.Phone,
          Email: member.Email,
          TripLinkEmail: member.TripLinkEmail,
          DisableSMS: member.DisableSMS ? 'Yes' : 'No',
          AllowAgentAccess: member.AllowAgentAccess ? 'Yes' : 'No',
          IsAdmin: member.IsAdmin ? 'Yes' : 'No'
        };
      });
    };

    function getBookingActiveUserReport(fromdate, todate, organizationId) {
      var promiseFlight = report.getAirActivity(fromdate, todate, organizationId);
      var promiseCar = report.getCarActivity(fromdate, todate, organizationId);
      var promiseHotel = report.getHotelActivity(fromdate, todate, organizationId);
      $q.all([promiseFlight, promiseCar, promiseHotel]).then(function (response) {
        var membersList = [];
        var flightsContext = response[0].data;
        var carsContext = response[1].data;
        var hotelsContext = response[2].data;
        var flightMembersList = getFlightMembers(flightsContext);
        var carMembersList = getCarMembers(carsContext);
        var hotelMembersList = getHotelMembers(hotelsContext);
        membersList.push.apply(membersList, flightMembersList);
        membersList.push.apply(membersList, carMembersList);
        membersList.push.apply(membersList, hotelMembersList);
        var activeBookingUserContext = getBookingActiveUsers(membersList);
        $scope.isExportData = !!activeBookingUserContext.length ? true : false;
        $scope.gridTranOptions = userGridOption();
        $scope.gridTranOptions.data = activeBookingUserContext;
        gridData = $scope.gridTranOptions.data;
        $scope.gridTranOptions.totalItems = activeBookingUserContext.length;
        updateGridPagination(activeBookingUserContext);
        transactionGrid();
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Report Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };

    function getBookingActiveUsers(membersList) {
      return membersList.reduce(function (newMemberList, member) {
        if (_.findIndex(newMemberList, function (o) {
          return o.Id == member.Id;
        }) === -1) {
          newMemberList.push(member);
        }
        return newMemberList;
      }, []);
    };

    function getFlightMembers(flights) {
      return flights.map(function (flight) {
        var firstName = void 0,
            lastName = void 0;
        if (flight.AirReservation.AirTravelers[0].GivenName !== null && flight.AirReservation.AirTravelers[0].LastName !== null) {
          firstName = flight.AirReservation.AirTravelers[0].GivenName;
          lastName = flight.AirReservation.AirTravelers[0].LastName;
        } else if (!!flight.Member) {
          firstName = flight.Member.FirstName;
          lastName = flight.Member.LastName;
        } else {
          firstName = '';
          lastName = '';
        }
        return {
          Id: !!flight.Member ? flight.Member.Id : '',
          FirstName: firstName,
          LastName: lastName,
          Phone: !!flight.Member ? flight.Member.Phone : '',
          Email: !!flight.Member ? flight.Member.Email : '',
          TripLinkEmail: !!flight.Member ? flight.Member.TripLinkEmail : '',
          DisableSMS: !!flight.Member ? flight.Member.DisableSMS ? 'Yes' : 'No' : '',
          AllowAgentAccess: !!flight.Member ? flight.Member.AllowAgentAccess ? 'Yes' : 'No' : '',
          IsAdmin: !!flight.Member ? flight.Member.IsAdmin ? 'Yes' : 'No' : ''
        };
      });
    };

    function getHotelMembers(hotels) {
      return hotels.map(function (hotel) {
        var name = void 0,
            firstName = void 0,
            lastName = void 0;
        if (hotel.GuestNames !== null) {
          name = hotel.GuestNames;
          name = name.split(" ");
          firstName = name[0];
          lastName = name[1];
        } else if (!!hotel.Member) {
          firstName = hotel.Member.FirstName;
          lastName = hotel.Member.LastName;
        } else {
          firstName = '';
          lastName = '';
        }
        return {
          Id: !!hotel.Member ? hotel.Member.Id : '',
          FirstName: firstName,
          LastName: lastName,
          Phone: !!hotel.Member ? hotel.Member.Phone : '',
          Email: !!hotel.Member ? hotel.Member.Email : '',
          TripLinkEmail: !!hotel.Member ? hotel.Member.TripLinkEmail : '',
          DisableSMS: !!hotel.Member ? hotel.Member.DisableSMS ? 'Yes' : 'No' : '',
          AllowAgentAccess: !!hotel.Member ? hotel.Member.AllowAgentAccess ? 'Yes' : 'No' : '',
          IsAdmin: !!hotel.Member ? hotel.Member.IsAdmin ? 'Yes' : 'No' : ''
        };
      });
    };

    function getCarMembers(cars) {
      return cars.map(function (car) {
        var name = void 0,
            firstName = void 0,
            lastName = void 0;
        if (car.Travelers !== null) {
          name = car.Travelers;
          name = name.split(" ");
          firstName = name[0];
          lastName = name[1];
        } else if (!!car.Member) {
          firstName = car.Member.FirstName;
          lastName = car.Member.LastName;
        } else {
          firstName = '';
          lastName = '';
        }
        return {
          Id: !!car.Member ? car.Member.Id : '',
          FirstName: firstName,
          LastName: lastName,
          Phone: !!car.Member ? car.Member.Phone : '',
          Email: !!car.Member ? car.Member.Email : '',
          TripLinkEmail: !!car.Member ? car.Member.TripLinkEmail : '',
          DisableSMS: !!car.Member ? car.Member.DisableSMS ? 'Yes' : 'No' : '',
          AllowAgentAccess: !!car.Member ? car.Member.AllowAgentAccess ? 'Yes' : 'No' : '',
          IsAdmin: !!car.Member ? car.Member.IsAdmin ? 'Yes' : 'No' : ''
        };
      });
    };
    $scope.exportReport = function () {
      var tempFileName = $scope.reportId === 1 ? 'Air_Activity_Report.csv' : $scope.reportId === 2 ? 'Hotel_Activity_Report.csv' : $scope.reportId === 4 ? 'All_Transaction_Report.csv' : $scope.reportId === 3 ? 'Car_Activity_Report.csv' : 'Report.csv';
      $scope.gridApi.grid.options.exporterCsvFilename = tempFileName;
      $scope.gridApi.exporter.csvExport('all', $scope.columnTypeId);
    };

    function smsLogsGridOption() {
      return {
        paginationPageSizes: [5, 10, 25, 50],
        enableFiltering: true,
        enableGridMenu: true,
        paginationPageSize: 25,
        useExternalPagination: false,
        useExternalSorting: false,
        enableColumnResizing: true,
        exporterMenuPdf: false,
        exporterMenuCsv: false,
        exporterCsvFilename: 'Report.csv',
        columnDefs: [{
          name: 'Traveler',
          visible: true,
          displayName: 'Traveler',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250,
          sort: {
            direction: uiGridConstants.ASC,
            priority: 0
          }
        }, {
          name: 'Company',
          visible: true,
          displayName: 'Company',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Phone',
          visible: true,
          displayName: 'Phone',
          enableHiding: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableSorting: true,
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Email',
          visible: true,
          displayName: 'Email',
          enableHiding: true,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Time',
          visible: true,
          enableHiding: true,
          displayName: 'Time',
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableSorting: true,
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Message',
          visible: true,
          displayName: 'Message',
          enableHiding: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableSorting: true,
          enableFiltering: true,
          enableColumnResizing: true,
          maxWidth: 250
        }, {
          name: 'Booking',
          visible: true,
          displayName: 'Booking',
          enableHiding: false,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableSorting: false,
          enableFiltering: false,
          enableColumnResizing: true,
          cellClass: 'grid-align'
        }],
        onRegisterApi: function onRegisterApi(gridApi) {
          $scope.gridApi = gridApi;
          $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
            if (!sortColumns.length) {
              paginationOptions.sort = null;
            } else {
              paginationOptions.sort = sortColumns[0].sort.direction;
            }
            updateGridPagination($scope.gridSMSLogsOptions.data);
            showReport(selectedClientId);
          });
          gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
            paginationOptions.pageNumber = newPage;
            paginationOptions.pageSize = pageSize;
            updateGridPagination($scope.gridSMSLogsOptions.data);
            showReport(selectedClientId);
          });
        }
      };
    };
    $scope.gridSMSLogsOptions = [];

    function getSMSLogsReport(fromdate, todate, organizationId) {
      progress.start();
      report.getSMSActivity(fromdate, todate, organizationId).then(function (response) {
        var smsLogsContext = getSMSLogs(response.data);
        $scope.isExportData = !!smsLogsContext.length ? true : false;
        $scope.gridSMSLogsOptions = smsLogsGridOption();
        gridData = $scope.gridSMSLogsOptions;
        $scope.gridTranOptions.data = smsLogsContext;
        $scope.gridTranOptions.totalItems = smsLogsContext.length;
        updateGridPagination(smsLogsContext);
        smsLogGrid();
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Report Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };

    function getSMSLogs(members) {
      return members.map(function (member) {
        return {
          Traveler: member.Member.DisplayName,
          Company: member.Member.Organization.Name,
          Phone: member.Phone,
          Email: member.Member.Email,
          Time: member.LastUpdated,
          Message: member.Message,
          Booking: !!member.FlightId ? 'Flight' : !!member.CarId ? 'Car' : !!member.HotelId ? 'Hotel' : ' '
        };
      });
    };
    //on page load shwoing data in grid
    $scope.getProfileFields();
    $scope.getProfiles();
    $scope.searchReport();
    // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        // Clear ui-grid
        $scope.gridDetails.data = [];
        $scope.gridDetails.totalItems = 0;
        $scope.getProfileFields();
        $scope.getProfiles();
        $scope.searchReport();
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(142);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(101);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(143), __esModule: true };

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33);
__webpack_require__(25);
module.exports = __webpack_require__(144);


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(41);
var ITERATOR = __webpack_require__(2)('iterator');
var Iterators = __webpack_require__(13);
module.exports = __webpack_require__(0).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33);
__webpack_require__(25);
module.exports = __webpack_require__(146);


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var get = __webpack_require__(49);
module.exports = __webpack_require__(0).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(148), __esModule: true };

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(149);
module.exports = __webpack_require__(0).Object.entries;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(4);
var $entries = __webpack_require__(150)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(6);
var getKeys = __webpack_require__(16);
var toIObject = __webpack_require__(11);
var isEnum = __webpack_require__(20).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(71);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;(function (module) {
  'use strict';

  module.controller('SideBarController', ['$rootScope', '$scope', '$q', 'alertService', 'authService', 'organizations', 'members', function ($rootScope, $scope, $q, alertService, authService, organizations, members) {
    $scope.handledSmsData = [];
    var vm = this;
    //console.log('metisMenu called');
    //$('#sidebar').css('min-height', '100%');
    //$('#side-menu').metisMenu();

    vm.smsHandles = [];
    vm.phoneHandles = [];

    //init of page
    function updateCurrentHandles() {
      alertService.getHandledSms().then(function (response) {
        if (response.data) {
          vm.smsHandles = response.data;
          vm.smsHandles.forEach(function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(sms, index) {
              return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return members.getMemberById(sms.TravelerId).then(function (res) {
                        vm.smsHandles[index]['travelerFirstName'] = res.data.FirstName;
                        vm.smsHandles[index]['travelerLastName'] = res.data.LastName;
                        vm.smsHandles[index]['travelerOrganizationName'] = res.data.Organization.Name;
                        vm.smsHandles[index]['channel'] = 'sms';
                      });

                    case 2:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

            return function (_x, _x2) {
              return _ref.apply(this, arguments);
            };
          }());
          // console.log('smsHandles, 19', data)
          // console.log(vm.smsHandles)
          // var handledSms = response.data
          // vm.smsHandles = handledSms
        }
      });
    }

    var logInUser = authService.getLoginMember();
    if (logInUser) {
      $scope.organizationId = logInUser.Organization.Id;
      $scope.organizationName = logInUser.Organization.Name;
      $scope.firstName = logInUser.FirstName;
      $scope.lastName = logInUser.LastName;
      $scope.logInUserRole = logInUser.Role;
      if (logInUser.Role == 4) {
        //$scope.introOptions.steps[0].intro = "Select an agency and then a client to begin.";
      }
    } else {
      $scope.organizationName = '';
      $scope.firstName = '';
      $scope.lastName = '';
    }
    var loginOrganizationPromise = organizations.getOrganizationById($scope.organizationId);
    $q.all([loginOrganizationPromise]).then(function (response) {
      $scope.LogoImageLink = response[0].data.LogoImageLink;
      updateCurrentHandles();
    });

    $scope.$on('clientChangeEvent', function (event, data) {
      $scope.allowOpenBookings = data.allowOpenBookings;
    });

    $scope.$on('removeFinishSms', function (event, data) {
      var dataBookingId = data.topic && data.topic.bookingId ? data.topic.bookingId : null;

      var tempSmsHandles = vm.smsHandles.filter(function (smsHandle) {
        var bookingId = smsHandle.Topic && smsHandle.Topic.BookingId ? smsHandle.Topic.BookingId : smsHandle.topic && smsHandle.topic.bookingId ? smsHandle.topic.bookingId : null;
        var travelerId = smsHandle.TravelerId ? smsHandle.TravelerId : smsHandle.travelerId;
        return dataBookingId && bookingId && dataBookingId !== bookingId && data.travelerId !== travelerId || data.travelerId !== travelerId;
      });
      vm.smsHandles = tempSmsHandles;
    });

    //on socket event
    $scope.$on('smsHandle', function (event, data) {
      /* data = {
        fromNumber,
        socketId,
        travelAgencyId,
        travelAgencyName,
        travelAgentFirstName,
        travelAgentLastName,
        travelAgentEmail,
        topic,
        travelerFirstName,
        travelerLastName,
        travelerOrganizationName,
      } */
      vm.smsHandles.push(data);
    });

    $scope.$on('phoneHandle', function (event, data) {
      /* data = {
        fromNumber,
        socketId,
        travelAgencyId,
        travelAgencyName,
        travelAgentFirstName,
        travelAgentLastName,
        travelAgentEmail,
        topic,
        travelerFirstName,
        travelerLastName,
        travelerOrganizationName,
      } */
      vm.phoneHandles.push(data);
    });
  }]);
})(angular.module('obex'));

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(153),
    data = _require.data;

(function (module) {
  'use strict';

  module.controller('SignupController', ['$scope', '$http', '$state', 'ngDialog', 'authService', function ($scope, $http, $state, ngDialog, authService) {
    var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var passwordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,})$/;
    $scope.user = {};
    $scope.validate = {
      //'valid', 'invalid', 'not-validated'
      emailValidity: 'not-validated',
      firstNameValidity: 'not-validated',
      lastNameValidity: 'not-validated',
      passwordValidity: 'not-validated',
      confirmValidity: 'not-validated'
    };
    $scope.signup = function () {
      $scope.ajaxload = true;
      var isEmailValid = emailRegex.test($scope.user.email);
      if (!isEmailValid) {
        $scope.validate.emailValidity = 'invalid';
      }

      if (!$scope.user.firstName) {
        $scope.validate.firstNameValidity = 'invalid';
      }

      if (!$scope.user.lastName) {
        $scope.validate.lastNameValidity = 'invalid';
      }

      var isPasswordValid = passwordRegex.test($scope.user.password);
      if (!isPasswordValid) {
        $scope.validate.passwordValidity = 'invalid';
      }

      if ($scope.user.password !== $scope.user.confirm) {
        $scope.validate.confirmValidity = 'invalid';
      }

      var emailInvalid = $scope.validate.emailValidity === 'invalid',
          firstNameInvalid = $scope.validate.firstNameValidity === 'invalid',
          lastNameInvalid = $scope.validate.lastNameValidity === 'invalid',
          passwordInvalid = $scope.validate.passwordValidity === 'invalid',
          confirmInvalid = $scope.validate.confirmValidity === 'invalid';
      if (emailInvalid || firstNameInvalid || lastNameInvalid || passwordInvalid || confirmInvalid) {
        $scope.ajaxload = false;
        var dialog = ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '';

            if (firstNameInvalid) {
              $scope.errMsg += '<p>First name must be entered.</p>';
            }
            if (lastNameInvalid) {
              $scope.errMsg += '<p>Last name must be entered.</p>';
            }
            if (emailInvalid) {
              $scope.errMsg += '<p>Email is invalid.</p>';
            }
            if (passwordInvalid) {
              $scope.errMsg += '<p>Password must contain minimum 8 characters, and must include at least 1 uppercase letter and 1 digit.</p>';
            }
            if (confirmInvalid) {
              $scope.errMsg += '<p>Password and Confirm Password fields do not match.</p>';
            }
            $scope.errTitle = 'Signing Up Error';
          }]
        });

        dialog.closePromise.then(function (data) {});
      } else {
        authService.signup($scope.user.email, $scope.user.password, $scope.user.firstName, $scope.user.lastName).then(function (result) {
          $scope.ajaxload = false;
          var dialog = ngDialog.open({
            template: 'templates/partials/viewSuccessMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.successMsg = result.data;
              $scope.strTitle = 'Sign UP Successful';
            }]
          });
          dialog.closePromise.then(function (data) {
            if (isMobile.any()) {
              $state.go('closepage');
            } else {
              $state.go('login');
            }
          });
        }, function (error) {
          $scope.ajaxload = false;
          var dialog = ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + error.data + '</p>';
              $scope.errTitle = 'Signing Up Error';
            }]
          });
          dialog.closePromise.then(function (data) {});
        });
      }
    };

    $scope.emailKeypress = function () {
      var isValid = emailRegex.test($scope.user.email);
      $scope.validate.emailValidity = isValid ? 'valid' : 'not-validated';
    };

    $scope.firstNameKeypress = function () {
      $scope.validate.firstNameValidity = $scope.user.firstName.length > 0 ? 'valid' : 'not-validated';
    };

    $scope.lastNameKeypress = function () {
      $scope.validate.lastNameValidity = $scope.user.lastName.length > 0 ? 'valid' : 'not-validated';
    };

    $scope.passwordKeypress = function () {
      var isValid = passwordRegex.test($scope.user.password);
      $scope.validate.passwordValidity = isValid ? 'valid' : 'not-validated';
    };

    $scope.confirmKeypress = function () {
      if ($scope.user.confirm) {
        var isValid = passwordRegex.test($scope.user.confirm);
        $scope.validate.confirmValidity = $scope.user.password === $scope.user.confirm && $scope.user.confirm.length > 0 && isValid ? 'valid' : 'not-validated';
      } else {
        $scope.validate.confirmValidity = 'not-validated';
      }
    };

    var isMobile = {
      Android: function Android() {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function BlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function iOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function Opera() {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function Windows() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
      },
      any: function any() {
        return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
      }
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v2.2.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-05-20T17:23Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//"use strict";
var arr = [];

var document = window.document;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	version = "2.2.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		var realStringObj = obj && obj.toString();
		return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
	},

	isPlainObject: function( obj ) {
		var key;

		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		// Not own constructor property must be Object
		if ( obj.constructor &&
				!hasOwn.call( obj, "constructor" ) &&
				!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
			return false;
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own
		for ( key in obj ) {}

		return key === undefined || hasOwn.call( obj, key );
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {

			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf( "use strict" ) === 1 ) {
				script = document.createElement( "script" );
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {

				// Otherwise, avoid the DOM node creation, insertion
				// and removal by using an indirect global eval

				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

// JSHint would error on this code due to the Symbol not being defined in ES5.
// Defining this global in .jshintrc would create a danger of using the global
// unguarded in another place, it seems safer to just disable JSHint for these
// three lines.
/* jshint ignore: start */
if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}
/* jshint ignore: end */

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.1
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-10-17
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, nidselect, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
					while ( i-- ) {
						groups[i] = nidselect + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( (parent = document.defaultView) && parent.top !== parent ) {
		// Support: IE 11
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( document.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				return m ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( (oldCache = uniqueCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		} );

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {

						// Inject the element directly into the jQuery object
						this.length = 1;
						this[ 0 ] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

				// Always skip document fragments
				if ( cur.nodeType < 11 && ( pos ?
					pos.index( cur ) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector( cur, selectors ) ) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnotwhite = ( /\S+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];

							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this === promise ? newDefer.promise() : this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add( function() {

					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 ||
				( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred.
			// If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.progress( updateFunc( i, progressContexts, progressValues ) )
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
} );


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {

	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
} );

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE9-10 only
		// Older IE sometimes signals "interactive" too soon
		if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	register: function( owner, initial ) {
		var value = initial || {};

		// If it is a node unlikely to be stringify-ed or looped over
		// use plain assignment
		if ( owner.nodeType ) {
			owner[ this.expando ] = value;

		// Otherwise secure it in a non-enumerable, non-writable property
		// configurability must be true to allow the property to be
		// deleted with the delete operator
		} else {
			Object.defineProperty( owner, this.expando, {
				value: value,
				writable: true,
				configurable: true
			} );
		}
		return owner[ this.expando ];
	},
	cache: function( owner ) {

		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return an empty object.
		if ( !acceptData( owner ) ) {
			return {};
		}

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ prop ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :
			owner[ this.expando ] && owner[ this.expando ][ key ];
	},
	access: function( owner, key, value ) {
		var stored;

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase( key ) );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key === undefined ) {
			this.register( owner );

		} else {

			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {

				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );

				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;

			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <= 35-45+
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://code.google.com/p/chromium/issues/detail?id=378607
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :

					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data, camelKey;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// with the key as-is
				data = dataUser.get( elem, key ) ||

					// Try to find dashed key if it exists (gh-2779)
					// This is for 2.2.x only
					dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );

				if ( data !== undefined ) {
					return data;
				}

				camelKey = jQuery.camelCase( key );

				// Attempt to get data from the cache
				// with the key camelized
				data = dataUser.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			camelKey = jQuery.camelCase( key );
			this.each( function() {

				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = dataUser.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				dataUser.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
					dataUser.set( this, key, value );
				}
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {

		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" ||
			!jQuery.contains( elem.ownerDocument, elem );
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() { return tween.cur(); } :
			function() { return jQuery.css( elem, prop, "" ); },
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([\w:-]+)/ );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE9
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE9-11+
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret = typeof context.getElementsByTagName !== "undefined" ?
			context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== "undefined" ?
				context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0-4.3, Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE9
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Support (at least): Chrome, IE9
		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		//
		// Support: Firefox<=42+
		// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
		if ( delegateCount && cur.nodeType &&
			( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push( { elem: cur, handlers: matches } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
		"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split( " " ),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
			"screenX screenY toElement" ).split( " " ),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX +
					( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
					( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY +
					( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
					( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://code.google.com/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {
	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,

	// Support: IE 10-11, Edge 10240+
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName( "tbody" )[ 0 ] ||
			elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android<4.1, PhantomJS<2
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {

	// Keep domManip exposed until 3.0 (gh-2225)
	domManip: domManip,

	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );


var iframe,
	elemdisplay = {

		// Support: Firefox
		// We have to pre-define these values for FF (#10227)
		HTML: "block",
		BODY: "block"
	};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */

// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		display = jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
				.appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var documentElement = document.documentElement;



( function() {
	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {
		div.style.cssText =

			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );
	}

	jQuery.extend( support, {
		pixelPosition: function() {

			// This test is executed only once but we still do memoizing
			// since we can use the boxSizingReliable pre-computing.
			// No need to check if the test was already performed, though.
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {

			// Support: Android 4.0-4.3
			// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
			// since that compresses better and they're computed together anyway.
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {

			// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return reliableMarginLeftVal;
		},
		reliableMarginRight: function() {

			// Support: Android 2.3
			// Check if div with explicit width and no margin-right incorrectly
			// gets computed margin-right based on width of container. (#3333)
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			// This support function is only executed once so no memoizing is needed.
			var ret,
				marginDiv = div.appendChild( document.createElement( "div" ) );

			// Reset CSS: box-sizing; display; margin; border; padding
			marginDiv.style.cssText = div.style.cssText =

				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;box-sizing:content-box;" +
				"display:block;margin:0;border:0;padding:0";
			marginDiv.style.marginRight = marginDiv.style.width = "0";
			div.style.width = "1px";
			documentElement.appendChild( container );

			ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );

			documentElement.removeChild( container );
			div.removeChild( marginDiv );

			return ret;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );
	ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

	// Support: Opera 12.1x only
	// Fall back to style even without computed
	// computed is undefined for elems on document fragments
	if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
		ret = jQuery.style( elem, name );
	}

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// http://dev.w3.org/csswg/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE9-11+
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?

		// If we already have the right measurement, avoid augmentation
		4 :

		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = dataPriv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {

			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = dataPriv.access(
					elem,
					"olddisplay",
					defaultDisplay( elem.nodeName )
				);
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				dataPriv.set(
					elem,
					"olddisplay",
					hidden ? display : jQuery.css( elem, "display" )
				);
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				style[ name ] = value;
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
					elem.offsetWidth === 0 ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {

		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show
				// and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = dataPriv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done( function() {
				jQuery( elem ).hide();
			} );
		}
		anim.done( function() {
			var prop;

			dataPriv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		} );
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {
	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnotwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
		opt.duration : opt.duration in jQuery.fx.speeds ?
			jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	window.clearInterval( timerId );

	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {

					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {
			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




var rclass = /[\t\r\n\f]/g;

function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnotwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + getClass( elem ) + " " ).replace( rclass, " " )
					.indexOf( className ) > -1
			) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g,
	rspaces = /[\x20\t\r\n\f]+/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?

					// Handle most common string cases
					ret.replace( rreturn, "" ) :

					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ?
								!option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome, Safari
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// The jqXHR state
			state = 0,

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {

								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE8-11+
			// IE throws exception if url is malformed, e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE8-11+
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( state === 2 ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );

				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapAll( html.call( this, i ) );
			} );
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function() {
		return this.parent().each( function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		} ).end();
	}
} );


jQuery.expr.filters.hidden = function( elem ) {
	return !jQuery.expr.filters.visible( elem );
};
jQuery.expr.filters.visible = function( elem ) {

	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	// Use OR instead of AND as the element is not visible if either is true
	// See tickets #10406 and #13132
	return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {

			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} ) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE9
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE9
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		box = elem.getBoundingClientRect();
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari<7-8+, Chrome<37-44+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},
	size: function() {
		return this.length;
	}
} );

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}



var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}

return jQuery;
}));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (module) {
  'use strict';

  module.controller('singleSignOnController', ['$scope', 'progressBar', 'clientSelectService', 'agencySelectService', 'singleSignOn', 'ngDialog', '$q', function ($scope, progressBar, clientSelectService, agencySelectService, singleSignOn, ngDialog, $q) {
    var progress = progressBar.getProgressBar();
    $scope.singleSignOn = {};
    $scope.validate = {};

    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }

    function getSingleSignOnByOrganizationId() {
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && valid.clientValid) {
        progress.start();
        singleSignOn.getSingleSignOnByOrganizationId(clientSelectService.getSelectedClient().id).then(function (response) {
          $scope.isEdit = true;
          $scope.singleSignOn = response.data;
        }, function (err) {
          $scope.isEdit = false;
          $scope.singleSignOn = {};
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>Single sign on not found</p>';
              $scope.errTitle = 'Single Sign On Error';
            }]
          });
        }).finally(function () {
          progress.complete();
        });
      } else if (valid.agencyValid) {
        // toastFactory.toast_info('Please select a client.');
      } else {
          // toastFactory.toast_info('Please select an agency and then client.');
        }
    };

    $scope.saveSingleSignOn = function () {
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && valid.clientValid) {
        if ($scope.singleSignOn.Cert) {
          var organization = clientSelectService.getSelectedClient();
          progress.start();
          singleSignOn.addSingleSignOn($scope.singleSignOn, organization.id).then(function () {
            var dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Single Sign On Success';
                $scope.successMsg = 'The single sign on has been saved succesfully.';
              }]
            });
            dialogPost.closePromise.then(function (data) {
              $state.go('app.singleSignOn');
            });
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                $scope.errTitle = 'Single Sign On Error';
              }]
            });
          }).finally(function () {
            progress.complete();
          });
        } else {
          if (!$scope.singleSignOn.Cert) {
            $scope.validate.cert = true;
          }
        }
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>"Please select client."</p>';
            $scope.errTitle = 'Single Sign On Error';
          }]
        });
      }
    };

    $scope.updateSingleSignOn = function () {
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && valid.clientValid) {
        if ($scope.singleSignOn.Cert) {
          progress.start();

          singleSignOn.updateSingleSignOn($scope.singleSignOn.OrganizationId, $scope.singleSignOn).then(function (singleSignOn) {
            ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Single Sign On Success';
                $scope.successMsg = 'The single sign on has been updated succesfully.';
              }]
            });
          }).finally(function () {
            progress.complete();
          });
        } else {
          if (!$scope.singleSignOn.Cert) {
            $scope.validate.cert = true;
          }
        }
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '<p>"Please select client."</p>';
            $scope.errTitle = 'Single Sign On Error';
          }]
        });
      }
    };

    getSingleSignOnByOrganizationId();

    // Watch orgFilterService for changes to getFilteredOrganization() output
    // expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {

      if (newValue !== oldValue) {
        getSingleSignOnByOrganizationId();
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(71);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(24);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(62);

var _typeof3 = _interopRequireDefault(_typeof2);

var _asyncToGenerator2 = __webpack_require__(72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;(function (module) {
  'use strict';

  module.controller('SmsController', ['$rootScope', '$scope', '$http', '$state', '$stateParams', 'socket', 'socketLogin', 'authService', 'conversationService', 'members', 'tripsDashBoard', 'progressBar', 'ngDialog', 'commonDialog', 'commonDialogMessage', 'currency', 'smsStatus', 'Upload', 'providers', 'fileReader', function ($rootScope, $scope, $http, $state, $stateParams, socket, socketLogin, authService, conversationService, members, tripsDashBoard, progressBar, ngDialog, commonDialog, commonDialogMessage, currency, smsStatus, Upload, providers, fileReader) {
    //var progress = progressBar.getProgressBar()
    var dialogId;
    $scope.istravellerIgnore = false;
    //Helper private functions
    function getFlightContext(bookingId) {
      tripsDashBoard.getFlightsDashById(bookingId).then(function (flights) {
        var contextData = flights.data;
        var statusColor = '#000000'; //black
        var flightStatus = 'scheduled';
        var dateTime = new Date();
        var arrivalTime = moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss');
        var currentDateTime = moment(dateTime).format('MM-DD-YYYY h:mm:ss');
        if (contextData.FlightStat !== null) {
          var departureTime = moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss');
          var estimatedDeparuteTime = moment(contextData.FlightStat.EstimatedDeparture).format('MM-DD-YYYY h:mm:ss');
          var estimatedArrival = moment(contextData.FlightStat.EstimatedArrival).format('MM-DD-YYYY h:mm:ss');
          statusColor = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? '#3d9400' : estimatedDeparuteTime > departureTime ? '#cc0000' : statusColor;
          flightStatus = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? 'on time' : estimatedDeparuteTime > departureTime ? 'delayed' : currentDateTime > estimatedArrival ? 'past flight' : flightStatus;
        }
        if (contextData.Cancelled === true) {
          statusColor = '#cc0000'; //red
          flightStatus = 'cancelled';
        }
        if (contextData.FlightStat === null && currentDateTime > arrivalTime) {
          flightStatus = 'past flight';
        }
        $scope.flightContext = {
          statusColor: statusColor,
          flightStatus: flightStatus,
          estimatedDeparture: contextData.FlightStat !== null && contextData.FlightStat.EstimatedDeparture !== null ? contextData.FlightStat.EstimatedDeparture : contextData.DepartureDateTime,
          estimatedArrival: contextData.FlightStat !== null && contextData.FlightStat.EstimatedArrival !== null ? contextData.FlightStat.EstimatedArrival : contextData.ArrivalDateTime,
          pnr: contextData.Pnr,
          depart: contextData.DepartureName + ' (' + contextData.DepartureAirport + ')',
          arrival: contextData.ArrivalName + ' (' + contextData.ArrivalAirport + ')',
          departureName: contextData.DepartureName,
          departureAirport: contextData.DepartureAirport,
          departureDateTime: moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss'),
          departureGate: contextData.FlightStat !== null && contextData.FlightStat.DepartureGate !== null ? contextData.FlightStat.DepartureGate : '-',
          departureTerminal: contextData.FlightStat !== null && contextData.FlightStat.DepartureTerminal !== null ? contextData.FlightStat.DepartureTerminal : '-',
          startDate: contextData.DepartureDateTime,
          endDate: contextData.ArrivalDateTime,
          arrivalName: contextData.ArrivalName,
          arrivalAirport: contextData.ArrivalAirport,
          arrivalDateTime: moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss'),
          arrivalGate: contextData.FlightStat !== null && contextData.FlightStat.ArrivalGate !== null ? contextData.FlightStat.ArrivalGate : '-',
          arrivalTerminal: contextData.FlightStat !== null && contextData.FlightStat.ArrivalTerminal !== null ? contextData.FlightStat.ArrivalTerminal : '-',
          operatingAirline: contextData.OperatingAirline,
          flightNumber: contextData.FlightNumber,
          duration: contextData.Duration,
          bookingSource: contextData.BookingSource,
          confirmation: contextData.ConfirmationNumber,
          cabin: contextData.Cabin,
          bookingClass: contextData.BookingClass,
          numberInParty: contextData.NumberInParty,
          airTravelers: contextData.AirReservation.AirTravelers,
          comment: contextData.AirReservation.Comment,
          seats: contextData.Seats,
          totalCharge: currency.getCurrencySymbol(contextData.AirReservation.CurrencyCode) + contextData.AirReservation.TotalFare,
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted ? 'Yes' : 'No',
          vendor: contextData.Vendor
        };
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'SMS History Error';
            }]
          });
        }
      });
    }

    function getHotelContext(bookingId) {
      var promiseGetHotel = tripsDashBoard.getHotelsDashById(bookingId);
      promiseGetHotel.then(function (hotels) {
        console.log(hotels);
        var contextData = hotels.data;$scope.hotelContext = {
          pnr: contextData.Pnr,
          hotelName: contextData.HotelName,
          address: contextData.Address,
          checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
          checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          guestNames: contextData.GuestNames,
          numberOfRooms: contextData.NumberOfRooms,
          roomType: contextData.RoomType,
          totalCharge: contextData.Total + ' ' + (contextData.CurrencyCode === null ? '' : contextData.CurrencyCode),
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted === true ? 'Yes' : 'No'
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: '<p>' + err.statusText + '</p>' + '<div class="ngdialog-buttons">' + '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Ok' + '</button>' + '</div>',
              className: 'ngdialog-theme-plain',
              plain: true
            });
          }
        };
      });
    }

    function getCarContext(bookingId) {
      var promiseGetCar = tripsDashBoard.getCarsDashById(bookingId);
      promiseGetCar.then(function (cars) {
        console.log(cars);
        var contextData = cars.data;$scope.carContext = {
          pnr: contextData.Pnr,
          rentalCompany: contextData.RentalCompany,
          pickupDateTime: moment(contextData.PickUpDateTime).format('MM-DD-YYYY h:mm'),
          pickupLocation: contextData.PickUpLocation,
          pickupLocationIsAirport: contextData.PickUpAtAirport === true ? 'Yes' : 'No',
          pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
          pickupLocationCode: contextData.PickUpLocationCode,
          dropoffDateTime: moment(contextData.DropOffDateTime).format('MM-DD-YYYY h:mm'),
          dropoffLocation: contextData.DropOffLocation,
          dropoffLocationIsAirport: contextData.DropOffAtAirport === true ? 'Yes' : 'No',
          dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
          dropoffLocationCode: contextData.DropOffLocationCode,
          carModel: contextData.CarModel,
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          totalCharge: contextData.TotalCharge + ' ' + (contextData.CurrencyCode === null ? '' : contextData.CurrencyCode),
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted === true ? 'Yes' : 'No'
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: '<p>' + err.statusText + '</p>' + '<div class="ngdialog-buttons">' + '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Ok' + '</button>' + '</div>',
              className: 'ngdialog-theme-plain',
              plain: true
            });
          }
        };
      });
    }

    function generateFlightContext(flightContext) {
      return flightContext.map(function (contextData) {
        var statusColor = '#000000'; //black
        var flightStatus = 'scheduled';
        var currentDateTime = new Date();
        var arrivalTime = moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss');
        currentDateTime = moment(currentDateTime).format('MM-DD-YYYY h:mm:ss');
        if (contextData.FlightStat !== null) {
          var departureTime = moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss');
          var estimatedDeparuteTime = moment(contextData.FlightStat.EstimatedDeparture).format('MM-DD-YYYY h:mm:ss');
          var estimatedArrival = moment(contextData.FlightStat.EstimatedArrival).format('MM-DD-YYYY h:mm:ss');
          statusColor = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? '#3d9400' : estimatedDeparuteTime > departureTime ? '#cc0000' : statusColor;
          flightStatus = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? 'on time' : estimatedDeparuteTime > departureTime ? 'delayed' : currentDateTime > estimatedArrival ? 'past flight' : flightStatus;
        }
        if (contextData.Cancelled === true) {
          statusColor = '#cc0000'; //red
          flightStatus = 'cancelled';
        }
        if (contextData.FlightStat === null && currentDateTime > arrivalTime) {
          flightStatus = 'past flight';
        }
        return {
          statusColor: statusColor,
          flightStatus: flightStatus,
          estimatedDeparture: contextData.FlightStat !== null && contextData.FlightStat.EstimatedDeparture !== null ? contextData.FlightStat.EstimatedDeparture : contextData.DepartureDateTime,
          estimatedArrival: contextData.FlightStat !== null && contextData.FlightStat.EstimatedArrival !== null ? contextData.FlightStat.EstimatedArrival : contextData.ArrivalDateTime,
          pnr: contextData.Pnr,
          bookingTypeName: 'A',
          bookingType: 'Airline Reservation',
          depart: contextData.DepartureName + ' (' + contextData.DepartureAirport + ')',
          arrival: contextData.ArrivalName + ' (' + contextData.ArrivalAirport + ')',
          departureName: contextData.DepartureName,
          departureAirport: contextData.DepartureAirport,
          departureDateTime: moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss'),
          departureGate: contextData.FlightStat !== null && contextData.FlightStat.DepartureGate !== null ? contextData.FlightStat.DepartureGate : '-',
          departureTerminal: contextData.FlightStat !== null && contextData.FlightStat.DepartureTerminal !== null ? contextData.FlightStat.DepartureTerminal : '-',
          startDate: contextData.DepartureDateTime,
          endDate: contextData.ArrivalDateTime,
          arrivalName: contextData.ArrivalName,
          arrivalAirport: contextData.ArrivalAirport,
          arrivalDateTime: moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss'),
          arrivalGate: contextData.FlightStat !== null && contextData.FlightStat.ArrivalGate !== null ? contextData.FlightStat.ArrivalGate : '-',
          arrivalTerminal: contextData.FlightStat !== null && contextData.FlightStat.ArrivalTerminal !== null ? contextData.FlightStat.ArrivalTerminal : '-',
          operatingAirline: contextData.OperatingAirline,
          flightNumber: contextData.FlightNumber,
          duration: contextData.Duration,
          bookingSource: contextData.BookingSource,
          confirmation: contextData.ConfirmationNumber,
          cabin: contextData.Cabin,
          bookingClass: contextData.BookingClass,
          numberInParty: contextData.NumberInParty,
          airTravelers: contextData.AirReservation.AirTravelers,
          comment: contextData.AirReservation.Comment,
          seats: contextData.Seats,
          totalCharge: currency.getCurrencySymbol(contextData.AirReservation.CurrencyCode) + contextData.AirReservation.TotalFare,
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted ? 'Yes' : 'No',
          vendor: contextData.Vendor
        };
      });
    }

    function generateCarContext(carContext) {
      return carContext.map(function (contextData) {
        return {
          bookingTypeName: 'C',
          bookingType: 'Car Reservation',
          pnr: contextData.Pnr,
          startDate: contextData.PickUpDateTime,
          rentalCompany: contextData.RentalCompany,
          pickupDateTime: moment(contextData.PickUpDateTime).format('MM-DD-YYYY h:mm'),
          pickupLocation: contextData.PickUpLocation,
          pickupLocationIsAirport: contextData.PickUpAtAirport === true ? 'Yes' : 'No',
          pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
          pickupLocationCode: contextData.PickUpLocationCode,
          dropoffDateTime: moment(contextData.DropOffDateTime).format('MM-DD-YYYY h:mm'),
          dropoffLocation: contextData.DropOffLocation,
          dropoffLocationIsAirport: contextData.DropOffAtAirport === true ? 'Yes' : 'No',
          dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
          dropoffLocationCode: contextData.DropOffLocationCode,
          carModel: contextData.CarModel,
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          totalCharge: contextData.TotalCharge + ' ' + (contextData.CurrencyCode === null ? '' : contextData.CurrencyCode),
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted === true ? 'Yes' : 'No'
        };
      });
    }

    function generateHotelContext(hotelContext) {
      return hotelContext.map(function (contextData) {
        return {
          bookingTypeName: 'H',
          bookingType: 'Hotel Reservation',
          pnr: contextData.Pnr,
          startDate: contextData.CheckInDate,
          hotelName: contextData.HotelName,
          address: contextData.Address,
          checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
          checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          guestNames: contextData.GuestNames,
          numberOfRooms: contextData.NumberOfRooms,
          roomType: contextData.RoomType,
          totalCharge: contextData.Total + ' ' + (contextData.CurrencyCode === null ? '' : contextData.CurrencyCode),
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted === true ? 'Yes' : 'No'
        };
      });
    }

    function getAllContexts(bookingId) {
      $scope.contextList = [];
      var tripFlightContext = [];
      var tripCarContext = [];
      var tripHotelContext = [];
      tripsDashBoard.getTripsDashbyId(bookingId).then(function (trips) {
        tripFlightContext = trips.data.Flights;
        tripCarContext = trips.data.Cars;
        tripHotelContext = trips.data.Hotels;
        var flightList = [];
        var hotelList = [];
        var carList = [];
        if (!!tripFlightContext.length) {
          flightList = generateFlightContext(tripFlightContext);
        }
        if (!!tripCarContext.length) {
          carList = generateCarContext(tripCarContext);
        }
        if (!!tripHotelContext.length) {
          hotelList = generateHotelContext(tripHotelContext);
        }
        $scope.contextList = [flightList, carList, hotelList].reduce(function (prevData, currData) {
          return prevData.concat(currData);
        }, []);
        var sortByDateAsc = function sortByDateAsc(a, b) {
          var firstStartDate = moment(a.startDate).format('MM-DD-YYYY');
          var secondStartDate = moment(b.startDate).format('MM-DD-YYYY');
          if (firstStartDate > secondStartDate) {
            return 1;
          } else if (firstStartDate < secondStartDate) {
            return -1;
          } else if (firstStartDate === secondStartDate) {
            if (a.bookingTypeName === 'A') {
              return -1;
            } else if (b.bookingTypeName === 'A') {
              return 1;
            } else if (a.bookingTypeName === 'H' && b.bookingTypeName === 'C') {
              return -1;
            } else if (a.bookingTypeName === 'C' && b.bookingTypeName === 'H') {
              return 1;
            } else {
              return 0;
            }
          }
        };
        $scope.contextList.sort(sortByDateAsc);
      });
    }

    function setBookingDetails(topic) {
      var bookingId = topic && topic.BookingId ? topic.BookingId : topic.bookingId;
      var bookingType = topic && topic.BookingType ? topic.BookingType : topic.bookingType;
      if (bookingType === 'FlightViewModel' || bookingType === 'Flight') {
        $scope.bookingType = 'Airline Reservation';
        getFlightContext(bookingId);
      } else if (bookingType === 'HotelViewModel' || bookingType === 'Hotel') {
        $scope.bookingType = 'Hotel Reservation';
        getHotelContext(bookingId);
      } else if (bookingType === 'CarViewModel' || bookingType === 'Car') {
        $scope.bookingType = 'Car Reservation';
        getCarContext(bookingId);
      } else if (bookingType === 'TripViewModel' || bookingType === 'Trip') {
        $scope.bookingType = 'Trip';
        getAllContexts(bookingId);
      }
      console.log('$scope.bookingType = ', $scope.bookingType);
    }
    //init of page
    function checkFirstVisit() {
      if (document.cookie.indexOf('mycookie') == -1) {
        // cookie doesn't exist, create it now
        document.cookie = 'mycookie=1';
      } else {
        setTimeout(function () {
          console.log('On refresh page');
          console.log('socket id', socketLogin.getSocketId());
          console.log('socket id', authService.getLoginMember().Email);
          conversationService.updateSocketId({
            socketId: socketLogin.getSocketId(),
            email: authService.getLoginMember().Email
          }).then(function (response) {
            console.log('updateSocketId', response);
          });
        }, 2000);
      }
    }
    console.log($stateParams); //{fromNumber: "13462764357", firstName: firstName, lastName: lastName}
    console.log($state.params);
    console.log(authService.getLoginMember());
    if ($stateParams.channel === null && $stateParams.fromNumber === null) {
      checkFirstVisit();
      // window.location.replace(
      //   window.location.href.split(window.location.hash)[0],
      // )
    }
    var _$state$params = $state.params,
        fromNumber = _$state$params.fromNumber,
        firstName = _$state$params.travelerFirstName,
        lastName = _$state$params.travelerLastName,
        travelerId = _$state$params.travelerId,
        organizationName = _$state$params.travelerOrganizationName,
        topic = _$state$params.topic,
        channel = _$state$params.channel;

    $scope.traveler = {};
    $scope.channel = channel;
    $scope.filesToSend = [];
    $scope.isSending = false;

    if (fromNumber) {
      $scope.isInConversation = true;

      if (channel === 'messenger') {
        $scope.conversationTitle = firstName + ' ' + lastName + ' from ' + organizationName + ' via Messenger';
      } else if (channel === 'sms') {
        $scope.conversationTitle = firstName + ' ' + lastName + ' from ' + organizationName + ' via SMS (+' + fromNumber + ')';
      } else {
        $scope.conversationTitle = firstName + ' ' + lastName + ' from ' + organizationName;
      }

      //messages
      members.getMemberById(travelerId).then(function (res) {
        var memberInfo = res.data;
        $scope.traveler = res.data;
        var loginMember = authService.getLoginMember();
        conversationService.getConversation(fromNumber).then(function () {
          var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
            var conversationData;
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    conversationData = response.data;

                    console.log('memberInfo 567', memberInfo);
                    $scope.chats = conversationData.map(function (message) {
                      if (message.isBot) {
                        var val = void 0;
                        try {
                          val = JSON.parse(message.message);
                          console.log('DEBUG => ', val);
                          if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' || val instanceof Object) {
                            var templateType = val.template_type;
                            if (templateType === 'generic') {
                              var elements = val.elements;
                              return {
                                direction: 'out',
                                img: 'images/avatar/bot.png',
                                name: 'Obex Bot',
                                time: moment(message.time).format('MM-DD-YYYY h:mm:ss a'),
                                message: undefined,
                                template: elements.map(function (m) {
                                  return {
                                    title: m.title,
                                    subtitle: m.subtitle,
                                    image_url: m.image_url
                                  };
                                }),
                                templateType: templateType,
                                mediaUrl0: message.mediaUrl0,
                                mediaUrl1: message.mediaUrl1,
                                mediaUrl2: message.mediaUrl2
                              };
                            } else if (templateType === 'airline_itinerary' || templateType === 'airline_checkin') {
                              return {
                                direction: 'out',
                                img: 'images/avatar/bot.png',
                                name: 'Obex Bot',
                                time: moment(message.time).format('MM-DD-YYYY h:mm:ss a'),
                                message: undefined,
                                template: {
                                  intro_message: val.intro_message,
                                  pnr_number: val.pnr_number,
                                  passenger_info: val.passenger_info[0],
                                  flight_info: val.flight_info[0],
                                  passenger_segment_info: val.passenger_segment_info[0],
                                  total_price: val.total_price,
                                  currency: val.currency
                                },
                                templateType: templateType,
                                mediaUrl0: message.mediaUrl0,
                                mediaUrl1: message.mediaUrl1,
                                mediaUrl2: message.mediaUrl2
                              };
                            } else if (templateType === 'airline_update') {
                              return {
                                direction: 'out',
                                img: 'images/avatar/bot.png',
                                name: 'Obex Bot',
                                time: moment(message.time).format('MM-DD-YYYY h:mm:ss a'),
                                message: undefined,
                                template: {
                                  intro_message: val.intro_message,
                                  pnr_number: val.pnr_number,
                                  flight_info: val.update_flight_info
                                },
                                templateType: templateType,
                                mediaUrl0: message.mediaUrl0,
                                mediaUrl1: message.mediaUrl1,
                                mediaUrl2: message.mediaUrl2
                              };
                            } else if (templateType === 'list') {
                              var _elements = val.elements;
                              return {
                                direction: 'out',
                                img: 'images/avatar/bot.png',
                                name: 'Obex Bot',
                                time: moment(message.time).format('MM-DD-YYYY h:mm:ss a'),
                                message: undefined,
                                template: _elements.map(function (m) {
                                  return {
                                    title: m.title,
                                    subtitle: m.subtitle
                                  };
                                }),
                                templateType: templateType,
                                mediaUrl0: message.mediaUrl0,
                                mediaUrl1: message.mediaUrl1,
                                mediaUrl2: message.mediaUrl2
                              };
                            }
                          }
                        } catch (e) {
                          val = JSON.parse((0, _stringify2.default)(message.message));
                          if (typeof val === 'string' || val instanceof String) {
                            return {
                              direction: 'out',
                              img: 'images/avatar/bot.png',
                              name: 'Obex Bot',
                              time: moment(message.time).format('MM-DD-YYYY h:mm:ss a'),
                              message: message.message,
                              mediaUrl0: message.mediaUrl0,
                              mediaUrl1: message.mediaUrl1,
                              mediaUrl2: message.mediaUrl2
                            };
                          }
                        }
                      } else {
                        return {
                          direction: message.Direction,
                          img: message.Direction === 'in' ? 'images/avatar/traveler.png' : 'images/avatar/agent.png',
                          name: message.Direction === 'in' ? memberInfo.FirstName + ' ' + memberInfo.LastName + '(' + message.FromNumber + ')' : loginMember.FirstName + ' ' + loginMember.LastName,
                          time: moment(message.time).format('MM-DD-YYYY h:mm:ss a'),
                          message: message.Message,
                          mediaUrl0: message.MediaUrl0,
                          mediaUrl1: message.MediaUrl1,
                          mediaUrl2: message.MediaUrl2
                        };
                      }
                    });

                    console.log('$scope.chats ', $scope.chats);

                  case 4:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());

        //context
        console.log('topic 715', topic);
        if (topic) {
          if (typeof topic === 'number') {
            conversationService.getTopic($scope.traveler.Email).then(function (response) {
              console.log('Topic 747', response.data);
              setBookingDetails(response.data);
            });
          } else {
            setBookingDetails(topic);
          }
        }
      });
    } else {
      $scope.isInConversation = false;
      $scope.conversationTitle = 'You are not assisting';
    }

    //on socket event
    $scope.$on('incomingText', function (event, data) {
      console.log('smsController incomingText ', event, data);
      $scope.$apply(function () {
        if (data.isBot) {
          var val = void 0;
          try {
            val = JSON.parse(data.message);
            console.log('DEBUG => ', val);
            if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' || val instanceof Object) {
              var templateType = val.template_type;
              if (templateType === 'generic') {
                var elements = val.elements;
                $scope.chats.push({
                  direction: 'out',
                  img: 'images/avatar/bot.png',
                  name: 'Obex Bot',
                  time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
                  message: undefined,
                  template: elements.map(function (m) {
                    return {
                      title: m.title,
                      subtitle: m.subtitle,
                      image_url: m.image_url
                    };
                  }),
                  templateType: templateType,
                  mediaUrl0: data.mediaUrl0,
                  mediaUrl1: data.mediaUrl1,
                  mediaUrl2: data.mediaUrl2
                });
              } else if (templateType === 'airline_itinerary' || templateType === 'airline_checkin') {
                $scope.chats.push({
                  direction: 'out',
                  img: 'images/avatar/bot.png',
                  name: 'Obex Bot',
                  time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
                  message: undefined,
                  template: {
                    intro_message: val.intro_message,
                    pnr_number: val.pnr_number,
                    passenger_info: val.passenger_info[0],
                    flight_info: val.flight_info[0],
                    passenger_segment_info: val.passenger_segment_info[0],
                    total_price: val.total_price,
                    currency: val.currency
                  },
                  templateType: templateType,
                  mediaUrl0: data.mediaUrl0,
                  mediaUrl1: data.mediaUrl1,
                  mediaUrl2: data.mediaUrl2
                });
              } else if (templateType === 'airline_update') {
                $scope.chats.push({
                  direction: 'out',
                  img: 'images/avatar/bot.png',
                  name: 'Obex Bot',
                  time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
                  message: undefined,
                  template: {
                    intro_message: val.intro_message,
                    pnr_number: val.pnr_number,
                    flight_info: val.update_flight_info
                  },
                  templateType: templateType,
                  mediaUrl0: data.mediaUrl0,
                  mediaUrl1: data.mediaUrl1,
                  mediaUrl2: data.mediaUrl2
                });
              } else if (templateType === 'list') {
                var _elements2 = val.elements;
                $scope.chats.push({
                  direction: 'out',
                  img: 'images/avatar/bot.png',
                  name: 'Obex Bot',
                  time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
                  message: undefined,
                  template: _elements2.map(function (m) {
                    return {
                      title: m.title,
                      subtitle: m.subtitle
                    };
                  }),
                  templateType: templateType,
                  mediaUrl0: data.mediaUrl0,
                  mediaUrl1: data.mediaUrl1,
                  mediaUrl2: data.mediaUrl2
                });
              }
            }
          } catch (e) {
            val = JSON.parse((0, _stringify2.default)(data.message));
            if (typeof val === 'string' || val instanceof String) {
              $scope.chats.push({
                direction: 'out',
                img: 'images/avatar/bot.png',
                name: 'Obex Bot',
                time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
                message: data.message,
                mediaUrl0: data.mediaUrl0,
                mediaUrl1: data.mediaUrl1,
                mediaUrl2: data.mediaUrl2
              });
            }
          }
        } else {
          if ($scope.chats.length && $scope.conversationTitle.includes(data.fromNumber)) {
            $scope.chats.push({
              direction: 'in',
              img: 'images/avatar/traveler.png',
              name: data.firstName + ' ' + data.lastName + '(' + data.fromNumber + ')',
              time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
              message: data.message,
              mediaUrl0: data.mediaUrl0,
              mediaUrl1: data.mediaUrl1,
              mediaUrl2: data.mediaUrl2
            });
            if (data.message.includes('The traveler does not want to chat at this time.')) {
              $scope.istravellerIgnore = true;
            } else {
              $scope.istravellerIgnore = false;
            }
          }
        }
      });
    });
    $scope.$on('outgoingText', function (event, data) {
      console.log('smsController outgoingText ', event, data);
      $scope.$apply(function () {
        $scope.chats.push({
          direction: 'out',
          img: 'images/avatar/agent.png',
          name: data.firstName + ' ' + data.lastName,
          time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
          message: data.message
        });
      });
    });
    //on user's action
    $scope.attachSms = function () {
      dialogId = ngDialog.open({
        template: 'templates/partials/attachFileForSms.html',
        className: 'ngdialog-theme-plain',
        scope: $scope,
        closeByEscape: false,
        closeByDocument: false
      });
    };
    $scope.$watch('files', function () {
      if ($scope.filesToSend) {
        //from binding in template
        if ($scope.filesToSend.length > 3) {
          alert('Only maximum of 3 files is allowed');
        }
      }
    });
    $scope.smsAttachment = function (files, chatParam) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          console.log(file);
          if (file != null) {
            conversationService.sendAttachment(file, chatParam).then(function (result) {
              var cloudinaryObj = result.data;
              var public_filename = cloudinaryObj.public_id + '.' + cloudinaryObj.format; // e.g. 'filename.jpg'
              console.log('conversationService.sendAttachment result', result);
              $scope.closeThisDialog(dialogId);
            });
          }
        }
      }
    };
    $scope.confirmSendAttachmentToSms = function () {
      if ($scope.filesToSend.length < 1) {
        alert('You must select at least 1 file');
      } else if ($scope.filesToSend.length > 3) {
        alert('You can not send more than 3 files');
      } else {
        $scope.isSending = true;
        var loginMember = authService.getLoginMember();
        var chatParam = {
          socketId: socketLogin.getSocketId(),
          agentId: loginMember.Id,
          agentFirstName: loginMember.FirstName,
          agentLastName: loginMember.LastName,
          agentEmail: loginMember.Email,
          agentOrganizationId: loginMember.OrganizationId,
          agencyName: loginMember.Organization.Name,
          smstext: '',
          topic: topic,
          travelerId: travelerId,
          travelerNumber: fromNumber,
          travelerFirstName: firstName,
          travelerLastName: lastName,
          channel: $scope.channel === null ? 'sms' : $scope.channel
        };
        $scope.smsAttachment($scope.filesToSend, chatParam);
      }
    };
    $scope.sendSms = function () {
      var loginMember = authService.getLoginMember();
      loginMember['SupportsOrganizations'] = [];
      if ($scope.smstext !== undefined && $scope.smstext.length > 0 && fromNumber !== null && fromNumber.length > 0) {
        $http.post('/textOut', {
          fromNumber: fromNumber,
          socketId: socketLogin.getSocketId(),
          firstName: loginMember.FirstName,
          lastName: loginMember.LastName,
          email: loginMember.Email,
          organizationId: loginMember.OrganizationId,
          loginMember: loginMember,
          smstext: $scope.smstext,
          topic: topic,
          travelerId: travelerId,
          channel: channel === null ? 'sms' : channel
        });
        $scope.smstext = '';
      }
    };
    $scope.finishConversation = function () {
      var confirmMessage = 'This is to confirm that you finish assisting the traveler. If so, you can click on the Yes button.  This tab will be closed and future messages from the traveler will not show up here.';
      ngDialog.openConfirm({
        template: confirmMessage + commonDialog.confirmDialog,
        className: 'ngdialog-theme-plain',
        plain: true
      }).then(function (value) {
        var loginMember = authService.getLoginMember();
        //progress.start()
        var smsData = {
          fromNumber: fromNumber,
          travelAgentEmail: loginMember.Email,
          status: smsStatus.Finished,
          message: 'Agent ' + loginMember.FirstName + ' ' + loginMember.LastName + ' finished conversation',
          channel: $scope.channel,
          travelAgentId: loginMember.Id,
          travelerId: travelerId,
          topic: topic,
          socketId: socketLogin.getSocketId(),
          organizationId: loginMember.Organization.Id
        };
        $http.post('/finish', smsData);
        $rootScope.$broadcast('removeFinishSms', smsData);
        $state.go('app');
        //progress.complete()
      });
    };
    $scope.onKeyPressed = function (keyEvent) {
      if (keyEvent.which === 13) {
        console.log('enter key ', keyEvent.which);
        $scope.sendSms();
      }
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;(function (module) {
  'use strict';

  module.controller('smsHistoryController', ['$scope', 'progressBar', 'historySms', 'tripsDashBoard', 'currency', 'uiGridConstants', 'clientSelectService', 'agencySelectService', '$timeout', function ($scope, progressBar, historySms, tripsDashBoard, currency, uiGridConstants, clientSelectService, agencySelectService, $timeout) {
    var progress = progressBar.getProgressBar();
    var gridData = [];
    $scope.showConversation = false;
    $scope.selectedRow = null;
    $scope.dateTo = new Date();
    $scope.dateFrom = moment($scope.dateTo).add(-1, 'week').toDate();

    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    var gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: false,
      useExternalSorting: false,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      enableColumnResizing: true,
      columnDefs: [{
        name: 'DisplayName',
        displayName: 'Traveler',
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'AgentName',
        displayName: 'Agent',
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Phone',
        displayName: 'Phone',
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Email',
        displayName: 'Primary Email',
        visible: true,
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'AlternateEmail',
        displayName: 'Alternate Email',
        visible: true,
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'LastUpdated',
        displayName: 'Time',
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        maxWidth: 250,
        enableColumnResizing: true,
        sort: {
          direction: uiGridConstants.DESC,
          priority: 0
        }
      }, {
        name: 'Message',
        displayName: 'Message',
        enableHiding: false,
        enableSorting: false,
        enableFiltering: false,
        enableColumnResizing: true
      }, {
        name: 'Conversation',
        displayName: '',
        visible: false,
        enableHiding: false
      }, {
        name: 'Channel',
        displayName: '',
        visible: false,
        enableHiding: false
      }, {
        name: 'CarId',
        displayName: '',
        visible: false,
        enableHiding: false
      }, {
        name: 'FlightId',
        displayName: '',
        visible: false,
        enableHiding: false
      }, {
        name: 'HotelId',
        displayName: '',
        visible: false,
        enableHiding: false
      }, {
        name: 'TripId',
        displayName: '',
        visible: false,
        enableHiding: false
      }, {
        name: 'TravelAgents',
        displayName: '',
        visible: false,
        enableHiding: false
      }]
    };

    $scope.gridDetails = _.cloneDeep(gridOptions);
    $scope.gridDetails.onRegisterApi = function (gridApi) {
      $scope.gridApi = gridApi;
      $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (!sortColumns.length) {
          paginationOptions.sort = null;
        } else {
          paginationOptions.sort = sortColumns[0].sort.direction;
        }
        updateGridPagination(gridData);
      });
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        paginationOptions.pageNumber = newPage;
        paginationOptions.pageSize = pageSize;
        updateGridPagination(gridData);
      });
      //Show trip booking details on grid row selection.
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        if ($scope.selectedRow === row) {
          $scope.showConversation = !$scope.showConversation;
        } else {
          $scope.showConversation = true;
          $scope.selectedRow = row;
        }
        if ($scope.showConversation) {
          $scope.hasNonTripContext = !!row.entity.CarId || !!row.entity.FlightId || !!row.entity.HotelId;
          $scope.hasTripContext = !!row.entity.TripId;

          $scope.TravelerName = row.entity.DisplayName;
          $scope.TravelerPhone = row.entity.Phone;
          $scope.Email = row.entity.Email;
          $scope.Channel = row.entity.Channel;
          populateChatPanel(row.entity.DisplayName, row.entity.Conversation, row.entity.AgentName, row.entity.TravelAgents);
          populateContextPanel(row.entity.CarId, row.entity.FlightId, row.entity.HotelId, row.entity.TripId);
        }
      });
    };

    var populateChatPanel = function populateChatPanel(travelerName, conversation, agentName, travelAgents) {
      progress.start();
      historySms.getDetailedConversation(conversation).then(function (response) {
        var chatMessages = response.data;
        console.log(chatMessages);

        $scope.chats = chatMessages.map(function (conversationMsg) {
          var message = void 0;
          var template = void 0;
          var templateType = void 0;
          var arrMsgTempDetails = {};
          var img = '';
          var direction = '';
          if (conversationMsg.Message.indexOf('{') !== -1) {
            img = 'images/avatar/bot.png';
            direction = 'out';
            var msgTemplate = JSON.parse(conversationMsg.Message);
            templateType = msgTemplate.template_type;
            template = {};
            if (templateType === 'airline_itinerary' || templateType === 'airline_checkin' || templateType === 'airline_update') {
              var flightInfo = msgTemplate.update_flight_info !== undefined ? msgTemplate.update_flight_info : msgTemplate.flight_info[0];
              template = {
                intro_message: msgTemplate.intro_message,
                pnr_number: msgTemplate.pnr_number,
                flight_info: {
                  flight_schedule: {
                    departure_time: flightInfo.flight_schedule.departure_time
                  },
                  departure_airport: {
                    city: flightInfo.departure_airport.city,
                    airport_code: flightInfo.departure_airport.airport_code
                  },
                  arrival_airport: {
                    city: flightInfo.arrival_airport.city,
                    airport_code: flightInfo.arrival_airport.airport_code
                  }
                }
              };
              if (templateType === 'airline_itinerary') {
                template.passenger_info = {
                  name: msgTemplate.passenger_info[0].name
                };
                template.total_price = msgTemplate.total_price;
                template.currency = msgTemplate.currency;
              }
            } else if (templateType === 'generic') {
              template = [];
              template: msgTemplate.elements.map(function (m) {
                return {
                  title: m.title,
                  subtitle: m.subtitle,
                  image_url: m.image_url
                };
              });
            } else if (templateType === 'list') {
              template = [];
              template: msgTemplate.elements.map(function (m) {
                return {
                  title: m.title,
                  subtitle: m.subtitle
                };
              });
            }
          } else {
            message = conversationMsg.Message;
            img = conversationMsg.AgentId === null ? 'images/avatar/traveler.png' : 'images/avatar/agent.png';
            direction = conversationMsg.AgentId === null ? 'in' : 'out';
          }
          arrMsgTempDetails = {
            direction: direction,
            img: img,
            time: moment.utc(conversationMsg.LastUpdated).local().format('MM-DD-YYYY H:mm:ss'),
            mediaUrl0: conversationMsg.mediaUrl0,
            mediaUrl1: conversationMsg.mediaUrl1,
            mediaUrl2: conversationMsg.mediaUrl2
          };
          if (conversationMsg.Message.indexOf('{') !== -1) {
            ;arrMsgTempDetails.templateType = templateType, arrMsgTempDetails.template = template;
          } else {
            arrMsgTempDetails.message = message;
          }

          if (conversationMsg.Message.indexOf('{') !== -1) {
            arrMsgTempDetails.name = 'Obex Bot';
          } else if (conversationMsg.Channel === 'messenger' && conversationMsg.IsBot === true) {
            arrMsgTempDetails.name = 'Obex Bot';
            arrMsgTempDetails.direction = 'out';
          } else if (travelAgents.length < 2 || !conversationMsg.AgentId) {
            arrMsgTempDetails.name = conversationMsg.AgentId === null ? travelerName + '(' + conversationMsg.Phone + ')' : agentName;
          } else {
            travelAgents.forEach(function (travelAgent) {
              if (travelAgent.Id === conversationMsg.AgentId) {
                arrMsgTempDetails.name = travelAgent.FirstName + ' ' + travelAgent.LastName;
              }
            });
          }
          return arrMsgTempDetails;
        });
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        progress.complete();
      });
    };

    var populateContextPanel = function populateContextPanel(carId, flightId, hotelId, tripId) {
      if (tripId) {
        populateTripContextPanel(tripId);
      } else if (carId) {
        populateCarContextPanel(carId);
      } else if (flightId) {
        populateFlightContextPanel(flightId);
      } else if (hotelId) {
        populateHotelContextPanel(hotelId);
      }
    };

    var populateCarContextPanel = function populateCarContextPanel(carId) {
      tripsDashBoard.getCarsDashById(carId).then(function (response) {
        var contextData = response.data;
        $scope.bookingType = 'Car Reservation';

        $scope.carContext = {
          pnr: contextData.Pnr,
          rentalCompany: contextData.RentalCompany,
          pickupDateTime: moment(contextData.PickUpDateTime).format('MM-DD-YYYY h:mm'),
          pickupLocation: contextData.PickUpLocation,
          pickupLocationIsAirport: contextData.PickUpAtAirport === true ? 'Yes' : 'No',
          pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
          pickupLocationCode: contextData.PickUpLocationCode,
          dropoffDateTime: moment(contextData.DropOffDateTime).format('MM-DD-YYYY h:mm'),
          dropoffLocation: contextData.DropOffLocation,
          dropoffLocationIsAirport: contextData.DropOffAtAirport === true ? 'Yes' : 'No',
          dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
          dropoffLocationCode: contextData.DropOffLocationCode,
          carModel: contextData.CarModel,
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          totalCharge: contextData.TotalCharge + ' ' + (contextData.CurrencyCode === null ? '' : contextData.CurrencyCode),
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted === true ? 'Yes' : 'No'
        };
      }).catch(function (err) {
        console.log(err);
      });
    };

    var populateFlightContextPanel = function populateFlightContextPanel(flightId) {
      tripsDashBoard.getFlightsDashById(flightId).then(function (response) {
        var contextData = response.data;
        $scope.bookingType = 'Airline Reservation';

        var statusColor = '#000000'; //black
        var flightStatus = 'scheduled';
        var dateTime = new Date();
        var arrivalTime = moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss');
        var currentDateTime = moment(dateTime).format('MM-DD-YYYY h:mm:ss');
        if (contextData.FlightStat !== null) {
          var departureTime = moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss');
          var estimatedDeparuteTime = moment(contextData.FlightStat.EstimatedDeparture).format('MM-DD-YYYY h:mm:ss');
          var estimatedArrival = moment(contextData.FlightStat.EstimatedArrival).format('MM-DD-YYYY h:mm:ss');
          statusColor = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? '#3d9400' : estimatedDeparuteTime > departureTime ? '#cc0000' : statusColor;
          flightStatus = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? 'on time' : estimatedDeparuteTime > departureTime ? 'delayed' : currentDateTime > estimatedArrival ? 'past flight' : flightStatus;
        }
        if (contextData.Cancelled === true) {
          statusColor = '#cc0000'; //red
          flightStatus = 'cancelled';
        }
        if (contextData.FlightStat === null && currentDateTime > arrivalTime) {
          flightStatus = 'past flight';
        }
        $scope.flightContext = {
          statusColor: statusColor,
          flightStatus: flightStatus,
          estimatedDeparture: contextData.FlightStat !== null && contextData.FlightStat.EstimatedDeparture !== null ? contextData.FlightStat.EstimatedDeparture : contextData.DepartureDateTime,
          estimatedArrival: contextData.FlightStat !== null && contextData.FlightStat.EstimatedArrival !== null ? contextData.FlightStat.EstimatedArrival : contextData.ArrivalDateTime,
          pnr: contextData.Pnr,
          depart: contextData.DepartureName + ' (' + contextData.DepartureAirport + ')',
          arrival: contextData.ArrivalName + ' (' + contextData.ArrivalAirport + ')',
          departureName: contextData.DepartureName,
          departureAirport: contextData.DepartureAirport,
          departureDateTime: moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss'),
          departureGate: contextData.FlightStat !== null && contextData.FlightStat.DepartureGate !== null ? contextData.FlightStat.DepartureGate : '-',
          departureTerminal: contextData.FlightStat !== null && contextData.FlightStat.DepartureTerminal !== null ? contextData.FlightStat.DepartureTerminal : '-',
          startDate: contextData.DepartureDateTime,
          endDate: contextData.ArrivalDateTime,
          arrivalName: contextData.ArrivalName,
          arrivalAirport: contextData.ArrivalAirport,
          arrivalDateTime: moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss'),
          arrivalGate: contextData.FlightStat !== null && contextData.FlightStat.ArrivalGate !== null ? contextData.FlightStat.ArrivalGate : '-',
          arrivalTerminal: contextData.FlightStat !== null && contextData.FlightStat.ArrivalTerminal !== null ? contextData.FlightStat.ArrivalTerminal : '-',
          operatingAirline: contextData.OperatingAirline,
          flightNumber: contextData.FlightNumber,
          duration: contextData.Duration,
          bookingSource: contextData.BookingSource,
          confirmation: contextData.ConfirmationNumber,
          cabin: contextData.Cabin,
          bookingClass: contextData.BookingClass,
          numberInParty: contextData.NumberInParty,
          airTravelers: contextData.AirReservation.AirTravelers,
          //airTravelers: Object.keys(contextData.AirReservation.AirTravelers).map(function(x){return contextData.AirReservation.AirTravelers[x].Name}).join(','),
          comment: contextData.AirReservation.Comment,
          seats: contextData.Seats,
          totalCharge: currency.getCurrencySymbol(contextData.AirReservation.CurrencyCode) + contextData.AirReservation.TotalFare,
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted ? 'Yes' : 'No',
          vendor: contextData.Vendor
        };
      }).catch(function (err) {
        console.log(err);
      });
    };

    var populateHotelContextPanel = function populateHotelContextPanel(hotelId) {
      tripsDashBoard.getHotelsDashById(hotelId).then(function (response) {
        var contextData = response.data;
        $scope.bookingType = 'Hotel Reservation';

        $scope.hotelContext = {
          pnr: contextData.Pnr,
          hotelName: contextData.HotelName,
          address: contextData.Address,
          checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
          checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          guestNames: contextData.GuestNames,
          numberOfRooms: contextData.NumberOfRooms,
          roomType: contextData.RoomType,
          totalCharge: contextData.Total + ' ' + (contextData.CurrencyCode === null ? '' : contextData.CurrencyCode),
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted === true ? 'Yes' : 'No'
        };
      }).catch(function (err) {
        console.log(err);
      });
    };

    var populateTripContextPanel = function populateTripContextPanel(tripId) {
      tripsDashBoard.getTripsDashbyId(tripId).then(function (response) {
        var trips = response.data;
        if (trips) {
          var flightList = mapFlightContext(trips.Flights);
          var hotelList = mapCarContext(trips.Cars);
          var carList = mapHotelContext(trips.Hotels);
          var limoList = mapLimoContext(trips.Limos);
          var contextList = [flightList, carList, hotelList, limoList].reduce(function (prevData, currData) {
            return prevData.concat(currData);
          }, []);

          contextList.sort(sortByDateAsc);
          $scope.contextList = contextList;
        } else {
          $scope.contextList = [];
        }
      }).catch(function (err) {
        console.log(err);
      });
    };

    var sortByDateAsc = function sortByDateAsc(a, b) {
      var firstStartDate = moment(a.startDate).format('MM-DD-YYYY');
      var secondStartDate = moment(b.startDate).format('MM-DD-YYYY');
      if (firstStartDate > secondStartDate) {
        return 1;
      } else if (firstStartDate < secondStartDate) {
        return -1;
      } else if (firstStartDate === secondStartDate) {
        if (a.bookingTypeName === 'A' && b.bookingTypeName === 'A') {
          var tempStartDate = moment(a.StartDate).format('MM-DD-YYYY HH:mm');
          var tempEndDate = moment(b.StartDate).format('MM-DD-YYYY HH:mm');
          if (tempStartDate > tempEndDate) {
            return 1;
          } else {
            return -1;
          }
        } else if (a.bookingTypeName === 'A') {
          return -1;
        } else if (b.bookingTypeName === 'A') {
          return 1;
        } else if (a.bookingTypeName === 'H' && b.bookingTypeName === 'C') {
          return -1;
        } else if (a.bookingTypeName === 'C' && b.bookingTypeName === 'H') {
          return 1;
        } else {
          return 0;
        }
      }
    };

    //function to set ui-grid data
    function setGridData() {
      var startDate = moment($scope.dateFrom).utc().format('MM-DD-YYYY hh:mm');
      var endDate = moment($scope.dateTo).utc().format('MM-DD-YYYY hh:mm');

      var selectedClientId = clientSelectService.getSelectedClient().id;
      var conversations = [];
      progress.start();
      historySms.getConversations(startDate, endDate, selectedClientId).then(function (response) {
        conversations = response.data;

        gridData = _.map(conversations, function (obj) {
          var tempData = {
            DisplayName: obj.Member.DisplayName,
            Phone: obj.Phone,
            LastUpdated: moment.utc(obj.LastUpdated).local().format('MM-DD-YYYY HH:mm:ss'),
            Conversation: obj.Conversation,
            CarId: obj.CarId,
            FlightId: obj.FlightId,
            HotelId: obj.HotelId,
            TripId: obj.TripId,
            Channel: obj.Channel,
            Message: obj.Message
          };

          var AgentName = '';
          if (obj.Message.indexOf('{') !== -1 || obj.Channel === 'messenger' && obj.TravelAgents.length === 0) {
            AgentName = 'Obex Bot, ';
          }

          obj.TravelAgents.forEach(function (travelAgent) {
            AgentName += travelAgent.FirstName + ' ' + travelAgent.LastName + ', ';
          });
          tempData.Email = obj.Member.Email ? obj.Member.Email : '';
          tempData.AlternateEmail = obj.Member.AlternateEmail ? obj.Member.AlternateEmail : '';
          tempData.AgentName = AgentName !== undefined && AgentName.length > 1 ? AgentName.substr(0, AgentName.length - 2) : '';

          tempData.TravelAgents = obj.TravelAgents;
          return tempData;
        });
        updateGridPagination(gridData);
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        progress.complete();
      });
    }

    //entry point
    setGridData();

    function updateGridPagination(gridData) {
      $scope.gridDetails.data = gridData;
      $scope.gridDetails.totalItems = gridData.length;
    }

    $scope.searchSmsHistory = function () {
      setGridData();
    };

    function mapFlightContext(flightContext) {
      return flightContext.map(function (contextData) {
        var statusColor = '#000000'; //black
        var flightStatus = 'scheduled';
        var currentDateTime = new Date();
        var arrivalTime = moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss');
        currentDateTime = moment(currentDateTime).format('MM-DD-YYYY h:mm:ss');
        if (contextData.FlightStat !== null) {
          var departureTime = moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss');
          var estimatedDeparuteTime = moment(contextData.FlightStat.EstimatedDeparture).format('MM-DD-YYYY h:mm:ss');
          var estimatedArrival = moment(contextData.FlightStat.EstimatedArrival).format('MM-DD-YYYY h:mm:ss');
          statusColor = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? '#3d9400' : estimatedDeparuteTime > departureTime ? '#cc0000' : statusColor;
          flightStatus = departureTime === estimatedDeparuteTime || estimatedDeparuteTime < departureTime ? 'on time' : estimatedDeparuteTime > departureTime ? 'delayed' : currentDateTime > estimatedArrival ? 'past flight' : flightStatus;
        }
        if (contextData.Cancelled === true) {
          statusColor = '#cc0000'; //red
          flightStatus = 'cancelled';
        }
        if (contextData.FlightStat === null && currentDateTime > arrivalTime) {
          flightStatus = 'past flight';
        }
        return {
          statusColor: statusColor,
          flightStatus: flightStatus,
          estimatedDeparture: contextData.FlightStat !== null && contextData.FlightStat.EstimatedDeparture !== null ? contextData.FlightStat.EstimatedDeparture : contextData.DepartureDateTime,
          estimatedArrival: contextData.FlightStat !== null && contextData.FlightStat.EstimatedArrival !== null ? contextData.FlightStat.EstimatedArrival : contextData.ArrivalDateTime,
          pnr: contextData.Pnr,
          bookingTypeName: 'A',
          bookingType: 'Airline Reservation',
          depart: contextData.DepartureName + ' (' + contextData.DepartureAirport + ')',
          arrival: contextData.ArrivalName + ' (' + contextData.ArrivalAirport + ')',
          departureName: contextData.DepartureName,
          departureAirport: contextData.DepartureAirport,
          departureDateTime: moment(contextData.DepartureDateTime).format('MM-DD-YYYY h:mm:ss'),
          departureGate: contextData.FlightStat !== null && contextData.FlightStat.DepartureGate !== null ? contextData.FlightStat.DepartureGate : '-',
          departureTerminal: contextData.FlightStat !== null && contextData.FlightStat.DepartureTerminal !== null ? contextData.FlightStat.DepartureTerminal : '-',
          startDate: contextData.DepartureDateTime,
          endDate: contextData.ArrivalDateTime,
          arrivalName: contextData.ArrivalName,
          arrivalAirport: contextData.ArrivalAirport,
          arrivalDateTime: moment(contextData.ArrivalDateTime).format('MM-DD-YYYY h:mm:ss'),
          arrivalGate: contextData.FlightStat !== null && contextData.FlightStat.ArrivalGate !== null ? contextData.FlightStat.ArrivalGate : '-',
          arrivalTerminal: contextData.FlightStat !== null && contextData.FlightStat.ArrivalTerminal !== null ? contextData.FlightStat.ArrivalTerminal : '-',
          operatingAirline: contextData.OperatingAirline,
          flightNumber: contextData.FlightNumber,
          duration: contextData.Duration,
          bookingSource: contextData.BookingSource,
          confirmation: contextData.ConfirmationNumber,
          cabin: contextData.Cabin,
          bookingClass: contextData.BookingClass,
          numberInParty: contextData.NumberInParty,
          airTravelers: contextData.AirReservation.AirTravelers,
          comment: contextData.AirReservation.Comment,
          seats: contextData.Seats,
          totalCharge: currency.getCurrencySymbol(contextData.AirReservation.CurrencyCode) + contextData.AirReservation.TotalFare,
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted ? 'Yes' : 'No',
          vendor: contextData.Vendor
        };
      });
    }

    function mapCarContext(carContext) {
      return carContext.map(function (contextData) {
        return {
          bookingTypeName: 'C',
          bookingType: 'Car Reservation',
          pnr: contextData.Pnr,
          startDate: contextData.PickUpDateTime,
          rentalCompany: contextData.RentalCompany,
          pickupDateTime: moment(contextData.PickUpDateTime).format('MM-DD-YYYY h:mm'),
          pickupLocation: contextData.PickUpLocation,
          pickupLocationIsAirport: contextData.PickUpAtAirport === true ? 'Yes' : 'No',
          pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
          pickupLocationCode: contextData.PickUpLocationCode,
          dropoffDateTime: moment(contextData.DropOffDateTime).format('MM-DD-YYYY h:mm'),
          dropoffLocation: contextData.DropOffLocation,
          dropoffLocationIsAirport: contextData.DropOffAtAirport === true ? 'Yes' : 'No',
          dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
          dropoffLocationCode: contextData.DropOffLocationCode,
          carModel: contextData.CarModel,
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          totalCharge: contextData.TotalCharge + ' ' + (contextData.CurrencyCode === null ? '' : contextData.CurrencyCode),
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted === true ? 'Yes' : 'No'
        };
      });
    }

    function mapHotelContext(hotelContext) {
      return hotelContext.map(function (contextData) {
        return {
          bookingTypeName: 'H',
          bookingType: 'Hotel Reservation',
          pnr: contextData.Pnr,
          startDate: contextData.CheckInDate,
          hotelName: contextData.HotelName,
          address: contextData.Address,
          checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
          checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
          confirmation: contextData.Confirmation,
          bookingSource: contextData.BookingSource,
          guestNames: contextData.GuestNames,
          numberOfRooms: contextData.NumberOfRooms,
          roomType: contextData.RoomType,
          totalCharge: contextData.Total + ' ' + (contextData.CurrencyCode === null ? '' : contextData.CurrencyCode),
          lastUpdated: moment(contextData.Updated).format('MM-DD-YYYY h:mm:ss'),
          isDeleted: contextData.Deleted === true ? 'Yes' : 'No'
        };
      });
    }

    function mapLimoContext(limoContext) {
      return limoContext.map(function (contextData) {
        return {
          Id: contextData.Id,
          bookingTypeName: 'L',
          bookingType: 'Limo Reservation',
          startDate: contextData.DepartureDate,
          departureDate: moment(contextData.DepartureDate).format('MM-DD-YYYY'),
          departureTime: moment(contextData.DepartureDate).format('h:mm a'),
          limoServiceName: contextData.LimoServiceName,
          locationName: contextData.LocationName,
          bookingSource: contextData.BookingSource,
          cancelled: contextData.Cancelled,
          confirmation: contextData.Confirmation,
          dropOff: contextData.DropOff,
          IPCC: contextData.IPCC,
          imageLink: contextData.ImageLink,
          instructions: contextData.Instructions,
          pickUp: contextData.PickUp,
          pnr: contextData.Pnr,
          time: contextData.Time
        };
      });
    }
    // Validate that filtered organization id is defined
    function validateOrganization() {
      var organization = clientSelectService.getSelectedClient();
      return organization.id != null && (0, _isInteger2.default)(organization.id);
    }

    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }

    angular.element(document).ready(function () {});
    // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      $scope.gridDetails.data = [];
      $scope.gridDetails.totalItems = 0;
      $scope.isInConversation = false;
      $scope.bookingType = null;
      $scope.chats = [];
      $scope.showConversation = false;
      if (newValue !== oldValue) {
        $scope.client = null;
        $scope.selectedValue = null;
        $timeout($scope.searchSmsHistory, 3000);
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__(92);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(24);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(62);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;(function (module) {
  'use strict';

  function SmsNotificationController($rootScope, $scope, $state, $http, $sce, socket, socketTransmit, socketLogin, alertService, authService, smsStatus) {
    $scope.groupAlerts = [];
    $scope.handleInProgress = false;
    //$scope.carouselVisible = false;
    $scope.onCarouselInit = function () {};
    $scope.renderHtml = function (htmlCode) {
      return $sce.trustAsHtml(htmlCode);
    };

    var status = !!$state.params.status ? $state.params.status : 0;

    //init of page
    function updateAlerts() {
      alertService.getUnhandledAlerts().then(function (response) {
        var unhandledAlerts = response.data;

        //25550624/group-by-multiple-values-underscore-js-but-keep-the-keys-and-values
        var groups = _.groupBy(unhandledAlerts, function (alert) {
          return alert.FromNumber + '#' + alert.FirstName + '#' + alert.LastName;
        });

        var grouppedAlerts = _.map(groups, function (group) {
          var _ref;

          return _ref = {
            handleClicked: false,
            fromNumber: group[0].FromNumber,
            firstName: group[0].Member.FirstName,
            lastName: group[0].Member.LastName,
            email: group[0].Member.AlternateEmail ? group[0].Member.AlternateEmail : group[0].Member.Email,
            travelerId: group[0].TravelerId,
            organizationName: group[0].Member.Organization.Name,
            conversation: group[0].ChatMessageId,
            topic: group[0].TopicId,
            fromDatabase: false,
            status: smsStatus.Live,
            alerts: _.map(group, function (g) {
              var val = void 0;
              try {
                val = JSON.parse(g.Message);
                if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' || val instanceof Object) {
                  console.log('DEBUG Case 1 ', val);
                  var templateType = val.template_type;
                  console.log('DEBUG ==> ', templateType);
                  console.log('DEBUG => ', val);
                  if (templateType === 'generic') {
                    var elements = val.elements;
                    return {
                      message: undefined,
                      template: elements.map(function (m) {
                        return {
                          title: m.title,
                          subtitle: m.subtitle,
                          image_url: m.image_url
                        };
                      }),
                      templateType: templateType,
                      time: moment(g.time).format('MM-DD-YYYY h:mm:ss a'),
                      mediaUrl0: g.MediaUrl0,
                      isBot: g.IsBot,
                      direction: 'in'
                    };
                  } else if (templateType === 'airline_itinerary') {
                    return {
                      message: undefined,
                      template: {
                        intro_message: val.intro_message,
                        pnr_number: val.pnr_number,
                        passenger_info: val.passenger_info[0],
                        flight_info: val.flight_info[0],
                        passenger_segment_info: val.passenger_segment_info[0],
                        total_price: val.total_price,
                        currency: val.currency
                      },
                      templateType: templateType,
                      time: moment(g.time).format('MM-DD-YYYY h:mm:ss a'),
                      mediaUrl0: g.MediaUrl0,
                      isBot: g.IsBot,
                      direction: 'in'
                    };
                  } else if (templateType === 'airline_checkin') {
                    return {
                      message: undefined,
                      template: {
                        intro_message: val.intro_message,
                        pnr_number: val.pnr_number,
                        flight_info: val.flight_info[0]
                      },
                      templateType: templateType,
                      time: moment(g.time).format('MM-DD-YYYY h:mm:ss a'),
                      mediaUrl0: g.MediaUrl0,
                      isBot: g.IsBot,
                      direction: 'in'
                    };
                  } else if (templateType === 'airline_update') {
                    return {
                      message: undefined,
                      template: {
                        intro_message: val.intro_message,
                        pnr_number: val.pnr_number,
                        flight_info: val.update_flight_info
                      },
                      templateType: templateType,
                      time: moment(g.time).format('MM-DD-YYYY h:mm:ss a'),
                      mediaUrl0: g.MediaUrl0,
                      isBot: g.IsBot,
                      direction: 'in'
                    };
                  } else if (templateType === 'list') {
                    var _elements = val.elements;
                    return {
                      message: undefined,
                      template: _elements.map(function (m) {
                        return {
                          title: m.title,
                          subtitle: m.subtitle
                        };
                      }),
                      templateType: templateType,
                      time: moment(g.time).format('MM-DD-YYYY h:mm:ss a'),
                      mediaUrl0: g.MediaUrl0,
                      isBot: g.IsBot,
                      direction: 'in'
                    };
                  }
                }
              } catch (e) {
                console.log('DEBUG Case 2', val);
                val = JSON.parse((0, _stringify2.default)(g.Message));
                console.log('DEBUG Case 3', val);
                if (typeof val === 'string' || val instanceof String) {
                  return {
                    message: g.Message,
                    time: moment(g.time).format('MM-DD-YYYY h:mm:ss a'),
                    mediaUrl0: g.MediaUrl0,
                    isBot: g.IsBot ? g.IsBot : false,
                    direction: 'in'
                  };
                }
              }
            })

          }, (0, _defineProperty3.default)(_ref, 'topic', group[0].TopicId), (0, _defineProperty3.default)(_ref, 'channel', group[0].Channel), _ref;
        });

        $scope.groupAlerts = grouppedAlerts;
      });
    }

    if (status === 0) {
      updateAlerts();
    }

    setTimeout(function () {
      if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        var evt = document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);
      } else {
        window.dispatchEvent(new Event('resize'));
      }
    }, 2000);

    //on socket event
    $scope.$on('updateAlerts', function (event, data) {
      console.log('updateAlerts');
      updateAlerts();
    });

    //init of page

    //on user's action
    $scope.handleAlert = function (alert) {
      //fromNumber, firstName, lastName) {
      $scope.handleInProgress = true;
      console.log(alert);
      console.log($scope.groupAlerts);
      var loginMember = authService.getLoginMember();
      var status = !!alert.status ? alert.status : smsStatus.Live;
      var handleData = {
        fromNumber: alert.fromNumber,
        socketId: socketLogin.getSocketId(),
        travelAgencyId: loginMember.Organization.Id,
        travelAgencyName: loginMember.Organization.Name,
        travelAgentFirstName: loginMember.FirstName,
        travelAgentLastName: loginMember.LastName,
        travelAgentEmail: loginMember.Email,
        travelAgentId: loginMember.Id,
        topic: alert.topic,
        travelerFirstName: alert.firstName,
        travelerLastName: alert.lastName,
        travelerOrganizationName: alert.organizationName,
        conversation: alert.conversation,
        fromDatabase: alert.fromDatabase,
        transferByAgentEmail: alert.transferByAgentEmail ? alert.transferByAgentEmail : null,
        status: status,
        channel: alert.channel,
        firstTimeHandle: true,
        travelerId: alert.travelerId
      };

      $rootScope.$broadcast('smsHandle', handleData);
      if ($state.current.name !== 'app.sms') {
        $http.post('/handleConversation', handleData).then(function (response) {
          $state.go('app.sms', {
            fromNumber: alert.fromNumber,
            travelerFirstName: alert.firstName,
            travelerLastName: alert.lastName,
            travelerOrganizationName: alert.organizationName,
            travelerId: alert.travelerId,
            topic: alert.topic,
            fromDatabase: false,
            conversation: alert.conversation,
            status: status,
            channel: alert.channel
          });
          setTimeout(function () {
            $scope.handleInProgress = false;
          }, 5000);
        });
      } else {
        $state.go($state.current, {}, {
          reload: true
        });
      }
    };
  }

  module.controller('SmsNotificationController', ['$rootScope', '$scope', '$state', '$http', '$sce', 'socket', 'socketTransmit', 'socketLogin', 'alertService', 'authService', 'smsStatus', SmsNotificationController]);
})(angular.module('obex'));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (module) {
  'use strict';

  module.controller('ssoOrganizationsController', ['$scope', 'progressBar', 'clientSelectService', 'agencySelectService', 'ssoOrganizations', 'ngDialog', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state', '$stateParams', 'toastFactory', 'authService', function ($scope, progressBar, clientSelectService, agencySelectService, ssoOrganizations, ngDialog, uiGridConstants, commonDialog, commonDialogMessage, $state, $stateParams, toastFactory, authService) {
    var progress = progressBar.getProgressBar();
    var id = $stateParams.id;
    $scope.ssoOrganization = {};
    $scope.validate = {};

    if (!!id) {
      getSsoOrganizationById(id);
      $scope.isEdit = true;
    };

    function getSsoOrganizationById(id) {
      progress.start();
      ssoOrganizations.getSsoOrganizationById(id).then(function (ssoOrganization) {
        $scope.isEdit = true;
        var ssoOrg = ssoOrganization.data[0];
        $scope.ssoOrganization = {
          id: ssoOrg.Id,
          organizationCode: ssoOrg.OrganizationCode,
          globalId: ssoOrg.GlobalId,
          organizationId: ssoOrg.OrganizationId
        };
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Get SSO Organization Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };
    // Begin ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    // ui-grid options
    $scope.gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: true,
      useExternalSorting: false,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      visible: true,
      enableColumnResizing: true,
      columnDefs: [{
        name: 'OrganizationCode',
        displayName: 'Organization Code',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'GlobalId',
        displayName: 'Global Id',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }],
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (!sortColumns.length) {
            paginationOptions.sort = null;
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction;
          }
        });
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          setGridData();
        });
        // Show organization details on grid row selection.
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.rowSelectingId = row.entity.Id;
          if (row.isSelected) {
            $scope.rowSelecting = true;
          } else {
            $scope.rowSelecting = false;
          }
        });
      }
    };
    $scope.edit = function () {
      $state.go('app.editSsoOrganization', {
        id: $scope.rowSelectingId
      });
    };
    $scope.saveSsoOrganization = function () {
      if ($scope.ssoOrganization.organizationCode && $scope.ssoOrganization.globalId) {
        var organization = clientSelectService.getSelectedClient();
        progress.start();
        ssoOrganizations.addSsoOrganization($scope.ssoOrganization, organization.id).then(function () {
          var dialogPost = ngDialog.open({
            template: 'templates/partials/viewSuccessMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Add SSO Organization Success';
              $scope.successMsg = 'The SSO Organization has been added succesfully.';
            }]
          });
          dialogPost.closePromise.then(function (data) {
            $state.go('app.ssoOrganizations');
          });
        }, function (err) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + ' ' + err.data + '</p>';
              $scope.errTitle = 'SSO Organization Error';
            }]
          });
        }).finally(function () {
          progress.complete();
        });
      } else {
        if (!$scope.ssoOrganization.organizationCode) {
          $scope.validate.organizationCode = true;
        }
        if (!$scope.ssoOrganization.globalId) {
          $scope.validate.globalId = true;
        }
      }
    };
    $scope.updateSsoOrganization = function () {
      if ($scope.ssoOrganization.organizationCode && $scope.ssoOrganization.globalId) {
        progress.start();
        ssoOrganizations.updateSsoOrganization($scope.ssoOrganization.id, $scope.ssoOrganization).then(function (organization) {
          var dialogPost = ngDialog.open({
            template: 'templates/partials/viewSuccessMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Update SSO Organization Success';
              $scope.successMsg = 'The SSO Organization has been updated succesfully.';
            }]
          });
          dialogPost.closePromise.then(function (data) {
            $state.go('app.ssoOrganizations');
          });
        }, function (err) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + ' ' + err.data + '</p>';
              $scope.errTitle = 'Update SSO Organization Error';
            }]
          });
        }).finally(function () {
          progress.complete();
        });
      } else {
        if (!$scope.ssoOrganization.organizationCode) {
          $scope.validate.organizationCode = true;
        }
        if (!$scope.ssoOrganization.globalId) {
          $scope.validate.globalId = true;
        }
      }
    };

    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }

    function setGridData() {

      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && valid.clientValid) {
        progress.start();
        var organization = clientSelectService.getSelectedClient();
        var organizationId = !!organization.id ? organization.id : 0;
        ssoOrganizations.getSsoOrganizationsByOrgId(organizationId).then(function (ssoOrganizations) {
          var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
          $scope.gridOptions.data = ssoOrganizations.data.slice(firstRow, firstRow + paginationOptions.pageSize);;
          $scope.gridOptions.totalItems = ssoOrganizations.data.length;
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + ' ' + err.data + '</p>';
                $scope.errTitle = 'SSO Organization Error';
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      }
    };

    $scope.view = function (rowEntity) {
      var selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
      if (!!selectedRow) {
        $scope.ssoOrganization = selectedRow;
        var view = ngDialog.open({
          template: 'templates/partials/viewSsoOrganization.html',
          className: 'ngdialog-theme-plain',
          scope: $scope
        });
        view.closePromise.then(function (data) {
          $scope.viewData = {};
        });
      }
    };

    setGridData();
    // Watch clientSelectService for changes to getFilteredOrganization() output
    // expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        $scope.gridOptions.data = [];
        $scope.gridOptions.totalItems = 0;
        setGridData();
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(function (module) {
  'use strict';

  module.controller('TopBarController', ['$q', '$scope', '$state', '$timeout', 'alertService', 'authService', 'organizations', 'clientSelectService', 'agencySelectService', 'socketLogin', 'obexRoles', 'pushService', 'ngDialog', function ($q, $scope, $state, $timeout, alertService, authService, organizations, clientSelectService, agencySelectService, socketLogin, obexRoles, Push, ngDialog) {
    //init of page
    console.log('******* TopBarController');
    $scope.showAlert = false;
    // Options
    $scope.introOptions = {
      steps: [{
        element: '#orgInput',
        intro: 'Select a client to begin.',
        position: 'bottom'
      }],
      showStepNumbers: false,
      showProgress: false,
      showBullets: false,
      exitOnOverlayClick: true,
      exitOnEsc: true,
      nextLabel: 'Next',
      prevLabel: 'Back',
      skipLabel: 'Skip',
      doneLabel: '<i class="fa fa-fw fa-check"></i> Got it!'
    };
    $scope.currentState = $state;

    var selectableAgencies = [];
    var selectableClients = [];

    // Intro on first app load
    /*
    const storage = $window.localStorage;
    if (storage.getItem('firstLoad') == null) {
      storage.setItem('firstLoad', true);
    }
      $scope.firstLoad = storage.getItem('firstLoad') == 'true';
    if ($scope.firstLoad) {
      $timeout(function () {
        $scope.initIntro();
      }, 500); // Delay for DOM to settle
      storage.setItem('firstLoad', false);
    }*/

    var logInUser = authService.getLoginMember();

    if (logInUser) {
      $scope.organizationId = logInUser.Organization.Id;
      $scope.organizationName = logInUser.Organization.Name;
      $scope.allowOpenBookings = logInUser.Organization.AllowOpenBookings;
      $scope.firstName = logInUser.FirstName;
      $scope.lastName = logInUser.LastName;
      socketLogin.setLoginMemberAndSend(logInUser);
      $scope.logInUserRole = logInUser.Role;
      if (logInUser.Role == 4) {
        //$scope.introOptions.steps[0].intro = "Select an agency and then a client to begin.";
      }
    } else {
      $scope.organizationName = '';
      $scope.firstName = '';
      $scope.lastName = '';
    }

    var hideStates = ['app.clientManagement', 'app.addClient', 'app.editClient', 'app.editClient', 'app.providers', 'app.addProvider', 'app.editProvider', 'app.categories', 'app.addCategory', 'app.editCategory', 'app.apps', 'app.addApp', 'app.editApp', 'app.agents', 'app.sms', 'app.sms-notif', 'app.changePassword'];
    function findInHiddenList(state) {
      return state === $state.current.name;
    }
    var stateInHiddenList = _.find(hideStates, findInHiddenList) !== undefined;
    $scope.hideAgencyDropdown = stateInHiddenList || logInUser.Role !== 4;
    $scope.hideClientDropdown = stateInHiddenList;

    console.log('$scope.hideAgencyDropdown ', $scope.hideAgencyDropdown);
    console.log('$scope.hideClientDropdown ', $scope.hideClientDropdown);

    agencySelectService.getSelectableAgencies().then(function (response) {
      selectableAgencies = response;
      $scope.selectableAgencies = selectableAgencies;
      console.log('Got selectable agencies ', $scope.selectableAgencies);

      if ($scope.selectableAgencies.length == 1) {
        agencySelectService.setSelectedAgency($scope.selectableAgencies[0].id, $scope.selectableAgencies[0].name);
      }

      if (logInUser.Role === obexRoles.roleTravelAgencyAdmin || logInUser.Role === obexRoles.roleTravelAgent) {
        agencySelectService.setSelectedAgency($scope.organizationId, $scope.organizationName, $scope.allowOpenBookings);
        clientSelectService.getAgencyClients($scope.organizationId).then(function (response) {
          $scope.selectableClients = response;
        });
      }
    });

    var selectableAgenciesPromise = agencySelectService.getSelectableAgencies();
    var loginOrganizationPromise = organizations.getOrganizationById($scope.organizationId);

    $q.all([selectableAgenciesPromise, loginOrganizationPromise]).then(function (response) {
      selectableAgencies = response[0];
      $scope.selectableAgencies = selectableAgencies;
      console.log("Got selectable agencies ", $scope.selectableAgencies);

      if ($scope.selectableAgencies.length == 1) {
        agencySelectService.setSelectedAgency($scope.selectableAgencies[0].id, $scope.selectableAgencies[0].name);
      }
      console.log("Selected agency ", agencySelectService.getSelectedAgency());
      $scope.LogoImageLink = response[2].data.LogoImageLink;
    });

    //agency
    $scope.$watchGroup(['selectedAgencyId', 'selectedAgencyName'], function (newValues, oldValues) {
      if (newValues[0] && newValues[1]) {
        agencySelectService.setSelectedAgency(newValues[0], newValues[1]);
        $timeout(function () {
          // Delay button show to match textbox animation duration
          $scope.clear_agency_visible = true;
        }, 301);
      } else {
        //console.log('No filter');
        document.getElementById('agencyDropdown').className += ' animatedBorder';
        document.getElementById('clientDropdown').className += ' animatedBorder';
      }
    }, true);

    // Watch selected client values and set client accordingly
    $scope.$watchGroup(['selectedClientId', 'selectedClientName', 'selectedClientAllowOpenBookings', 'selectdClientChatAppName'], function (newValues, oldValues) {
      if (newValues[0] && newValues[1]) {
        clientSelectService.setSelectedClient(newValues[0], newValues[1], newValues[2], newValues[3]);
        $timeout(function () {
          // Delay button show to match textbox animation duration
          $scope.clear_client_visible = true;
        }, 301);
      } else {
        //console.log('No filter');
        document.getElementById('clientDropdown').className += ' animatedBorder';
      }
    }, true);

    // Get persisting filtered organization on load
    var filterClient = clientSelectService.getSelectedClient();
    if (filterClient) {
      $scope.clientInput = filterClient.name;
      $scope.selectedClientId = filterClient.id;
      $scope.selectedClientName = filterClient.name;
      $scope.selectedClientAllowOpenBookings = filterClient.allowOpenBookings;
      $scope.selectdClientChatAppName = filterClient.ChatAppName;
    } else {
      $scope.clientInput = undefined;
      $scope.selectedClientId = undefined;
      $scope.selectedClientName = undefined;
      $scope.selectedClientAllowOpenBookings = undefined;
      $scope.selectdClientChatAppName = undefined;
    }

    // Set selected client
    $scope.setSelectedClient = function (item) {
      $scope.selectedClientId = item.id;
      $scope.selectedClientName = item.name;
      $scope.selectdClientChatAppName = item.ChatAppName;
      $('#clientDropdown').removeClass('animatedBorder');
      $scope.selectedClientAllowOpenBookings = item.allowOpenBookings;
    };

    // Clear selected client
    $scope.clearSelectedClient = function () {
      $scope.clear_client_visible = false;
      $scope.clientInput = undefined;
      $scope.selectedClientId = undefined;
      $scope.selectedClientName = undefined;
      $scope.selectdClientChatAppName = undefined;
      document.getElementById("clientDropdown").className += " animatedBorder";
      $scope.selectedClientAllowOpenBookings = undefined;
      clientSelectService.clearSelectedClient();
      console.log("$scope.selectableClients ", $scope.selectableClients);
      console.log("agencySelectService.getSelectedAgency().id ", agencySelectService.getSelectedAgency().id);
      if (logInUser.Role !== 4) {
        $scope.getClients($scope.organizationId);
      } else {
        var selectedAgency = agencySelectService.getSelectedAgency().id;
        $scope.getClients(selectedAgency);
      }
    };

    $scope.isClientSelected = function () {
      return !!$scope.selectedClientId || !!$scope.selectedClientName || !!$scope.selectedClientAllowOpenBookings || !!$scope.selectdClientChatAppName;
    };

    // Get persisting filtered agency on load

    var filterAgency = agencySelectService.getSelectedAgency();
    if (filterAgency) {
      $scope.agencyInput = filterAgency.name;
      $scope.selectedAgencyId = filterAgency.id;
      $scope.selectedAgencyName = filterAgency.name;
    } else {
      $scope.agencyInput = undefined;
      $scope.selectedAgencyId = undefined;
      $scope.selectedAgencyName = undefined;
      $scope.clear_agency_visible = false;
    }

    // Set selected agency
    $scope.setSelectedAgency = function (item) {
      $scope.selectedAgencyId = item.id;
      $scope.selectedAgencyName = item.name;
      $("#agencyDropdown").removeClass("animatedBorder");
      console.log("$scope.selectableClients line no 254 ", selectableClients);
      $scope.getClients(item.id);
    };

    $scope.viewMyProfile = function () {
      $scope.loginMember = authService.getLoginMember();
      $scope.loginMemberRoleName = getRoleName($scope.logInUserRole);
      ngDialog.open({
        template: 'dlg-template-my-profile',
        className: 'ngdialog-theme-plain',
        scope: $scope
      });
    };

    function getRoleName(loginUserRole) {
      if (loginUserRole == 4) {
        return 'Obex Admin';
      } else if (loginUserRole == 3) {
        return 'Travel Manager';
      } else if (loginUserRole == 2) {
        return 'Travel Agency Admin';
      } else if (loginUserRole == 1) {
        return 'Travel Agent';
      } else {
        return 'User';
      }
    }
    // Clear selected agency
    $scope.clearSelectedAgency = function () {
      $scope.clear_agency_visible = false;
      $scope.agencyInput = undefined;
      $scope.selectedAgencyId = undefined;
      $scope.selectedAgencyName = undefined;
      document.getElementById('agencyDropdown').className += ' animatedBorder';
      agencySelectService.clearSelectedAgency();

      $scope.clearSelectedClient();
      $scope.selectableClients = [];
    };

    $scope.isAgencySelected = function () {
      return !!$scope.selectedAgencyId || !!$scope.selectedAgencyName;
    };

    $scope.getClients = function (id) {
      clientSelectService.getAgencyClients(id).then(function (response) {
        $scope.selectableClients = response;
      });
    };

    function updateAlertCount() {
      alertService.getUnhandledAlerts().then(function (response) {
        var unhandledAlerts = response.data;
        var groups = _.groupBy(unhandledAlerts, function (alert) {
          return alert.FromNumber + '#' + alert.FirstName + '#' + alert.LastName;
        });
        //$scope.alertCount = unhandledAlerts.length > 0 ? unhandledAlerts.length : '';
        $scope.alertCount = _.size(groups) > 0 ? _.size(groups) : '';
        $scope.showAlert = true;
      });
    }

    function updateVoiceAlertCount() {
      alertService.getUnhandledVoiceAlerts().then(function (response) {
        var unhandledVoiceAlerts = response.data;
        $scope.alertCountVoice = !!unhandledVoiceAlerts.length ? unhandledVoiceAlerts.length : '';
      });
    }

    function notifyDesktop(data) {
      console.log(data);
      var text = 'From: ' + data.member.DisplayName + ' (' + data.member.Organization.Name + ') \n Phone Number: ' + data.fromNumber + ' \n ' + data.message;
      Push.create('Obex Notification', {
        tag: 'notifyDesktop',
        icon: '/images/icons/obex32.png',
        body: text,
        link: '/#!/',
        requireInteraction: true,
        timeout: 300000,
        onClick: function onClick() {
          window.focus();
          Push.close('notifyDesktop');
          Push.clear();
        },
        vibrate: [200, 100, 200, 100, 200, 100, 200]
      });
    }

    updateAlertCount();
    updateVoiceAlertCount();

    //on socket events
    $scope.$on('updateAlertCount', function (event, data) {
      updateAlertCount();
    });

    $scope.$on('updateAlertCountVoice', function (event, data) {
      console.log('updateAlertCountVoice ', data);
      updateVoiceAlertCount();
    });

    $scope.$on('notifyDesktop', function (event, data) {
      notifyDesktop(data);
    });

    //on user's actions
    $scope.gotoSmsNotif = function () {
      $scope.showAlert = false;
      $state.go('app.sms-notif', {});
    };

    $scope.gotoPhoneNotif = function () {
      $state.go('app.phone-notif', {});
    };

    $scope.menuToggle = function () {
      if ($('#sidebar').hasClass('show')) {
        $('#sidebar').removeClass('show').addClass('hide');
        $('#page-wrapper').css({
          margin: '0px'
        });
      } else {
        setTimeout(function () {
          $('#sidebar').removeClass('hide').addClass('show');
        }, 500);
        $('#page-wrapper').css({
          margin: '0 0 0 250px'
        });
      }
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('travelerController', ['$rootScope', '$scope', '$http', 'traveler', 'progressBar', 'ngDialog', 'commonDialog', 'fileReader', 'singleSignOn', 'commonDialogMessage', '$stateParams', '$state', 'uiGridConstants', 'agencySelectService', 'clientSelectService', 'toastFactory', 'authService', 'socketLogin', '$timeout', '$q', 'smsStatus', 'obexRoles', function ($rootScope, $scope, $http, traveler, progressBar, ngDialog, commonDialog, fileReader, singleSignOn, commonDialogMessage, $stateParams, $state, uiGridConstants, agencySelectService, clientSelectService, toastFactory, authService, socketLogin, $timeout, $q, smsStatus, obexRoles) {
    var progress = progressBar.getProgressBar();
    $scope.showAllTraveler = traveler.getShowAll();
    var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var passwordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,})$/;
    $scope.validate = { //'valid', 'invalid', 'not-validated'
      emailValidity: 'not-validated',
      firstNameValidity: 'not-validated',
      lastNameValidity: 'not-validated',
      passwordValidity: 'not-validated',
      confirmValidity: 'not-validated'
    };

    $scope.filesToSend = [];
    $scope.isSso = false;

    var gridData = void 0;
    $scope.traveler = {
      Id: 0,
      FirstName: null,
      LastName: null,
      Email: null,
      OrganizationId: 0,
      IsAdmin: false,
      AccountEnabled: false,
      DisableSMS: false,
      AllowAgentAccess: false,
      Phone: null,
      CustomerAccountNumber: null,
      Password: null,
      TripLinkEmail: null
    };
    $scope.isUpdate = false;
    $scope.searchKeyword = '';
    $scope.edit = function () {
      $state.go('app.editTraveler', {
        id: $scope.rowSelectingId
      });
    };
    $scope.searchTravelers = function () {
      traveler.setShowAll($scope.showAllTraveler);
      setGridData();
    };
    $scope.chatAppName = clientSelectService.getSelectedClient().ChatAppName;
    //Call this code while edit traveler
    var id = $stateParams.id;
    if (!!id) {
      $scope.isUpdate = true;
      getTravelerById(id);
    };

    var userRole = authService.getLoginMember().Role;

    // ui-grid code
    // ui-grid options
    var gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: false,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: true,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      exporterMenuPdf: false,
      exporterMenuCsv: false,
      multiSelect: false,
      paginationPage: 1,
      columnDefs: [{
        headerCellTemplate: '<div></div>',
        field: 'SMS',
        enableHiding: false,
        enableSorting: true,
        enableFiltering: false,
        enableColumnResizing: false,
        exporterSuppressExport: true,
        maxWidth: 50,
        cellTemplate: '<span ng-show="grid.appScope.chatAppName === \'OWA\' ' + ' && row.entity.Phone !== null && ' + obexRoles.roleTravelManager + ' != ' + userRole + ' && ' + obexRoles.roleObexAdmin + ' != ' + userRole + '" style="padding-left: 2px;"><button class=" btn smsBtn" angular-ripple title="SMS traveler" ng-click="grid.appScope.cellClicked(row,col)" ><i class="fa fa-comment"></i></button></span> <span ng-show="grid.appScope.chatAppName !== \'OWA\' || row.entity.Phone === null || ' + obexRoles.roleTravelManager + ' == ' + userRole + ' || ' + obexRoles.roleObexAdmin + ' == ' + userRole + '" style="padding-left: 2px;"><button class=" btn smsBtn smsBtnDisable" angular-ripple title="{{grid.appScope.chatAppName !== \'OWA\' && row.entity.Phone !== null ? \'Chat is not allowed\' : \'Traveler phone is required\'}}">' + '<i class="fa fa-comment"></i></button></span>'
      }, {
        name: 'FirstName',
        enableHiding: false,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250,
        sort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }
      }, {
        name: 'LastName',
        displayName: 'Last Name',
        enableHiding: false,
        enableFiltering: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Email',
        visible: true,
        enableHiding: true,
        enableFiltering: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Phone',
        visible: true,
        displayName: 'Phone',
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'IsAdmin',
        displayName: 'Admin Access',
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'AccountEnabled',
        displayName: 'Account Enabled',
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250
      }],
      rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>'
    };
    $scope.gridDetails = _.cloneDeep(gridOptions);
    $scope.gridDetails.onRegisterApi = function (gridApi) {
      $scope.gridApi = gridApi;

      // Row Selection
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        $scope.rowSelectingId = row.entity.Id;
        if (row.isSelected) {
          $scope.rowSelecting = true;
          if (row.entity.AccountEnabled === 'No') {
            $scope.disabledDeleteBtn = false;
          } else {
            $scope.disabledDeleteBtn = true;
          }
        } else {
          $scope.rowSelecting = false;
          $scope.disabledDeleteBtn = false;
        }
      });
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        getTravelers(clientSelectService.getSelectedClient().id);
      });
    };

    $scope.onDblClick = function (row) {
      $scope.rowSelectingId = row.entity.Id;
      $scope.view();
      // Override default rowSelection action
      row.isSelected = true;
      $scope.rowSelecting = true;
    };
    var allTravelersData = [];
    function updateGridPagination(gridData, totalItems) {
      allTravelersData = gridData;
      $scope.gridDetails.data = gridData;
      $scope.gridDetails.totalItems = totalItems;
    };

    function setGridData() {
      if (authService.getLoginMember().Role === 3) {
        getTravelers(authService.getLoginMember().OrganizationId);
      } else {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid && valid.clientValid) {
          if (!!clientSelectService.getSelectedClient().id) {
            getTravelers(clientSelectService.getSelectedClient().id);
          }
        } else if (valid.agencyValid) {
          //toastFactory.toast_info('Please select a client.');
        } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
      }
    };

    function setSso() {
      if (authService.getLoginMember().Role === 4) {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid && valid.clientValid) {
          if (!!clientSelectService.getSelectedClient().id) {
            var orgId = clientSelectService.getSelectedClient().id;
            singleSignOn.getSingleSignOnByOrganizationId(orgId).then(function (singleSignOnOrg) {
              console.log("singleSignOnOrg: ", singleSignOnOrg);
              $scope.isSso = true;
            }, function (err) {
              if (err && err.statusText == 'Not Found') {
                $scope.isSso = false;
              } else {
                console.log("error while validation organization is sso or not", err);
              }
            });
          }
        }
      }
    }

    function getTravelers(id) {
      $scope.chatAppName = clientSelectService.getSelectedClient().ChatAppName;
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && id) {
        progress.start();
        traveler.getTravelersByOrgId(id, $scope.gridDetails, $scope.showAllTraveler, $scope.searchKeyword).then(function (response) {
          var travelersData = response.data;
          $scope.isExportData = !!travelersData.SupportedTravelers.length ? true : false;
          var travelers = [];
          if ($scope.showAllTraveler !== true) {
            travelers = travelersData.SupportedTravelers.filter(function (traveler) {
              return traveler.AccountEnabled;
            }).map(function (traveler) {
              return {
                Id: traveler.Id,
                FirstName: traveler.FirstName,
                LastName: traveler.LastName,
                Phone: traveler.Phone,
                Email: traveler.AlternateEmail ? traveler.AlternateEmail : traveler.Email,
                AccountEnabled: traveler.AccountEnabled ? 'Yes' : 'No',
                IsAdmin: traveler.IsAdmin ? 'Yes' : 'No',
                DeviceToken: traveler.DeviceToken,
                OSPlatform: traveler.OSPlatform
              };
            });
          } else {
            travelers = travelersData.SupportedTravelers.map(function (traveler) {
              return {
                Id: traveler.Id,
                FirstName: traveler.FirstName,
                LastName: traveler.LastName,
                Phone: traveler.Phone,
                Email: traveler.AlternateEmail ? traveler.AlternateEmail : traveler.Email,
                AccountEnabled: traveler.AccountEnabled ? 'Yes' : 'No',
                IsAdmin: traveler.IsAdmin ? 'Yes' : 'No',
                DeviceToken: traveler.DeviceToken,
                OSPlatform: traveler.OSPlatform
              };
            });
          }
          gridData = travelers;
          updateGridPagination(gridData, travelersData.TotalTravelers);
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + '</p>';
                $scope.errTitle = 'Traveler Error';
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      }
    };
    setGridData();
    setSso();
    function getTravelerById(id) {
      progress.start();
      traveler.getTravelerById(id).then(function (traveler) {
        $scope.traveler = traveler.data;
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
              $scope.errTitle = 'Get Traveler Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };
    //update First and Last Name
    function updateName(travelerContext) {
      traveler.updateName(travelerContext.Id, travelerContext).then(function (traveler) {
        var dialogPost = ngDialog.open({
          template: 'templates/partials/viewSuccessMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Edit Traveler Success';
            $scope.successMsg = 'The traveler has been updated successfully.';
          }]
        });
        dialogPost.closePromise.then(function (data) {
          $state.go('app.travelers');
        });
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
              $scope.errTitle = 'Update Traveler Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    };
    //Enable Disable Account and Delete the account
    $scope.deleteAccount = function () {
      var confirm = ngDialog.open({
        template: 'templates/partials/viewConfirm.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.strTitle = 'Delete Traveler?';
          $scope.strMsg = 'Do you really want to delete this traveler?';
        }]
      });
      confirm.closePromise.then(function (data) {
        if ($scope.rowSelectingId && data.value === 1) {
          progress.start();
          traveler.deleteAccount($scope.rowSelectingId).then(function (del) {
            var dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete Traveler Success';
                $scope.successMsg = 'Account deleted successfully';
              }]
            });
            dialogPost.closePromise.then(function (data) {
              $scope.gridApi.core.clearAllFilters();
              setGridData();
            });
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
                  $scope.errTitle = 'Delete Traveler Error';
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
        }
      });
    };

    $scope.sendHrFeedData = function () {
      var loginUser = authService.getLoginMember();
      var isPasswordValid = passwordRegex.test($scope.password);
      var isConfirmPasswordValid = $scope.password !== $scope.confirmPassword ? false : true;
      var isFileUpload = $scope.filesToSend && $scope.filesToSend.length < 1 ? false : true;
      var selectedClient = clientSelectService.getSelectedClient();
      var orgId = selectedClient.id;
      var orgName = selectedClient.name;
      var isEmailValid = emailRegex.test($scope.userEmail);
      if (!$scope.isSso && !isPasswordValid || $scope.userEmail && !isEmailValid || isFileUpload && $scope.filesToSend.length > 1 || !$scope.isSso && !isConfirmPasswordValid || !isFileUpload || !orgId) {
        var dialog = ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = '';
            if (!orgId) {
              $scope.errMsg += '<p>Please select client.</p>';
            }
            if (!isFileUpload) {
              $scope.errMsg += '<p>Please select .csv file.</p>';
            }
            if (isFileUpload && $scope.filesToSend.length > 1) {
              $scope.errMsg += '<p>Please select one file at a time.</p>';
            }
            if ($scope.userEmail && !isEmailValid) {
              $scope.errMsg += '<p>Additional email is invalid.</p>';
            }
            if (!$scope.isSso) {
              if (!isPasswordValid) {
                $scope.errMsg += '<p>Password must contain minimum 8 characters, and must include at least 1 uppercase letter and 1 digit.</p>';
              }
              if (!isConfirmPasswordValid) {
                $$scope.errMsg += '<p>Password and Confirm Password do not match.</p>';
              }
            }
            $scope.errTitle = 'Upload HR Errors';
          }]
        });
        dialog.closePromise.then(function (data) {});
      } else {
        var file = $scope.filesToSend[0];
        var additionalEmail = $scope.userEmail ? $scope.userEmail.trim() : '';
        if (file != null) {
          var successMsg = !additionalEmail ? loginUser.Email : loginUser.Email + ' and ' + additionalEmail;
          var confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Upload HR Feed';
              $scope.strMsg = 'Travelers / Employees in csv file will be uploaded for the selected client. Log (success / error) will send to you at ' + successMsg + '.';
            }]
          });
          confirm.closePromise.then(function (data) {
            if (data.value === 1) {
              if (!$scope.isSso) {
                var _data = {
                  organizationId: orgId,
                  password: $scope.password,
                  userEmail: loginUser.Email,
                  additionalEmail: additionalEmail,
                  orgName: orgName
                };
                traveler.sendNonSsoInfo(file, _data);
              } else {
                var _data2 = {
                  organizationId: orgId,
                  userEmail: loginUser.Email,
                  additionalEmail: additionalEmail,
                  orgName: orgName
                };
                traveler.sendSsoInfo(file, _data2);
              }
              confirm.closePromise.then(function (data) {
                $state.go('app.travelers');
              });
            }
          });
        } else {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>You must select .csv file</p>';
              $scope.errTitle = 'Upload HR File Error';
            }]
          });
        }
      }
    };

    //Set/reset admin access to user
    function setAdmin(travelerData) {
      progress.start();
      traveler.setAdmin($scope.traveler.Id, $scope.traveler.IsAdmin).then(function (del) {
        enableAccount(travelerData);
      }, function (err) {
        progress.complete();
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + ' : ' + err.data + '</p>';
              $scope.errTitle = 'Traveler Error';
            }]
          });
        }
      });
    };
    //Enable Disable Account and Delete the account
    function enableAccount(travelerData) {
      traveler.setEnableDisableAccount($scope.traveler.Id, $scope.traveler.AccountEnabled).then(function (del) {
        updateName(travelerData);
      }, function (err) {
        progress.complete();
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Delete Traveler Error';
            }]
          });
        }
      });
    };
    $scope.updateTraveler = function () {
      if (!!clientSelectService.getSelectedClient().id) {
        var travelerData = $scope.traveler;
        var firstNameInvalid = !travelerData.FirstName ? true : false;
        var lastNameInvalid = !travelerData.LastName ? true : false;

        if (firstNameInvalid || lastNameInvalid) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '';
              if (firstNameInvalid) {
                $scope.errMsg += '<p>First name must be entered.</p>';
              }
              if (lastNameInvalid) {
                $scope.errMsg += '<p>Last name must be entered.</p>';
              }
              $scope.errTitle = 'Edit Traveler Error';
            }]
          });
        } else {
          setAdmin($scope.traveler);
        }
      } else {
        // toastFactory.toast_info('Please select client.');
      }
    };
    $scope.view = function (rowId) {
      var selectId = !!rowId ? rowId : $scope.rowSelectingId;
      if (selectId) {
        getTravelerById(selectId);
      }
      ngDialog.open({
        template: 'templates/partials/viewTraveler.html',
        className: 'ngdialog-theme-plain',
        scope: $scope
      });
    };
    $scope.saveTraveler = function () {
      if (!!clientSelectService.getSelectedClient().id) {
        var travelerData = $scope.traveler;
        var isEmailValid = emailRegex.test(travelerData.Email);
        var isPasswordValid = passwordRegex.test(travelerData.Password);
        !isEmailValid ? $scope.validate.emailValidity = 'invalid' : $scope.validate.emailValidity = 'valid';
        !travelerData.FirstName ? $scope.validate.firstNameValidity = 'invalid' : $scope.validate.firstNameValidity = 'valid';
        !travelerData.LastName ? $scope.validate.lastNameValidity = 'invalid' : $scope.validate.lastNameValidity = 'valid';
        !isPasswordValid ? $scope.validate.passwordValidity = 'invalid' : $scope.validate.passwordValidity = 'valid';
        travelerData.Password !== $scope.confirmPassword ? $scope.validate.confirmValidity = 'invalid' : $scope.validate.confirmValidity = 'valid';
        var emailInvalid = $scope.validate.emailValidity === 'invalid',
            firstNameInvalid = $scope.validate.firstNameValidity === 'invalid',
            lastNameInvalid = $scope.validate.lastNameValidity === 'invalid',
            passwordInvalid = $scope.validate.passwordValidity === 'invalid',
            confirmInvalid = $scope.validate.confirmValidity === 'invalid';
        if (emailInvalid || firstNameInvalid || lastNameInvalid || passwordInvalid || confirmInvalid) {
          $scope.ajaxload = false;
          var dialog = ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '';

              if (firstNameInvalid) {
                $scope.errMsg += '<p>First name must be entered.</p>';
              }
              if (lastNameInvalid) {
                $scope.errMsg += '<p>Last name must be entered.</p>';
              }
              if (emailInvalid) {
                $scope.errMsg += '<p>Email is invalid.</p>';
              }
              if (passwordInvalid) {
                $scope.errMsg += '<p>Password must contain minimum 8 characters, and must include at least 1 uppercase letter and 1 digit.</p>';
              }
              if (confirmInvalid) {
                $scope.errMsg += '<p>Password and Confirm Password fields do not match.</p>';
              }
              $scope.errTitle = 'Add Traveler Error';
            }]
          });
          dialog.closePromise.then(function (data) {});
        } else {
          progress.start();
          travelerData.OrganizationId = clientSelectService.getSelectedClient().id;
          traveler.saveTraveler(travelerData).then(function (data) {
            var dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Add Traveler Success';
                $scope.successMsg = 'The traveler has been created successfully.';
              }]
            });
            dialogPost.closePromise.then(function (data) {
              $state.go('app.travelers');
            });
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + ': ' + err.data + '</p>';
                  $scope.errTitle = 'Save traveler Error';
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
        }
      } else {
        // toastFactory.toast_info('Please select client.');
      }
    };
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      $scope.clientId = client.id;
      $scope.clientName = client.name;
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }

    $scope.exportTravelersList = function () {
      $scope.gridDetails.data = allTravelersData;
      $scope.gridDetails.exporterCsvFilename = $scope.clientName + '_Traverlers.csv';
      $timeout(function () {
        $scope.gridApi.exporter.csvExport('all', 'all');
        updateGridPagination(allTravelersData, allTravelersData.length);
      }, 100);
    };

    $scope.cellClicked = function (row, col) {
      console.log(row.entity);
      $scope.selectedRow = row.entity;
      $scope.bookingId = null;
      $scope.devicetoken = $scope.selectedRow.DeviceToken;
      $scope.osplatform = $scope.selectedRow.OSPlatform;
      $scope.bookingType = null;
      $scope.smsText = null;
      ngDialog.open({
        template: 'templates/partials/agentInitiatedMessage.html',
        className: 'ngdialog-theme-plain',
        scope: $scope,
        closeByEscape: false,
        closeByDocument: false
      });
    };
    $scope.confirmSendSms = function () {
      var loginUser = authService.getLoginMember();
      loginUser['SupportsOrganizations'] = [];
      console.log('$scope.smsText ', $scope.smsText);
      console.log('$scope.selectedRow ', $scope.selectedRow);
      $http.post('/agentsms', {
        alerttext: $scope.smsText,
        payload: {
          'aps': {
            'content-available': 1,
            'bookingId': $scope.bookingId,
            'bookingType': $scope.bookingType,
            'alertText': $scope.smsText
          }
        },
        devicetoken: $scope.devicetoken,
        osplatform: $scope.osplatform,
        agentEmail: loginUser.Email,
        agencyId: loginUser.Organization.Id,
        travelerEmail: $scope.selectedRow.Email,
        clientId: $scope.clientId
      });
      var traveler = $scope.selectedRow;
      console.log('socketId: ', socketLogin.getSocketId());
      var handleData = {
        fromNumber: traveler.Phone,
        socketId: socketLogin.getSocketId(),
        firstName: loginUser.FirstName,
        lastName: loginUser.LastName,
        email: loginUser.Email,
        organizationId: loginUser.Organization.Id,
        loginMember: loginUser,
        smstext: $scope.smsText,
        travelAgencyId: loginUser.Organization.Id,
        travelAgencyName: loginUser.Organization.Name,
        travelAgentFirstName: loginUser.FirstName,
        travelAgentLastName: loginUser.LastName,
        travelAgentEmail: loginUser.Email,
        travelAgentId: loginUser.Id,
        topic: {
          bookingId: $scope.bookingId,
          bookingType: $scope.bookingType,
          email: traveler.Email,
          phoneNumber: traveler.Phone
        },
        travelerFirstName: traveler.FirstName,
        travelerLastName: traveler.LastName,
        travelerOrganizationName: $scope.clientName,
        travelerId: traveler.Id,
        fromDatabase: false,
        status: smsStatus.Live,
        channel: 'sms'
      };
      var data = {
        travelerNumber: traveler.Phone,
        travelerFirstName: traveler.FirstName,
        travelerLastName: traveler.LastName,
        travelerEmail: traveler.Email,
        socketId: socketLogin.getSocketId(),
        travelAgentFirstName: loginUser.FirstName,
        travelAgentLastName: loginUser.LastName,
        travelAgentEmail: loginUser.Email,
        travelAgentId: loginUser.Id,
        travelAgentOrganizationId: loginUser.Organization.Id,
        loginMemberId: loginUser.Id,
        smstext: $scope.smsText,
        topic: {
          bookingId: $scope.bookingId,
          bookingType: $scope.bookingType,
          email: traveler.Email,
          phoneNumber: traveler.Phone
        },
        travelerId: traveler.Id,
        fromDatabase: false,
        channel: 'sms'
      };
      $http.post('/agentInitiatedSms', data).then(function (response) {
        $rootScope.$broadcast('smsHandle', handleData);
        $state.go('app.sms', {
          fromNumber: traveler.Phone,
          travelerFirstName: traveler.FirstName,
          travelerLastName: traveler.LastName,
          travelerOrganizationName: $scope.clientName,
          travelerId: traveler.Id,
          fromDatabase: false,
          status: smsStatus.Live,
          channel: 'sms',
          topic: {
            bookingId: $scope.bookingId,
            bookingType: $scope.bookingType,
            email: traveler.Email,
            phoneNumber: traveler.Phone
          }
        });
        //console.log('Post to /agentInitiatedSms ', handleData);
        //return $http.post('/handleConversation', handleData);
      }, function (error) {
        console.log(error);
      });
    };
    //Cancel popup changes
    $scope.cancelChanges = function () {
      ngDialog.closeThisDialog(1);
    };
    // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      $scope.gridDetails.data = [];
      $scope.gridDetails.totalItems = 0;
      console.log(newValue);
      console.log(oldValue);
      if (newValue.id !== oldValue.id) {
        traveler.setShowAll(false);
        $scope.showAllTraveler = false;
        setSso();
      }
      //$scope.showAllTraveler = false;
      setGridData();
    }, true);
    $scope.handleTravelerSearch = function () {
      getTravelers(clientSelectService.getSelectedClient().id);
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.controller('travelerManagementController', ['$scope', 'organizations', '$stateParams', 'progressBar', 'ngDialog', 'toastFactory', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state', 'clientSelectService', function ($scope, organizations, $stateParams, progressBar, ngDialog, toastFactory, uiGridConstants, commonDialog, commonDialogMessage, $state, clientSelectService) {
    console.log(clientSelectService.getSelectedClient());
    if (clientSelectService.getSelectedClient() === undefined && clientSelectService.getSelectedClient().id === undefined) {
      //toastFactory.toast_info('Please select a client.');
    }
  }]);
})(angular.module('obex'));

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _getIterator2 = __webpack_require__(101);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//This file is used for maintain JavaScript functions that are bound to a particular scope or view
;(function (module) {
  'use strict';

  module.controller('travelerTrackController', ['$rootScope', '$scope', '$http', '$state', '$document', 'progressBar', 'ngDialog', 'toastr', 'currency', 'travelerTrack', 'tripsDashBoard', '$filter', '$window', 'commonDialogMessage', '$compile', 'organizations', 'socketLogin', 'uiGridConstants', 'clientSelectService', 'agencySelectService', 'toastFactory', 'authService', '$q', 'smsStatus', 'obexRoles', function ($rootScope, $scope, $http, $state, $document, progressBar, ngDialog, toastr, currency, travelerTrack, tripsDashBoard, $filter, $window, commonDialogMessage, $compile, organizations, socketLogin, uiGridConstants, clientSelectService, agencySelectService, toastFactory, authService, $q, smsStatus, obexRoles) {
    //variable declaration
    var progress = progressBar.getProgressBar();
    var storage = $window.localStorage;
    $scope.statusNote = {
      Id: 0,
      NewAgentNote: '',
      BookingType: ''
    };
    $scope.pre31days = false;
    $scope.next24hours = true;
    $scope.days1to7 = false;
    $scope.post31days = false;
    $scope.customDate = false;
    $scope.customFromDate = new Date();
    $scope.cities = [];
    $scope.customToDate = addMonth($scope.customFromDate); // Look ahead 1 month by default
    $scope.isTravelers = true;
    $scope.isAlerts = true;
    $scope.isTravelersNearToAlerts = false;
    $scope.isCustomDate = false;
    $scope.isTravelerMarkerContent = false;
    $scope.isDetails = false;
    var maps = null;
    $scope.isExportData = false;
    var infoWindow = null;
    $scope.isTripsDash = false;
    $scope.selectedCityName = '';
    var selectedClientId = clientSelectService.getSelectedClient().id;
    var markerContent = '';
    var markerLocators = null;
    var parentListTravelersListByTripId = [];

    function addMonth(startDate) {
      // Does not handle end-of-month edge case, e.g. Oct 31 + 1 month = Dec 01
      return new Date(new Date(startDate).setMonth(startDate.getMonth() + 1));
    }

    $scope.sendSms = function (bookingId, devicetoken, osplatform, bookingType) {
      console.log(bookingId);
      console.log(bookingType);
      console.log(devicetoken);
      console.log(osplatform);
      $scope.bookingId = bookingId;
      $scope.devicetoken = devicetoken;
      $scope.osplatform = osplatform;
      $scope.bookingType = bookingType;
      ngDialog.open({
        template: 'templates/partials/agentInitiatedMessage.html',
        className: 'ngdialog-theme-plain',
        scope: $scope,
        closeByEscape: false,
        closeByDocument: false
      });
    };
    $scope.confirmSendSms = function () {
      var loginUser = authService.getLoginMember();
      loginUser['SupportedOrganizations'] = [];
      console.log('$scope.smsText ', $scope.smsText);
      console.log('$scope.selectedRow ', $scope.selectedRow);
      var traveler = $scope.selectedRow.Member ? $scope.selectedRow.Member : $scope.selectedRow.Traveler;
      $scope.TravelerEmail = !$scope.TravelerEmail ? traveler.Email : $scope.TravelerEmail;
      $scope.TravelerCompanyId = !$scope.TravelerCompanyId ? traveler.OrganizationId : $scope.TravelerCompanyId;
      $http.post('/agentsms', {
        alerttext: $scope.smsText,
        payload: {
          aps: {
            'content-available': 1,
            bookingId: $scope.bookingId,
            bookingType: $scope.bookingType,
            alertText: $scope.smsText
          }
        },
        devicetoken: $scope.devicetoken,
        osplatform: $scope.osplatform,
        agentEmail: loginUser.Email,
        agencyId: loginUser.Organization.Id,
        travelerEmail: $scope.TravelerEmail,
        clientId: $scope.TravelerCompanyId
      });

      console.log('socketId: ', socketLogin.getSocketId());

      var handleData = {
        fromNumber: traveler.Phone,
        socketId: socketLogin.getSocketId(),
        firstName: loginUser.FirstName,
        lastName: loginUser.LastName,
        email: loginUser.Email,
        organizationId: loginUser.Organization.Id,
        loginMember: loginUser,
        smstext: $scope.smsText,
        travelAgencyId: loginUser.Organization.Id,
        travelAgencyName: loginUser.Organization.Name,
        travelAgentFirstName: loginUser.FirstName,
        travelAgentLastName: loginUser.LastName,
        travelAgentEmail: loginUser.Email,
        travelAgentId: loginUser.Id,
        topic: {
          bookingId: $scope.bookingId,
          bookingType: $scope.bookingType,
          email: $scope.TravelerEmail,
          phoneNumber: traveler.Phone
        },
        travelerFirstName: traveler.FirstName,
        travelerLastName: traveler.LastName,
        travelerOrganizationName: traveler.Organization.Name,
        travelerId: traveler.Id
      };

      var data = {
        travelerNumber: traveler.Phone,
        travelerFirstName: traveler.FirstName,
        travelerLastName: traveler.LastName,
        travelerEmail: traveler.Email,
        socketId: socketLogin.getSocketId(),
        travelAgentFirstName: loginUser.FirstName,
        travelAgentLastName: loginUser.LastName,
        travelAgentEmail: loginUser.Email,
        travelAgentId: loginUser.Id,
        travelAgentOrganizationId: loginUser.Organization.Id,
        loginMemberId: loginUser.Id,
        smstext: $scope.smsText,
        topic: {
          bookingId: $scope.bookingId,
          bookingType: $scope.bookingType,
          email: traveler.Email,
          phoneNumber: traveler.Phone
        },
        travelerId: traveler.Id,
        fromDatabase: false,
        channel: 'sms'
      };
      $http.post('/agentInitiatedSms', data).then(function (response) {
        $rootScope.$broadcast('smsHandle', handleData);
        return $http.post('/handleConversation', handleData);
      }).then(function (response) {
        $state.go('app.sms', {
          fromNumber: traveler.Phone,
          travelerFirstName: traveler.FirstName,
          travelerLastName: traveler.LastName,
          travelerOrganizationName: traveler.Organization.Name,
          travelerId: traveler.Id,
          status: smsStatus.Live,
          fromDatabase: false,
          channel: 'sms',
          organizationId: traveler.Organization.Id,
          topic: {
            bookingId: $scope.bookingId,
            bookingType: $scope.bookingType,
            email: $scope.TravelerEmail,
            phoneNumber: traveler.Phone
          }
        });
      }, function (error) {
        console.log(error);
      });
    };

    //Setting up map and markers
    var mapOptions = {
      zoom: 3,
      center: new google.maps.LatLng(20, -65),
      mapTypeId: google.maps.MapTypeId.TERRAIN

      //Alerts Grid
    };$scope.alertsGrid = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: false,
      paginationPageSize: 10,
      useExternalPagination: true,
      useExternalSorting: false,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      rowHeight: 20,
      columnDefs: [{
        name: 'title',
        displayName: 'Alerts',
        cellTemplate: '<span style="padding:3px">{{ row.entity.title }}</span>',
        enableHiding: false,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableSorting: true,
        enableFiltering: true,
        enableRowSelection: true
      }],
      //Information Pop up on selection of Alerts grid row
      onRegisterApi: function onRegisterApi(gridApiAlerts) {
        $scope.gridApiAlerts = gridApiAlerts;
        gridApiAlerts.selection.on.rowSelectionChanged($scope, function (row) {
          if ($scope.isAlerts) {
            google.maps.event.trigger(row.entity, 'click');
          }
        });
      }
    };

    maps = new google.maps.Map(document.getElementById('map'), mapOptions);
    infoWindow = new google.maps.InfoWindow();
    //Load alerts from web service
    function loadAlerts(maps, infoWindow) {
      progress.start();
      $scope.AlertMarkers = [];
      $scope.alertsGrid.data = [];
      travelerTrack.getAlerts().then(function (alerts) {
        var alertsListcontext = alerts.data;

        $scope.AlertMarkers = alertsListcontext.map(function (alertlist) {
          var alertValue = 8;
          if (alertlist.Title.indexOf('Level 1') !== -1) {
            alertValue = 1;
          } else if (alertlist.Title.indexOf('Level 2') !== -1) {
            alertValue = 2;
          } else if (alertlist.Title.indexOf('Level 3') !== -1) {
            alertValue = 4;
          }
          var alertMarker = createAlertMarker(alertlist, alertValue, maps, infoWindow);
          if (alertValue === 8) {
            alertMarker.setVisible(true);
          } else {
            alertMarker.setVisible(false);
          }
          return alertMarker;
        });

        $scope.alertsGrid.data = $scope.AlertMarkers.filter(function (alertMarker) {
          return alertMarker.visible === true;
        });
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Traveler Track Load Alert Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    }

    function generateNotesHistory() {
      progress.start();
      var id = storage.getItem('id');
      $scope.statusNote.BookingType = storage.getItem('bookingType');
      if ($scope.statusNote.BookingType === 'Flight' && $scope.isVisible) {
        tripsDashBoard.getFlightsDashById(id).then(function (tripsFlights) {
          var tripsFlightsContext = tripsFlights.data.AgentNotes;
          if (tripsFlights.data.HasAgentNotes) {
            $scope.notesHistoryList = tripsFlightsContext.map(function (agentNote) {
              return {
                Agent: agentNote.Agent.FirstName + ' ' + agentNote.Agent.LastName,
                Note: agentNote.Note,
                NoteTime: $filter('date')(agentNote.LastUpdated, 'MM-dd-yyyy') + '   ' + $filter('date')(agentNote.LastUpdated, 'shortTime')
              };
            });
          }
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + '</p>';
                $scope.errTitle = 'Notes Error';
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      }
      // generate Car booking details
      else if ($scope.statusNote.BookingType === 'Car' && $scope.isVisible) {
          tripsDashBoard.getCarsDashById(id).then(function (tripsCars) {
            var tripsCarsContext = tripsCars.data.AgentNotes;
            if (tripsCars.data.HasAgentNotes) {
              $scope.notesHistoryList = tripsCarsContext.map(function (agentNote) {
                return {
                  Agent: agentNote.Agent.FirstName + ' ' + agentNote.Agent.LastName,
                  Note: agentNote.Note,
                  NoteTime: $filter('date')(agentNote.LastUpdated, 'MM-dd-yyyy') + '   ' + $filter('date')(agentNote.LastUpdated, 'shortTime')
                };
              });
            }
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + '</p>';
                  $scope.errTitle = 'Notes Error';
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
        }
        // generate hotel booking details
        else if ($scope.statusNote.BookingType === 'Hotel' && $scope.isVisible) {
            tripsDashBoard.getHotelsDashById(id).then(function (tripsHotels) {
              var tripsHotelsContext = tripsHotels.data.AgentNotes;
              if (tripsHotels.data.HasAgentNotes) {
                $scope.notesHistoryList = tripsHotelsContext.map(function (agentNote) {
                  return {
                    Agent: agentNote.Agent.FirstName + ' ' + agentNote.Agent.LastName,
                    Note: agentNote.Note,
                    NoteTime: $filter('date')(agentNote.LastUpdated, 'MM-dd-yyyy') + '   ' + $filter('date')(agentNote.LastUpdated, 'shortTime')
                  };
                });
              }
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '<p>' + err.statusText + '</p>';
                    $scope.errTitle = 'Notes Error';
                  }]
                });
              }
            }).finally(function () {
              progress.complete();
            });
          } else if ($scope.statusNote.BookingType === 'Limo' && $scope.isVisible) {
            tripsDashBoard.getLimosDashById(id).then(function (tripsLimos) {
              var tripsLimosContext = tripsLimos.data.AgentNotes;
              if (tripsLimos.data.HasAgentNotes) {
                $scope.notesHistoryList = tripsLimosContext.map(function (agentNote) {
                  return {
                    Agent: agentNote.Agent.FirstName + ' ' + agentNote.Agent.LastName,
                    Note: agentNote.Note,
                    NoteTime: $filter('date')(agentNote.LastUpdated, 'MM-dd-yyyy') + '   ' + $filter('date')(agentNote.LastUpdated, 'shortTime')
                  };
                });
              }
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '<p>' + err.statusText + '</p>';
                    $scope.errTitle = 'Notes Error';
                  }]
                });
              }
            }).finally(function () {
              progress.complete();
            });
          }
    }
    $scope.notesHistory = function () {
      $scope.isVisible = $scope.isVisible ? false : true;
      generateNotesHistory();
    };
    $scope.saveBookingStatus = function () {
      progress.start();
      var id = storage.getItem('id');
      $scope.statusNote.BookingType = storage.getItem('bookingType');
      $scope.statusNote.Id = id;
      var toDate = $filter('date')(new Date(storage.getItem('dateTo')), 'yyyy-MM-dd');
      var fromDate = $filter('date')(new Date(storage.getItem('dateFrom')), 'yyyy-MM-dd');
      $scope.dateTo = toDate;
      $scope.dateFrom = fromDate;
      //Update flight booking status
      if ($scope.statusNote.BookingType === 'Flight') {
        tripsDashBoard.updateFlightStatus(id, $scope.statusNote).then(function (flightUpdate) {
          var dialogPost = ngDialog.open({
            template: 'templates/partials/viewSuccessMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.successMsg = commonDialogMessage.tripDashStatusUpdatedMessage;
              $scope.strTitle = 'Notes Created Success';
            }]
          });
          dialogPost.closePromise.then(function (data) {
            $scope.statusNote = {};
            $scope.editStatusForm.$setPristine();
            if ($scope.isVisible) {
              generateNotesHistory();
            }
          });
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + '</p>';
                $scope.errTitle = 'Notes Error';
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      }
      //Update Car booking status
      else if ($scope.statusNote.BookingType === 'Car') {
          tripsDashBoard.updateCarStatus(id, $scope.statusNote).then(function (carUpdate) {
            var dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.successMsg = commonDialogMessage.tripDashStatusUpdatedMessage;
                $scope.strTitle = 'Notes Created Success';
              }]
            });
            dialog.closePromise.then(function (data) {
              $scope.statusNote = {};
              $scope.editStatusForm.$setPristine();
              if ($scope.isVisible) {
                generateNotesHistory();
              }
            });
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + '</p>';
                  $scope.errTitle = 'Notes Error';
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
        }
        //Update Hotel booking status
        else if ($scope.statusNote.BookingType === 'Hotel') {
            tripsDashBoard.updateHotelStatus(id, $scope.statusNote).then(function (hotelUpdate) {
              var dialogPost = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.successMsg = commonDialogMessage.tripDashStatusUpdatedMessage;
                  $scope.strTitle = 'Notes Created Success';
                }]
              });
              dialogPost.closePromise.then(function (data) {
                $scope.statusNote = {};
                $scope.editStatusForm.$setPristine();
                if ($scope.isVisible) {
                  generateNotesHistory();
                }
              });
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '<p>' + err.statusText + '</p>';
                    $scope.errTitle = 'Notes Error';
                  }]
                });
              }
            }).finally(function () {
              progress.complete();
            });
          }
          //Update Limo booking status
          else if ($scope.statusNote.BookingType === 'Limo') {
              tripsDashBoard.updateLimoStatus(id, $scope.statusNote).then(function (limoUpdate) {
                var dialogPost = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.successMsg = commonDialogMessage.tripDashStatusUpdatedMessage;
                    $scope.strTitle = 'Notes Created Success';
                  }]
                });
                dialogPost.closePromise.then(function (data) {
                  $scope.statusNote = {};
                  $scope.editStatusForm.$setPristine();
                  if ($scope.isVisible) {
                    generateNotesHistory();
                  }
                });
              }, function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = '<p>' + err.statusText + '</p>';
                      $scope.errTitle = 'Notes Error';
                    }]
                  });
                }
              }).finally(function () {
                progress.complete();
              });
            }
    };
    //edit status and notes by Id
    generateNotesHistory();
    $scope.editStatus = function (id, bookingType) {
      $scope.statusNote = {};
      $scope.statusNote.BookingType = bookingType;
      storage.setItem('bookingType', bookingType);
      storage.setItem('id', id);
      ngDialog.open({
        template: 'templates/partials/editStatusTripDash.html',
        controller: 'tripsDashBoardController',
        closeByDocument: false
      });
    };

    function getCities(selectedClientId) {
      progress.start();
      var promiseDepartureCities = travelerTrack.getDepartureCities(selectedClientId);
      var promiseArrivalCities = travelerTrack.getArrivalCities(selectedClientId);
      $q.all([promiseDepartureCities, promiseArrivalCities]).then(function (response) {
        $scope.cities = angular.merge(response[0].data, response[1].data);
      }, function (err) {
        console.log(err);
      }).finally(function () {
        progress.complete();
      });
    }
    loadAlerts(maps, infoWindow);
    //Load travelers data from web service
    function searchTravelersData(fromDate, toDate, maps, infoWindow) {
      var travelersNearAlert = $scope.isTravelersNearToAlerts;
      if (authService.getLoginMember().Role === 3) {
        selectedClientId = authService.getLoginMember().OrganizationId;
        getCities(selectedClientId);
        getTravelerData(fromDate, toDate, travelersNearAlert, selectedClientId);
      } else {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid && valid.clientValid) {
          selectedClientId = clientSelectService.getSelectedClient().id;
          getCities(selectedClientId);
          getTravelerData(fromDate, toDate, travelersNearAlert, selectedClientId);
        } else if (valid.agencyValid) {
          //toastFactory.toast_info('Please select a client.');
        } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
      }
    }
    $scope.searchTravelersByCity = function (selectedCityName) {
      $scope.selectedCityName = selectedCityName;
      $scope.searchTravelersNearAlertsOrInCity();
    };

    function createMarkerLocators(markerData) {
      var markerLocators = {};
      for (var i = 0; i < markerData.length; i++) {
        var travelerLocation = markerData[i];
        if (travelerLocation.Location != null) {
          var cityName = travelerLocation.Location;
          if (markerLocators[cityName]) {
            markerLocators[cityName].push(travelerLocation);
          } else {
            markerLocators[cityName] = [];
            markerLocators[cityName].push(travelerLocation);
          }
        }
      }
      return markerLocators;
    }
    $document.on('click', '.prevLocator, .nextLocator', function (event) {
      if (!angular.element(event.target).hasClass('disabled')) {
        var cityName = event.target.parentElement.getAttribute('data-cityname');
        if (markerLocators[cityName] && Array.isArray(markerLocators[cityName]) && markerLocators[cityName].length > 0) {
          var userRole = authService.getLoginMember().Role;
          var markerIndexNum = parseInt(event.target.parentElement.getAttribute('data-idx'), 10);
          markerIndexNum = angular.element(event.target).hasClass('prevLocator') ? --markerIndexNum : ++markerIndexNum;
          var markerData = markerLocators[cityName][markerIndexNum];
          var bookingType = void 0,
              bookingId = void 0,
              contentWindow = void 0,
              DeviceToken = void 0,
              OSPlatform = void 0;
          var _markerContent = createrMarkerContent(markerData);
          var arrTravelersData = getTravelersDataByDateAsc(markerData);
          bookingType = arrTravelersData['bookingType'];
          bookingId = arrTravelersData['bookingId'];
          DeviceToken = arrTravelersData['DeviceToken'];
          OSPlatform = arrTravelersData['OSPlatform'];
          arrTravelersData.forEach(function (objTraveler) {
            if (objTraveler.hasOwnProperty('DepartureDateTime')) {
              _markerContent = createFlightMarker([objTraveler], _markerContent);
            } else if (objTraveler.hasOwnProperty('PickUpDateTime')) {
              _markerContent = createCarMarker([objTraveler], _markerContent);
            } else if (objTraveler.hasOwnProperty('DepartureDate')) {
              _markerContent = createLimoMarker([objTraveler], _markerContent);
            } else {
              _markerContent = createHotelMarker([objTraveler], _markerContent);
            }
            parentListTravelersListByTripId[markerData.TripId] ? markerData.DisplayTitle = markerData.travelerName : markerData.DisplayTitle = markerData.DisplayTitle;
            markerData.content = _markerContent;
            markerData.city = markerData.Location;
            var demoContentWindow = showInfoMarkerWindow(userRole, markerData, bookingType, bookingId, markerIndexNum, DeviceToken, OSPlatform);
            var democompiled = $compile(demoContentWindow)($scope);
            infoWindow.setContent(democompiled[0]);
          });
        }
      }
    });

    function getTravelerData(fromDate, toDate, travelersNearAlert, selectedClientId) {
      //marker for traveler
      $scope.travelersMarkers = [];
      //for making travelersList blank
      $scope.travelersList = [];
      progress.start();
      travelerTrack.getTravelers(fromDate, toDate, travelersNearAlert.toString(), selectedClientId).then(function (travelers) {
        var travelersListContext = travelers.data;
        var tempMarkerLocators = [];
        $scope.isDetails = false;

        if (!!travelersListContext.length) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(travelersListContext), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var traveler = _step.value;

              var isCityNameExit = false;
              if (!!$scope.selectedCityName.length) {
                if (!traveler.Trip) {
                  if (!!traveler.Flight) {
                    isCityNameExit = traveler.Flight.some(function (flight) {
                      return flight.DepartureName == $scope.selectedCityName || flight.ArrivalName == $scope.selectedCityName;
                    });
                  } else if (!!traveler.Car) {
                    isCityNameExit = traveler.Car.some(function (car) {
                      return car.DropOffLocation == $scope.selectedCityName || car.PickUpLocation == $scope.selectedCityName;
                    });
                  } else if (!!traveler.Hotel) {
                    isCityNameExit = traveler.Hotel.some(function (hotel) {
                      return hotel.CityName == $scope.selectedCityName;
                    });
                  } else if (!!traveler.Limo) {
                    isCityNameExit = traveler.Limo.some(function (limo) {
                      return limo.LocationName == $scope.selectedCityName || limo.DropOff == $scope.selectedCityName || limo.PickUp == $scope.selectedCityName;
                    });
                  }
                } else {
                  if (!!traveler.Trip.Flights.length) {
                    isCityNameExit = traveler.Trip.Flights.some(function (flight) {
                      return flight.DepartureName == $scope.selectedCityName || flight.ArrivalName == $scope.selectedCityName;
                    });
                  } else if (!!traveler.Trip.Cars.length) {
                    isCityNameExit = traveler.Trip.Cars.some(function (car) {
                      return car.DropOffLocation == $scope.selectedCityName || car.PickUpLocation == $scope.selectedCityName;
                    });
                  } else if (!!traveler.Trip.Hotels.length) {
                    isCityNameExit = traveler.Trip.Hotels.some(function (hotel) {
                      return hotel.CityName == $scope.selectedCityName;
                    });
                  } else if (!!traveler.Trip.Limos.length) {
                    isCityNameExit = traveler.Trip.Limos.some(function (limo) {
                      return limo.LocationName == $scope.selectedCityName || limo.DropOff == $scope.selectedCityName || limo.PickUp == $scope.selectedCityName;
                    });
                  }
                }
              }

              if ((isCityNameExit === false && $scope.selectedCityName.length == 0 || isCityNameExit === true && !!$scope.selectedCityName.length) && traveler.DisplayTitle) {
                var name = void 0;
                if (traveler.Trip && traveler.Trip.Flights.length !== 0 && !!traveler.Trip.Flights[0].AirReservation && !!traveler.Trip.Flights[0].AirReservation.AirTravelers && traveler.Trip.Flights[0].AirReservation.AirTravelers.length > 0 && traveler.Trip.Flights[0].AirReservation.AirTravelers[0].LastName !== null && traveler.Trip.Flights[0].AirReservation.AirTravelers[0].GivenName !== null) {
                  traveler.travelerName = traveler.Trip.Flights[0].AirReservation.AirTravelers[0].LastName + ', ' + traveler.Trip.Flights[0].AirReservation.AirTravelers[0].GivenName;
                } else if (traveler.Trip && traveler.Trip.Hotels.length !== 0 && traveler.Trip.Hotels[0].GuestNames !== null) {
                  name = traveler.Trip.Hotels[0].GuestNames;
                  name = name.split(' ');
                  traveler.travelerName = name[1] + ', ' + name[0];
                } else if (traveler.Trip && traveler.Trip.Cars.length !== 0 && traveler.Trip.Cars[0].Travelers !== null) {
                  name = traveler.Trip.Cars[0].Travelers;
                  name = name.split(' ');
                  traveler.travelerName = name[1] + ', ' + name[0];
                } else if (traveler.Trip && traveler.Trip.Limos && traveler.Trip.Limos.length !== 0 && traveler.Trip.Limos[0].Travelers !== null) {
                  name = traveler.Trip.Limos[0].Travelers;
                  name = name.split(' ');
                  traveler.travelerName = name[1] + ', ' + name[0];
                } else {
                  traveler.travelerName = traveler.LastName + ', ' + traveler.FirstName;
                }
                var travelerMarker = createTravelerMarker(traveler, maps, infoWindow);
                travelerMarker.setVisible($scope.isTravelers);
                $scope.travelersMarkers.push(travelerMarker);
                tempMarkerLocators.push(traveler);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          markerLocators = createMarkerLocators(tempMarkerLocators);
        }
        $scope.isExportData = !!$scope.travelersMarkers.length ? true : false;
        setTravelersGridData($scope.travelersMarkers);
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Traveler Track search Error'; //PLACE HOLDER
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
      exportToExcel(fromDate, toDate, selectedClientId);
    }

    function createrMarkerContent(traveler) {
      markerContent = '&nbsp;<b>(' + traveler.City + ',&nbsp' + traveler.Country + ')</b>';
      if (traveler.Trip != null) {
        markerContent = markerContent + '<p style="margin-top:10px;"><b>Trip</b>&nbsp;&nbsp;(' + $filter('date')(traveler.Trip.StartDate, 'mediumDate') + ' &#8212; ' + $filter('date')(traveler.Trip.EndDate, 'mediumDate') + ')</p>';
      }
      return markerContent;
    }

    function getTravelersDataByDateAsc(traveler) {
      var flightList = [],
          carList = [],
          hotelList = [],
          limoList = [];
      var bookingType = void 0,
          bookingId = void 0,
          DeviceToken = void 0,
          OSPlatform = void 0;

      if (!!traveler.Trip && !!traveler.Trip.Member) {
        $scope.selectedRow = traveler.Trip;
        DeviceToken = traveler.Trip.Member.DeviceToken;
        OSPlatform = traveler.Trip.Member.OSPlatform;
      }
      // creating flight marker
      if (!!traveler.Trip && !!traveler.Trip.Flights.length || !!traveler.Flight) {
        if (!traveler.Trip) {
          $scope.selectedRow = traveler.Flight;
          flightList.push(traveler.Flight);
          bookingType = 'Flight';
          bookingId = traveler.FlightId;
        } else {
          flightList = traveler.Trip.Flights;
          bookingType = 'Trip';
          bookingId = traveler.TripId;
        }
      }
      // creating Car marker
      if (!!traveler.Trip && !!traveler.Trip.Cars.length || !!traveler.Car) {
        if (!traveler.Trip) {
          $scope.selectedRow = traveler.Car;
          carList.push(traveler.Car);
          bookingType = 'Car';
          bookingId = traveler.CarId;
        } else {
          carList = traveler.Trip.Cars;
          bookingType = 'Trip';
          bookingId = traveler.TripId;
        }
      }
      // creating Hotel marker
      if (!!traveler.Trip && !!traveler.Trip.Hotels.length || !!traveler.Hotel) {
        if (!traveler.Trip) {
          $scope.selectedRow = traveler.Hotel;
          hotelList.push(traveler.Hotel);
          bookingType = 'Hotel';
          bookingId = traveler.HotelId;
        } else {
          hotelList = traveler.Trip.Hotels;
          bookingType = 'Trip';
          bookingId = traveler.TripId;
        }
      }
      // creating Limo marker
      if (!!traveler.Trip && traveler.Trip.Limos && !!traveler.Trip.Limos.length || !!traveler.Limo) {
        if (!traveler.Trip) {
          $scope.selectedRow = traveler.Limo;
          limoList.push(traveler.Limo);
          bookingType = 'Limo';
          bookingId = traveler.LimoId;
        } else {
          limoList = traveler.Trip.Limos;
          bookingType = 'Trip';
          bookingId = traveler.TripId;
        }
      }
      var sortTravelersDataByDateAsc = function sortTravelersDataByDateAsc(currData, nextData) {
        var firstStartDate = void 0,
            secondStartDate = void 0;
        if (currData.hasOwnProperty('DepartureDateTime')) {
          firstStartDate = moment(currData.DepartureDateTime).format('MM-DD-YYYY');
        } else if (currData.hasOwnProperty('PickUpDateTime')) {
          firstStartDate = moment(currData.PickUpDateTime).format('MM-DD-YYYY');
        } else if (currData.hasOwnProperty('DepartureDate')) {
          firstStartDate = moment(currData.DepartureDate).format('MM-DD-YYYY');
        } else {
          firstStartDate = moment(currData.CheckInDate).format('MM-DD-YYYY');
        }
        if (nextData.hasOwnProperty('DepartureDateTime')) {
          secondStartDate = moment(nextData.DepartureDateTime).format('MM-DD-YYYY');
        } else if (nextData.hasOwnProperty('PickUpDateTime')) {
          secondStartDate = moment(nextData.PickUpDateTime).format('MM-DD-YYYY');
        } else if (currData.hasOwnProperty('DepartureDate')) {
          secondStartDate = moment(currData.DepartureDate).format('MM-DD-YYYY');
        } else {
          secondStartDate = moment(nextData.CheckInDate).format('MM-DD-YYYY');
        }
        if (firstStartDate > secondStartDate) {
          return 1;
        } else if (firstStartDate < secondStartDate) {
          return -1;
        } else if (firstStartDate === secondStartDate) {
          if (currData.BookingTypeName === 'A' && nextData.BookingTypeName === 'A') {
            var tempStartDate = moment(a.DepartureDateTime).format('MM-DD-YYYY HH:mm');
            var tempEndDate = moment(b.DepartureDateTime).format('MM-DD-YYYY HH:mm');
            if (tempStartDate > tempEndDate) {
              return 1;
            } else {
              return -1;
            }
          } else if (currData.hasOwnProperty('DepartureDateTime')) {
            return -1;
          } else if (nextData.hasOwnProperty('DepartureDateTime')) {
            return 1;
          } else if (currData.hasOwnProperty('CheckInDate') && nextData.hasOwnProperty('PickUpDateTime')) {
            return -1;
          } else if (currData.hasOwnProperty('PickUpDateTime') && nextData.hasOwnProperty('CheckInDate')) {
            return 1;
          } else {
            return 0;
          }
        }
      };
      var arrTravelersData = [flightList, carList, hotelList, limoList].reduce(function (prevData, currData) {
        return prevData.concat(currData);
      }, []);
      arrTravelersData.sort(sortTravelersDataByDateAsc);
      arrTravelersData['bookingType'] = bookingType;
      arrTravelersData['bookingId'] = bookingId;
      arrTravelersData['DeviceToken'] = DeviceToken;
      arrTravelersData['OSPlatform'] = OSPlatform;
      return arrTravelersData;
    }

    function createTravelerMarker(traveler, maps, infoWindow) {
      var marker = new google.maps.Marker({
        map: maps,
        position: new google.maps.LatLng(traveler.Latitude, traveler.Longitude),
        title: traveler.Location,
        icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
        displayTitle: traveler.DisplayTitle,
        city: traveler.Location,
        TripId: traveler.TripId,
        travelerName: traveler.travelerName
      });
      //Displaying marker on click
      google.maps.event.addListener(marker, 'click', function () {
        var userRole = authService.getLoginMember().Role;
        var markerContent = createrMarkerContent(traveler);
        var arrTravelersData = getTravelersDataByDateAsc(traveler);
        var bookingType = void 0,
            bookingId = void 0,
            contentWindow = void 0,
            DeviceToken = void 0,
            OSPlatform = void 0;
        bookingType = arrTravelersData['bookingType'];
        bookingId = arrTravelersData['bookingId'];
        DeviceToken = arrTravelersData['DeviceToken'];
        OSPlatform = arrTravelersData['OSPlatform'];
        var markerIndex = markerLocators[traveler.City].map(function (item) {
          return item.TripId;
        }).indexOf(traveler.TripId);
        arrTravelersData.forEach(function (objTraveler) {
          if (objTraveler.hasOwnProperty('DepartureDateTime')) {
            markerContent = createFlightMarker([objTraveler], markerContent);
          } else if (objTraveler.hasOwnProperty('PickUpDateTime')) {
            markerContent = createCarMarker([objTraveler], markerContent);
          } else if (objTraveler.hasOwnProperty('DepartureDate')) {
            markerContent = createLimoMarker([objTraveler], markerContent);
          } else {
            markerContent = createHotelMarker([objTraveler], markerContent);
          }
          marker.content = markerContent;
          contentWindow = showInfoMarkerWindow(userRole, marker, bookingType, bookingId, markerIndex, DeviceToken, OSPlatform);
          var compiled = $compile(contentWindow)($scope);
          infoWindow.setContent(compiled[0]);
          infoWindow.open(maps, marker);
        });
      });
      return marker;
    }
    google.maps.event.addListener(maps, 'click', function (event) {
      infoWindow.close();
    });

    function createCarMarker(carList, markerContent) {
      markerContent = carList.reduce(function (content, car) {
        return content + '<p style="padding: 0px 2px 2px 2px;">' + '<i class="fa fa-fw fa-car"></i>&emsp;' + car.PickUpLocation + '&nbsp;(' + $filter('date')(car.PickUpDateTime, 'MM/dd/yyyy  h:mma') + ')' + '&nbsp;<b>&#8594;</b>&nbsp;' + car.DropOffLocation + ' (' + $filter('date')(car.DropOffDateTime, 'MM/dd/yyyy  h:mma') + ')</p>';
      }, markerContent);
      return markerContent;
    }

    function createHotelMarker(hotelList, markerContent) {
      markerContent = hotelList.reduce(function (content, hotel) {
        return content + '<p style="padding: 0px 2px 2px 2px;">' + '<i class="fa fa-fw fa-bed"></i>&emsp;' + hotel.HotelName + ',&nbsp;' + hotel.Address + '&nbsp;(' + $filter('date')(hotel.CheckInDate, 'MM/dd/yyyy  h:mma') + '&nbsp;<b>&#8594;</b>&nbsp;' + $filter('date')(hotel.CheckOutDate, 'MM/dd/yyyy  h:mma') + ')</p>';
      }, markerContent);
      return markerContent;
    }

    function createLimoMarker(limoList, markerContent) {
      markerContent = limoList.reduce(function (content, limo) {
        return content + '<p style="padding: 0px 2px 2px 2px;">' + '<i class="fa fa-fw fa-taxi"></i>&emsp;' + limo.PickUp + '&nbsp;(' + $filter('date')(limo.DepartureDate, 'MM/dd/yyyy  h:mma') + ')' + '&nbsp;<b>&#8594;</b>&nbsp;' + limo.DropOff + '</p>';
      }, markerContent);
      return markerContent;
    }

    function createFlightMarker(flightList, markerContent) {
      markerContent = flightList.reduce(function (content, flight) {
        return content + '<p style="padding: 0px 2px 2px 2px;">' + '<i class="fa fa-fw fa-plane"></i>&emsp;' + flight.DepartureAirport + '&nbsp;(' + $filter('date')(flight.DepartureDateTime, 'MM/dd/yyyy  h:mma') + ')&nbsp;<b>&#8594;</b>&nbsp;' + flight.ArrivalAirport + '&nbsp;(' + $filter('date')(flight.ArrivalDateTime, 'MM/dd/yyyy  h:mma') + ')</p>';
      }, markerContent);
      return markerContent;
    }
    //To show marker information on click of marker
    function showInfoMarkerWindow(userRole, marker, bookingType, id) {
      var markerIndexNum = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var DeviceToken = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
      var OSPlatform = arguments[6];

      var traveler = $scope.selectedRow.Member ? $scope.selectedRow.Member : $scope.selectedRow.Traveler;
      var strPreviousClassName = '';
      var strNextClassName = '';
      if (markerIndexNum < 1) {
        strPreviousClassName = 'prevLocator disabled';
      } else {
        strPreviousClassName = 'prevLocator';
      }
      if (markerIndexNum == markerLocators[marker.city].length - 1) {
        strNextClassName = 'nextLocator disabled';
      } else {
        strNextClassName = 'nextLocator';
      }

      var btnHtml = '<button angular-ripple class="btn" style="margin-bottom:0px;" title="SMS traveler" ng-click="sendSms(' + id + ", '" + DeviceToken + "', '" + OSPlatform + "', '" + bookingType + '\')" type="button"><i class="fa fa-comment"></i></button>';

      if (!traveler.Phone || userRole === obexRoles.roleTravelManager || userRole === obexRoles.roleObexAdmin) {
        btnHtml = '<button angular-ripple class="btn" style="margin-bottom:0px;opacity: 0.6;cursor: not-allowed" title="Traveler phone is required" type="button"><i class="fa fa-comment"></i></button>';
      }

      return '<div style="float:left;width:100%">' + '<div style="float:left;width:100%"><font size="4">' + marker.DisplayTitle + '&nbsp' + '</font>' + marker.content + '</div>' + '<div style="float:left;width:40%"><a href ng-click="getTripDetails($event, ' + userRole + ')" ><span style="border-bottom: 1px solid" bookingType=' + bookingType + ' bookingId=' + id + '>Details</span></a>' + '</div>' + '<div style="float:right;text-align:center;width:10%">' + btnHtml + '</div>' + '<div class="locatorsPaging" data-idx=' + markerIndexNum + ' data-cityname="' + marker.city + '">' + '<a id="prevTab" class="' + strPreviousClassName + '" href="javascript:void(0);" title="Previous"></a>' + '&nbsp;' + '<a id="nextTab" class="' + strNextClassName + '" href="javascript:void(0);" title="Next"></a>' + '</div>' + '</div>';
    }

    //Creating alert markers
    function createAlertMarker(alert, alertValue, maps, infoWindow) {
      var marker = new google.maps.Marker({
        map: maps,
        position: new google.maps.LatLng(alert.Latitude, alert.Longitude),
        icon: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
        title: alert.Category,
        alertValue: alertValue
      });
      var content = '<p> ' + alert.Category + ' </p><p>' + alert.PublishDate + '</p><p><b>' + alert.Title + '</b></p><p>' + alert.Summary + '</p><p><a href= ' + alert.LinkUrl + ' target="_blank" >More Details</a></p>';
      content = content + '<p><a href="#" class="exportat" item-category="' + alert.Category + '">Export Travelers Affected</a></p>';
      marker.content = content;
      google.maps.event.addListener(marker, 'click', function () {
        infoWindow.setContent(marker.content);
        infoWindow.open(maps, marker);
      });
      return marker;
    }

    //To open information window
    $scope.openInfoWindow = function (e, selectedMarker) {
      e.preventDefault();
      google.maps.event.trigger(selectedMarker, 'click');
    };
    $scope.travelersGrid = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: false,
      paginationPageSize: 10,
      useExternalPagination: true,
      useExternalSorting: false,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      showTreeExpandNoChildren: false,
      rowHeight: 20,
      columnDefs: [{
        name: 'DisplayTitle',
        height: '200px',
        displayName: 'Travelers',
        cellTemplate: '<span style="padding:3px"> {{ row.entity.DisplayTitle }} </span>',
        enableHiding: false,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableSorting: true,
        enableFiltering: true,
        enableRowSelection: true
      }],
      //Information Pop up on selection of travelers grid row
      onRegisterApi: function onRegisterApi(gridApiTravelers) {
        $scope.gridApiTravelers = gridApiTravelers;
        gridApiTravelers.selection.on.rowSelectionChanged($scope, function (row) {
          if ($scope.isTravelers) {
            google.maps.event.trigger(row.entity, 'click');
            $scope.isDetails = false;
          }
        });
      }
    };

    $scope.travelersStateChanged = function () {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)($scope.travelersMarkers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var travelerMarker = _step2.value;

          travelerMarker.setVisible($scope.isTravelers);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    };

    $scope.alertValues = [{ level: 1, isShowAlert: false, title: 1 }, { level: 2, isShowAlert: false, title: 2 }, { level: 4, isShowAlert: false, title: 3 }, { level: 8, isShowAlert: true, title: 4 }];
    $scope.alertsStateChanged = function (isShowAlert, alertValue) {
      $scope.alertsGrid.data = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)($scope.AlertMarkers), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var alertMarker = _step3.value;

          if (alertMarker.alertValue === alertValue) {
            alertMarker.setVisible(isShowAlert);
          }
          if (alertMarker.visible === true) {
            $scope.alertsGrid.data.push(alertMarker);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    };

    function reloadMarkers() {
      if (!!$scope.travelersMarkers) {
        $scope.travelersMarkers.map(function (travelersMarkers) {
          travelersMarkers.setMap(null);
          travelersMarkers.setVisible($scope.isTravelers);
          return travelersMarkers;
        });
      }
    }
    //Search according to radio button
    $scope.pre31daysSelected = function () {
      $scope.next24hours = false;
      $scope.days1to7 = false;
      $scope.post31days = false;
      $scope.customDate = false;
      var fromDate = new Date();
      var toDate = new Date();
      $scope.isCustomDate = false;
      reloadMarkers();
      fromDate.setDate(fromDate.getDate() - 31);
      fromDate = $filter('date')(fromDate, 'yyyy-MM-dd');
      toDate = $filter('date')(toDate, 'yyyy-MM-dd');
      $scope.isDetails = false;
      searchTravelersData(fromDate, toDate, maps, infoWindow);
    };
    $scope.next24hoursSelected = function () {
      $scope.pre31days = false;
      $scope.days1to7 = false;
      $scope.post31days = false;
      $scope.customDate = false;
      var fromDate = new Date();
      var toDate = new Date();
      $scope.isCustomDate = false;
      reloadMarkers();
      toDate.setHours(toDate.getHours() + 24);
      fromDate = $filter('date')(fromDate, 'yyyy-MM-dd');
      toDate = $filter('date')(toDate, 'yyyy-MM-dd');
      $scope.isDetails = false;
      searchTravelersData(fromDate, toDate, maps, infoWindow);
    };
    $scope.days1to7Selected = function () {
      $scope.pre31days = false;
      $scope.next24hours = false;
      $scope.post31days = false;
      $scope.customDate = false;
      var fromDate = new Date();
      var toDate = new Date();
      $scope.isCustomDate = false;
      reloadMarkers();
      toDate.setDate(toDate.getDate() + 7);
      fromDate = $filter('date')(fromDate, 'yyyy-MM-dd');
      toDate = $filter('date')(toDate, 'yyyy-MM-dd');
      $scope.isDetails = false;
      searchTravelersData(fromDate, toDate, maps, infoWindow);
    };
    $scope.post31daysSelected = function () {
      $scope.pre31days = false;
      $scope.next24hours = false;
      $scope.days1to7 = false;
      $scope.customDate = false;
      var fromDate = new Date();
      var toDate = new Date();
      $scope.isCustomDate = false;
      reloadMarkers();
      toDate.setDate(toDate.getDate() + 31);
      fromDate = $filter('date')(fromDate, 'yyyy-MM-dd');
      toDate = $filter('date')(toDate, 'yyyy-MM-dd');
      $scope.isDetails = false;
      searchTravelersData(fromDate, toDate, maps, infoWindow);
    };
    $scope.customDateSelected = function () {
      $scope.pre31days = false;
      $scope.next24hours = false;
      $scope.days1to7 = false;
      $scope.post31days = false;
      $scope.isCustomDate = true;
    };
    $scope.searchCustomDate = function () {
      var fromDate = new Date();
      var toDate = new Date();
      reloadMarkers();
      fromDate = $filter('date')($scope.customFromDate, 'yyyy-MM-dd');
      toDate = $filter('date')($scope.customToDate, 'yyyy-MM-dd');
      $scope.isDetails = false;
      searchTravelersData(fromDate, toDate, maps, infoWindow);
    };
    //To get search data for next24hours default selection on page load
    if ($scope.next24hours) {
      $scope.next24hoursSelected();
    }
    $scope.searchTravelersNearAlertsOrInCity = function () {
      var fromDate = new Date();
      var toDate = new Date();
      reloadMarkers();
      if (document.getElementById('pre31days').checked) {
        fromDate.setDate(fromDate.getDate() - 31);
        fromDate = $filter('date')(fromDate, 'yyyy-MM-dd');
        toDate = $filter('date')(toDate, 'yyyy-MM-dd');
        searchTravelersData(fromDate, toDate, maps, infoWindow);
      } else if (document.getElementById('next24hours').checked) {
        toDate.setHours(toDate.getHours() + 24);
        fromDate = $filter('date')(fromDate, 'yyyy-MM-dd');
        toDate = $filter('date')(toDate, 'yyyy-MM-dd');
        searchTravelersData(fromDate, toDate, maps, infoWindow);
      } else if (document.getElementById('post31days').checked) {
        toDate.setDate(toDate.getDate() + 31);
        fromDate = $filter('date')(fromDate, 'yyyy-MM-dd');
        toDate = $filter('date')(toDate, 'yyyy-MM-dd');
        searchTravelersData(fromDate, toDate, maps, infoWindow);
      } else if (document.getElementById('customDate').checked) {
        fromDate = $filter('date')($scope.customFromDate, 'yyyy-MM-dd');
        toDate = $filter('date')($scope.customToDate, 'yyyy-MM-dd');
        searchTravelersData(fromDate, toDate, maps, infoWindow);
      } else if (document.getElementById('days1to7').checked) {
        toDate.setDate(toDate.getDate() + 7);
        fromDate = $filter('date')(fromDate, 'yyyy-MM-dd');
        toDate = $filter('date')(toDate, 'yyyy-MM-dd');
        searchTravelersData(fromDate, toDate, maps, infoWindow);
      }
    };

    function exportToExcel(fromDate, toDate, selectedClientId) {
      progress.start();
      travelerTrack.getTravelerExportList(fromDate, toDate, $scope.isTravelersNearToAlerts, selectedClientId).then(function (travelers) {
        $scope.getArray = [];
        if (!!travelers.data) {
          $scope.getArray = travelers.data.map(function (traveler) {
            return {
              travelerName: traveler.TravelerName ? traveler.TravelerName : '',
              travelArrangerName: traveler.TravelArrangers && !!traveler.TravelArrangers.length ? traveler.TravelArrangers[0].FirstName + ' ' + traveler.TravelArrangers[0].LastName : '',
              email: traveler.Email && traveler.TravelArrangers && !!traveler.TravelArrangers.length ? traveler.Email + ', ' + traveler.TravelArrangers[0].Email : traveler.Email ? traveler.Email : '',
              title: traveler.Title ? traveler.Title : '',
              segment: traveler.Segment ? traveler.Segment : '',
              startDate: traveler.StartDate ? traveler.StartDate : '',
              endDate: traveler.EndDate ? traveler.EndDate : '',
              departureCity: traveler.DepartureCity ? traveler.DepartureCity : '',
              arrivalCity: traveler.ArrivalCity ? traveler.ArrivalCity : '',
              currentLocation: traveler.CurrentLocation ? traveler.CurrentLocation : '',
              currentLocationCountry: traveler.CurrentLocationCountry ? traveler.CurrentLocationCountry : ''
            };
          });
        }
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Traveler Track Export CSV Error'; //PLACE HOLDER
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    }
    //Displaying in tree structure
    var writeoutNode = function writeoutNode(childArray, currentLevel, dataArray) {
      childArray.forEach(function (childNode) {
        if (!!childNode.childElement.length || childNode.singleparent) {
          childNode.$$treeLevel = currentLevel;
        }
        dataArray.push(childNode);
        writeoutNode(childNode.childElement, currentLevel + 1, dataArray);
      });
    };
    //  Creation parent with child nodes
    function setTravelersGridData(travelersMarkers) {
      var parentWithChild = [];
      var parentListTraveler = [];
      if (!!travelersMarkers.length) {
        var newparent = travelersMarkers[0];
        newparent.DisplayName = '';
        parentListTraveler[0] = newparent;
        travelersMarkers.forEach(function (travelersmarker) {
          newparent = travelersmarker;
          var flag = false;
          parentListTraveler.filter(function (parentList) {
            return travelersmarker.travelerName == parentList.travelerName;
          }).map(function (parentList) {
            flag = true;
          });
          if (flag === false) {
            newparent.DisplayName = '';
            parentListTraveler.push(newparent);
          }
        });
        if (!!parentListTraveler) {
          parentListTraveler.forEach(function (parentList) {
            parentListTravelersListByTripId[parentList.TripId] = parentList.TripId;
            var parent = parentList;
            parent.DisplayTitle = parent.travelerName + ' ' + parent.DisplayName;
            parent.childElement = [];
            var parentListMarkers = travelersMarkers.filter(function (travelersmarker) {
              return parentList.travelerName == travelersmarker.travelerName && parentList != travelersmarker;
            });
            parentListMarkers.forEach(function (travelersmarker) {
              var child = travelersmarker;
              child.childElement = [];
              child.DisplayTitle = travelersmarker.displayTitle;
              parent.childElement.push(child);
            });
            parentWithChild.push(parent);
          });
        }
        $scope.travelersGrid.data = [];
        parentWithChild.map(function (parentwithchild) {
          parentwithchild.singleparent = false;
        });
        parentWithChild.filter(function (parentchild) {
          return !parentchild.childElement.length;
        }).map(function (parentchild) {
          parentchild.singleparent = true;
        });
        writeoutNode(parentWithChild, 0, $scope.travelersGrid.data);
      } else {
        $scope.travelersGrid.data = [];
      }
    }
    // get trip details by trip Id
    $scope.getTripDetails = function (e, userRole) {
      var bookingType = void 0,
          bookingId = void 0;
      bookingType = e.target.attributes.bookingType.value;
      bookingId = e.target.attributes.bookingId.value;
      progress.start();
      // generate trip container booking details
      $scope.isDetails = false;
      switch (bookingType) {
        // generate trip container booking details
        case 'Trip':
          $scope.bookingListInDetails = [];
          $scope.isDetails = true;
          generateTripDetails(bookingId);
          break;
        case 'Flight':
          var flightContext = [];
          $scope.bookingListInDetails = [];
          $scope.isDetails = true;
          tripsDashBoard.getFlightsDashById(bookingId).then(function (flights) {
            flightContext.push(flights.data);
            $scope.bookingListInDetails = generateBookingFlight(flightContext);
            $scope.selectedRow = $scope.bookingListInDetails[0];
            $scope.TravelerEmail = flights.data.Member.Email;
            $scope.TravelerCompanyId = flights.data.Member.Organization.Id;
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + '</p>';
                  $scope.errTitle = 'Traveler Track Details Error'; //PLACE HOLDER
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
          break;
        case 'Car':
          var carContext = [];
          $scope.bookingListInDetails = [];
          $scope.isDetails = true;
          tripsDashBoard.getCarsDashById(bookingId).then(function (cars) {
            carContext.push(cars.data);
            $scope.bookingListInDetails = generateBookingCar(carContext);
            $scope.selectedRow = $scope.bookingListInDetails[0];
            $scope.TravelerEmail = cars.data.Member.Email;
            $scope.TravelerCompanyId = cars.data.Member.Organization.Id;
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + '</p>';
                  $scope.errTitle = 'Traveler Track Details Error'; //PLACE HOLDER
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
          break;
        case 'Hotel':
          var hotelContext = [];
          $scope.bookingListInDetails = [];
          $scope.isDetails = true;
          tripsDashBoard.getHotelsDashById(bookingId).then(function (hotels) {
            hotelContext.push(hotels.data);
            $scope.bookingListInDetails = generateBookingHotel(hotelContext);
            $scope.selectedRow = $scope.bookingListInDetails[0];
            $scope.TravelerEmail = hotels.data.Member.Email;
            $scope.TravelerCompanyId = hotels.data.Member.Organization.Id;
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + '</p>';
                  $scope.errTitle = 'Traveler Track Details Error'; //PLACE HOLDER
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
          break;
        case 'Limo':
          var limoContext = [];
          $scope.bookingListInDetails = [];
          $scope.isDetails = true;
          tripsDashBoard.getLimosDashById(bookingId).then(function (limos) {
            limoContext.push(limos.data);
            $scope.bookingListInDetails = generateBookingLimo(limoContext);
            $scope.selectedRow = $scope.bookingListInDetails[0];
            $scope.TravelerEmail = limos.data.Member.Email;
            $scope.TravelerCompanyId = limos.data.Member.Organization.Id;
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '<p>' + err.statusText + '</p>';
                  $scope.errTitle = 'Traveler Track Details Error'; //PLACE HOLDER
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
          break;
      }
      $scope.userRole = userRole;
    };
    //generate trip details by trip Id
    function generateTripDetails(id) {
      tripsDashBoard.getTripsDashbyId(id).then(function (trips) {
        var tripFlightContext = trips.data.Flights;
        var tripCarContext = trips.data.Cars;
        var tripHotelContext = trips.data.Hotels;
        var tripLimoContext = trips.data.Limos;
        var flightList = [];
        var carList = [];
        var hotelList = [];
        var limoList = [];
        if (!!tripFlightContext.length) {
          flightList = generateBookingFlight(tripFlightContext, trips.data.Member);
        }
        if (!!tripCarContext.length) {
          carList = generateBookingCar(tripCarContext, trips.data.Member);
        }
        if (!!tripHotelContext.length) {
          hotelList = generateBookingHotel(tripHotelContext, trips.data.Member);
        }
        if (!!tripLimoContext.length) {
          limoList = generateBookingLimo(tripLimoContext, trips.data.Member);
        }

        /*$scope.bookingListInDetails = [flightList, carList, hotelList].reduce(function(prevData,
        currData) {
        return prevData.concat(currData);
        }, []);*/
        $scope.bookingListInDetails = [].concat(flightList, carList, hotelList, limoList);

        var sortByDateAsc = function sortByDateAsc(a, b) {
          var firstStartDate = moment(a.StartDate).format('MM-DD-YYYY');
          var secondStartDate = moment(b.StartDate).format('MM-DD-YYYY');
          if (firstStartDate > secondStartDate) {
            return 1;
          } else if (firstStartDate < secondStartDate) {
            return -1;
          } else if (firstStartDate === secondStartDate) {
            if (a.BookingTypeName === 'A' && b.BookingTypeName === 'A') {
              var tempStartDate = moment(a.StartDate).format('MM-DD-YYYY HH:mm');
              var tempEndDate = moment(b.StartDate).format('MM-DD-YYYY HH:mm');
              if (tempStartDate > tempEndDate) {
                return 1;
              } else {
                return -1;
              }
            } else if (a.BookingTypeName === 'A') {
              return -1;
            } else if (b.BookingTypeName === 'A') {
              return 1;
            } else if (a.BookingTypeName === 'H' && b.BookingTypeName === 'C') {
              return -1;
            } else if (a.BookingTypeName === 'C' && b.BookingTypeName === 'H') {
              return 1;
            } else {
              return 0;
            }
          }
        };
        $scope.bookingListInDetails.sort(sortByDateAsc);
        $scope.selectedRow = $scope.bookingListInDetails[0];
        $scope.TravelerEmail = trips.data.Member.Email;
        $scope.TravelerCompanyId = trips.data.Member.Organization.Id;
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = '<p>' + err.statusText + '</p>';
              $scope.errTitle = 'Traveler Track Details Error'; //PLACE HOLDER
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    }
    $scope.CloseTripDetails = function () {
      $scope.isDetails = false;
    };

    function generateBookingFlight(flightContext, member) {
      return flightContext.map(function (flight) {
        var travelerName = flight.Member ? flight.Member.LastName + ', ' + flight.Member.FirstName : member ? member.LastName + ', ' + member.FirstName : '';
        return {
          Id: flight.Id,
          BookingTypeName: 'A',
          StartDate: flight.DepartureDateTime,
          Company: flight.Member ? flight.Member.Organization.Name : member ? member.Organization.Name : '',
          Seg: 1,
          TravelerDisplayName: travelerName,
          Travelers: [travelerName],
          Supplier: flight.OperatingAirline,
          Source: !!flight.BookingSource ? flight.BookingSource : '',
          Pnr: !!flight.Pnr ? flight.Pnr : '',
          StartLocation: flight.DepartureName,
          EndLocation: flight.ArrivalName,
          BookingType: 'Flight',
          FlightNumber: flight.FlightNumber,
          Duration: flight.Duration,
          Seat: flight.Seats,
          EndDate: flight.ArrivalDateTime,
          Class: (!!flight.BookingClass ? flight.BookingClass : '') + (!!flight.BookingClassDescription ? ' - ' + flight.BookingClassDescription : ''),
          Status: !!flight.ConfirmationNumber ? 'Confirmed - ' + flight.ConfirmationNumber : '',
          Type: 0,
          NumberOfRooms: 0,
          Address: 0,
          Total: currency.getCurrencySymbol(flight.AirReservation.CurrencyCode) + flight.AirReservation.TotalFare,
          DeviceToken: flight.Member ? flight.Member.DeviceToken : member ? member.DeviceToken : null,
          OSPlatform: flight.Member ? flight.Member.OSPlatform : member ? member.OSPlatform : null,
          Traveler: flight.Member ? flight.Member : member
        };
      });
    }

    function generateBookingCar(carContext, member) {
      return carContext.map(function (car) {
        var travelerName = car.Member ? car.Member.LastName + '/' + car.Member.FirstName : member ? member.LastName + ', ' + member.FirstName : '';
        return {
          Id: car.Id,
          BookingTypeName: 'C',
          StartDate: car.PickUpDateTime,
          Company: car.Member ? car.Member.Organization.Name : member ? member.Organization.Name : '',
          Seg: 2,
          TravelerDisplayName: travelerName,
          Travelers: [travelerName],
          Supplier: car.RentalCompany,
          Source: !!car.BookingSource ? car.BookingSource : '',
          Pnr: !!car.Pnr ? car.Pnr : '',
          StartLocation: car.PickUpLocation,
          EndLocation: car.DropOffLocation,
          BookingType: 'Car',
          FlightNumber: 0,
          Duration: 0,
          Seat: 0,
          EndDate: car.DropOffDateTime,
          Class: 0,
          Status: !!car.Confirmation ? 'Confirmed - ' + car.Confirmation : '',
          Type: car.CarModel,
          NumberOfRooms: 0,
          Address: 0,
          Total: currency.getCurrencySymbol(car.CurrencyCode) + car.TotalCharge,
          DeviceToken: car.Member ? car.Member.DeviceToken : member ? member.DeviceToken : null,
          OSPlatform: car.Member ? car.Member.OSPlatform : member ? member.OSPlatform : null,
          Traveler: car.Member ? car.Member : member
        };
      });
    }

    function generateBookingHotel(hotelContext, member) {
      return hotelContext.map(function (hotel) {
        var travelerName = !!hotel.GuestNames ? hotel.GuestNames : hotel.Member ? hotel.Member.LastName + '/' + hotel.Member.FirstName : member ? member.LastName + ', ' + member.FirstName : '';
        return {
          Id: hotel.Id,
          BookingTypeName: 'H',
          StartDate: hotel.CheckInDate,
          Company: hotel.Member ? hotel.Member.Organization.Name : member ? member.Organization.Name : '',
          Seg: 3,
          TravelerDisplayName: travelerName,
          Travelers: [travelerName],
          Supplier: hotel.HotelName,
          Source: !!hotel.BookingSource ? hotel.BookingSource : '',
          Pnr: !!hotel.Pnr ? hotel.Pnr : '',
          StartLocation: '',
          BookingType: 'Hotel',
          FlightNumber: 0,
          Duration: 0,
          Seat: 0,
          EndDate: hotel.CheckOutDate,
          Class: 0,
          Status: !!hotel.Confirmation ? 'Confirmed - ' + hotel.Confirmation : '',
          Type: hotel.RoomType,
          NumberOfRooms: hotel.NumberOfRooms,
          Address: hotel.Address,
          Total: currency.getCurrencySymbol(hotel.CurrencyCode) + hotel.Total,
          DeviceToken: hotel.Member ? hotel.Member.DeviceToken : member ? member.DeviceToken : null,
          OSPlatform: hotel.Member ? hotel.Member.OSPlatform : member ? member.OSPlatform : null,
          Traveler: hotel.Member ? hotel.Member : member
        };
      });
    }

    function generateBookingLimo(limoContext, member) {
      return limoContext.map(function (limo) {
        var travelerName = member.LastName + '/' + member.FirstName;
        return {
          Id: limo.Id,
          BookingTypeName: 'L',
          DepartureDate: limo.DepartureDate,
          LimoServiceName: limo.LimoServiceName,
          LocationName: limo.LocationName,
          Seg: 4,
          TravelerDisplayName: travelerName,
          Travelers: [travelerName],
          BookingType: 'Limo',
          Traveler: member,
          BookingSource: limo.BookingSource,
          Cancelled: limo.Cancelled,
          Confirmation: limo.Confirmation,
          DropOff: limo.DropOff,
          IPCC: limo.IPCC,
          ImageLink: limo.ImageLink,
          Instructions: limo.Instructions,
          PickUp: limo.PickUp,
          Pnr: limo.Pnr,
          Time: limo.Time,
          StartDate: limo.DepartureDate
        };
      });
    }

    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }
    // Watch agencySelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      $scope.travelersGrid.data = [];
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && valid.clientValid) {
        if (newValue !== oldValue) {
          selectedClientId = newValue.id;
          if (!!selectedClientId) {
            if ($scope.isTravelersNearToAlerts) {
              $scope.searchTravelersNearAlertsOrInCity();
            } else if ($scope.pre31days) {
              $scope.pre31daysSelected();
            } else if ($scope.next24hours) {
              $scope.next24hoursSelected();
            } else if ($scope.days1to7) {
              $scope.days1to7Selected();
            } else if ($scope.post31days) {
              $scope.post31daysSelected();
            } else if ($scope.isCustomDate) {
              $scope.searchCustomDate();
            }
          } else {
            // clear travelers grid and markers
            $scope.isExportData = false;
            $scope.travelersGrid.data = [];
            reloadMarkers();
          }
        }
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('travelManagerAssignmentController', ['$scope', 'travelManagerAssignment', 'progressBar', 'ngDialog', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', 'organizations', 'members', '$q', 'toastr', 'authService', 'clientSelectService', 'agencySelectService', 'toastFactory', function ($scope, travelManagerAssignment, progressBar, ngDialog, uiGridConstants, commonDialog, commonDialogMessage, organizations, members, $q, toastr, authService, clientSelectService, agencySelectService, toastFactory) {
    //variable declaration
    var progress = progressBar.getProgressBar();
    var _addTravelManagerList = [];
    var _deleteTravelManagerList = [];
    var _unassignedSnapshot = [];
    var _assignedSnapshot = [];
    $scope.ownOrgName = authService.getLoginMember().Organization.Name;

    function dialogBox(dialogMessage, dialogType) {
      ngDialog.open({
        template: dialogMessage + dialogType,
        className: 'ngdialog-theme-plain',
        plain: true
      });
    }
    // Validate that filtered organization id is defined
    function validateOrganization() {
      var organization = clientSelectService.getSelectedClient();
      return organization.id != null && (0, _isInteger2.default)(organization.id);
    };
    // Watch orgFilterService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        clearGrids();
        setGridData();
      }
    }, true);

    function clearGrids() {
      $scope.gridUnassignedTravelManagers.data = [];
      $scope.gridUnassignedTravelManagers.totalItems = 0;
      $scope.gridAssignedTravelManagers.data = [];
      $scope.gridAssignedTravelManagers.totalItems = 0;
      $scope.unassignedGridApi.grid.selection.selectAll = false;
      $scope.assignedGridApi.grid.selection.selectAll = false;
    };

    /*function getTravelAgencyId(filterOrgId) {
      return organizations.getOrganizationById(filterOrgId).then(function(organization) {
        return organization.data.TravelAgencyId;
      });
    };*/
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }
    // Sets both grids' data
    function setGridData() {
      var valid = validateAgencyAndClientSelection();
      if (valid.agencyValid && valid.clientValid) {
        if (validateOrganization()) {
          progress.start();
          // Organization to assign/unassign travel Managers to/from
          var filterOrg = clientSelectService.getSelectedClient();
          var filterOrgId = filterOrg.id;
          $scope.filterOrgName = filterOrg.name;

          var agency = agencySelectService.getSelectedAgency();

          // All Manager from loginMember's travel agency
          var promiseAll = members.getTravelManagers(agency.id);
          // Travel Manager Organizations for filtered organization
          var promiseAssigned = travelManagerAssignment.getTravelManagerOrganizationsById(filterOrgId);
          //const promiseTravelAgencyId = getTravelAgencyId(filterOrgId);
          $q.all([promiseAll, promiseAssigned]).then(function (responses) {
            if (responses[0].data.length > 0) {
              //const travelAgencyId = responses[2];
              // Processing
              var assignedContext = processAssignedManagers(responses[1].data);
              var unassignedContext = processUnassignedManagers(responses[0].data, assignedContext);
              // Populate grids
              clearGrids();
              $scope.gridUnassignedTravelManagers.data = unassignedContext;
              $scope.gridUnassignedTravelManagers.totalItems = unassignedContext.length;
              $scope.gridAssignedTravelManagers.data = assignedContext;
              $scope.gridAssignedTravelManagers.totalItems = assignedContext.length;
              // Save snapshots of initial grid data
              _unassignedSnapshot = $scope.gridUnassignedTravelManagers.data.slice(0);
              _assignedSnapshot = $scope.gridAssignedTravelManagers.data.slice(0);
            } else {
              toastr.warning('No content received.', 'Alert');
            }
          }, function (err) {
            dialogBox(err.statusText, commonDialog.openDialog);
          }).finally(function () {
            progress.complete();
          });
        } else {
          $scope.filterOrgName = null;
        }
      } else if (valid.agencyValid) {
        //toastFactory.toast_info('Please select a client.');
      } else {
          //toastFactory.toast_info('Please select an agency and then client.');
        }
    };
    // Filter out assigned Managers from all Managers
    function processUnassignedManagers(membersInfo, assignedInfo) {
      if (!!membersInfo && !!assignedInfo) {
        // Grab MemberId's of assigned Managers
        var assignedIds = _.map(assignedInfo, 'MemberId');
        return membersInfo.filter(function (member) {
          // Select members whose MemberId's are not in the assignedIds array
          return assignedIds.indexOf(member.Id) < 0;
        }).map(function (member) {
          return {
            MemberId: member.Id,
            MemberName: member.DisplayName,
            OrganizationId: member.OrganizationId
          };
        });
      }
    };
    // Only returns a projection
    function processAssignedManagers(assignedInfo) {
      if (!!assignedInfo) {
        return assignedInfo.map(function (travelManager) {
          return {
            MemberId: travelManager.Member.Id,
            MemberName: travelManager.Member.DisplayName,
            OrganizationId: travelManager.OrganizationId,
            TravelManagerOrganizationId: travelManager.Id
          };
        });
      }
    };
    // addTravelManager and deleteTravelManager should only act as purely visual functions --
    // the values sent to server will depend on diff from snapshotted data at time of action.
    $scope.addTravelManager = function () {

      var unassignedTravelManagers = $scope.gridUnassignedTravelManagers.data.filter(function (travelManager) {
        return _addTravelManagerList.indexOf(travelManager) === -1;
      });

      $scope.gridUnassignedTravelManagers.data = unassignedTravelManagers;
      $scope.gridUnassignedTravelManagers.totalItems = unassignedTravelManagers.length;

      var assignedManagers = $scope.gridAssignedTravelManagers.data.concat(_addTravelManagerList);
      $scope.gridAssignedTravelManagers.data = assignedManagers;
      $scope.gridAssignedTravelManagers.totalItems = assignedManagers.length;

      // Clear _addTravelManagerList
      _addTravelManagerList.length = 0;
      // Deselect left-side selectAll checkbox
      $scope.unassignedGridApi.grid.selection.selectAll = false;
    };
    $scope.deleteTravelManager = function () {
      var assignedTravelManagers = $scope._deleteTravelAgentList.data.filter(function (deleteTravelManager) {
        return $scope.gridAssignedTravelManagers.data.indexOf(deleteTravelManager) === -1;
      });
      $scope.gridAssignedTravelManagers.data = assignedTravelManagers;
      $scope.gridAssignedTravelManagers.totalItems = assignedTravelManagers.length;

      var unassignedManagers = $scope.gridUnassignedTravelManagers.data.concat(_deleteTravelAgentList);

      $scope.gridUnassignedTravelManagers.data = unassignedManagers;
      $scope.gridUnassignedTravelManagers.totalItems = unassignedManagers.length;

      /*_deleteTravelManagerList.forEach(function(delManager) {
        // Remove row from right
        $scope.gridAssignedTravelManagers.data.splice($scope.gridAssignedTravelManagers.data.indexOf(delManager),
          1);
        $scope.gridAssignedTravelManagers.totalItems--;
        // Push row to left
        $scope.gridUnassignedTravelManagers.data.push(delManager);
        $scope.gridUnassignedTravelManagers.totalItems++;
      });
      // Clear _deleteTravelManagerList
      _deleteTravelManagerList.length = 0;
      // Deselect right-side selectAll checkbox
      $scope.assignedGridApi.grid.selection.selectAll = false;*/
    };
    // Send changes to API
    $scope.saveTravelManagers = function () {
      if (validateOrganization()) {
        var orgId = clientSelectService.getSelectedClient().id;
        // Check diffs against snapshots
        var toAdd = _.differenceWith($scope.gridAssignedTravelManagers.data, _assignedSnapshot, _.isEqual).map(function (travelManager) {
          return {
            Id: 0,
            MemberId: travelManager.MemberId,
            OrganizationId: orgId
          };
        });
        var toDelete = _.differenceWith($scope.gridUnassignedTravelManagers.data, _unassignedSnapshot, _.isEqual).map(function (travelManager) {
          return {
            TravelManagerOrganizationId: travelManager.TravelManagerOrganizationId
          };
        });
        var promiseAdd = travelManagerAssignment.addTravelManagerOrganizations(toAdd).then(function (response) {
          return !!response;
        });
        var promiseDel = travelManagerAssignment.deleteTravelManagerOrganizations(toDelete).then(function (response) {
          return !!response;
        });
        var promises = [];
        if (toAdd.length > 0) {
          promises.push(promiseAdd);
        }
        if (toDelete.length > 0) {
          promises.push(promiseDel);
        }
        if (promises.length > 0) {
          progress.start();
          $q.all(promises).then(function (responses) {
            progress.complete();
            if (responses.length === 2 && responses[0] && responses[1] || responses.length === 1 && responses[0]) {
              toastr.success('Changes were successfully made.', 'Success');
              setGridData();
            } else {
              toastr.error('An error occurred while making changes.', 'Error');
            }
          });
        } else {
          toastr.info('No changes were made.', 'Info');
        }
      }
    };
    // Resync grid data with server
    $scope.reset = function () {
      clearGrids();
      setGridData();
      _addTravelManagerList.length = 0;
      _deleteTravelManagerList.length = 0;
      if (validateOrganization()) {
        toastr.info('Grids were reset.', 'Reset');
      }
    };
    // ui-grid below        
    var columnDefs = [{
      name: 'MemberName',
      displayName: 'Travel Manager',
      visible: true,
      enableHiding: false,
      enableSorting: true,
      sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
      enableFiltering: true,
      enableColumnResizing: true,
      sort: {
        direction: uiGridConstants.ASC,
        priority: 0
      }
    }];
    var gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: false,
      paginationPageSize: 25,
      useExternalPagination: false,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: true,
      enableRowHeaderSelection: true,
      multiSelect: true,
      enableSelectionBatchEvent: true,
      columnDefs: columnDefs
    };
    /* TODO: enableFullRowSelection not working as intended:
    see https://github.com/angular-ui/ui-grid/issues/2254, https://github.com/angular-ui/ui-grid/commit/679b615bd19ff71ff1e835d7f6066e7a919f279a
    */
    // Left grid (Unassigned Managers)
    $scope.gridUnassignedTravelManagers = _.cloneDeep(gridOptions);
    $scope.gridUnassignedTravelManagers.onRegisterApi = function (gridApi) {
      $scope.unassignedGridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        if (row.isSelected) {
          _addTravelManagerList.push(row.entity);
        } else {
          _addTravelManagerList.splice(_addTravelManagerList.indexOf(row.entity), 1);
        }
      });
      // Handle mass selection events
      gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
        _addTravelManagerList = gridApi.selection.getSelectedRows();
      });
    };
    // Right grid (Assigned Managers)
    $scope.gridAssignedTravelManagers = _.cloneDeep(gridOptions);
    $scope.gridAssignedTravelManagers.onRegisterApi = function (gridApi) {
      $scope.assignedGridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        if (row.isSelected) {
          _deleteTravelManagerList.push(row.entity);
        } else {
          _deleteTravelManagerList.splice(_deleteTravelManagerList.indexOf(row.entity), 1);
        }
      });
      // Handle mass selection events
      gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
        _deleteTravelManagerList = gridApi.selection.getSelectedRows();
      });
    };
    // End ui-grid
    setGridData();
  }]);
})(angular.module('obex'));

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('travelSpendController', ['$scope', 'travelSpend', '$stateParams', 'progressBar', 'ngDialog', 'clientSelectService', 'agencySelectService', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$filter', '$q', 'toastFactory', 'authService', function ($scope, travelSpend, $stateParams, progressBar, ngDialog, clientSelectService, agencySelectService, uiGridConstants, commonDialog, commonDialogMessage, $filter, $q, toastFactory, authService) {
    var progress = progressBar.getProgressBar();
    $scope.dateCustFrom = new Date();
    $scope.dateCustTo = addMonth($scope.dateCustFrom); // Look ahead 1 month by default
    $scope.isCustomDate = false;
    $scope.isMonthDate = 'monthYear';
    var fromDate = null;
    var toDate = null;
    var selectedClientId = clientSelectService.getSelectedClient().id;

    function lastDayOfMonth(month, year) {
      return new Date(year, month, 0).toLocaleDateString().replace(/[^ -~]/g, '');
    };

    function firstDayOfMonth(month, year) {
      return new Date(year, month - 1, 1).toLocaleDateString().replace(/[^ -~]/g, '');
    };
    $scope.years = _.range(2010, 2099);

    function validateToDate(fromDate, toDate) {
      return fromDate <= toDate;
    };

    function addMonth(startDate) {
      // Does not handle end-of-month edge case, e.g. Oct 31 + 1 month = Dec 01
      return new Date(new Date(startDate).setMonth(startDate.getMonth() + 1));
    }
    $scope.monthList = [{
      id: 1,
      name: 'January'
    }, {
      id: 2,
      name: 'February'
    }, {
      id: 3,
      name: 'March'
    }, {
      id: 4,
      name: 'April'
    }, {
      id: 5,
      name: 'May'
    }, {
      id: 6,
      name: 'June'
    }, {
      id: 7,
      name: 'July'
    }, {
      id: 8,
      name: 'August'
    }, {
      id: 9,
      name: 'September'
    }, {
      id: 10,
      name: 'October'
    }, {
      id: 11,
      name: 'November'
    }, {
      id: 12,
      name: 'December'
    }];
    $scope.monthDateSelected = function () {
      $scope.isCustomDate = false;
    };
    $scope.yearName = new Date().getFullYear();
    $scope.monthId = new Date().getMonth() + 1;
    // Validate that filtered organization id is defined
    function validateOrganization() {
      var client = clientSelectService.getSelectedClient();
      return client.id != null && (0, _isInteger2.default)(client.id);
    }
    $scope.searchTravelSpend = function () {
      setTravelSpend();
    };
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }

    function setTravelSpend() {
      if (authService.getLoginMember().Role === 3) {
        selectedClientId = authService.getLoginMember().OrganizationId;
        showCharts(selectedClientId);
      } else {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid && valid.clientValid) {
          selectedClientId = clientSelectService.getSelectedClient().id;
          showCharts(selectedClientId);
        } else if (valid.agencyValid) {
          // toastFactory.toast_info('Please select a client.');
        } else {
            // toastFactory.toast_info('Please select an agency and then client.');
          }
      }
    };

    function showCharts(selectedClientId) {
      if ($scope.isCustomDate) {
        fromDate = $filter('date')($scope.dateCustFrom, 'yyyy-MM-dd').replace(/[^ -~]/g, '');
        toDate = $filter('date')($scope.dateCustTo, 'yyyy-MM-dd').replace(/[^ -~]/g, '');
      } else {
        fromDate = $filter('date')(new Date(firstDayOfMonth($scope.monthId, $scope.yearName)), 'yyyy-MM-dd');
        toDate = $filter('date')(new Date(lastDayOfMonth($scope.monthId, $scope.yearName)), 'yyyy-MM-dd');
      };
      // const organization = clientSelectService.getSelectedClient();
      if (validateToDate(fromDate, toDate)) {
        // Show charts -- DOM must be unhidden early enough for Chartist to be able to draw items upon
        $scope.showCharts = true;
        progress.start();
        var promiseTotalSpend = travelSpend.getTotalSpendByDates(fromDate, toDate, selectedClientId);
        var promiseTopAirline = travelSpend.getTopAirlines(fromDate, toDate, selectedClientId);
        var promiseTopHotel = travelSpend.getTopHotels(fromDate, toDate, selectedClientId);
        var promiseCarRental = travelSpend.getTopCarRentalCompanies(fromDate, toDate, selectedClientId);
        var promiseCityPairs = travelSpend.getTopCityPairs(fromDate, toDate, selectedClientId);
        $q.all([promiseTotalSpend, promiseTopAirline, promiseTopHotel, promiseCarRental, promiseCityPairs]).then(function (response) {
          var totalSpendContext = response[0].data;
          var topAirlineContext = response[1].data;
          var topHotelContext = response[2].data;
          var carRentalContext = response[3].data;
          var cityPairsContext = response[4].data;
          totalSpendBreakdownYTD(totalSpendContext);
          generateTopAirlines(topAirlineContext);
          generateTopHotels(topHotelContext);
          generateTopCarRentalCompanies(carRentalContext);
          getTopCityPairs(cityPairsContext);
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '<p>' + err.statusText + '</p>';
                $scope.errTitle = 'Travel spend Error'; //PLACE HOLDER
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      } else {
        //toastFactory.toast_warn(commonDialogMessage.dateErrorMessage);
      };
    }
    //on page load shwoing data in grid
    setTravelSpend();
    // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        // Destroy old charts
        destroyCharts();
        // Clear ui-grid
        $scope.gridOptions.data = [];
        $scope.gridOptions.totalItems = 0;
        // Show/hide charts
        if (validateOrganization()) {
          // Redundancy
          $scope.showCharts = true;
        } else {
          $scope.showCharts = false;
        }
        // Re-fetch charts
        setTravelSpend();
      }
    }, true);
    // Programmatically destroy Chartist objects -- very brute-force for now
    function destroyCharts() {
      var charts = [$scope.totalSpendChart, $scope.topAirlineChart, $scope.topAirlineDomChart, $scope.topAirlineIntChart, $scope.topHotelChart, $scope.topCarRentalChart].forEach(function (apiObj) {
        if (apiObj) {
          apiObj.detach();
        }
      });
      var containers = [$('#chartTotalSpend'), $('#chartTopAirline'), $('#chartTopAirlineDom'), $('#chartTopAirlineInt'), $('#chartTopHotel'), $('#chartTopCities')].forEach(function (container) {
        container.empty();
      });
      $scope.isTotalSpendData = false;
      $scope.isTopCombAirData = false;
      $scope.isTopDomAirData = false;
      $scope.isTopIntAirData = false;
      $scope.isTopHotelData = false;
      $scope.isTopCarRentalData = false;
    };

    function totalSpendBreakdownYTD(totalSpendContext) {
      var totalSpendSeriesList = totalSpendContext.filter(function (totalSpend) {
        return !!totalSpend.Name;
      }).map(function (totalSpend) {
        return {
          value: totalSpend.Amount
        };
      });
      var totalSpendLabelList = totalSpendContext.filter(function (totalSpend) {
        return !!totalSpend.Name;
      }).map(function (totalSpend) {
        return totalSpend.Name;
      });
      // assign data to chart
      var dataTotalSpend = {
        labels: totalSpendLabelList,
        series: [totalSpendSeriesList]
      };
      var totalSpendCount = totalSpendContext.filter(function (totalSpend) {
        return !!totalSpend.Amount;
      });
      if (!!totalSpendCount.length) {
        $scope.isTotalSpendData = true;
      } else {
        $scope.isTotalSpendData = false;
      }
      $scope.totalSpendChart = new Chartist.Bar('#chartTotalSpend', dataTotalSpend, {
        seriesBarDistance: 15,
        height: 650,
        reverseData: true,
        horizontalBars: true,
        axisY: {
          offset: 120
        },
        axisX: {
          offset: 320,
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return '$' + value.toFixed(0);
          }
        },
        plugins: [Chartist.plugins.ctBarLabels({
          labelClass: 'ct-labelBar',
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return '$' + value.toFixed(0);
          }
        })]
      }).on('draw', function (ctx) {
        if (ctx.type === 'label') {
          var dX = ctx.width / 2 + (100 - ctx.width);
          ctx.element.attr({
            x: ctx.element.attr('x') - dX
          });
        };
        if (ctx.type === 'bar') {
          ctx.element.attr({
            style: 'stroke-width: 20px'
          });
        };
      });
    };

    function generateTopAirlines(topAirlineContext) {
      //for top combine airline chart
      var topAirlinesComContext = topAirlineContext[0];
      generateTopCombineAir(topAirlinesComContext);
      //for top domestic airline chart
      var topAirlinesDomContext = topAirlineContext[1];
      generateTopDomesticAir(topAirlinesDomContext);
      //for International airline chart
      var topAirlinesIntContext = topAirlineContext[2];
      generateTopIntAir(topAirlinesIntContext);
    };

    function generateTopCombineAir(topAirlinesComContext) {
      var totalCombine = 0;
      var topAirlineCombSerList = void 0;
      var topAirlineCombSeriesList = topAirlinesComContext.filter(function (topAirline) {
        return topAirline.Name == 'Combined' && !!topAirline.Airline;
      }).map(function (topAirline) {
        return {
          name: topAirline.Airline,
          value: topAirline.Segments
        };
      });
      totalCombine = topAirlineCombSeriesList.reduce(function (totalSegments, element) {
        return totalSegments += element.value;
      }, totalCombine);
      //calculate list of other catergory
      var topAirlineOtherList = topAirlineCombSeriesList.filter(function (topAirline) {
        return Math.round(topAirline.value / totalCombine * 100) <= 5;
      });
      var totalOtherCategory = 0;
      totalOtherCategory = topAirlineOtherList.reduce(function (totalSegments, element) {
        return totalSegments += element.value;
      }, totalOtherCategory);
      //calculate list of top catergory
      var topAirlineList = topAirlineCombSeriesList.filter(function (topAirline) {
        return Math.round(topAirline.value / totalCombine * 100) > 5;
      });
      if (!!totalOtherCategory) {
        topAirlineCombSerList = _.concat(topAirlineList, {
          name: 'Others (less than 5%)',
          value: totalOtherCategory
        });
      } else {
        topAirlineCombSerList = topAirlineList;
      }
      var topAirlinesCombLabelList = topAirlineCombSerList.map(function (element) {
        return element.name;
      });
      $scope.isTopCombAirData = !!topAirlineCombSerList.length ? true : false;
      // assign data to chart
      var dataTopAirline = {
        labels: topAirlinesCombLabelList,
        series: topAirlineCombSerList
      };
      $scope.topAirlineChart = new Chartist.Pie('#chartTopAirline', dataTopAirline, {
        labelInterpolationFnc: function labelInterpolationFnc(label, index) {
          return Math.round(dataTopAirline.series[index].value / totalCombine * 100) + '%';
        },
        width: 250,
        height: 250,
        chartPadding: 5,
        labelOffset: 37,
        labelDirection: 'explode',
        plugins: [Chartist.plugins.legend({
          clickable: false
        })]
      }).on('draw', function (context) {
        if (context.type === 'slice') {
          var $slice = $(context.element._node);
          $slice.tooltipster({
            content: $slice.parent().attr('ct:series-name') + ' ' + $slice.attr('ct:value') + ' ' + 'segments'
          });
        }
      });
    };

    function generateTopDomesticAir(topAirlinesDomContext) {
      var totalDom = 0;
      var topDomesticSerList = void 0;
      var topAirlineDomesticSerList = topAirlinesDomContext.filter(function (topDomAirline) {
        return topDomAirline.Name == 'Domestic' && !!topDomAirline.Airline;
      }).map(function (topDomAirline) {
        return {
          name: topDomAirline.Airline,
          value: topDomAirline.Segments
        };
      });
      totalDom = topAirlineDomesticSerList.reduce(function (totalSegments, element) {
        return totalSegments += element.value;
      }, totalDom);
      //calculate list of other catergory
      var topDomesticOtherList = topAirlineDomesticSerList.filter(function (topAirline) {
        return Math.round(topAirline.value / totalDom * 100) <= 5;
      });
      var totalOtherCategory = 0;
      totalOtherCategory = topDomesticOtherList.reduce(function (totalSegments, element) {
        return totalSegments += element.value;
      }, totalOtherCategory);
      //calculate list of top catergory
      var topDomesticList = topAirlineDomesticSerList.filter(function (topAirline) {
        return Math.round(topAirline.value / totalDom * 100) > 5;
      });
      if (!!totalOtherCategory) {
        topDomesticSerList = _.concat(topDomesticList, {
          name: 'Others (less than 5%)',
          value: totalOtherCategory
        });
      } else {
        topDomesticSerList = topDomesticList;
      }
      var topDomesticLblList = topDomesticSerList.map(function (element) {
        return element.name;
      });
      $scope.isTopDomAirData = !!topDomesticSerList.length ? true : false;
      // assign data to chart
      var dataTopAirlineDom = {
        labels: topDomesticLblList,
        series: topDomesticSerList
      };
      $scope.topAirlineDomChart = new Chartist.Pie('#chartTopAirlineDom', dataTopAirlineDom, {
        labelInterpolationFnc: function labelInterpolationFnc(label, index) {
          return Math.round(dataTopAirlineDom.series[index].value / totalDom * 100) + '%';
        },
        width: 140,
        height: 140,
        chartPadding: 5,
        labelOffset: 12,
        labelDirection: 'explode',
        plugins: [Chartist.plugins.legend({
          className: 'ct-legend-inside-air',
          clickable: false
        })]
      }).on('draw', function (context) {
        if (context.type === 'slice') {
          var $slice = $(context.element._node);
          $slice.tooltipster({
            content: $slice.parent().attr('ct:series-name') + ' ' + $slice.attr('ct:value') + ' ' + 'segments'
          });
        }
      });
    };

    function generateTopIntAir(topAirlinesIntContext) {
      var totalInt = 0;
      var topIntSerList = void 0;
      var topAirlineInteSerList = topAirlinesIntContext.filter(function (topIntAirline) {
        return topIntAirline.Name == 'International' && !!topIntAirline.Airline;
      }).map(function (topIntAirline) {
        return {
          name: topIntAirline.Airline,
          value: topIntAirline.Segments
        };
      });
      totalInt = topAirlineInteSerList.reduce(function (totalSegments, element) {
        return totalSegments += element.value;
      }, totalInt);
      //calculate list of other catergory
      var topIntOtherList = topAirlineInteSerList.filter(function (topAirline) {
        return Math.round(topAirline.value / totalInt * 100) <= 5;
      });
      var totalOtherCategory = 0;
      totalOtherCategory = topIntOtherList.reduce(function (totalSegments, element) {
        return totalSegments += element.value;
      }, totalOtherCategory);
      //calculate list of top catergory
      var topIntList = topAirlineInteSerList.filter(function (topAirline) {
        return Math.round(topAirline.value / totalInt * 100) > 5;
      });
      if (!!totalOtherCategory) {
        topIntSerList = _.concat(topIntList, {
          name: 'Others (less than 5%)',
          value: totalOtherCategory
        });
      } else {
        topIntSerList = topIntList;
      }
      var topIntLabelList = topIntSerList.map(function (element) {
        return element.name;
      });
      $scope.isTopIntAirData = !!topIntSerList.length ? true : false;
      // assign data to chart
      var dataTopAirlineInt = {
        labels: topIntLabelList,
        series: topIntSerList
      };
      $scope.topAirlineIntChart = new Chartist.Pie('#chartTopAirlineInt', dataTopAirlineInt, {
        labelInterpolationFnc: function labelInterpolationFnc(label, index) {
          return Math.round(dataTopAirlineInt.series[index].value / totalInt * 100) + '%';
        },
        width: 140,
        height: 140,
        chartPadding: 5,
        labelOffset: 12,
        labelDirection: 'explode',
        plugins: [Chartist.plugins.legend({
          className: 'ct-legend-inside-air',
          clickable: false
        })]
      }).on('draw', function (context) {
        if (context.type === 'slice') {
          var $slice = $(context.element._node);
          $slice.tooltipster({
            content: $slice.parent().attr('ct:series-name') + ' ' + $slice.attr('ct:value') + ' ' + 'segments'
          });
        }
      });
    };

    function generateTopHotels(hotelNightsContext) {
      var totalHotelNights = 0;
      var topHotelSerList = void 0;
      var topHotelSeriesList = hotelNightsContext.filter(function (topHotel) {
        return !!topHotel.HotelName && !!topHotel.NumberOfNights;
      }).map(function (topHotel) {
        return {
          name: topHotel.HotelName,
          value: topHotel.NumberOfNights
        };
      });
      totalHotelNights = topHotelSeriesList.reduce(function (totalNights, element) {
        return totalNights += element.value;
      }, totalHotelNights);
      //calculate list of other catergory
      var topHotelOtherList = topHotelSeriesList.filter(function (topHotel) {
        return Math.round(topHotel.value / totalHotelNights * 100) <= 5;
      });
      var totalOtherCategory = 0;
      totalOtherCategory = topHotelOtherList.reduce(function (totalNights, element) {
        return totalNights += element.value;
      }, totalOtherCategory);
      //calculate list of top catergory
      var topHotelList = topHotelSeriesList.filter(function (topHotel) {
        return Math.round(topHotel.value / totalHotelNights * 100) > 5;
      });
      if (!!totalOtherCategory) {
        topHotelSerList = _.concat(topHotelList, {
          name: 'Others (less than 5%)',
          value: totalOtherCategory
        });
      } else {
        topHotelSerList = topHotelList;
      }
      var topHotelLabelList = topHotelSerList.map(function (element) {
        return element.name;
      });
      if (topHotelLabelList.length > 7) {
        $("#chartTopHotel").css({
          "margin-left": "10px"
        });
      } else {
        $("#chartTopHotel").css({
          "margin-left": "280px"
        });
      }
      $scope.isTopHotelData = !!topHotelSerList.length ? true : false;
      // assign data to chart
      var dataHotel = {
        labels: topHotelLabelList,
        series: topHotelSerList
      };
      $scope.topHotelChart = new Chartist.Pie('#chartTopHotel', dataHotel, {
        labelInterpolationFnc: function labelInterpolationFnc(label, index) {
          return Math.round(dataHotel.series[index].value / totalHotelNights * 100) + '%';
        },
        width: 250,
        height: 250,
        chartPadding: 5,
        labelOffset: 37,
        plugins: [Chartist.plugins.legend({
          clickable: false
        })]
      }).on('draw', function (context) {
        if (context.type === 'slice') {
          var $slice = $(context.element._node);
          $slice.tooltipster({
            content: $slice.parent().attr('ct:series-name') + ' ' + $slice.attr('ct:value') + ' ' + 'room nights'
          });
        }
      });
    };

    function generateTopCarRentalCompanies(carRentalContext) {
      var totalNumberofDays = 0;
      var topCarRentalSerList = void 0;
      var topCarRentalSeriesList = carRentalContext.filter(function (carRental) {
        return !!carRental.RentalCompany && !!carRental.NumberOfDays;
      }).map(function (carRental) {
        return {
          name: carRental.RentalCompany,
          value: carRental.NumberOfDays
        };
      });
      totalNumberofDays = topCarRentalSeriesList.reduce(function (totalDays, element) {
        return totalDays += element.value;
      }, totalNumberofDays);
      //calculate list of other catergory
      var topCarRentalOtherList = topCarRentalSeriesList.filter(function (topCarRental) {
        return Math.round(topCarRental.value / totalNumberofDays * 100) <= 5;
      });
      var totalOtherCategory = 0;
      totalOtherCategory = topCarRentalOtherList.reduce(function (totalNights, element) {
        return totalNights += element.value;
      }, totalOtherCategory);
      //calculate list of top catergory
      var topCarRentalList = topCarRentalSeriesList.filter(function (topCarRental) {
        return Math.round(topCarRental.value / totalNumberofDays * 100) > 5;
      });
      if (!!totalOtherCategory) {
        topCarRentalSerList = _.concat(topCarRentalList, {
          name: 'Others (less than 5%)',
          value: totalOtherCategory
        });
      } else {
        topCarRentalSerList = topCarRentalList;
      }
      var topCarRentalLabelList = topCarRentalSerList.map(function (element) {
        return element.name;
      });
      $scope.isTopCarRentalData = !!topCarRentalSerList.length ? true : false;
      // assign data to chart
      var dataTopCarRental = {
        labels: topCarRentalLabelList,
        series: topCarRentalSerList
      };
      $scope.topCarRentalChart = new Chartist.Pie('#chartTopCities', dataTopCarRental, {
        labelInterpolationFnc: function labelInterpolationFnc(label, index) {
          return Math.round(dataTopCarRental.series[index].value / totalNumberofDays * 100) + '%';
        },
        width: 250,
        height: 250,
        chartPadding: 5,
        labelOffset: 37,
        plugins: [Chartist.plugins.legend({
          clickable: false
        })]
      }).on('draw', function (context) {
        if (context.type === 'slice') {
          var $slice = $(context.element._node);
          $slice.tooltipster({
            content: $slice.parent().attr('ct:series-name') + ' ' + $slice.attr('ct:value') + ' ' + 'days'
          });
        }
      });
    };
    // ui-grid code for generate top city pairs
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    $scope.gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: false,
      useExternalSorting: false,
      enableColumnResizing: true,
      columnDefs: [{
        name: 'Cities',
        visible: true,
        displayName: 'City Pair',
        enableHiding: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableSorting: true,
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Segments',
        visible: true,
        displayName: 'Segments',
        enableHiding: true,
        type: 'number',
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableSorting: true,
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Volume',
        visible: true,
        displayName: 'Volume',
        type: 'number',
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'LeadingCarrier',
        visible: true,
        displayName: 'Leading Carrier',
        enableHiding: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableSorting: true,
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'LeadingCarrierSegments',
        visible: true,
        displayName: 'Leading Carrier Segments',
        type: 'number',
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'SegmentMarketShare',
        visible: true,
        displayName: 'Segment Market Share',
        type: 'number',
        enableHiding: false,
        enableSorting: true,
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }],
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (!sortColumns.length) {
            paginationOptions.sort = null;
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction;
          }
        });
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
        });
      }
    };

    function getTopCityPairs(topCityPairsContext) {
      var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
      $scope.gridOptions.data = topCityPairsContext.slice(firstRow, firstRow + paginationOptions.pageSize);
      $scope.gridOptions.totalItems = topCityPairsContext.length;
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';

  module.controller('tripFieldsController', ['$scope', 'tripFields', '$stateParams', 'progressBar', 'ngDialog', 'uiGridConstants', 'organizations', 'commonDialog', 'commonDialogMessage', '$q', '$state', 'clientSelectService', 'agencySelectService', 'toastFactory', 'authService', function ($scope, tripFields, $stateParams, progressBar, ngDialog, uiGridConstants, organizations, commonDialog, commonDialogMessage, $q, $state, clientSelectService, agencySelectService, toastFactory, authService) {
    var progress = progressBar.getProgressBar();
    $scope.tripField = {
      Id: 0,
      Name: null,
      AgencyDefinition: null,
      OrganizationId: null,
      Required: false,
      FieldOption: {
        Id: 0,
        TripFieldId: 0,
        Name: null
      }
    };
    $scope.isEdit = false;
    $scope.isNew = false;
    $scope.fieldOptionList = [{
      Id: 0,
      Name: '',
      TripFieldId: 0
    }];
    $scope.isDetails = false;
    var selectedClientId = clientSelectService.getSelectedClient().id;
    // get trip field details by id for edit
    var id = $stateParams.id;
    if (!!id) {
      tripFieldDetailsById(id);
    }
    $scope.organizationSelId = clientSelectService.getSelectedClient().id;
    // Validate that filtered organization id is defined
    function validateOrganization() {
      var organization = clientSelectService.getSelectedClient();
      return organization.id != null && (0, _isInteger2.default)(organization.id);
    }

    function tripFieldDetailsById(id) {
      progress.start();
      tripFields.getTripFieldById(id).then(function (response) {
        $scope.isEdit = true;
        $scope.isNew = false;
        var tripFieldContext = response.data;
        bindTripField(tripFieldContext);
      });
    };

    function bindTripField(tripFieldContext) {
      if (!!tripFieldContext) {
        $scope.tripField.Id = tripFieldContext.Id;
        $scope.tripField.OrganizationId = tripFieldContext.OrganizationId;
        $scope.tripField.Name = tripFieldContext.Name;
        $scope.tripField.AgencyDefinition = tripFieldContext.AgencyDefinition;
        $scope.tripField.Required = tripFieldContext.Required;
        $scope.fieldOptionList = !!tripFieldContext.TripFieldOptions.length ? tripFieldContext.TripFieldOptions : [{
          Id: 0,
          Name: '',
          TripFieldId: tripFieldContext.Id
        }], $scope.organizationSelId = tripFieldContext.OrganizationId;
        bindOrganizationName(tripFieldContext.OrganizationId);
      }
    };

    function bindOrganizationName(organizationId) {
      organizations.getOrganizationById(organizationId).then(function (supportOrganization) {
        $scope.organization = supportOrganization.data;
      });
    };
    $scope.saveTripField = function () {
      if ($scope.tripFieldForm.$valid && !!$scope.organizationSelId) {
        var tripField = $scope.tripField;
        tripField.OrganizationId = $scope.organizationSelId;
        var promisePost = tripFields.addTripField(tripField);
        var fieldOptionList = $scope.fieldOptionList.filter(function (fieldOption) {
          return !!fieldOption.Name;
        });
        progress.start();
        promisePost.then(function (tripFielddata) {
          if (!!fieldOptionList.length) {
            var promisePostFieldOption = tripFields.addTripFieldOption(tripFielddata.data.Id, fieldOptionList);
            promisePostFieldOption.then(function () {
              var dialogPost = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.successMsg = commonDialogMessage.fieldNameSavedMessage;
                  $scope.strTitle = 'Add Trip Field Success';
                }]
              });
              dialogPost.closePromise.then(function (data) {
                $scope.clearAll();
                $state.go('app.tripField');
              });
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = err.statusText;
                    $scope.errTitle = 'Add Trip Field Error';
                  }]
                });
              }
            }).finally(function () {
              progress.complete();
            });
          } else {
            var dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.successMsg = commonDialogMessage.fieldNameSavedMessage;
                $scope.strTitle = 'Add Trip Field Success';
              }]
            });
            dialogPost.closePromise.then(function (data) {
              $scope.clearAll();
              $state.go('app.tripField');
            });
          }
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = err.statusText;
                $scope.errTitle = 'Add Trip Field Error';
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = commonDialogMessage.tripFieldRequiredMessage;
            $scope.errTitle = 'Trip Field Error';
          }]
        });
      }
    };
    $scope.updateTripField = function () {
      if ($scope.tripFieldForm.$valid && !!$scope.organizationSelId) {
        var tripField = $scope.tripField;
        tripField.OrganizationId = $scope.organizationSelId;
        var fieldOptionList = $scope.fieldOptionList.filter(function (fieldOption) {
          return !!fieldOption.Name;
        });
        progress.start();
        var promisePut = tripFields.updateTripField(tripField.Id, tripField);
        promisePut.then(function () {
          if (!!fieldOptionList.length) {
            var promisePutOption = tripFields.updateTripFieldOption(tripField.Id, fieldOptionList);
            promisePutOption.then(function () {
              var dialogPut = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.successMsg = commonDialogMessage.fieldNameUpdatedMessage;
                  $scope.strTitle = 'Update Trip Field Success';
                }]
              });
              dialogPut.closePromise.then(function (data) {
                $state.go('app.tripField');
              });
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = err.statusText;
                    $scope.errTitle = 'Add Trip Field Error';
                  }]
                });
              }
            });
          } else {
            var dialogPut = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.successMsg = commonDialogMessage.fieldNameUpdatedMessage;
                $scope.strTitle = 'Update Trip Field Success';
              }]
            });
            dialogPut.closePromise.then(function (data) {
              $state.go('app.tripField');
            });
          }
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = err.statusText;
                $scope.errTitle = 'Add Trip Field Error';
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      } else {
        ngDialog.open({
          template: 'templates/partials/viewErrorMsg.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.errMsg = commonDialogMessage.tripFieldRequiredMessage;
            $scope.errTitle = 'Trip Field Required Message';
          }]
        });
      }
    };
    $scope.clearAll = function () {
      $scope.tripField = {};
      $scope.isEdit = false;
      $scope.isNew = false;
      $scope.organizationSelId = null;
      $scope.tripFieldForm.$setPristine();
      $scope.fieldOptionList = [{
        Id: 0,
        Name: '',
        TripFieldId: 0
      }];
    };
    $scope.addFieldOption = function () {
      $scope.fieldOptionList.push({
        Id: 0,
        Name: '',
        TripFieldId: $scope.tripField.Id
      });
    };
    $scope.removeFieldOption = function (index, optionId) {
      if (!!optionId) {
        var confirm = ngDialog.open({
          template: 'templates/partials/viewConfirm.html',
          className: 'ngdialog-theme-plain',
          controller: ['$scope', function ($scope) {
            $scope.strTitle = 'Delete Field Option?';
            $scope.strMsg = 'Do you really want to delete this field option?';
          }]
        });
        confirm.closePromise.then(function (data) {
          if (data.value === 1) {
            tripFields.deleteTripFieldOption(optionId).then(function (del) {
              var dialogDel = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.successMsg = commonDialogMessage.fieldOptionDeletedMessage;
                  $scope.strTitle = 'Delete Trip Field Option Success';
                }]
              });
              dialogDel.closePromise.then(function (data) {
                $scope.fieldOptionList.splice(index, 1);
                if ($scope.fieldOptionList.length == 0) {
                  $scope.fieldOptionList.push({
                    Id: 0,
                    Name: '',
                    TripFieldId: $scope.tripField.Id
                  });
                }
              });
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = err.statusText;
                    $scope.errTitle = 'Remove Trip Field Error';
                  }]
                });
              }
            }).finally(function () {
              progress.complete();
            });
          }
        });
      } else {
        if ($scope.fieldOptionList.length > 1) {
          $scope.fieldOptionList.splice(index, 1);
        } else {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = 'At least 1 field option is required.';
              $scope.errTitle = 'Trip Field Required Message';
            }]
          });
        };
      };
    };
    // ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    $scope.gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: false,
      paginationPageSize: 25,
      useExternalPagination: true,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      columnDefs: [{
        name: 'Name',
        visible: true,
        enableHiding: false,
        displayName: 'Field Name',
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250,
        sort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }
      }, {
        name: 'AgencyDefinition',
        visible: true,
        displayName: 'Agency Definition',
        enableHiding: false,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: 'Required',
        displayName: 'Required',
        visible: true,
        enableSorting: false,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        maxWidth: 250,
        enableColumnResizing: true,
        cellTemplate: ' <span ng-show="row.entity.Required" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.Required" style="padding-left: 5px;">No</span>',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: [{
            value: 'true',
            label: 'Yes'
          }, {
            value: 'false',
            label: 'No'
          }]
        }
      }, {
        name: 'TripFieldOptions',
        visible: true,
        displayName: 'Field Option',
        enableHiding: false,
        enableSorting: false,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: false,
        cellTemplate: '<div style="padding-left: 5px;"> {{grid.appScope.setFieldOptions(row.entity.TripFieldOptions)}}</div>',
        enableColumnResizing: true
      }],
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (!sortColumns.length) {
            paginationOptions.sort = null;
          } else {
            paginationOptions.sort = sortColumns[0].sort.direction;
          }
        });
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          setGridData();
        });
        // Show organization details on grid row selection.
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.rowSelectingId = row.entity.Id;
          if (row.isSelected) {
            $scope.rowSelecting = true;
          } else {
            $scope.rowSelecting = false;
          }
        });
      }
    };
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }

    function setGridData() {
      if (authService.getLoginMember().Role === 3) {
        getTripFields();
      } else {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid && valid.clientValid) {
          selectedClientId = clientSelectService.getSelectedClient().id;
          $scope.organizationSelId = selectedClientId;
          if (!!selectedClientId) {
            getTripFieldsbyOrg(selectedClientId);
          }
        } else if (valid.agencyValid) {
          // toastFactory.toast_info('Please select a client.');
        } else {
            // toastFactory.toast_info('Please select an agency and then client.');
          }
      }
    };

    function getTripFieldsbyOrg(organizationId) {
      progress.start();
      organizations.getOrganizationById(organizationId).then(function (response) {
        var tripFieldsContext = response.data.TripFields;
        var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
        $scope.gridOptions.data = tripFieldsContext.slice(firstRow, firstRow + paginationOptions.pageSize);
        $scope.gridOptions.totalItems = tripFieldsContext.length;
        if (!tripFieldsContext.length) {
          //\\toastFactory.toast_warn(commonDialogMessage.tripFieldNoResultMessage);
        }
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = err.statusText;
              $scope.errTitle = 'Trip Field Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    }

    function getTripFields() {
      progress.start();
      tripFields.getTripFields().then(function (response) {
        var tripFieldsContext = response.data;
        var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
        $scope.gridOptions.data = tripFieldsContext.slice(firstRow, firstRow + paginationOptions.pageSize);
        $scope.gridOptions.totalItems = tripFieldsContext.length;
        if (!tripFieldsContext.length) {
          //\\toastFactory.toast_warn(commonDialogMessage.tripFieldNoResultMessage);
        }
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = err.statusText;
              $scope.errTitle = 'Trip Field Error';
            }]
          });
        }
      }).finally(function () {
        progress.complete();
      });
    }
    setGridData();
    $scope.setFieldOptions = function (optionList) {
      var optionName = '';
      optionName = optionList.reduce(function (option, name) {
        return option += name.Name + ' , ';
      }, optionName);
      return optionName.substring(0, optionName.length - 2);
    };
    $scope.view = function () {
      if (!!$scope.rowSelectingId) {
        tripFieldDetailsById($scope.rowSelectingId);
      }
      ngDialog.open({
        template: 'templates/partials/viewTripField.html',
        className: 'ngdialog-theme-plain',
        scope: $scope
      });
    };
    $scope.deleteTripField = function () {
      var confirm = ngDialog.open({
        template: 'templates/partials/viewConfirm.html',
        className: 'ngdialog-theme-plain',
        controller: ['$scope', function ($scope) {
          $scope.strTitle = 'Delete Trip Field?';
          $scope.strMsg = 'Do you really want to delete this trip field?';
        }]
      });
      confirm.closePromise.then(function (data) {
        if ($scope.rowSelectingId && data.value === 1) {
          progress.start();
          tripFields.deleteTripField($scope.rowSelectingId).then(function (response) {
            var dialog = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.successMsg = 'The trip field has been succesfully deleted.';
                $scope.strTitle = 'Delete Trip Field Success';
              }]
            });
            dialog.closePromise.then(function (data) {});
          }, function (err) {
            if (err.status != 401) {
              var dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = err.statusText;
                  $scope.errTitle = 'Delete Trip Field Error'; //PLACE HOLDER
                }]
              });
              dialog.closePromise.then(function (data) {});
            }
          }).finally(function () {
            progress.complete();
            setGridData();
          });
        }
      });
    };
    $scope.edit = function () {
      $state.go('app.editTripField', {
        id: $scope.rowSelectingId
      });
    };
    // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        $scope.organizationSelId = null;
        $scope.gridOptions.data = [];
        $scope.gridOptions.totalItems = 0;
        setGridData();
      }
    }, true);
  }]);
})(angular.module('obex'));

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(3);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _defineProperty2 = __webpack_require__(92);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (module) {
  "use strict";

  module.controller("tripsDashBoardController", ["$rootScope", "$scope", "$http", "$state", "tripsDashBoard", "progressBar", "ngDialog", "toastFactory", "currency", "$filter", "$window", "commonDialog", "commonDialogMessage", "uiGridConstants", "$q", "clientSelectService", "agencySelectService", "authService", "allowIntegrations", "socketLogin", "$timeout", "smsStatus", function ($rootScope, $scope, $http, $state, tripsDashBoard, progressBar, ngDialog, toastFactory, currency, $filter, $window, commonDialog, commonDialogMessage, uiGridConstants, $q, clientSelectService, agencySelectService, authService, allowIntegrations, socketLogin, $timeout, smsStatus) {
    var storage = $window.localStorage;
    var progress = progressBar.getProgressBar();
    $scope.dateFrom = new Date();
    $scope.dateTo = moment($scope.dateFrom).add(1, "week").toDate();
    $scope.showDetails = false;
    var tripsList = [];
    $scope.bookingListInDetails = [];
    $scope.userRole = authService.getLoginMember().Role;
    $scope.statusNote = {
      Id: 0,
      NewAgentNote: "",
      BookingType: ""
    };
    $scope.isVisible = false;
    storage.setItem("dateFrom", $scope.dateFrom);
    storage.setItem("dateTo", $scope.dateTo);
    var selectedClientId = clientSelectService.getSelectedClient().id;
    var selectedClientName = clientSelectService.getSelectedClient().name;
    $scope.VirtualPaymentAllowed = false;
    $scope.isSearchComplted = false;
    $scope.selectedClientChatAppName = clientSelectService.getSelectedClient().ChatAppName;
    function addMonth(startDate) {
      // Does not handle end-of-month edge case, e.g. Oct 31 + 1 month = Dec 01
      return new Date(new Date(startDate).setMonth(startDate.getMonth() + 1));
    }
    function sortByDateAsc(a, b) {
      var firstStartDate = moment(a.StartDate).format("MM-DD-YYYY");
      var secondStartDate = moment(b.StartDate).format("MM-DD-YYYY");
      if (firstStartDate > secondStartDate) {
        return 1;
      } else if (firstStartDate < secondStartDate) {
        return -1;
      } else if (firstStartDate === secondStartDate) {
        if (a.BookingTypeName === "A" && b.BookingTypeName === "A") {
          var tempStartDate = moment(a.StartDate).format("MM-DD-YYYY HH:mm");
          var tempEndDate = moment(b.StartDate).format("MM-DD-YYYY HH:mm");
          if (tempStartDate > tempEndDate) {
            return 1;
          } else {
            return -1;
          }
        } else if (a.BookingTypeName === "A") {
          return -1;
        } else if (b.BookingTypeName === "A") {
          return 1;
        } else if (a.BookingTypeName === "H" && b.BookingTypeName === "C") {
          return -1;
        } else if (a.BookingTypeName === "C" && b.BookingTypeName === "H") {
          return 1;
        } else {
          return 0;
        }
      }
    }

    $scope.loadTripDashboard = function () {
      tripsList = [];
      $scope.isVisible = false;
      $scope.showDetails = false;
      storage.setItem("dateTo", $scope.dateTo);
      storage.setItem("dateFrom", $scope.dateFrom);
      setGridData();
    };
    $scope.resetFilter = function () {
      $scope.dateFrom = new Date();
      $scope.dateTo = addMonth($scope.dateFrom);
      $scope.statusNote = {};
      $scope.showDetails = false;
      $scope.loadTripDashboard();
    };
    $scope.sendSms = function (bookingId, devicetoken, osplatform, bookingType) {
      $scope.bookingId = bookingId;
      $scope.devicetoken = devicetoken;
      $scope.osplatform = osplatform;
      $scope.bookingType = bookingType;

      ngDialog.open({
        template: "templates/partials/agentInitiatedMessage.html",
        className: "ngdialog-theme-plain",
        scope: $scope,
        closeByEscape: false,
        closeByDocument: false
      });
    };
    $scope.confirmSendSms = function () {
      var _handleData;

      var loginUser = authService.getLoginMember();
      loginMember['SupportsOrganizations'] = [];
      console.log("$scope.smsText ", $scope.smsText);
      console.log("$scope.selectedRow ", $scope.selectedRow);
      $http.post("/agentsms", {
        alerttext: $scope.smsText,
        payload: {
          aps: {
            "content-available": 1,
            bookingId: $scope.bookingId,
            bookingType: $scope.bookingType,
            alertText: $scope.smsText
          }
        },
        devicetoken: $scope.devicetoken,
        osplatform: $scope.osplatform,
        agentEmail: loginUser.Email,
        agencyId: loginUser.Organization.Id,
        travelerEmail: $scope.TravelerEmail,
        clientId: $scope.TravelerCompanyId
      });
      var traveler = $scope.selectedRow.Traveler;
      console.log("socketId: ", socketLogin.getSocketId());

      var handleData = (_handleData = {
        fromNumber: traveler.Phone,
        socketId: socketLogin.getSocketId(),
        firstName: loginUser.FirstName,
        lastName: loginUser.LastName,
        email: loginUser.Email,
        organizationId: loginUser.Organization.Id,
        loginMember: loginUser,
        smstext: $scope.smsText,
        travelAgencyId: loginUser.Organization.Id,
        travelAgencyName: loginUser.Organization.Name,
        travelAgentFirstName: loginUser.FirstName,
        travelAgentLastName: loginUser.LastName,
        travelAgentEmail: loginUser.Email,
        travelAgentId: loginUser.Id,
        topic: {
          bookingId: $scope.bookingId,
          bookingType: $scope.bookingType,
          email: $scope.TravelerEmail,
          phoneNumber: traveler.Phone
        },
        travelerFirstName: traveler.FirstName,
        travelerLastName: traveler.LastName,
        travelerOrganizationName: traveler.Organization.Name
      }, (0, _defineProperty3.default)(_handleData, "organizationId", traveler.Organization.Id), (0, _defineProperty3.default)(_handleData, "travelerId", traveler.Id), (0, _defineProperty3.default)(_handleData, "fromDatabase", false), (0, _defineProperty3.default)(_handleData, "status", smsStatus.Live), (0, _defineProperty3.default)(_handleData, "channel", "sms"), _handleData);
      var data = {
        travelerNumber: traveler.Phone,
        travelerFirstName: traveler.FirstName,
        travelerLastName: traveler.LastName,
        travelerEmail: traveler.Email,
        socketId: socketLogin.getSocketId(),
        travelAgentFirstName: loginUser.FirstName,
        travelAgentLastName: loginUser.LastName,
        travelAgentEmail: loginUser.Email,
        travelAgentId: loginUser.Id,
        travelAgentOrganizationId: loginUser.Organization.Id,
        loginMemberId: loginUser.Id,
        smstext: $scope.smsText,
        topic: {
          bookingId: $scope.bookingId,
          bookingType: $scope.bookingType,
          email: traveler.Email,
          phoneNumber: traveler.Phone
        },
        travelerId: traveler.Id,
        fromDatabase: false,
        channel: "sms"
      };
      $http.post("/agentInitiatedSms", data).then(function (response) {
        $rootScope.$broadcast("smsHandle", handleData);

        //console.log('Post to /agentInitiatedSms ', handleData);
        return $http.post("/handleConversation", handleData);
      }).then(function (response) {
        $state.go("app.sms", {
          fromNumber: traveler.Phone,
          travelerFirstName: traveler.FirstName,
          travelerLastName: traveler.LastName,
          travelerOrganizationName: traveler.Organization.Name,
          organizationId: traveler.Organization.Id,
          travelerId: traveler.Id,
          fromDatabase: false,
          status: smsStatus.Live,
          channel: "sms",
          topic: {
            bookingId: $scope.bookingId,
            bookingType: $scope.bookingType,
            email: $scope.TravelerEmail,
            phoneNumber: traveler.Phone
          }
        });
      }, function (error) {
        console.log(error);
      });
    };

    //Cancel popup changes
    $scope.cancelChanges = function () {
      ngDialog.closeThisDialog(1);
    };
    //validate to Date is not less than from date
    function validateToDate(fromDate, toDate) {
      return fromDate <= toDate;
    }
    // Validate that filtered organization id is defined
    function validateAgencyAndClientSelection() {
      var agency = agencySelectService.getSelectedAgency();
      var client = clientSelectService.getSelectedClient();
      return {
        agencyValid: agency.id != null && (0, _isInteger2.default)(agency.id),
        clientValid: client.id != null && (0, _isInteger2.default)(client.id)
      };
    }

    function generateNotesHistory() {
      progress.start();
      var id = storage.getItem("id");
      $scope.statusNote.BookingType = storage.getItem("bookingType");
      if ($scope.statusNote.BookingType === "Flight" && $scope.isVisible) {
        tripsDashBoard.getFlightsDashById(id).then(function (tripsFlights) {
          var tripsFlightsContext = tripsFlights.data.AgentNotes;
          if (tripsFlights.data.HasAgentNotes) {
            $scope.notesHistoryList = tripsFlightsContext.map(function (agentNote) {
              return {
                Agent: agentNote.Agent.FirstName + " " + agentNote.Agent.LastName,
                Note: agentNote.Note,
                NoteTime: $filter("date")(agentNote.LastUpdated, "MM-dd-yyyy") + "   " + $filter("date")(agentNote.LastUpdated, "shortTime")
              };
            });
          }
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: "templates/partials/viewErrorMsg.html",
              className: "ngdialog-theme-plain",
              controller: ["$scope", function ($scope) {
                $scope.errMsg = "<p>" + err.statusText + "</p>";
                $scope.errTitle = "Notes Error";
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      }
      // generate Car booking details
      else if ($scope.statusNote.BookingType === "Car" && $scope.isVisible) {
          tripsDashBoard.getCarsDashById(id).then(function (tripsCars) {
            var tripsCarsContext = tripsCars.data.AgentNotes;
            if (tripsCars.data.HasAgentNotes) {
              $scope.notesHistoryList = tripsCarsContext.map(function (agentNote) {
                return {
                  Agent: agentNote.Agent.FirstName + " " + agentNote.Agent.LastName,
                  Note: agentNote.Note,
                  NoteTime: $filter("date")(agentNote.LastUpdated, "MM-dd-yyyy") + "   " + $filter("date")(agentNote.LastUpdated, "shortTime")
                };
              });
            }
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: "templates/partials/viewErrorMsg.html",
                className: "ngdialog-theme-plain",
                controller: ["$scope", function ($scope) {
                  $scope.errMsg = "<p>" + err.statusText + "</p>";
                  $scope.errTitle = "Notes Error";
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
        }
        // generate hotel booking details
        else if ($scope.statusNote.BookingType === "Hotel" && $scope.isVisible) {
            tripsDashBoard.getHotelsDashById(id).then(function (tripsHotels) {
              var tripsHotelsContext = tripsHotels.data.AgentNotes;
              if (tripsHotels.data.HasAgentNotes) {
                $scope.notesHistoryList = tripsHotelsContext.map(function (agentNote) {
                  return {
                    Agent: agentNote.Agent.FirstName + " " + agentNote.Agent.LastName,
                    Note: agentNote.Note,
                    NoteTime: $filter("date")(agentNote.LastUpdated, "MM-dd-yyyy") + "   " + $filter("date")(agentNote.LastUpdated, "shortTime")
                  };
                });
              }
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: "templates/partials/viewErrorMsg.html",
                  className: "ngdialog-theme-plain",
                  controller: ["$scope", function ($scope) {
                    $scope.errMsg = "<p>" + err.statusText + "</p>";
                    $scope.errTitle = "Notes Error";
                  }]
                });
              }
            }).finally(function () {
              progress.complete();
            });
          } else if ($scope.statusNote.BookingType === "Limo" && $scope.isVisible) {
            tripsDashBoard.getLimosDashById(id).then(function (tripsLimos) {
              var tripsLimosContext = tripsLimos.data.AgentNotes;
              if (tripsLimos.data.HasAgentNotes) {
                $scope.notesHistoryList = tripsLimosContext.map(function (agentNote) {
                  return {
                    Agent: agentNote.Agent.FirstName + " " + agentNote.Agent.LastName,
                    Note: agentNote.Note,
                    NoteTime: $filter("date")(agentNote.LastUpdated, "MM-dd-yyyy") + "   " + $filter("date")(agentNote.LastUpdated, "shortTime")
                  };
                });
              }
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: "templates/partials/viewErrorMsg.html",
                  className: "ngdialog-theme-plain",
                  controller: ["$scope", function ($scope) {
                    $scope.errMsg = "<p>" + err.statusText + "</p>";
                    $scope.errTitle = "Notes Error";
                  }]
                });
              }
            }).finally(function () {
              progress.complete();
            });
          }
    }
    $scope.notesHistory = function () {
      $scope.isVisible = $scope.isVisible ? false : true;
      generateNotesHistory();
    };
    $scope.saveBookingStatus = function () {
      progress.start();
      var id = storage.getItem("id");
      $scope.statusNote.BookingType = storage.getItem("bookingType");
      $scope.statusNote.Id = id;
      var toDate = $filter("date")(new Date(storage.getItem("dateTo")), "yyyy-MM-dd");
      var fromDate = $filter("date")(new Date(storage.getItem("dateFrom")), "yyyy-MM-dd");
      $scope.dateTo = toDate;
      $scope.dateFrom = fromDate;
      //Update flight booking status
      if ($scope.statusNote.BookingType === "Flight") {
        tripsDashBoard.updateFlightStatus(id, $scope.statusNote).then(function (flightUpdate) {
          var dialogPost = ngDialog.open({
            template: "templates/partials/viewSuccessMsg.html",
            className: "ngdialog-theme-plain",
            controller: ["$scope", function ($scope) {
              $scope.successMsg = commonDialogMessage.tripDashStatusUpdatedMessage;
              $scope.strTitle = "Notes Created Success";
            }]
          });
          dialogPost.closePromise.then(function (data) {
            $scope.statusNote = {};
            $scope.editStatusForm.$setPristine();
            if ($scope.isVisible) {
              generateNotesHistory();
            }
          });
        }, function (err) {
          if (err.status != 401) {
            ngDialog.open({
              template: "templates/partials/viewErrorMsg.html",
              className: "ngdialog-theme-plain",
              controller: ["$scope", function ($scope) {
                $scope.errMsg = "<p>" + err.statusText + "</p>";
                $scope.errTitle = "Notes Error";
              }]
            });
          }
        }).finally(function () {
          progress.complete();
        });
      }
      //Update Car booking status
      else if ($scope.statusNote.BookingType === "Car") {
          tripsDashBoard.updateCarStatus(id, $scope.statusNote).then(function (carUpdate) {
            var dialog = ngDialog.open({
              template: "templates/partials/viewSuccessMsg.html",
              className: "ngdialog-theme-plain",
              controller: ["$scope", function ($scope) {
                $scope.successMsg = commonDialogMessage.tripDashStatusUpdatedMessage;
                $scope.strTitle = "Notes Created Success";
              }]
            });
            dialog.closePromise.then(function (data) {
              $scope.statusNote = {};
              $scope.editStatusForm.$setPristine();
              if ($scope.isVisible) {
                generateNotesHistory();
              }
            });
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: "templates/partials/viewErrorMsg.html",
                className: "ngdialog-theme-plain",
                controller: ["$scope", function ($scope) {
                  $scope.errMsg = "<p>" + err.statusText + "</p>";
                  $scope.errTitle = "Notes Error";
                }]
              });
            }
          }).finally(function () {
            progress.complete();
          });
        }
        //Update Hotel booking status
        else if ($scope.statusNote.BookingType === "Hotel") {
            tripsDashBoard.updateHotelStatus(id, $scope.statusNote).then(function (hotelUpdate) {
              var dialogPost = ngDialog.open({
                template: "templates/partials/viewSuccessMsg.html",
                className: "ngdialog-theme-plain",
                controller: ["$scope", function ($scope) {
                  $scope.successMsg = commonDialogMessage.tripDashStatusUpdatedMessage;
                  $scope.strTitle = "Notes Created Success";
                }]
              });
              dialogPost.closePromise.then(function (data) {
                $scope.statusNote = {};
                $scope.editStatusForm.$setPristine();
                if ($scope.isVisible) {
                  generateNotesHistory();
                }
              });
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: "templates/partials/viewErrorMsg.html",
                  className: "ngdialog-theme-plain",
                  controller: ["$scope", function ($scope) {
                    $scope.errMsg = "<p>" + err.statusText + "</p>";
                    $scope.errTitle = "Notes Error";
                  }]
                });
              }
            }).finally(function () {
              progress.complete();
            });
          }
          //Update Limo booking status
          else if ($scope.statusNote.BookingType === "Limo") {
              tripsDashBoard.updateLimoStatus(id, $scope.statusNote).then(function (limoUpdate) {
                var dialogPost = ngDialog.open({
                  template: "templates/partials/viewSuccessMsg.html",
                  className: "ngdialog-theme-plain",
                  controller: ["$scope", function ($scope) {
                    $scope.successMsg = commonDialogMessage.tripDashStatusUpdatedMessage;
                    $scope.strTitle = "Notes Created Success";
                  }]
                });
                dialogPost.closePromise.then(function (data) {
                  $scope.statusNote = {};
                  $scope.editStatusForm.$setPristine();
                  if ($scope.isVisible) {
                    generateNotesHistory();
                  }
                });
              }, function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: "templates/partials/viewErrorMsg.html",
                    className: "ngdialog-theme-plain",
                    controller: ["$scope", function ($scope) {
                      $scope.errMsg = "<p>" + err.statusText + "</p>";
                      $scope.errTitle = "Notes Error";
                    }]
                  });
                }
              }).finally(function () {
                progress.complete();
              });
            }
    };
    // Begin ui-grid code
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 25,
      sort: null
    };
    // ui-grid options
    var gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: true,
      paginationPageSize: 25,
      useExternalPagination: false,
      useExternalSorting: false,
      enableRowSelection: true,
      enableSelectAll: false,
      enableRowHeaderSelection: false,
      exporterMenuPdf: false,
      exporterMenuCsv: false,
      multiSelect: false,
      enableColumnResizing: true,
      columnDefs: [{
        name: "StartDate",
        visible: true,
        enableHiding: true,
        enableSorting: true,
        enableFiltering: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableColumnResizing: true,
        maxWidth: 250,
        sort: {
          direction: uiGridConstants.ASC,
          priority: 0
        },
        cellFilter: "date:'MM-dd-yyyy'"
      }, {
        name: "Seg",
        visible: true,
        displayName: "Seg",
        enableHiding: true,
        enableSorting: false,
        enableFiltering: false,
        enableColumnResizing: true,
        maxWidth: 250,
        cellTemplate: '<span><span></span><span ng-if="(row.entity.Seg==0)"><span ng-if="(row.entity.Flight==1)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-plane"></i></span></span>' + '<span><span></span><span ng-if="(row.entity.Seg==0)"><span ng-if="(row.entity.Hotel==1)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-bed"></i></span></span>' + '<span><span></span><span ng-if="(row.entity.Seg==0)"><span ng-if="(row.entity.Car==1)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-car"></i></span></span>' + '<span><span></span><span ng-if="(row.entity.Seg==0)"><span ng-if="(row.entity.Limo==1)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-cab"></i></span></span>' + '<span><span></span><span ng-if="(row.entity.Seg==1)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-plane"></i></span>' + '<span><span></span><span ng-if="(row.entity.Seg==2)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-car"></i></span>' + '<span><span></span><span ng-if="(row.entity.Seg==4)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-cab"></i></span>' + '<span><span></span><span ng-if="(row.entity.Seg==3)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-bed"></i></span>'
      }, {
        name: "TripTitle",
        displayName: "Trip",
        visible: true,
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 300
      }, {
        name: "TravelerDisplayName",
        visible: true,
        displayName: "Traveler Name",
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: "Supplier",
        visible: true,
        displayName: "Supplier",
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: "Source",
        visible: true,
        displayName: "Source",
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: "Pnr",
        visible: true,
        displayName: "Pnr",
        enableHiding: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableSorting: true,
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: "StartLocation",
        visible: true,
        displayName: "Start Location",
        enableHiding: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableSorting: true,
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: "EndLocation",
        visible: true,
        displayName: "End Location",
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }, {
        name: "Agent",
        visible: false,
        enableHiding: true,
        enableSorting: true,
        sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
        enableFiltering: true,
        enableColumnResizing: true,
        maxWidth: 250
      }],
      rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>'
    };
    // End ui-grid option

    $scope.gridDetails = _.cloneDeep(gridOptions);
    $scope.gridDetails.onRegisterApi = function (gridApi) {
      $scope.gridApi = gridApi;
      $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (!sortColumns.length) {
          paginationOptions.sort = null;
        } else {
          paginationOptions.sort = sortColumns[0].sort.direction;
        }
      });
      // Grid Pagination.
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        updateGridPagination(tripsList);
      });
      // Show trip booking details on grid row selection.
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        $scope.bookingListInDetails = [];
        $scope.showDetails = row.isSelected;
        $scope.selectedRow = row.entity;
        $scope.TravelerEmail = row.entity.TravelerEmail;
        $scope.TravelerCompanyId = row.entity.TravelerCompanyId;
        var id = row.entity.Id;
        var bookingType = row.entity.BookingType;
        console.log($scope.selectedRow);
        var errorHandler = function errorHandler(err) {
          if (err.status != 401) {
            ngDialog.open({
              template: "templates/partials/viewErrorMsg.html",
              className: "ngdialog-theme-plain",
              controller: ["$scope", function ($scope) {
                $scope.errMsg = "<p>" + err.statusText + "</p>";
                $scope.errTitle = "Notes Error";
              }]
            });
          }
        };

        switch (bookingType) {
          case "Trip":
            storage.setItem("tripId", id);
            progress.start();
            tripsDashBoard.getTripsDashbyId(id).then(function (trips) {
              var flightList = generateBookingFlight(trips.data.Flights, trips.data.Member);
              var carList = generateBookingCar(trips.data.Cars, trips.data.Member);
              var hotelList = generateBookingHotel(trips.data.Hotels, trips.data.Member);
              var limoList = generateBookingLimo(trips.data.Limos, trips.data.Member);

              $scope.bookingListInDetails = [].concat(flightList, carList, hotelList, limoList);
              $scope.bookingListInDetails.sort(sortByDateAsc);
            }, errorHandler).finally(function () {
              progress.complete();
            });
            break;
          case "Flight":
            storage.setItem("tripId", 0);
            progress.start();
            tripsDashBoard.getFlightsDashById(id).then(function (flights) {
              $scope.bookingListInDetails = generateBookingFlight([flights.data], flights.data.Member);
            }, errorHandler).finally(function () {
              progress.complete();
            });
            break;
          case "Car":
            storage.setItem("tripId", 0);
            progress.start();
            tripsDashBoard.getCarsDashById(id).then(function (cars) {
              $scope.bookingListInDetails = generateBookingCar([cars.data], cars.data.Member);
            }, errorHandler).finally(function () {
              progress.complete();
            });
            break;
          case "Hotel":
            storage.setItem("tripId", 0);
            progress.start();
            tripsDashBoard.getHotelsDashById(id).then(function (hotels) {
              $scope.bookingListInDetails = generateBookingHotel([hotels.data], hotels.data.Member);
            }, errorHandler).finally(function () {
              progress.complete();
            });
            break;
          case "Limo":
            storage.setItem("tripId", 0);
            progress.start();
            tripsDashBoard.getLimosDashById(id).then(function (limos) {
              $scope.bookingListInDetails = generateBookingLimo([limos.data], limos.data.Member);
            }, errorHandler).finally(function () {
              progress.complete();
            });
            break;
        }
      });
      setGridData();
    };
    //edit status and notes by Id
    generateNotesHistory();
    $scope.editStatus = function (id, bookingType) {
      $scope.statusNote = {};
      $scope.statusNote.BookingType = bookingType;
      storage.setItem("bookingType", bookingType);
      storage.setItem("id", id);
      ngDialog.open({
        template: "templates/partials/editStatusTripDash.html",
        controller: "tripsDashBoardController",
        closeByDocument: false
      });
    };
    //Show Virtual card on ui
    $scope.showCardDetails = function (bookingData, isConfermaAllowed) {
      $scope.cardImageDataFromParent = {};
      isConfermaAllowed ? bookingData.VirtualCardId !== null && bookingData.VirtualCardId !== "" ? tripsDashBoard.getVirtualCardImage(bookingData.VirtualCardId, selectedClientId).then(function (response) {
        $scope.cardImageDataFromParent = response;
        ngDialog.open({
          template: "templates/partials/viewVirtualCard.html",
          className: "modal-xl ngdialog-theme-plain",
          controller: ["$scope", function ($scope) {
            $scope.flip = function () {
              angular.element(".virtual-card").toggleClass("flipped");
            };
            $scope.bookingData = bookingData;
            $scope.cardImageData = response.data;
          }],
          closeByDocument: false
        });
      }, function (error) {
        showErrorMessage(error.statusText, "Conferma Payment Error");
      }) : showErrorMessage("This booking does not have Virtual Card Id, so not showing the conferma.", "Details Not Found") : showErrorMessage("Conferma virtual payment is not allowed for this organization.", "Not Allowed");
    };
    function showErrorMessage(message, title) {
      ngDialog.open({
        template: "templates/partials/viewErrorMsg.html",
        className: "ngdialog-theme-plain sm",
        controller: ["$scope", function ($scope) {
          $scope.errMsg = "<p>" + message + "</p>";
          $scope.errTitle = title;
        }]
      });
    }
    function checkAllowIntegrationForVirtualPayment(id) {
      allowIntegrations.getAllowIntegrationsByOrganizationId(id).then(function (response) {
        var integrationData = response.data;
        console.log("integrationData", integrationData);
        if (integrationData) {
          integrationData.forEach(function (integration) {
            console.log("integration.Name.toLowerCase()", integration.Name.toLowerCase());
            if (integration.Name.toLowerCase() === "conferma" && integration.Allowed) {
              $scope.VirtualPaymentAllowed = true;
            }
          });
          console.log("VirtualPaymentAllowed ", $scope.VirtualPaymentAllowed);
        }
      });
    }
    //Begin function to set ui-grid data
    function setGridData() {
      //$scope.tripsList = [];
      tripsList = [];
      $scope.gridDetails.data = [];
      $scope.gridDetails.totalItems = 0;
      if (authService.getLoginMember().Role === 3) {
        selectedClientId = authService.getLoginMember().OrganizationId;
        selectedClientName = clientSelectService.getSelectedClient().name;
        getTripDashboard(selectedClientId);
        checkAllowIntegrationForVirtualPayment(selectedClientId);
      } else {
        var valid = validateAgencyAndClientSelection();
        if (valid.agencyValid && valid.clientValid) {
          selectedClientId = clientSelectService.getSelectedClient().id;
          selectedClientName = clientSelectService.getSelectedClient().name;
          getTripDashboard(selectedClientId);
          checkAllowIntegrationForVirtualPayment(selectedClientId);
        } else if (valid.agencyValid) {
          //toastFactory.toast_info('Please select a client.');
        } else {}
          //toastFactory.toast_info('Please select an agency and then client.');

          //updateGridPagination($scope.tripsList);
        updateGridPagination(tripsList);
        progress.complete();
      }
    }

    function getTripDashboard(selectedClientId) {
      $scope.isSearchComplted = false;
      progress.start();
      // const organization = clientSelectService.getSelectedClient();
      var dateTo = $filter("date")(new Date(storage.getItem("dateTo")), "yyyy-MM-dd");
      var dateFrom = $filter("date")(new Date(storage.getItem("dateFrom")), "yyyy-MM-dd");
      // get trips data
      var promiseTrips = tripsDashBoard.getTripsDash(dateFrom, dateTo, selectedClientId);
      var promiseFlights = tripsDashBoard.getFlightsDash(dateFrom, dateTo, selectedClientId);
      var promiseCars = tripsDashBoard.getCarsDash(dateFrom, dateTo, selectedClientId);
      var promiseHotels = tripsDashBoard.getHotelsDash(dateFrom, dateTo, selectedClientId);
      var promiseLimos = tripsDashBoard.getLimosDash(dateFrom, dateTo, selectedClientId);

      $q.all([promiseTrips, promiseFlights, promiseCars, promiseHotels, promiseLimos]).then(function (response) {
        progress.complete();
        var tripsContext = response[0].data;
        var flightsContext = response[1].data;
        var carsContext = response[2].data;
        var hotelsContext = response[3].data;
        var limosContext = response[4].data;
        var trips = generateTrips(tripsContext);
        var flightsList = flightsContext.filter(function (flight) {
          return !flight.TripId;
        });
        var flightBookingList = generateBookingFlight(flightsList);

        var carsList = carsContext.filter(function (car) {
          return !car.TripId;
        });
        var carBookingList = generateBookingCar(carsList);

        var hotelsList = hotelsContext.filter(function (hotel) {
          return !hotel.TripId;
        });
        var hotelBookingList = generateBookingHotel(hotelsList);

        var limosList = limosContext.filter(function (limo) {
          return !limo.TripId;
        });
        var limoBookingList = generateBookingLimo(limosList);

        tripsList = [].concat(flightBookingList, carBookingList, hotelBookingList, limoBookingList, trips);
        $scope.isSearchComplted = selectedClientName !== null && selectedClientName !== '' ? true : false;
        $scope.isExportData = !!tripsList.length ? true : false;
      }, function (err) {
        if (err.status != 401) {
          ngDialog.open({
            template: "templates/partials/viewErrorMsg.html",
            className: "ngdialog-theme-plain",
            controller: ["$scope", function ($scope) {
              $scope.errMsg = "<p>" + err.statusText + "</p>";
              $scope.errTitle = "Trip Dashboard Error";
            }]
          });
        }
        $scope.isSearchComplted = true;
      }).finally(function () {
        //assign items to ui grid
        progress.complete();
        //updateGridPagination($scope.tripsList);
        updateGridPagination(tripsList);
      });
    }

    $scope.CloseTripDetails = function () {
      $scope.showDetails = false;
    };
    var allTripsDashboardData = [];
    function updateGridPagination(gridData) {
      allTripsDashboardData = gridData;
      $scope.gridDetails.data = gridData;
      $scope.gridDetails.totalItems = gridData.length;
      var valid = validateAgencyAndClientSelection();
    }

    $scope.exportTripsDashboardData = function () {
      $scope.gridDetails.data = allTripsDashboardData;
      $scope.gridDetails.exporterCsvFilename = selectedClientName + "_TripsDashboard.csv";
      $timeout(function () {
        $scope.gridApi.exporter.csvExport("all", "all");
        updateGridPagination(allTripsDashboardData);
      }, 100);
    };

    // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
    $scope.$watch(function () {
      return clientSelectService.getSelectedClient();
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        $scope.showDetails = false;
        setGridData();
      }
    }, true);
    //Generate trips data
    function generateTrips(tripsContext) {
      return tripsContext.map(function (trip) {
        var travelerName = void 0,
            name = void 0;
        var travelersList = [];
        if (trip.Flights.length !== 0 && trip.Flights[0].AirReservation && trip.Flights[0].AirReservation.AirTravelers.length !== 0) {
          travelersList = trip.Flights[0].AirReservation.AirTravelers.map(function (traveler) {
            return traveler.LastName + ", " + traveler.GivenName;
          });
        }
        if (trip.Flights.length !== 0 && trip.Flights[0].AirReservation && trip.Flights[0].AirReservation.AirTravelers.length !== 0 && trip.Flights[0].AirReservation.AirTravelers[0].LastName !== null && trip.Flights[0].AirReservation.AirTravelers[0].GivenName !== null) {
          travelerName = trip.Flights[0].AirReservation.AirTravelers[0].LastName + ", " + trip.Flights[0].AirReservation.AirTravelers[0].GivenName;
        } else if (trip.Hotels.length !== 0 && trip.Hotels[0].GuestNames !== null) {
          name = trip.Hotels[0].GuestNames;
          name = name.split(" ");
          travelerName = name[1] + ", " + name[0];
        } else if (trip.Cars.length !== 0 && trip.Cars[0].Travelers !== null) {
          name = trip.Cars[0].Travelers;
          name = name.split(" ");
          travelerName = name[1] + ", " + name[0];
        } else {
          travelerName = trip.Member.LastName + ", " + trip.Member.FirstName;
        }

        if (!travelersList.length) {
          travelersList.push(travelerName);
        }

        return {
          Id: trip.Id,
          StartDate: trip.StartDate,
          Company: !!trip.Member.Organization ? trip.Member.Organization.Name : "",
          Seg: 0,
          TravelerDisplayName: travelerName,
          Travelers: travelersList,
          //TravelerDisplayName: ((!!trip.Member) ? trip.Member.LastName + ', ' + trip.Member.FirstName : ''),
          Supplier: "-",
          Source: "-",
          Pnr: !!trip.Pnr ? trip.Pnr : "",
          StartLocation: "-",
          EndLocation: "-",
          TripTitle: trip.Title,
          Agent: null,
          //Total: generateTripTotal(trip.Flights, trip.Cars, trip.Hotels),
          BookingType: "Trip", // T-Trips, F-Flights,H-Hotels,C-Cars,
          Flight: !!trip.Flights.length ? 1 : 0,
          Hotel: !!trip.Hotels.length ? 1 : 0,
          Car: !!trip.Cars.length ? 1 : 0,
          Limo: !!trip.Limos.length ? 1 : 0,
          FlightNumber: 0,
          Duration: 0,
          Seat: 0,
          EndDate: trip.EndDate,
          Class: 0,
          Status: 0,
          Type: 0,
          NumberOfRooms: 0,
          Address: 0,
          Rate: 0,
          DeviceToken: !!trip.Member.DeviceToken ? trip.Member.DeviceToken : null,
          OSPlatform: !!trip.Member.OSPlatform ? trip.Member.OSPlatform : null,
          TravelerEmail: !!trip.Member.Email ? trip.Member.Email : null,
          TravelerCompanyId: !!trip.Member.Organization.Id ? trip.Member.Organization.Id : null,
          Traveler: trip.Member
        };
      });
    }
    // get total for trips
    /*function generateTripTotal(flightData, carData, hotelData) {
      let currencyCode = '';
      let total = 0;
      let arrTotal = [];
      total = flightData.reduce(function(total, flight) {
        if (!!flight.AirReservation && arrTotal.indexOf(flight.AirReservationId) === -1) {
          arrTotal.push(flight.AirReservationId);			
          currencyCode = flight.AirReservation.CurrencyCode;
          return total + flight.AirReservation.TotalFare;
        } else {
          return total + 0;
        }
      }, total);
      total = carData.reduce(function(total, car) {			
        return total + car.TotalCharge;;
      }, total);
      total = hotelData.reduce(function(total, hotel) {
        return total + hotel.Total;
      }, total);
      currencyCode = ((!!hotelData.length && !currencyCode) ? ((!!hotelData[0].CurrencyCode) ? hotelData[0].CurrencyCode :
          currencyCode) :
        currencyCode);
      currencyCode = ((!!carData.length && !currencyCode) ? ((!!carData[0].CurrencyCode) ? carData[0].CurrencyCode :
          currencyCode) :
        currencyCode);
      return currency.getCurrencySymbol(currencyCode) + total.toFixed(2);
    };*/

    function generateBookingFlight(flights, member) {
      return flights.map(function (flight) {
        var travelerName = flight.Member ? flight.Member.LastName + ", " + flight.Member.FirstName : member ? member.LastName + ", " + member.FirstName : "";
        return {
          Id: flight.Id,
          BookingTypeName: "A",
          StartDate: flight.DepartureDateTime,
          Company: flight.Member ? flight.Member.Organization.Name : member ? member.Organization.Name : "",
          Seg: 1,
          TravelerDisplayName: travelerName,
          Travelers: [travelerName],
          Supplier: flight.OperatingAirline,
          Source: !!flight.BookingSource ? flight.BookingSource : "",
          Pnr: !!flight.Pnr ? flight.Pnr : "",
          StartLocation: flight.DepartureName,
          EndLocation: flight.ArrivalName,
          BookingType: "Flight",
          FlightNumber: flight.FlightNumber,
          Duration: flight.Duration,
          Seat: flight.Seats,
          EndDate: flight.ArrivalDateTime,
          Class: (!!flight.BookingClass ? flight.BookingClass : "") + (!!flight.BookingClassDescription ? " - " + flight.BookingClassDescription : ""),
          Status: !!flight.ConfirmationNumber ? "Confirmed - " + flight.ConfirmationNumber : "",
          Type: 0,
          NumberOfRooms: 0,
          Address: 0,
          Trips: "",
          Agent: null,
          Total: currency.getCurrencySymbol(flight.AirReservation.CurrencyCode) + flight.AirReservation.TotalFare,
          Flight: 0,
          Hotel: 0,
          Car: 0,
          DeviceToken: flight.Member ? flight.Member.DeviceToken : member ? member.DeviceToken : null,
          OSPlatform: flight.Member ? flight.Member.OSPlatform : member ? member.OSPlatform : null
        };
      });
    }

    function generateBookingCar(cars, member) {
      return cars.map(function (car) {
        var travelerName = car.Member ? car.Member.LastName + "/" + car.Member.FirstName : member ? member.LastName + ", " + member.FirstName : "";
        return {
          Id: car.Id,
          BookingTypeName: "C",
          StartDate: car.PickUpDateTime,
          Company: car.Member ? car.Member.Organization.Name : member ? member.Organization.Name : "",
          Seg: 2,
          TravelerDisplayName: travelerName,
          Travelers: [travelerName],
          Traveler: car.Member ? car.Member.LastName + "/" + car.Member.FirstName : member ? member.LastName + "/" + member.FirstName : "",
          Supplier: car.RentalCompany,
          Source: !!car.BookingSource ? car.BookingSource : "",
          Pnr: !!car.Pnr ? car.Pnr : "",
          StartLocation: car.PickUpLocation,
          EndLocation: car.DropOffLocation,
          BookingType: "Car",
          FlightNumber: 0,
          Duration: 0,
          Seat: 0,
          EndDate: car.DropOffDateTime,
          Class: 0,
          Status: !!car.Confirmation ? "Confirmed - " + car.Confirmation : "",
          Type: car.CarModel,
          Trips: "",
          Agent: null,
          Total: currency.getCurrencySymbol(car.CurrencyCode) + car.TotalCharge,
          NumberOfRooms: 0,
          Address: 0,
          Flight: 0,
          Hotel: 0,
          Car: 0,
          DeviceToken: car.Member ? car.Member.DeviceToken : member ? member.DeviceToken : null,
          OSPlatform: car.Member ? car.Member.OSPlatform : member ? member.OSPlatform : null
        };
      });
    }

    function generateBookingHotel(hotels, member) {
      return hotels.map(function (hotel) {
        var travelerName = !!hotel.GuestNames ? hotel.GuestNames : hotel.Member ? hotel.Member.LastName + "/" + hotel.Member.FirstName : member ? member.LastName + ", " + member.FirstName : "";
        return {
          Id: hotel.Id,
          BookingTypeName: "H",
          StartDate: hotel.CheckInDate,
          Company: hotel.Member ? hotel.Member.Organization.Name : member ? member.Organization.Name : "",
          Seg: 3,
          TravelerDisplayName: travelerName,
          Travelers: [travelerName],
          Traveler: hotel.Member ? hotel.Member.LastName + "/" + hotel.Member.FirstName : member ? member.LastName + "/" + member.FirstName : "",
          Supplier: hotel.HotelName,
          Source: !!hotel.BookingSource ? hotel.BookingSource : "",
          Pnr: !!hotel.Pnr ? hotel.Pnr : "",
          StartLocation: "",
          EndLocation: "",
          BookingType: "Hotel",
          FlightNumber: 0,
          Duration: 0,
          Seat: 0,
          EndDate: hotel.CheckOutDate,
          Class: 0,
          Status: !!hotel.Confirmation ? "Confirmed - " + hotel.Confirmation : "",
          Type: hotel.RoomType,
          NumberOfRooms: hotel.NumberOfRooms,
          Address: hotel.Address,
          Trips: "",
          Agent: null,
          Flight: 0,
          Hotel: 1,
          Car: 0,
          Total: currency.getCurrencySymbol(hotel.CurrencyCode) + hotel.Total,
          DeviceToken: hotel.Member ? hotel.Member.DeviceToken : member ? member.DeviceToken : null,
          OSPlatform: hotel.Member ? hotel.Member.OSPlatform : member ? member.OSPlatform : null,
          VirtualCardId: hotel.VirtualCardId
        };
      });
    }

    function generateBookingLimo(limoContext, member) {
      return limoContext.map(function (limo) {
        var travelerName = limoContext.Member ? limoContext.Member.LastName + ", " + limoContext.Member.FirstName : member ? member.LastName + ", " + member.FirstName : "";
        return {
          Id: limo.Id,
          BookingTypeName: "L",
          DepartureDate: limo.DepartureDate,
          LimoServiceName: limo.LimoServiceName,
          LocationName: limo.LocationName,
          Seg: 4,
          TravelerDisplayName: travelerName,
          Travelers: [travelerName],
          BookingType: "Limo",
          Traveler: member,
          BookingSource: limo.BookingSource,
          Cancelled: limo.Cancelled,
          Confirmation: limo.Confirmation,
          DropOff: limo.DropOff,
          IPCC: limo.IPCC,
          ImageLink: limo.ImageLink,
          Instructions: limo.Instructions,
          PickUp: limo.PickUp,
          Pnr: limo.Pnr,
          Time: limo.Time,
          StartDate: limo.DepartureDate
        };
      });
    }
  }]);
})(angular.module("obex"));

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// TODO: accordion
(function (module) {
  'use strict';

  module.directive('accordionPanel', function () {
    return {
      restrict: 'A',
      link: function link(scope, elem, attrs) {
        elem.on('click', function (e) {
          e.preventDefault();
          var panelId = $(this).attr('href');
          var spanId = $(this).find('span');
          if ($(panelId).is(':visible')) {
            $(panelId).slideUp('fast');
            $(spanId).removeClass('glyphicon-chevron-down');
            $(spanId).addClass('glyphicon-chevron-right');
          } else {
            $(panelId).slideDown('fast');
            $(spanId).removeClass('glyphicon-chevron-right');
            $(spanId).addClass('glyphicon-chevron-down');
          }
          $('#accordion .panel-body').not(panelId).slideUp('fast');
          $('#accordion span').not(spanId).removeClass('glyphicon-chevron-down');
          $('#accordion span').not(spanId).addClass('glyphicon-chevron-right');
        });
      }
    };
  });
})(angular.module('obex'));

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.directive('permissions', ['authService', function (authService) {
    return {
      restrict: 'A',
      scope: {
        permissions: '='
      },
      link: function link(scope, elem, attrs) {
        scope.$watch(authService.isLoggedIn, function () {
          if (authService.userHasPermission(scope.permissions)) {
            elem.show();
          } else {
            elem.hide();
          }
        });
      }
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.directive('catchSrcError', function () {
    return {
      restrict: 'A',
      link: function link(scope, element, attrs) {
        element.bind('error', function () {
          if (attrs.src != attrs.catchSrcError) {
            attrs.$set('src', attrs.catchSrcError);
          }
        });
      }
    };
  });
})(angular.module('obex'));

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.directive('clientautocomplete', ['$filter', clientAutoCompleteDir]);

  function clientAutoCompleteDir($filter) {
    return {
      restrict: 'A',
      link: function link(scope, elem, attrs) {
        elem.autocomplete({
          source: function source(request, response) {
            //term has the data typed by the user
            var params = request.term;

            //simulates api call with data $filter
            var data = scope.dataSource;
            if (data) {
              var result = $filter('filter')(data, {
                name: params
              });
              _.map(result, function (item) {
                item['value'] = item['name'];
                item['id'] = item['id'];
              });
            }

            response(result);
          },

          select: function select(event, ui) {
            $('#hidId').val(ui.item.id);
            scope.selectedValue = ui.item.id;
          },

          minLength: 1
        }).autocomplete('widget').addClass('client-autocomplete');
      }
    };
  }
})(angular.module('obex'));

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.directive('ngDatepicker', ['$document', function ($document) {
    'use strict';

    var setScopeValues = function setScopeValues(scope, attrs) {
      scope.format = attrs.format || 'YYYY-MM-DD';
      scope.viewFormat = attrs.viewFormat || 'Do MMMM YYYY';
      scope.locale = attrs.locale || 'en';
      scope.firstWeekDaySunday = scope.$eval(attrs.firstWeekDaySunday) || false;
      scope.placeholder = attrs.placeholder || '';
      scope.style = attrs.style || '';
    };

    return {
      restrict: 'EA',
      require: '?ngModel',
      scope: {},
      link: function link(scope, element, attrs, ngModel) {
        setScopeValues(scope, attrs);

        scope.calendarOpened = false;
        scope.days = [];
        scope.dayNames = [];
        scope.viewValue = null;
        scope.dateValue = null;

        moment.locale(scope.locale);
        var date = moment();

        var generateCalendar = function generateCalendar(date) {
          var lastDayOfMonth = date.endOf('month').date(),
              month = date.month(),
              year = date.year(),
              n = 1;

          var firstWeekDay = scope.firstWeekDaySunday === true ? date.set('date', 2).day() : date.set('date', 1).day();
          if (firstWeekDay !== 1) {
            n -= firstWeekDay - 1;
          }

          scope.dateValue = date.format('MMMM YYYY');
          scope.days = [];

          for (var i = n; i <= lastDayOfMonth; i += 1) {
            if (i > 0) {
              scope.days.push({ day: i, month: month + 1, year: year, enabled: true });
            } else {
              scope.days.push({ day: null, month: null, year: null, enabled: false });
            }
          }
        };

        var generateDayNames = function generateDayNames() {
          var date = scope.firstWeekDaySunday === true ? moment('2015-06-07') : moment('2015-06-01');
          for (var i = 0; i < 7; i += 1) {
            scope.dayNames.push(date.format('ddd'));
            date.add('1', 'd');
          }
        };

        generateDayNames();

        scope.showCalendar = function () {
          scope.calendarOpened = true;
          generateCalendar(date);
        };

        scope.closeCalendar = function () {
          scope.calendarOpened = false;
        };

        scope.prevYear = function () {
          date.subtract(1, 'Y');
          generateCalendar(date);
        };

        scope.prevMonth = function () {
          date.subtract(1, 'M');
          generateCalendar(date);
        };

        scope.nextMonth = function () {
          date.add(1, 'M');
          generateCalendar(date);
        };

        scope.nextYear = function () {
          date.add(1, 'Y');
          generateCalendar(date);
        };

        scope.selectDate = function (event, date) {
          event.preventDefault();
          var selectedDate = moment(date.day + '.' + date.month + '.' + date.year, 'DD.MM.YYYY');
          ngModel.$setViewValue(selectedDate.format(scope.format));
          scope.viewValue = selectedDate.format(scope.viewFormat);
          scope.closeCalendar();
        };

        // if clicked outside of calendar
        var classList = ['ng-datepicker', 'ng-datepicker-input'];
        if (attrs.id !== undefined) classList.push(attrs.id);
        $document.on('click', function (e) {
          if (!scope.calendarOpened) return;

          var i = 0,
              element;

          if (!e.target) return;

          for (element = e.target; element; element = element.parentNode) {
            var id = element.id;
            var classNames = element.className;

            if (id !== undefined) {
              for (i = 0; i < classList.length; i += 1) {
                if (id.indexOf(classList[i]) > -1 || classNames.indexOf(classList[i]) > -1) {
                  return;
                }
              }
            }
          }

          scope.closeCalendar();
          scope.$apply();
        });

        ngModel.$render = function () {
          var newValue = ngModel.$viewValue;
          if (newValue !== undefined) {
            scope.viewValue = moment(newValue).format(attrs.viewFormat);
            scope.dateValue = newValue;
          }
        };
      },

      template: '<div><input type="text" ng-focus="showCalendar()" ng-value="viewValue" class="ng-datepicker-input" style="{{ style }}" placeholder="{{ placeholder }}"></div>' + '<div class="ng-datepicker" ng-show="calendarOpened">' + '  <div class="controls">' + '    <div class="left">' + '      <i class="fa fa-backward prev-year-btn" ng-click="prevYear()"></i>' + '      <i class="fa fa-angle-left prev-month-btn" ng-click="prevMonth()"></i>' + '    </div>' + '    <span class="date" ng-bind="dateValue"></span>' + '    <div class="right">' + '      <i class="fa fa-angle-right next-month-btn" ng-click="nextMonth()"></i>' + '      <i class="fa fa-forward next-year-btn" ng-click="nextYear()"></i>' + '    </div>' + '  </div>' + '  <div class="day-names">' + '    <span ng-repeat="dn in dayNames">' + '      <span>{{ dn }}</span>' + '    </span>' + '  </div>' + '  <div class="calendar">' + '    <span ng-repeat="d in days">' + '      <span class="day" ng-click="selectDate($event, d)" ng-class="{disabled: !d.enabled}">{{ d.day }}</span>' + '    </span>' + '  </div>' + '</div>'
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.directive('fileinputListener', function () {
    return {
      restrict: 'A',
      link: function link(scope, element, attrs) {
        var onChangeHandler = scope.$eval(attrs.fileinputListener);
        element.bind('change', onChangeHandler);
      }
    };
  });
})(angular.module('obex'));

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/fronteed/iCheck/issues/62
(function (module) {
  'use strict';

  module.directive('icheck', ['$timeout', '$parse', function ($timeout, $parse) {
    return {
      require: '?ngModel',
      link: function link($scope, element, $attrs, ngModel) {
        $scope.$applyAsync(function () {
          if (ngModel) {
            var render = ngModel.$render;
            ngModel.$render = function () {
              render();
              element.iCheck('updated');
            };
          }
          element.on('ifCreated', function () {
            if ($attrs['icheck']) {
              element.parent().addClass('icheck_' + $attrs['icheck']);
            }
          }).iCheck({
            radioClass: 'iradio_minimal-grey',
            checkboxClass: 'icheckbox_minimal-grey'
          }).on('ifChanged', function (event) {
            if ($(element).attr('type') === 'checkbox') {
              element.triggerHandler('click');
              element.triggerHandler('change');
            } else if ($(element).attr('type') === 'radio') {
              if ($(element).context.checked) {
                element.triggerHandler('click');
              }
            }
            $scope.$apply(function () {
              event.isChecked = element[0].checked;
            });
          });
        });
      }
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.directive('imageFileSelect', ['$scope', function ($scope) {
    return {
      link: function link($scope, el) {

        el.bind("change", function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        });
      }
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// TODO: migrate autocomplete to UI Bootstrap typeahead
(function (module) {
  'use strict';

  module.directive('organizationautocomplete', ['$filter', orgAutoCompleteDir]);

  function orgAutoCompleteDir($filter) {
    return {
      restrict: 'A',
      link: function link(scope, elem, attrs) {
        // Autohighlight on focus -- optional
        elem.on('focus', function () {
          this.select();
        });

        elem.autocomplete({
          source: function source(request, response) {
            //term has the data typed by the user
            var params = request.term;

            if (scope.organizationMap) {
              var result = $filter('filter')(scope.organizationMap, {
                name: params
              });
              _.map(result, function (item) {
                item['value'] = item['name'];
                item['id'] = item['id'];
              });
            }
            response(result);
          },

          select: function select(event, ui) {
            scope.organizationInput = ui.item.id;
            scope.selectedId = ui.item.id;
            scope.selectedName = ui.item.name;
            scope.$apply();
          },

          minLength: 0
        }).autocomplete('widget').addClass('org-autocomplete');
      }
    };
  }
})(angular.module('obex'));

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  'use strict';

  module.directive('resizer', ['$document', '$timeout', function ($document, $timeout) {
    return function ($scope, $element, $attrs) {
      $element.on('mousedown', function (event) {
        event.preventDefault();
        $document.on('mousemove', mousemove);
        $document.on('mouseup', mouseup);
      });

      /*
      Directive scheme
        <div resizer="vertical/horizontal" resizer-height="number" resizer-top="#id" resizer-bottom="#id" resizer-offset-element="?#id" 
      resizer-top-bound="?number" resizer-bottom-bound="?number" resizer-top-padding-bottom="number"></div>
      */

      // Default fallback attribute values
      if (!$attrs.resizerOffsetElement) {
        $attrs.resizerOffsetElement = $attrs.resizerTop;
      }
      if (!$attrs.resizerTopBound) {
        $attrs.resizerTopBound = 0;
      }
      if (!$attrs.resizerBottomBound) {
        $attrs.resizerBottomBound = 1080;
      }

      // Grab offsets on document ready
      var offset;
      var padding;

      angular.element(document).ready(function () {
        // Hacky -- wait for angular to load DOMs before grabbing
        $timeout(function () {
          offset = $($attrs.resizerOffsetElement).offset() || { left: 0, top: 0 }; //jquery -- tofix
          padding = parseInt($attrs.resizerTopPaddingBottom) + parseInt($attrs.resizerHeight) || parseInt($attrs.resizerHeight);
        }, 500);
      });

      function mousemove(event) {
        if ($attrs.resizer == 'vertical') {
          // Handle vertical orientation resizer (i.e. drag left/right)
          var x = event.pageX;
          if ($attrs.resizerMax && x > $attrs.resizerMax) {
            x = parseInt($attrs.resizerMax);
          }
          $element.css({
            left: x + 'px'
          });
          $($attrs.resizerLeft).css({
            width: x + 'px'
          });
          $($attrs.resizerRight).css({
            left: x + parseInt($attrs.resizerWidth) + 'px'
          });
        } else {

          // Handle horizontal orientation resizer (i.e. drag up/down)
          var y = event.pageY - offset.top;
          if (y > $attrs.resizerTopBound && y < $attrs.resizerBottomBound) {
            $element.css({
              top: y + 'px'
            });
            $($attrs.resizerTop).css({
              height: y - padding + 1 + 'px'
            });
          }
        }
      }

      function mouseup() {
        $document.unbind('mousemove', mousemove);
        $document.unbind('mouseup', mouseup);
      }
    };
  }]);
})(angular.module('obex'));

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  'use strict';

  angular.module('obex').factory('aclService', ['$http', '$q', '$window', 'obexConstant', function ($http, $q, $window, obexConstant) {
    return {};
  }]);
})();

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('agencyManagement', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    var showAll = false;
    return {
      setShowAll: function setShowAll(showAllAgencies) {
        showAll = showAllAgencies;
      },
      getShowAll: function getShowAll() {
        return showAll;
      },
      addOrganization: function addOrganization(organization) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var postData = {
            Id: organization.Id,
            Name: organization.Name,
            AddressLine1: organization.AddressLine1,
            AddressLine2: organization.AddressLine2,
            City: organization.City,
            PostalCode: organization.PostalCode,
            Country: organization.Country,
            StateProv: organization.StateProv,
            IsTravelAgency: organization.IsTravelAgency,
            TravelAgencyId: organization.TravelAgencyId,
            HasConcur: organization.HasConcur,
            Domains: organization.Domains,
            AcceptEmails: organization.AcceptEmails,
            WebSite: organization.WebSite,
            LogoImageLink: organization.LogoImageLink
          };
          return $http.post(obexConstant.urlOrganization, postData, {
            headers: authHeader
          });
        });
      },
      getOrganizations: function getOrganizations() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(obexConstant.urlOrganization, {
            headers: authHeader
          });
        });
      },
      getOrganizationById: function getOrganizationById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlOrganization + '/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getClients: function getClients() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(obexConstant.urlClients, {
            headers: authHeader
          });
        });
      },
      getAgencies: function getAgencies() {
        var includeAllAgencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = includeAllAgencies === true ? obexConstant.urlAgencies + '/' + includeAllAgencies : obexConstant.urlAgencies;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      updateOrganization: function updateOrganization(id, organization) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlOrganization + '/' + id;
          var putData = {
            Id: organization.Id,
            Name: organization.Name,
            AddressLine1: organization.AddressLine1,
            AddressLine2: organization.AddressLine2,
            City: organization.City,
            PostalCode: organization.PostalCode,
            Country: organization.Country,
            StateProv: organization.StateProv,
            IsTravelAgency: organization.IsTravelAgency,
            Inactive: organization.Inactive,
            TravelAgencyId: organization.TravelAgencyId,
            HasConcur: organization.HasConcur,
            Domains: organization.Domains,
            AcceptEmails: organization.AcceptEmails,
            WebSite: organization.WebSite,
            LogoImageLink: organization.LogoImageLink,
            DefaultPhone: organization.DefaultPhone
          };
          if (organization.DefaultAfterHoursPhone !== null) {
            putData["DefaultAfterHoursPhone"] = organization.DefaultAfterHoursPhone;
          }
          if (organization.DefaultInternationalPhone !== null) {
            putData["DefaultInternationalPhone"] = organization.DefaultInternationalPhone;
          }
          if (organization.DefaultEmail !== null) {
            putData["DefaultEmail"] = organization.DefaultEmail;
          }
          if (organization.DefaultStartRegularHours !== null) {
            putData["DefaultStartRegularHours"] = organization.DefaultStartRegularHours;
          }
          if (organization.DefaultEndRegularHours !== null) {
            putData["DefaultEndRegularHours"] = organization.DefaultEndRegularHours;
          }
          if (organization.DefaultWindowsTimeZone !== null) {
            putData["DefaultWindowsTimeZoneId"] = organization.DefaultWindowsTimeZone.Id;
          }
          if (organization.DefaultServiceStartDay !== null) {
            putData["DefaultServiceStartDay"] = organization.DefaultServiceStartDay;
          }
          if (organization.DefaultServiceEndDay !== null) {
            putData["DefaultServiceEndDay"] = organization.DefaultServiceEndDay;
          }
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      deleteOrganization: function deleteOrganization(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlOrganization + '/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      },
      getCountries: function getCountries() {
        return $http.get('/js/content/countryData.json');
      },
      getStates: function getStates() {
        return $http.get('/js/content/stateData.json');
      }
    };
  }]);
})();

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(24);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Maintain and distribute overarching organization filter data
;(function () {
  'use strict';

  angular.module('obex').factory('agencySelectService', ['$q', '$window', 'organizations', 'authService', 'obexRoles', function ($q, $window, organizations, authService, obexRoles) {
    var storage = $window.localStorage;
    var selectedAgency = {};
    return {
      getSelectableAgencies: function getSelectableAgencies() {
        var logInUser = authService.getLoginMember();
        return organizations.getAgencies().then(function (response) {
          var agencies = response.data;
          var selectableAgencies = agencies.map(function (org) {
            return {
              name: org.Name,
              id: org.Id
            };
          }).sort(function (a, b) {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });

          return $q.when(selectableAgencies);
        });
      },
      setSelectedAgency: function setSelectedAgency(id, name) {
        selectedAgency.id = id;
        selectedAgency.name = name;
        storage.setItem('selectedAgency', (0, _stringify2.default)(selectedAgency));
        console.log('selectedAgency set to', selectedAgency);
      },
      getSelectedAgency: function getSelectedAgency() {
        var sa = selectedAgency;
        if (sa.id === undefined || sa.name === undefined) {
          if (storage.getItem('selectedAgency')) {
            sa = JSON.parse(storage.getItem('selectedAgency'));
          }
        }
        return sa;
      },
      clearSelectedAgency: function clearSelectedAgency() {
        selectedAgency.id = undefined;
        selectedAgency.name = undefined;
        storage.removeItem('selectedAgency');
        console.log('selectedAgency cleared');
      }
    };
  }]);
})();

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('agencySettings', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    return {
      //Get agency id
      getAgencyById: function getAgencyById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlOrganization + '/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },

      //GET time ZONE
      getWindowsTimeZones: function getWindowsTimeZones() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = '' + obexConstant.urlWindowsTimeZones;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },

      //Update agency
      updateAgency: function updateAgency(id, organization) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlOrganization + '/' + id;
          return $http.put(url, organization, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('agentAssignment', ['$http', '$q', 'obexConstant', 'authService', function ($http, $q, obexConstant, authService) {
    return {
      getTravelAgentOrganizationsById: function getTravelAgentOrganizationsById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelAgentOrganizations + '/organization/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      addTravelAgentOrganizations: function addTravelAgentOrganizations(travelAgentOrganizationList) {
        var promises = _.map(travelAgentOrganizationList, function (travelAgentOrganization) {
          return authService.getAuthorizationHeader().then(function (authHeader) {
            var url = '' + obexConstant.urlTravelAgentOrganizations;
            var postData = {
              Id: travelAgentOrganization.Id,
              MemberId: travelAgentOrganization.MemberId,
              OrganizationId: travelAgentOrganization.OrganizationId
            };
            return $http.post(url, postData, {
              headers: authHeader
            });
          });
        });
        return $q.all(promises);
      },
      deleteTravelAgentOrganizations: function deleteTravelAgentOrganizations(travelAgentOrganizationIdList) {
        var promises = _.map(travelAgentOrganizationIdList, function (travelAgentOrganization) {
          return authService.getAuthorizationHeader().then(function (authHeader) {
            var url = obexConstant.urlTravelAgentOrganizations + '/' + travelAgentOrganization.TravelAgentOrganizationId;
            return $http.delete(url, {
              headers: authHeader
            });
          });
        });
        return $q.all(promises);
      }
    };
  }]);
})();

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(function () {
  'use strict';

  angular.module('obex').factory('agentsService', ['$rootScope', '$http', 'authService', function ($rootScope, $http, authService) {
    return {
      getOnlineAgents: function getOnlineAgents() {
        var loginMember = authService.getLoginMember();
        console.log('call authService.getLoginMember() in alert.service ', loginMember);
        return $http.get('/getOnlineAgents/' + loginMember.OrganizationId);
      }
    };
  }]);
})();

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  'use strict';

  angular.module('obex').factory('alertService', ['$rootScope', '$http', 'smsStatus', 'authService', function ($rootScope, $http, smsStatus, authService) {
    return {
      getUnhandledAlerts: function getUnhandledAlerts() {
        var loginMember = authService.getLoginMember();
        //\\return $http.get('/unhandledAlerts/' + loginMember.OrganizationId);
        return $http({
          method: 'GET',
          url: '/unhandledAlerts/' + loginMember.OrganizationId + '/' + loginMember.Email,
          params: { 'foobar': new Date().getTime() }
        });
      },
      getHandledSms: function getHandledSms() {
        var loginMember = authService.getLoginMember();
        return $http.get('/handledSms/' + loginMember.Email);
      },
      getUnhandledVoiceAlerts: function getUnhandledVoiceAlerts() {
        var loginMember = authService.getLoginMember();
        return $http({
          method: 'GET',
          url: '/unhandledVoiceAlerts/' + loginMember.OrganizationId + '/' + loginMember.Email,
          params: { 'foobar': new Date().getTime() }
        });
      },
      getHandledPhone: function getHandledPhone() {
        var loginMember = authService.getLoginMember();
        return $http.get('/handledPhone/' + loginMember.Email);
      }
    };
  }]);
})();

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services
(function () {
  'use strict';

  angular.module('obex').factory('allowIntegrations', ['$http', '$q', 'obexConstant', 'authService', function ($http, $q, obexConstant, authService) {
    return {
      getAllowIntegrationsByOrganizationId: function getAllowIntegrationsByOrganizationId(organizationId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAllowIntegrations + '/organization/id/' + organizationId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getAllowIntegrationById: function getAllowIntegrationById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAllowIntegrations + '/id/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      addAllowIntegration: function addAllowIntegration(AllowIntegration) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = '' + obexConstant.urlAllowIntegrations;
          var postData = {
            OrganizationId: AllowIntegration.OrganizationId,
            Allowed: AllowIntegration.Allowed,
            CategoryApp: AllowIntegration.CategoryApp
          };
          return $http.post(url, postData, {
            headers: authHeader
          });
        });
      },
      updateAllowIntegration: function updateAllowIntegration(id, AllowIntegration) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAllowIntegrations + '/id/' + id;
          var putData = {
            Id: AllowIntegration.Id,
            OrganizationId: AllowIntegration.OrganizationId,
            Allowed: AllowIntegration.Allowed,
            CategoryApp: AllowIntegration.CategoryApp
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      deleteAllowIntegration: function deleteAllowIntegration(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAllowIntegrations + '/id/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('apps', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    return {
      addApp: function addApp(app) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var postData = {
            CategoryId: app.CategoryId,
            Name: app.Name
          };
          return $http.post(obexConstant.urlApp, postData, {
            headers: authHeader
          });
        });
      },
      getApps: function getApps() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(obexConstant.urlApp, {
            headers: authHeader
          });
        });
      },
      getAppById: function getAppById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlApp + '/id/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      updateApp: function updateApp(id, app) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlApp + '/id/' + id;
          var putData = {
            Id: app.Id,
            CategoryId: app.CategoryId,
            Name: app.Name
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      deleteApp: function deleteApp(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlApp + '/id/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(24);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;(function () {
  'use strict';

  angular.module('obex').factory('authService', ['$http', '$q', '$window', 'obexConstant', '$state', function ($http, $q, $window, obexConstant, $state) {
    var storage = $window.localStorage;
    var cacheToken = {};
    var cachePermission = '';
    var cacheLoginMember = {};
    return {
      clear: function clear() {
        cacheToken.access_token = undefined;
        cacheToken.refresh_token = undefined;
        cacheToken.expires_in = undefined;
        storage.clear();
      },
      setToken: function setToken(token) {
        cacheToken.access_token = token.access_token;
        storage.setItem('access_token', cacheToken.access_token);
        cacheToken.refresh_token = token.refresh_token;
        storage.setItem('refresh_token', cacheToken.refresh_token);
        cacheToken.expires_in = token.expires_in;
        storage.setItem('expires_in', cacheToken.expires_in);
      },
      setPermission: function setPermission(permission) {
        cachePermission = permission;
        storage.setItem('permission', cachePermission);
      },
      setLoginMember: function setLoginMember(loginMember) {
        cacheLoginMember = loginMember;
        storage.setItem('loginMember', (0, _stringify2.default)(loginMember));
      },
      getAuthorizationHeader: function getAuthorizationHeader() {
        if (cacheToken.access_token && cacheToken.expires_in > moment(new Date().getTime()).unix()) {
          return $q.when({
            Authorization: 'Bearer ' + cacheToken.access_token
          });
        } else {
          cacheToken.access_token = storage.getItem('access_token');
          cacheToken.refresh_token = storage.getItem('refresh_token');
          cacheToken.expires_in = Number(storage.getItem('expires_in'));
          if (cacheToken.access_token && cacheToken.expires_in > moment(new Date().getTime()).unix()) {
            return $q.when({
              Authorization: 'Bearer ' + cacheToken.access_token
            });
          } else {
            return $http.post('/refreshToken', { token: cacheToken.refresh_token }).then(function (response) {
              var token = response.data;
              cacheToken.access_token = token.access_token;
              storage.setItem('access_token', cacheToken.access_token);
              cacheToken.refresh_token = token.refresh_token;
              storage.setItem('refresh_token', cacheToken.refresh_token);
              cacheToken.expires_in = token.expires_in;
              storage.setItem('expires_in', cacheToken.expires_in);
              return {
                Authorization: 'Bearer ' + cacheToken.access_token
              };
            }, function (err) {
              $state.go('login');
            });
          }
        }
      },
      isAuthenticated: function isAuthenticated() {
        if (cacheToken.access_token) {
          return true;
        } else {
          if (storage.getItem('access_token')) {
            //reload cache with localStorage
            cacheToken.access_token = storage.getItem('access_token');
            cacheToken.refresh_token = storage.getItem('refresh_token');
            cacheToken.expires_in = storage.getItem('expires_in');
            return true;
          } else {
            return false;
          }
        }
      },
      userHasPermission: function userHasPermission(permissions) {
        var permission = cachePermission;
        if (!permission) {
          permission = storage.getItem('permission');
        }

        return !!_.find(permissions, function (p) {
          return p === permission;
        });
      },
      getLoginMember: function getLoginMember() {
        var loginMember = cacheLoginMember;
        if (loginMember.Email === undefined) {
          loginMember = JSON.parse(storage.getItem('loginMember'));
        }

        return loginMember;
      },
      getTokenFromCredential: function getTokenFromCredential(email, password) {
        return $http.post('/login', { email: email, password: password });
      },
      signup: function signup(email, password, firstName, lastName) {
        var postData = {
          Email: email,
          Password: password,
          FirstName: firstName,
          LastName: lastName
        };
        return $http.post(obexConstant.urlActivation, postData);
      },
      completeActivation: function completeActivation(password, guid) {
        var postData = {
          Password: password,
          Guid: guid
        };
        return $http.post(obexConstant.urlCompleteActivation, postData);
      },
      forgotPassword: function forgotPassword(email, newPassword) {
        var postData = {
          Email: email,
          Password: newPassword
        };
        return $http.post(obexConstant.urlResetPassword + '/' + email, postData);
      }
    };
  }]);
})();

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('obex').factory('authInterceptor', function (authToken) {
  return {
    request: function request(config) {
      var token = authToken.getToken();

      if (token) {
        config.headers.Authorization = 'Bearer ' + token;
      }

      return config;
    },

    response: function response(_response) {
      return _response;
    }
  };
});

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('categories', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    return {
      addCategory: function addCategory(category) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var postData = {
            Name: category.Name
          };
          return $http.post(obexConstant.urlCategory, postData, {
            headers: authHeader
          });
        });
      },
      getCategories: function getCategories() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(obexConstant.urlCategory, {
            headers: authHeader
          });
        });
      },
      getCategoryById: function getCategoryById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlCategory + '/id/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      updateCategory: function updateCategory(id, category) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlCategory + '/id/' + id;
          var putData = {
            Id: category.Id,
            Name: category.Name
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      deleteCategory: function deleteCategory(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlCategory + '/id/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(24);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;(function () {
  'use strict';

  angular.module('obex').factory('clientSelectService', ['$q', '$window', 'organizations', 'authService', '$rootScope', function ($q, $window, organizations, authService, $rootScope) {
    var storage = $window.localStorage;
    var selectedClient = {};
    return {
      getSelectableClients: function getSelectableClients() {
        var boolAllClients = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var logInUser = authService.getLoginMember();
        if (logInUser.Role == 1 || logInUser.Role == 2) {
          if (boolAllClients) {
            return organizations.getSelectedAgencyClients(logInUser.Organization.Id, true).then(function (response) {
              var allOrganizationInfo = response.data;
              console.log(response.data);
              var allOrganizationMap = allOrganizationInfo.map(function (org) {
                return {
                  name: org.Name,
                  id: org.Id,
                  travelAgencyId: org.TravelAgencyId,
                  allowOpenBookings: org.AllowOpenBookings,
                  chatAppName: org.ChatAppName
                };
              }).sort(function (a, b) {
                return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
              });

              return $q.when(allOrganizationMap);
            });
          } else {
            return organizations.getSelectedAgencyClients(logInUser.Organization.Id).then(function (response) {
              var allOrganizationInfo = response.data;
              console.log(response.data);
              var allOrganizationMap = allOrganizationInfo.filter(function (obj) {
                return !obj.Inactive;
              }).map(function (org) {
                return {
                  name: org.Name,
                  id: org.Id,
                  travelAgencyId: org.TravelAgencyId,
                  allowOpenBookings: org.AllowOpenBookings,
                  chatAppName: org.ChatAppName
                };
              }).sort(function (a, b) {
                return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
              });

              return $q.when(allOrganizationMap);
            });
          }
        } else {
          return organizations.getClients(boolAllClients).then(function (response) {
            var allOrganizationInfo = response.data;
            console.log(response.data);
            var allOrganizationMap = allOrganizationInfo.map(function (org) {
              return {
                name: org.Name,
                id: org.Id,
                travelAgencyId: org.TravelAgencyId,
                allowOpenBookings: org.AllowOpenBookings,
                chatAppName: org.ChatAppName
              };
            }).sort(function (a, b) {
              return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
            });
            return $q.when(allOrganizationMap);
          });
        }
      },
      setSelectedClient: function setSelectedClient(id, name, allowOpenBookings, chatAppName) {
        selectedClient.id = id;
        selectedClient.name = name;
        selectedClient.allowOpenBookings = allowOpenBookings;
        selectedClient.ChatAppName = chatAppName;
        storage.setItem('selectedClient', (0, _stringify2.default)(selectedClient));
        console.log('selectedClient set to', selectedClient);
        $rootScope.$broadcast('clientChangeEvent', {
          clientID: selectedClient.id,
          allowOpenBookings: allowOpenBookings,
          ChatAppName: chatAppName
        });
      },
      getSelectedClient: function getSelectedClient() {
        var sc = selectedClient;
        if (sc.id === undefined || sc.name === undefined) {
          if (storage.getItem('selectedClient')) {
            sc = JSON.parse(storage.getItem('selectedClient'));
          }
        }
        return sc;
      },
      getAgencyClients: function getAgencyClients(id) {
        return organizations.getSelectedAgencyClients(id).then(function (response) {
          var allOrganizationInfo = response.data;
          console.log(response.data);
          var allOrganizationMap = allOrganizationInfo.map(function (org) {
            return {
              name: org.Name,
              id: org.Id,
              travelAgencyId: org.TravelAgencyId,
              allowOpenBookings: org.AllowOpenBookings,
              ChatAppName: org.ChatAppName
            };
          }).sort(function (a, b) {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });

          return $q.when(allOrganizationMap);
        });
      },
      clearSelectedClient: function clearSelectedClient() {
        selectedClient.id = undefined;
        selectedClient.name = undefined;
        selectedClient.allowOpenBookings = undefined;
        selectedClient.ChatAppName = undefined;
        storage.removeItem('selectedClient');
        console.log('selectedClient cleared');
      }
    };
  }]);
})();

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('clientSettings', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    return {
      getOrganizationById: function getOrganizationById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlOrganization + '/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      updateOrganization: function updateOrganization(id, organization) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlOrganization + '/' + id;
          return $http.put(url, organization, {
            headers: authHeader
          });
        });
      },
      getWindowsTimeZones: function getWindowsTimeZones() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = '' + obexConstant.urlWindowsTimeZones;
          return $http.get(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(function () {
  'use strict';

  angular.module('obex').factory('conversationService', ['$rootScope', '$http', 'authService', 'obexConstant', function ($rootScope, $http, authService, obexConstant) {
    return {
      getConversation: function getConversation(fromNumber) {
        var loginMember = authService.getLoginMember();
        var url = obexConstant.urlGetConversation + '/fromNumber/' + fromNumber.replace('+', '') + '/travelagentid/' + loginMember.Id;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      updateConversation: function updateConversation(fromNumber, smsStatus) {
        var loginMember = authService.getLoginMember();
        console.log('call authService.getLoginMember() in alert.service ', loginMember);
        return $http.get('/conversation/' + fromNumber + '/' + loginMember.Id + '/' + smsStatus);
      },
      sendAttachment: function sendAttachment(imgOrPdf, chatParam) {
        var fd = new FormData();
        fd.append('image', imgOrPdf);
        fd.append('socketId', chatParam.socketId);
        fd.append('agentId', chatParam.agentId);
        fd.append('agentFirstName', chatParam.agentFirstName);
        fd.append('agentLastName', chatParam.agentLastName);
        fd.append('agentEmail', chatParam.agentEmail);
        fd.append('agentOrganizationId', chatParam.agentOrganizationId);
        fd.append('agencyName', chatParam.agencyName);
        fd.append('smstext', chatParam.smstext);
        fd.append('topic', chatParam.topic);
        fd.append('travelerId', chatParam.travelerId);
        fd.append('travelerNumber', chatParam.travelerNumber);
        fd.append('travelerFirstName', chatParam.travelerFirstName);
        fd.append('travelerLastName', chatParam.travelerLastName);
        fd.append('channel', chatParam.channel);

        return $http.post('/smsImgOrPdf', fd, {
          headers: { 'Content-Type': undefined },
          transformRequest: angular.identity
        });
      },
      getTopic: function getTopic(email) {
        var url = obexConstant.urlGetTopic + '/' + email;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      updateSocketId: function updateSocketId(data) {
        var url = obexConstant.urlGetConversation + '/socketid/' + data.socketId + '/travelagentemail/' + data.email;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.put(url, data, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This factory service is used to transform and return the  currency symbol to UI .
(function () {
  'use strict';

  angular.module('obex').factory('currency', function () {
    return {
      getCurrencySymbol: function getCurrencySymbol(currencySymbol) {
        switch (currencySymbol) {
          case 'USD':
          case 'CAD':
            return '$';
          case 'EUR':
            return ' €';
          case 'GBP':
            return '£';
          case 'CNY':
            return ' ¥';
          default:
            return !!currencySymbol ? currencySymbol : '';
        };
      }
    };
  });
})();

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('customerAccount', ['$http', '$q', 'obexConstant', 'authService', function ($http, $q, obexConstant, authService) {
    return {
      getCustomerAccouts: function getCustomerAccouts() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = '' + obexConstant.urlCustomerAccount;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getCustomerAccoutsById: function getCustomerAccoutsById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlCustomerAccount + '/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getCustomerAccountByOrgId: function getCustomerAccountByOrgId(organizationId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlCustomerAccount + '/organization/' + organizationId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },

      //curd operation
      addCustomerAccount: function addCustomerAccount(customerAccount, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var postData = {
            Id: 0,
            Name: customerAccount.Name,
            Number: customerAccount.Number,
            IsDefaultAccount: customerAccount.IsDefaultAccount,
            OrganizationId: orgId
          };
          return $http.post(obexConstant.urlCustomerAccount, postData, {
            headers: authHeader
          });
        });
      },
      updateCustomerAccount: function updateCustomerAccount(id, customerAccount, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlCustomerAccount + '/' + id;
          var putData = {
            Id: customerAccount.Id,
            Name: customerAccount.Name,
            Number: customerAccount.Number,
            IsDefaultAccount: customerAccount.IsDefaultAccount,
            OrganizationId: orgId
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      deleteCustomerAccount: function deleteCustomerAccount(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlCustomerAccount + '/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
    'use strict';

    angular.module('obex').factory('fileReader', ['$q', '$log', function ($q, log) {
        var onLoad = function onLoad(reader, deferred, scope) {
            return function () {
                scope.$apply(function () {
                    deferred.resolve(reader.result);
                });
            };
        };

        var onError = function onError(reader, deferred, scope) {
            return function () {
                scope.$apply(function () {
                    deferred.reject(reader.result);
                });
            };
        };

        var onProgress = function onProgress(reader, scope) {
            return function (event) {
                scope.$broadcast("fileProgress", {
                    total: event.total,
                    loaded: event.loaded
                });
            };
        };

        var getReader = function getReader(deferred, scope) {
            var reader = new FileReader();
            reader.onload = onLoad(reader, deferred, scope);
            reader.onerror = onError(reader, deferred, scope);
            reader.onprogress = onProgress(reader, scope);
            return reader;
        };

        var readAsDataURL = function readAsDataURL(file, scope) {
            var deferred = $q.defer();

            var reader = getReader(deferred, scope);
            reader.readAsDataURL(file);

            return deferred.promise;
        };

        var readAsText = function readAsText(file, scope) {
            var deferred = $q.defer();
            var reader = getReader(deferred, scope);
            reader.readAsText(file);
            return deferred.promise;
        };

        return {
            readAsDataUrl: readAsDataURL,
            readAsText: readAsText
        };
    }]);
})();

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('gdsSettings', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    return {
      getGdsSettingsByAgencyId: function getGdsSettingsByAgencyId(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlGdsSettingsV2 + '/organization/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getGdsSettingById: function getGdsSettingById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlGdsSettings + '/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      addGdsSetting: function addGdsSetting(gdsSetting, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.post(obexConstant.urlGdsSettings, gdsSetting, {
            headers: authHeader
          });
        });
      },
      updateGdsSetting: function updateGdsSetting(id, gdsSetting) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlGdsSettings + '/' + id;
          return $http.put(url, gdsSetting, {
            headers: authHeader
          });
        });
      },
      deleteGdsSetting: function deleteGdsSetting(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlGdsSettings + '/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(function () {
  'use strict';

  angular.module('obex').factory('handledConversationService', ['$rootScope', '$http', 'authService', function ($rootScope, $http, authService) {
    return {
      getHandlingData: function getHandlingData(fromNumber) {
        var loginMember = authService.getLoginMember();
        console.log('call authService.getLoginMember() in alert.service ', loginMember);
        return $http.get('/handledConversation/' + fromNumber + '/' + loginMember.Id);
      }
    };
  }]);
})();

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('historySms', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    return {
      getConversations: function getConversations(startDate, endDate, orgId) {
        var url = obexConstant.urlSmsHistory + '/admin/organization/' + orgId + '/' + startDate + '/' + endDate;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },

      /*getConversationsByStatus(startDate, endDate, orgId, statusId) {
          const url = `${obexConstant.urlSmsHistory}/admin/organization/${orgId}/${startDate}/${endDate}/${statusId}`;
          return authService.getAuthorizationHeader().then(authHeader =>
            $http.get(url, {
              headers: authHeader,
            }));            
        },*/
      getDetailedConversation: function getDetailedConversation(conversation) {
        var url = obexConstant.urlSmsHistory + '/admin/conversation/' + conversation;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getConversationsByAgentIdByStatus: function getConversationsByAgentIdByStatus(agentId, conversationStatus) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlSmsHistory + '/admin/agent/' + agentId + '/' + conversationStatus;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      updateConversationsStatusByConversation: function updateConversationsStatusByConversation(conversationKey, status) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlSmsHistory + '/admin/setstatus/' + conversationKey + '/' + status;
          return $http.put(url, null, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('members', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    var showAll = false;
    return {
      setShowAll: function setShowAll(showAllAgents) {
        showAll = showAllAgents;
      },
      getShowAll: function getShowAll() {
        return showAll;
      },
      getMembersByAdmin: function getMembersByAdmin() {
        var includeAllMembers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var url = obexConstant.urlAccount + '/admin/' + includeAllMembers;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getTravelManagers: function getTravelManagers(organizationId) {
        var url = obexConstant.urlTravelManagerOrganizations + '/members/travelmanagers/organization/' + organizationId;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getMembers: function getMembers() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(obexConstant.urlAccount, {
            headers: authHeader
          });
        });
      },
      getAllAgentsByAdmin: function getAllAgentsByAdmin(travelAgencyId) {
        var url = obexConstant.urlBaseUrl + 'v2/members/admin/travelagencyid/' + travelAgencyId + '/true';
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      gerMemberAccount: function gerMemberAccount(email) {
        var url = obexConstant.urlAccount + '/email/' + email;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      changePassword: function changePassword(id, member) {
        var url = obexConstant.urlAccount + '/changepassword/' + id;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.put(url, member, {
            headers: authHeader
          });
        });
      },
      getMemberById: function getMemberById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAccount + '/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getMembersByOrgId: function getMembersByOrgId(orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAccount + '/supportedusers/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      deleteAccount: function deleteAccount(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAccount + '/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      },
      setAdmin: function setAdmin(id, isAdmin) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAccount + '/setadmin/' + id + '/' + isAdmin;
          return $http.put(url, null, {
            headers: authHeader
          });
        });
      },
      setEnableDisableAccount: function setEnableDisableAccount(id, enable) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAccount + '/enableAccount/' + id;
          return $http.put(url, null, {
            headers: authHeader
          });
        });
      },
      updateName: function updateName(id, member) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAccount + '/updatename/' + id;
          var putData = {
            Id: member.Id,
            FirstName: member.FirstName,
            LastName: member.LastName
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      saveAgent: function saveAgent(member) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = '' + obexConstant.urlAccount;
          return $http.post(url, member, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Maintain and distribute overarching organization filter data
(function () {
  'use strict';

  angular.module('obex').factory('myAgencyService', ['$q', '$window', 'organizations', 'authService', function ($q, $window, organizations, authService) {
    return {
      getAgency: function getAgency(orgId) {
        return organizations.getOrganizationById(orgId).then(function (response) {
          return response.data;
        });
      }
    };
  }]);
})();

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services
(function () {
  'use strict';

  angular.module('obex').factory('organizationProviders', ['$http', '$q', 'obexConstant', 'authService', function ($http, $q, obexConstant, authService) {
    return {
      getOrganizationProvidersByOrganizationId: function getOrganizationProvidersByOrganizationId(organizationId) {
        var url = obexConstant.urlOrganizationProviders + '/admin/organization/' + organizationId;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      addOrganizationProviders: function addOrganizationProviders(organizationProvidersList) {
        var promises = _.map(organizationProvidersList, function (organizationProvider) {
          return authService.getAuthorizationHeader().then(function (authHeader) {
            var url = '' + obexConstant.urlOrganizationProviders;
            var postData = {
              Id: 0,
              OrganizationId: organizationProvider.OrganizationId,
              ProviderId: organizationProvider.ProviderId
            };
            return $http.post(url, postData, {
              headers: authHeader
            });
          });
        });
        return $q.all(promises);
      },
      deleteOrganizationProviders: function deleteOrganizationProviders(organizationProvidersList) {
        var promises = _.map(organizationProvidersList, function (organizationProvider) {
          return authService.getAuthorizationHeader().then(function (authHeader) {
            var url = obexConstant.urlOrganizationProviders + '/' + organizationProvider.Id;
            return $http.delete(url, {
              headers: authHeader
            });
          });
        });
        return $q.all(promises);
      }
    };
  }]);
})();

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('organizations', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    var showAll = false;
    return {
      setShowAll: function setShowAll(showAllClients) {
        showAll = showAllClients;
      },
      getShowAll: function getShowAll() {
        return showAll;
      },
      addOrganization: function addOrganization(organization) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var postData = {
            Id: organization.Id,
            Name: organization.Name,
            AddressLine1: organization.AddressLine1,
            AddressLine2: organization.AddressLine2,
            City: organization.City,
            PostalCode: organization.PostalCode,
            Country: organization.Country,
            StateProv: organization.StateProv,
            IsTravelAgency: organization.IsTravelAgency,
            TravelAgencyId: organization.TravelAgencyId,
            AllowOpenBookings: organization.AllowOpenBookings,
            AllowFbChat: organization.AllowFbChat,
            BookingToolName: organization.BookingToolName,
            Domains: organization.Domains,
            TripLinkAccounts: organization.TripLinkAccounts,
            AcceptEmails: organization.AcceptEmails,
            WebSite: organization.WebSite,
            LogoImageLink: organization.LogoImageLink
          };
          return $http.post(obexConstant.urlOrganization, postData, {
            headers: authHeader
          });
        });
      },
      getOrganizations: function getOrganizations() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(obexConstant.urlOrganization, {
            headers: authHeader
          });
        });
      },
      getOrganizationById: function getOrganizationById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlOrganization + '/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getClients: function getClients() {
        var includeAllClients = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var url = obexConstant.urlClients + '/' + (includeAllClients === true ? 'true' : 'false');
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getAgencies: function getAgencies() {
        var includeAllAgencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var url = includeAllAgencies === true ? obexConstant.urlAgencies + '/' + includeAllAgencies : obexConstant.urlAgencies;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getSelectedAgencyClients: function getSelectedAgencyClients(travelAgency) {
        var includeAllClients = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var url = obexConstant.urlAgenciesClients + '/' + travelAgency + '/';
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      updateOrganization: function updateOrganization(id, organization) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlOrganization + '/' + id;
          var putData = {
            Id: organization.Id,
            Name: organization.Name,
            AddressLine1: organization.AddressLine1,
            AddressLine2: organization.AddressLine2,
            City: organization.City,
            PostalCode: organization.PostalCode,
            Country: organization.Country,
            StateProv: organization.StateProv,
            IsTravelAgency: organization.IsTravelAgency,
            Inactive: organization.Inactive,
            TravelAgencyId: organization.TravelAgencyId,
            AllowOpenBookings: organization.AllowOpenBookings,
            AllowFbChat: organization.AllowFbChat,
            BookingToolName: organization.BookingToolName,
            Domains: organization.Domains,
            TripLinkAccounts: organization.TripLinkAccounts,
            AcceptEmails: organization.AcceptEmails,
            WebSite: organization.WebSite,
            LogoImageLink: organization.LogoImageLink,
            TravelAgencyPhone: organization.TravelAgencyPhone
          };
          if (organization.TravelAgencyAfterHoursPhone !== null) {
            putData["TravelAgencyAfterHoursPhone"] = organization.TravelAgencyAfterHoursPhone;
          }
          if (organization.TravelAgencyInternationalPhone !== null) {
            putData["TravelAgencyInternationalPhone"] = organization.TravelAgencyInternationalPhone;
          }
          if (organization.TravelAgencyEmail !== null) {
            putData["TravelAgencyEmail"] = organization.TravelAgencyEmail;
          }
          if (organization.TravelAgencyStartRegularHours !== null) {
            putData["TravelAgencyStartRegularHours"] = organization.TravelAgencyStartRegularHours;
          }
          if (organization.TravelAgencyEndRegularHours !== null) {
            putData["TravelAgencyEndRegularHours"] = organization.TravelAgencyEndRegularHours;
          }
          if (organization.TravelAgencyWindowsTimeZoneId !== null) {
            putData["TravelAgencyWindowsTimeZoneId"] = organization.TravelAgencyWindowsTimeZoneId;
          }
          if (organization.TravelAgencyServiceStartDay !== null) {
            putData["TravelAgencyServiceStartDay"] = organization.TravelAgencyServiceStartDay;
          }
          if (organization.TravelAgencyServiceEndDay !== null) {
            putData["TravelAgencyServiceEndDay"] = organization.TravelAgencyServiceEndDay;
          }
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      deleteOrganization: function deleteOrganization(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlOrganization + '/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      },
      getCountries: function getCountries() {
        return $http.get('/js/content/countryData.json');
      },
      getStates: function getStates() {
        return $http.get('/js/content/stateData.json');
      }
    };
  }]);
})();

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(24);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Maintain and distribute overarching organization filter data
(function () {
  'use strict';

  angular.module('obex').factory('orgFilterService', ['$q', '$window', 'organizations', 'authService', function ($q, $window, organizations, authService) {
    var storage = $window.localStorage;
    var filtered_organization = {};
    return {
      getSupportsOrganizationMap: function getSupportsOrganizationMap() {
        var member = authService.getLoginMember();
        var supportsOrganizationInfo = member.SupportsOrganizations.concat(member.Organization);
        var supportsOrganizationMap = supportsOrganizationInfo.map(function (org) {
          return {
            name: org.Name,
            id: org.Id
          };
        });
        console.log('Got Supports Organization Map');
        return supportsOrganizationMap;
      },
      getAllOrganizationMap: function getAllOrganizationMap() {
        // For Obex admin
        return organizations.getOrganizations().then(function (response) {
          var allOrganizationInfo = response.data;
          var allOrganizationMap = allOrganizationInfo.map(function (org) {
            return {
              name: org.Name,
              id: org.Id
            };
          });
          console.log('Got All Organization Map');
          return $q.when(allOrganizationMap);
        });
      },
      setFilteredOrganization: function setFilteredOrganization(id, name) {
        filtered_organization.id = id;
        filtered_organization.name = name;
        storage.setItem('filter', (0, _stringify2.default)(filtered_organization));
        console.log('Filtered organization set to', filtered_organization);
        //console.log('localStorage set to ', JSON.parse(storage.getItem('filter')));
      },
      getFilteredOrganization: function getFilteredOrganization() {
        var filtered = filtered_organization;
        if (filtered.id === undefined || filtered.name === undefined) {
          if (storage.getItem('filter')) {
            filtered = JSON.parse(storage.getItem('filter'));
          }
        }
        //console.log('Get Filtered Organization', filtered);
        return filtered;
      },
      clearFilteredOrganization: function clearFilteredOrganization() {
        filtered_organization.id = undefined;
        filtered_organization.name = undefined;
        storage.removeItem('filter');
        console.log('Filtered organization cleared');
      }
    };
  }]);
})();

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('historyPhone', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    return {
      getPhoneLogsForAllMember: function getPhoneLogsForAllMember(startDate, endDate) {
        var url = obexConstant.urlPhoneHistory + '/admin/' + startDate + '/' + endDate;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getPhoneLogsForMember: function getPhoneLogsForMember(memberId, startDate, endDate) {
        var url = obexConstant.urlPhoneHistory + '/admin/member/' + memberId + '/' + startDate + '/' + endDate;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getPhoneLogDetailsForFlight: function getPhoneLogDetailsForFlight(flightId) {
        var url = obexConstant.urlPhoneHistory + '/admin/flight/' + flightId;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getPhoneLogDetailsForCar: function getPhoneLogDetailsForCar(carId) {
        var url = obexConstant.urlPhoneHistory + '/admin/car/' + carId;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getPhoneLogDetailsForHotel: function getPhoneLogDetailsForHotel(hotelId) {
        var url = obexConstant.urlPhoneHistory + '/admin/hotel/' + hotelId;
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for pnr related functionality
(function () {
  'use strict';

  angular.module('obex').factory('pnr', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    return {
      processingPnr: function processingPnr(pnrs) {
        var pnrObj = { "pnrs": pnrs };
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlProcessPnr + '/gdssettingid/1';
          console.log("process pnr: ", url, pnrObj);
          return $http.post(url, pnrObj, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('profileFieldService', ['$http', '$q', 'obexConstant', 'authService', function ($http, $q, obexConstant, authService) {
    return {
      addProfileField: function addProfileField(profileField) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var postData = {
            OrganizationId: profileField.OrganizationId,
            Column: parseInt(profileField.ProfileColumn),
            Name: profileField.GdsFieldName,
            AgencyDefinition: profileField.ProfileFieldName,
            IsRequired: profileField.IsRequired
          };
          var url = '' + obexConstant.urlProfileFields;
          return $http.post(url, postData, {
            headers: authHeader
          });
        });
      },
      addProfileFieldOption: function addProfileFieldOption(profileFieldId, profileFieldOptionList) {
        var promises = _.map(profileFieldOptionList, function (profileFieldOption) {
          return authService.getAuthorizationHeader().then(function (authHeader) {
            var url = '' + obexConstant.urlProfileFieldOptions;
            var postData = {
              Id: profileFieldOptionList.Id,
              Name: profileFieldOption.Name,
              profileFieldId: profileFieldId
            };
            return $http.post(url, postData, {
              headers: authHeader
            });
          });
        });
        return $q.all(promises);
      },
      // Defaults to get all profile fields when orgId is undefined

      getProfileFieldsByOrgId: function getProfileFieldsByOrgId(orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlProfileFields + '/organization/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      updateProfileField: function updateProfileField(newProfileField) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var id = newProfileField.Id;
          var putData = {
            Id: id,
            OrganizationId: newProfileField.OrganizationId,
            Name: newProfileField.GdsFieldName,
            AgencyDefinition: newProfileField.ProfileFieldName,
            Column: newProfileField.ProfileColumn,
            IsRequired: newProfileField.IsRequired
          };
          var url = obexConstant.urlProfileFields + '/' + id;
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      updateProfileFieldOption: function updateProfileFieldOption(id, ProfileFieldOptionList) {
        var promises = _.map(ProfileFieldOptionList, function (profileFieldOption) {
          return authService.getAuthorizationHeader().then(function (authHeader) {
            if (!!profileFieldOption.Id) {
              var url = obexConstant.urlProfileFieldOptions + '/' + profileFieldOption.Id;
              var putData = {
                Id: profileFieldOption.Id,
                Name: profileFieldOption.Name,
                ProfileFieldId: profileFieldOption.ProfileFieldId
              };
              return $http.put(url, putData, {
                headers: authHeader
              });
            } else {
              var _url = '' + obexConstant.urlProfileFieldOptions;
              var postData = {
                Id: profileFieldOption.Id,
                Name: profileFieldOption.Name,
                ProfileFieldId: profileFieldOption.ProfileFieldId
              };
              return $http.post(_url, postData, {
                headers: authHeader
              });
            }
          });
        });
        return $q.all(promises);
      },
      deleteProfileField: function deleteProfileField(fieldId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlProfileFields + '/' + fieldId;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      },
      deleteProfileFieldOption: function deleteProfileFieldOption(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlProfileFieldOptions + '/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage progressBar services.
(function () {
  'use strict';

  angular.module('obex').service('progressBar', ['ngProgressFactory', function (ngProgressFactory) {
    var progressBar = ngProgressFactory.createInstance();
    return {
      getProgressBar: function getProgressBar() {
        return progressBar;
      }
    };
  }]);
})();

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('providers', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    return {
      addProvider: function addProvider(provider) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var postData = {
            Id: provider.Id,
            Name: provider.Name,
            Code: provider.Code,
            IATACode: provider.IATACode,
            LoginTitle: provider.LoginTitle,
            ImageLink: provider.ImageLink,
            Login2Code: provider.Login2Code,
            Login2Title: provider.Login2Title,
            Login3Code: provider.Login3Code,
            Login3Title: provider.Login3Title,
            ProviderType: provider.ProviderType
          };
          return $http.post(obexConstant.urlProvider, postData, {
            headers: authHeader
          });
        });
      },
      getProviders: function getProviders() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(obexConstant.urlProvider, {
            headers: authHeader
          });
        });
      },
      getProvidersByAdmin: function getProvidersByAdmin() {
        var url = obexConstant.urlProvider + '/admin/';
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getProviderById: function getProviderById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlProvider + '/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      updateProvider: function updateProvider(id, provider) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlProvider + '/' + id;
          var putData = {
            Id: provider.Id,
            Name: provider.Name,
            Code: provider.Code,
            IATACode: provider.IATACode,
            LoginTitle: provider.LoginTitle,
            ImageLink: provider.ImageLink,
            Login2Code: provider.Login2Code,
            Login2Title: provider.Login2Title,
            Login3Code: provider.Login3Code,
            Login3Title: provider.Login3Title,
            ProviderType: provider.ProviderType
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      deleteProvider: function deleteProvider(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlProvider + '/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      },

      // Send raw image to node backend for uploading and processing
      uploadImage: function uploadImage(img) {
        return authService.getAuthorizationHeader().then(function (_ref) {
          var Authorization = _ref.Authorization;

          var fd = new FormData();
          fd.append('image', img);
          return $http.post('/provider/img', fd, {
            headers: {
              'Content-Type': undefined,
              Authorization: Authorization
            },
            transformRequest: angular.identity
          });
        });
      },

      // Send raw image to node backend for uploading and processing
      deleteImage: function deleteImage(img) {
        var postData = { id: img };
        return $http({
          method: 'DELETE',
          url: '/provider/img',
          data: postData,
          headers: { 'Content-Type': 'application/json;charset=utf-8' }
        });
      },

      // Retrieve url for a transformed image
      transformImage: function transformImage(filename) {
        var postData = { id: filename };
        return $http.post('/provider/img/transform', postData);
      }
    };
  }]);
})();

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  'use strict';

  var Push = __webpack_require__(209); // Common.js

  angular.module('obex').factory('pushService', ['$http', '$q', '$window', 'obexConstant', function ($http, $q, $window, obexConstant) {
    return Push;
  }]);
})();

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * @license
 *
 * Push v1.0.9
 * =========
 * A compact, cross-browser solution for the JavaScript Notifications API
 *
 * Credits
 * -------
 * Tsvetan Tsvetkov (ttsvetko)
 * Alex Gibson (alexgibson)
 *
 * License
 * -------
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015-2017 Tyler Nickerson
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
!function(i,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(i=i||self).Push=t()}(this,function(){"use strict";var i={errors:{incompatible:"".concat("PushError:"," Push.js is incompatible with browser."),invalid_plugin:"".concat("PushError:"," plugin class missing from plugin manifest (invalid plugin). Please check the documentation."),invalid_title:"".concat("PushError:"," title of notification must be a string"),permission_denied:"".concat("PushError:"," permission request declined"),sw_notification_error:"".concat("PushError:"," could not show a ServiceWorker notification due to the following reason: "),sw_registration_error:"".concat("PushError:"," could not register the ServiceWorker due to the following reason: "),unknown_interface:"".concat("PushError:"," unable to create notification: unknown interface")}};function t(i){return(t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(i){return typeof i}:function(i){return i&&"function"==typeof Symbol&&i.constructor===Symbol&&i!==Symbol.prototype?"symbol":typeof i})(i)}function n(i,t){if(!(i instanceof t))throw new TypeError("Cannot call a class as a function")}function e(i,t){for(var n=0;n<t.length;n++){var e=t[n];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(i,e.key,e)}}function o(i,t,n){return t&&e(i.prototype,t),n&&e(i,n),i}function r(i,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");i.prototype=Object.create(t&&t.prototype,{constructor:{value:i,writable:!0,configurable:!0}}),t&&c(i,t)}function s(i){return(s=Object.setPrototypeOf?Object.getPrototypeOf:function(i){return i.__proto__||Object.getPrototypeOf(i)})(i)}function c(i,t){return(c=Object.setPrototypeOf||function(i,t){return i.__proto__=t,i})(i,t)}function a(i,t){return!t||"object"!=typeof t&&"function"!=typeof t?function(i){if(void 0===i)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return i}(i):t}var u=function(){function i(t){n(this,i),this._win=t,this.GRANTED="granted",this.DEFAULT="default",this.DENIED="denied",this._permissions=[this.GRANTED,this.DEFAULT,this.DENIED]}return o(i,[{key:"request",value:function(i,t){return arguments.length>0?this._requestWithCallback.apply(this,arguments):this._requestAsPromise()}},{key:"_requestWithCallback",value:function(i,t){var n,e=this,o=this.get(),r=!1,s=function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:e._win.Notification.permission;r||(r=!0,void 0===n&&e._win.webkitNotifications&&(n=e._win.webkitNotifications.checkPermission()),n===e.GRANTED||0===n?i&&i():t&&t())};o!==this.DEFAULT?s(o):this._win.webkitNotifications&&this._win.webkitNotifications.checkPermission?this._win.webkitNotifications.requestPermission(s):this._win.Notification&&this._win.Notification.requestPermission?(n=this._win.Notification.requestPermission(s))&&n.then&&n.then(s).catch(function(){t&&t()}):i&&i()}},{key:"_requestAsPromise",value:function(){var i=this,t=this.get(),n=t!==this.DEFAULT,e=this._win.Notification&&this._win.Notification.requestPermission,o=this._win.webkitNotifications&&this._win.webkitNotifications.checkPermission;return new Promise(function(r,s){var c,a=!1,u=function(t){a||(a=!0,!function(t){return t===i.GRANTED||0===t}(t)?s():r())};n?u(t):o?i._win.webkitNotifications.requestPermission(function(i){u(i)}):e?(c=i._win.Notification.requestPermission(u))&&c.then&&c.then(u).catch(s):r()})}},{key:"has",value:function(){return this.get()===this.GRANTED}},{key:"get",value:function(){return this._win.Notification&&this._win.Notification.permission?this._win.Notification.permission:this._win.webkitNotifications&&this._win.webkitNotifications.checkPermission?this._permissions[this._win.webkitNotifications.checkPermission()]:navigator.mozNotification?this.GRANTED:this._win.external&&this._win.external.msIsSiteMode?this._win.external.msIsSiteMode()?this.GRANTED:this.DEFAULT:this.GRANTED}}]),i}(),f=function(){function i(){n(this,i)}return o(i,null,[{key:"isUndefined",value:function(i){return void 0===i}},{key:"isNull",value:function(i){return null===obj}},{key:"isString",value:function(i){return"string"==typeof i}},{key:"isFunction",value:function(i){return i&&"[object Function]"==={}.toString.call(i)}},{key:"isObject",value:function(i){return"object"===t(i)}},{key:"objectMerge",value:function(i,t){for(var n in t)i.hasOwnProperty(n)&&this.isObject(i[n])&&this.isObject(t[n])?this.objectMerge(i[n],t[n]):i[n]=t[n]}}]),i}(),l=function i(t){n(this,i),this._win=t},h=function(i){function t(){return n(this,t),a(this,s(t).apply(this,arguments))}return r(t,l),o(t,[{key:"isSupported",value:function(){return void 0!==this._win.Notification}},{key:"create",value:function(i,t){return new this._win.Notification(i,{icon:f.isString(t.icon)||f.isUndefined(t.icon)||f.isNull(t.icon)?t.icon:t.icon.x32,body:t.body,tag:t.tag,requireInteraction:t.requireInteraction})}},{key:"close",value:function(i){i.close()}}]),t}(),_=function(t){function e(){return n(this,e),a(this,s(e).apply(this,arguments))}return r(e,l),o(e,[{key:"isSupported",value:function(){return void 0!==this._win.navigator&&void 0!==this._win.navigator.serviceWorker}},{key:"getFunctionBody",value:function(i){var t=i.toString().match(/function[^{]+{([\s\S]*)}$/);return null!=t&&t.length>1?t[1]:null}},{key:"create",value:function(t,n,e,o,r){var s=this;this._win.navigator.serviceWorker.register(o),this._win.navigator.serviceWorker.ready.then(function(o){var c={id:t,link:e.link,origin:document.location.href,onClick:f.isFunction(e.onClick)?s.getFunctionBody(e.onClick):"",onClose:f.isFunction(e.onClose)?s.getFunctionBody(e.onClose):""};void 0!==e.data&&null!==e.data&&(c=Object.assign(c,e.data)),o.showNotification(n,{icon:e.icon,body:e.body,vibrate:e.vibrate,tag:e.tag,data:c,requireInteraction:e.requireInteraction,silent:e.silent}).then(function(){o.getNotifications().then(function(i){o.active.postMessage(""),r(i)})}).catch(function(t){throw new Error(i.errors.sw_notification_error+t.message)})}).catch(function(t){throw new Error(i.errors.sw_registration_error+t.message)})}},{key:"close",value:function(){}}]),e}(),v=function(i){function t(){return n(this,t),a(this,s(t).apply(this,arguments))}return r(t,l),o(t,[{key:"isSupported",value:function(){return void 0!==this._win.navigator.mozNotification}},{key:"create",value:function(i,t){var n=this._win.navigator.mozNotification.createNotification(i,t.body,t.icon);return n.show(),n}}]),t}(),d=function(i){function t(){return n(this,t),a(this,s(t).apply(this,arguments))}return r(t,l),o(t,[{key:"isSupported",value:function(){return void 0!==this._win.external&&void 0!==this._win.external.msIsSiteMode}},{key:"create",value:function(i,t){return this._win.external.msSiteModeClearIconOverlay(),this._win.external.msSiteModeSetIconOverlay(f.isString(t.icon)||f.isUndefined(t.icon)?t.icon:t.icon.x16,i),this._win.external.msSiteModeActivate(),null}},{key:"close",value:function(){this._win.external.msSiteModeClearIconOverlay()}}]),t}(),w=function(i){function t(){return n(this,t),a(this,s(t).apply(this,arguments))}return r(t,l),o(t,[{key:"isSupported",value:function(){return void 0!==this._win.webkitNotifications}},{key:"create",value:function(i,t){var n=this._win.webkitNotifications.createNotification(t.icon,i,t.body);return n.show(),n}},{key:"close",value:function(i){i.cancel()}}]),t}();return new(function(){function t(i){n(this,t),this._currentId=0,this._notifications={},this._win=i,this.Permission=new u(i),this._agents={desktop:new h(i),chrome:new _(i),firefox:new v(i),ms:new d(i),webkit:new w(i)},this._configuration={serviceWorker:"/serviceWorker.min.js",fallback:function(i){}}}return o(t,[{key:"_closeNotification",value:function(t){var n=!0,e=this._notifications[t];if(void 0!==e){if(n=this._removeNotification(t),this._agents.desktop.isSupported())this._agents.desktop.close(e);else if(this._agents.webkit.isSupported())this._agents.webkit.close(e);else{if(!this._agents.ms.isSupported())throw n=!1,new Error(i.errors.unknown_interface);this._agents.ms.close()}return n}return!1}},{key:"_addNotification",value:function(i){var t=this._currentId;return this._notifications[t]=i,this._currentId++,t}},{key:"_removeNotification",value:function(i){var t=!1;return this._notifications.hasOwnProperty(i)&&(delete this._notifications[i],t=!0),t}},{key:"_prepareNotification",value:function(i,t){var n,e=this;return n={get:function(){return e._notifications[i]},close:function(){e._closeNotification(i)}},t.timeout&&setTimeout(function(){n.close()},t.timeout),n}},{key:"_serviceWorkerCallback",value:function(i,t,n){var e=this,o=this._addNotification(i[i.length-1]);navigator&&navigator.serviceWorker&&(navigator.serviceWorker.addEventListener("message",function(i){var t=JSON.parse(i.data);"close"===t.action&&Number.isInteger(t.id)&&e._removeNotification(t.id)}),n(this._prepareNotification(o,t))),n(null)}},{key:"_createCallback",value:function(i,t,n){var e,o=this,r=null;if(t=t||{},e=function(i){o._removeNotification(i),f.isFunction(t.onClose)&&t.onClose.call(o,r)},this._agents.desktop.isSupported())try{r=this._agents.desktop.create(i,t)}catch(e){var s=this._currentId,c=this.config().serviceWorker;this._agents.chrome.isSupported()&&this._agents.chrome.create(s,i,t,c,function(i){return o._serviceWorkerCallback(i,t,n)})}else this._agents.webkit.isSupported()?r=this._agents.webkit.create(i,t):this._agents.firefox.isSupported()?this._agents.firefox.create(i,t):this._agents.ms.isSupported()?r=this._agents.ms.create(i,t):(t.title=i,this.config().fallback(t));if(null!==r){var a=this._addNotification(r),u=this._prepareNotification(a,t);f.isFunction(t.onShow)&&r.addEventListener("show",t.onShow),f.isFunction(t.onError)&&r.addEventListener("error",t.onError),f.isFunction(t.onClick)&&r.addEventListener("click",t.onClick),r.addEventListener("close",function(){e(a)}),r.addEventListener("cancel",function(){e(a)}),n(u)}n(null)}},{key:"create",value:function(t,n){var e,o=this;if(!f.isString(t))throw new Error(i.errors.invalid_title);return e=this.Permission.has()?function(i,e){try{o._createCallback(t,n,i)}catch(i){e(i)}}:function(e,r){o.Permission.request().then(function(){o._createCallback(t,n,e)}).catch(function(){r(i.errors.permission_denied)})},new Promise(e)}},{key:"count",value:function(){var i,t=0;for(i in this._notifications)this._notifications.hasOwnProperty(i)&&t++;return t}},{key:"close",value:function(i){var t;for(t in this._notifications)if(this._notifications.hasOwnProperty(t)&&this._notifications[t].tag===i)return this._closeNotification(t)}},{key:"clear",value:function(){var i,t=!0;for(i in this._notifications)this._notifications.hasOwnProperty(i)&&(t=t&&this._closeNotification(i));return t}},{key:"supported",value:function(){var i=!1;for(var t in this._agents)this._agents.hasOwnProperty(t)&&(i=i||this._agents[t].isSupported());return i}},{key:"config",value:function(i){return(void 0!==i||null!==i&&f.isObject(i))&&f.objectMerge(this._configuration,i),this._configuration}},{key:"extend",value:function(t){var n,e={}.hasOwnProperty;if(!e.call(t,"plugin"))throw new Error(i.errors.invalid_plugin);for(var o in e.call(t,"config")&&f.isObject(t.config)&&null!==t.config&&this.config(t.config),n=new(0,t.plugin)(this.config()))e.call(n,o)&&f.isFunction(n[o])&&(this[o]=n[o])}}]),t}())("undefined"!=typeof window?window:global)});
//# sourceMappingURL=push.min.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(210)))

/***/ }),
/* 210 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('report', ['$http', '$q', 'obexConstant', 'authService', function ($http, $q, obexConstant, authService) {
    return {
      getAirActivity: function getAirActivity(startDate, endDate, organizationId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlFlights + '/admin/' + startDate + '/' + endDate + '/' + organizationId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getProfiles: function getProfiles(organizationId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlProfiles + '/organization/' + organizationId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getHotelActivity: function getHotelActivity(startDate, endDate, organizationId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlHotels + '/admin/' + startDate + '/' + endDate + '/' + organizationId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getCarActivity: function getCarActivity(startDate, endDate, organizationId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlCars + '/admin/' + startDate + '/' + endDate + '/' + organizationId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getActiveUser: function getActiveUser() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = '' + obexConstant.urlAccount;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getBookingActiveUser: function getBookingActiveUser() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = '' + obexConstant.urlAccount;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getSMSActivity: function getSMSActivity(startDate, endDate) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlSmsHistory + '/admin/' + startDate + '/' + endDate;
          return $http.get(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('singleSignOn', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    return {
      getSingleSignOnByOrganizationId: function getSingleSignOnByOrganizationId(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlSingleSignOn + '/organization/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      updateSingleSignOn: function updateSingleSignOn(id, singleSignOn) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlSingleSignOn + '/organization/id/' + id;
          return $http.put(url, singleSignOn, {
            headers: authHeader
          });
        });
      },
      addSingleSignOn: function addSingleSignOn(singleSignOn, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var postData = {
            Id: 0,
            IdPURL: singleSignOn.IdPURL,
            Cert: singleSignOn.Cert,
            Code: singleSignOn.Code,
            OrganizationId: orgId
          };
          return $http.post(obexConstant.urlSingleSignOn, postData, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  'use strict';

  angular.module('obex').factory('smsHistory', ['$rootScope', 'tripsDashBoard', 'currency', function ($rootScope, tripsDashBoard, currency) {
    $rootScope.smsHistory = {};
    return {
      addSmsMessage: function addSmsMessage(number, sms) {
        var smsMessages = $rootScope.smsHistory[number];
        if (smsMessages === undefined) {
          $rootScope.smsHistory[number] = [];
        }

        $rootScope.smsHistory[number].push(sms);
      },

      retrieveSmsMessages: function retrieveSmsMessages(number) {
        return $rootScope.smsHistory[number];
      }

    };
  }]);
})();

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(function () {
  'use strict';

  angular.module('obex').factory('socket', ['$rootScope', function ($rootScope) {
    var socketIo = io();
    return {
      //on: function(event, callback) {
      on: function on(event, callback) {
        socketIo.on(event, callback);
      },

      emit: function emit(eventName, data, callback) {
        socketIo.emit(eventName, data, function () {
          var args = arguments;
          if (callback) {
            callback.apply(socketIo, args);
          }
        });
      },

      join: function join(room) {
        socketIo.join(room);
      },

      sendClientConnect: function sendClientConnect(socketId, loginMember) {
        var space = '  ';
        socketIo.emit('client connect', {
          socketId: socketId,
          loginMember: loginMember
        });
      },

      sendClientDisconnect: function sendClientDisconnect(socketId, loginMember) {
        var space = '  ';
        socketIo.emit('client logout', {
          socketId: socketId,
          loginMember: loginMember,
          data: loginMember
        });
      }
    };
  }]);
})();

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(function () {
  'use strict';

  angular.module('obex').factory('socketEvent', ['$rootScope', 'socket', 'socketLogin', 'alertService', function ($rootScope, socket, socketLogin, alertService) {
    var _socketId = null;
    var _timeConnected = null;
    socket.on('my socketId', function (data) {
      console.log('socket id, time connected ', data.socketId, data.timeConnected);
      socketLogin.setSocketIdAndSend(data.socketId);
    });

    socket.on('unhandledIncomingText', function (data) {
      console.log('unhandledIncomingText', data);
      $rootScope.$broadcast('updateAlerts', data);
      $rootScope.$broadcast('updateAlertCount', data);
      $rootScope.$broadcast('notifyDesktop', data);
    });

    socket.on('incomingText', function (data) {
      console.log('incomingText', data);
      $rootScope.$broadcast('incomingText', data);
    });

    socket.on('outgoingText', function (data) {
      console.log('outgoingText', data);
      $rootScope.$broadcast('outgoingText', data);
    });

    socket.on('updateAlertCount', function () {
      console.log('updateAlertCount');
      $rootScope.$broadcast('updateAlerts');
      $rootScope.$broadcast('updateAlertCount');
    });

    socket.on('unhandledIncomingVoice', function (data) {
      console.log('unhandledIncomingVoice', data);
      $rootScope.$broadcast('updateAlertsVoice', data);
      $rootScope.$broadcast('updateAlertCountVoice', data);
    });

    socket.on('updateAlertCountVoice', function () {
      console.log('updateAlertCountVoice');
      //\\$rootScope.$broadcast('updateAlerts');
      $rootScope.$broadcast('updateAlertCountVoice');
    });

    return {};
  }]);
})();

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(function () {
  'use strict';

  angular.module('obex').factory('socketLogin', ['$rootScope', 'socket', function ($rootScope, socket) {
    var _socketId = null;
    var _loginMember = null;
    return {
      setSocketIdAndSend: function setSocketIdAndSend(socketId) {
        // _socketId && _socketId.length
        //   ? socket.sendClientDisconnect(socketId)
        //   : ''
        console.log('old socketID', _socketId);
        _socketId = socketId;
        if (_loginMember) {
          var space = '  ';
          socket.sendClientConnect(_socketId, _loginMember);
        }
      },
      setLoginMemberAndSend: function setLoginMemberAndSend(loginMember) {
        _loginMember = loginMember;
        if (_socketId) {
          socket.sendClientConnect(_socketId, _loginMember);
        }
      },
      getSocketId: function getSocketId() {
        return _socketId;
      },
      getLoginMember: function getLoginMember() {
        return _loginMember;
      }
    };
  }]);
})();

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  'use strict';

  angular.module('obex').factory('socketTransmit', ['$rootScope', 'socket', 'socketLogin', function ($rootScope, socket, socketLogin) {

    return {
      sendHandleConversation: function sendHandleConversation(fromNumber) {
        socket.emit('handle conversation', {
          socketId: socketLogin.getSocketId(),
          fromNumber: fromNumber
        });
      },

      sendStopHandleConversation: function sendStopHandleConversation(fromNumber) {
        socket.emit('stop handle conversation', {
          socketId: socketLogin.getSocketId(),
          fromNumber: fromNumber
        });
      }
    };
  }]);
})();

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('ssoOrganizations', ['$http', '$q', 'obexConstant', 'authService', function ($http, $q, obexConstant, authService) {
    return {
      getSsoOrganizationById: function getSsoOrganizationById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlSsoOrganization + '/id/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getSsoOrganizationsByOrgId: function getSsoOrganizationsByOrgId(organizationId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlSsoOrganization + '/organizationid/' + organizationId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },

      //curd operation
      addSsoOrganization: function addSsoOrganization(ssoOrganization, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var postData = {
            Id: 0,
            OrganizationCode: ssoOrganization.organizationCode,
            GlobalId: ssoOrganization.globalId,
            OrganizationId: orgId
          };
          return $http.post(obexConstant.urlSsoOrganization, postData, {
            headers: authHeader
          });
        });
      },
      updateSsoOrganization: function updateSsoOrganization(id, ssoOrganization) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlSsoOrganization + '/id/' + id;
          var putData = {
            Id: ssoOrganization.id,
            OrganizationCode: ssoOrganization.organizationCode,
            GlobalId: ssoOrganization.globalId,
            OrganizationId: ssoOrganization.organizationId
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    angular.module('obex').factory('toastFactory', ['toastr', function (toastr) {
        return {
            toast_error: function toast_error(errMsg) {
                toastr.error(errMsg, 'Error', {
                    closeButton: true,
                    timeOut: 3500
                });
            },
            toast_warn: function toast_warn(warnMsg) {
                toastr.warning(warnMsg, 'Alert', {
                    closeButton: true,
                    timeOut: 3500
                });
            },
            toast_info: function toast_info(infoMsg) {
                toastr.info(infoMsg, 'Info', {
                    closeButton: true,
                    timeOut: 3500
                });
            }
        };
    }]);
})();

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('traveler', ['$http', 'obexConstant', 'authService', '$q', function ($http, obexConstant, authService, $q) {
    var showAll = false;
    var currentRequestCanceler = null;
    return {
      setShowAll: function setShowAll(showAllTravelers) {
        showAll = showAllTravelers;
      },
      getShowAll: function getShowAll() {
        return showAll;
      },
      getTravelerById: function getTravelerById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAccount + '/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getTravelersByOrgId: function getTravelersByOrgId(orgId, paginationData, showAllTraveler, searchKeyword) {
        if (currentRequestCanceler) {
          currentRequestCanceler.resolve();
        }
        currentRequestCanceler = $q.defer();
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelers + '/' + orgId + '/page/' + (paginationData.paginationCurrentPage ? paginationData.paginationCurrentPage : 1) + '/pagesize/' + paginationData.paginationPageSize + '/columnname/FirstName/ordertype/asc/searchphrase/' + (searchKeyword === '' ? ' ' : searchKeyword) + '/includeinactive/' + showAllTraveler;
          return $http.get(url, {
            headers: authHeader,
            timeout: currentRequestCanceler ? currentRequestCanceler.promise : 0
          }).finally(function () {
            currentRequestCanceler = null;
          }).catch(function (error) {
            if (error.status === -1) {
              console.log('Request canceled');
            } else {
              console.error('API call error:', error);
              throw error;
            }
          });
        });
      },
      deleteAccount: function deleteAccount(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAccount + '/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      },
      setAdmin: function setAdmin(id, isAdmin) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAccount + '/setadmin/' + id + '/' + isAdmin;
          return $http.put(url, null, {
            headers: authHeader
          });
        });
      },
      setEnableDisableAccount: function setEnableDisableAccount(id, enable) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAccount + '/enableAccount/' + id;
          return $http.put(url, null, {
            headers: authHeader
          });
        });
      },
      updateName: function updateName(id, traveler) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlAccount + '/updatename/' + id;
          var putData = {
            Id: traveler.Id,
            FirstName: traveler.FirstName,
            LastName: traveler.LastName
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      saveTraveler: function saveTraveler(traveler) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = '' + obexConstant.urlAccount;
          return $http.post(url, traveler, {
            headers: authHeader
          });
        });
      },
      sendNonSsoInfo: function sendNonSsoInfo(file, data) {
        return authService.getAuthorizationHeader().then(function (_ref) {
          var Authorization = _ref.Authorization;

          var fd = new FormData();
          fd.append('image', file);
          fd.append('organizationId', data.organizationId);
          fd.append('password', data.password);
          fd.append('additionalEmail', data.additionalEmail);
          fd.append('userEmail', data.userEmail);
          fd.append('orgName', data.orgName);
          $http.post('/userUploadingForNonSso', fd, {
            headers: {
              'Content-Type': undefined,
              Authorization: Authorization
            },
            transformRequest: angular.identity
          });
        });
      },
      sendSsoInfo: function sendSsoInfo(file, data) {
        return authService.getAuthorizationHeader().then(function (_ref2) {
          var Authorization = _ref2.Authorization;

          var fd = new FormData();
          fd.append('image', file);
          fd.append('organizationId', data.organizationId);
          fd.append('additionalEmail', data.additionalEmail);
          fd.append('userEmail', data.userEmail);
          fd.append('orgName', data.orgName);
          $http.post('/userUploadingForSso', fd, {
            headers: {
              'Content-Type': undefined,
              Authorization: Authorization
            },
            transformRequest: angular.identity
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('travelerTrack', ['$http', 'obexConstant', 'authService', function ($http, obexConstant, authService) {
    return {
      getAlerts: function getAlerts() {
        var url = obexConstant.urlTravelerTrack + '/Alerts/15';
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getTravelers: function getTravelers(startDate, endDate, travelersNearAlert, organizationId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelerTrack + '/Travelers/' + startDate + '/' + endDate + '/' + travelersNearAlert + '/' + organizationId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getDepartureCities: function getDepartureCities(clientId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelerCities + '/departurecities/' + clientId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getArrivalCities: function getArrivalCities(clientId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelerCities + '/arrivalcities/' + clientId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      adminTripById: function adminTripById(tripId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTrips + '/admin/' + tripId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      adminFlightById: function adminFlightById(flightId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlFlights + '/admin/' + flightId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      adminHotelById: function adminHotelById(hotelId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlHotels + '/admin/' + hotelId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      adminCarById: function adminCarById(carId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlCars + '/admin/' + carId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getTravelerExportList: function getTravelerExportList(startDate, endDate, travelersNearAlert, organizationId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelerTrack + '/ExportTravelers/' + startDate + '/' + endDate + '/' + travelersNearAlert + '/' + organizationId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('travelManagerAssignment', ['$http', '$q', 'obexConstant', 'authService', function ($http, $q, obexConstant, authService) {
    return {
      getTravelManagerOrganizationsById: function getTravelManagerOrganizationsById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelManagerOrganizations + '/TravelManagerOrganizationDetails/Organization/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      addTravelManagerOrganizations: function addTravelManagerOrganizations(travelManagerOrganizationList) {
        var promises = _.map(travelManagerOrganizationList, function (travelManagerOrganization) {
          return authService.getAuthorizationHeader().then(function (authHeader) {
            var url = obexConstant.urlTravelManagerOrganizations + '/CreateTravelManagerOrganizations';
            var postData = {
              Id: travelManagerOrganization.Id,
              MemberId: travelManagerOrganization.MemberId,
              OrganizationId: travelManagerOrganization.OrganizationId
            };
            return $http.post(url, postData, {
              headers: authHeader
            });
          });
        });
        return $q.all(promises);
      },
      deleteTravelManagerOrganizations: function deleteTravelManagerOrganizations(travelManagerOrganizationIdList) {
        var promises = _.map(travelManagerOrganizationIdList, function (travelManagerOrganization) {
          return authService.getAuthorizationHeader().then(function (authHeader) {
            var url = obexConstant.urlTravelManagerOrganizations + '/DeleteTravelManagerOrganizations/id/' + travelManagerOrganization.TravelManagerOrganizationId;
            return $http.delete(url, {
              headers: authHeader
            });
          });
        });
        return $q.all(promises);
      }
    };
  }]);
})();

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
(function () {
  'use strict';

  angular.module('obex').factory('travelSpend', ['$http', '$q', 'obexConstant', 'authService', function ($http, $q, obexConstant, authService) {
    return {
      getTotalSpendByDates: function getTotalSpendByDates(startDate, endDate, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelSpend + '/admin/totalspend/' + startDate + '/' + endDate + '/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getTopCityPairs: function getTopCityPairs(startDate, endDate, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelSpend + '/admin/topcitypairs/' + startDate + '/' + endDate + '/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getTopAirlines: function getTopAirlines(startDate, endDate, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelSpend + '/admin/topairlines/' + startDate + '/' + endDate + '/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getTopHotelCities: function getTopHotelCities(startDate, endDate, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelSpend + '/admin/tophotelcities/' + startDate + '/' + endDate + '/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getTopCarCities: function getTopCarCities(startDate, endDate, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelSpend + '/admin/topcarcities/' + startDate + '/' + endDate + '/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getTopHotels: function getTopHotels(startDate, endDate, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelSpend + '/admin/tophotels/' + startDate + '/' + endDate + '/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getTopCarRentalCompanies: function getTopCarRentalCompanies(startDate, endDate, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTravelSpend + '/admin/topcarrentalcompanies/' + startDate + '/' + endDate + '/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services
(function () {
  'use strict';

  angular.module('obex').factory('tripFields', ['$http', '$q', 'obexConstant', 'authService', function ($http, $q, obexConstant, authService) {
    return {
      getTripFields: function getTripFields() {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          return $http.get(obexConstant.urlTripField, {
            headers: authHeader
          });
        });
      },
      getTripFieldById: function getTripFieldById(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTripField + '/' + id;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      addTripField: function addTripField(tripField) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = '' + obexConstant.urlTripField;
          var postData = {
            Id: tripField.Id,
            Name: tripField.Name,
            OrganizationId: tripField.OrganizationId,
            Required: tripField.Required,
            AgencyDefinition: tripField.AgencyDefinition
          };
          return $http.post(url, postData, {
            headers: authHeader
          });
        });
      },
      addTripFieldOption: function addTripFieldOption(tripFieldId, tripFieldOptionList) {
        var promises = _.map(tripFieldOptionList, function (tripFieldOption) {
          return authService.getAuthorizationHeader().then(function (authHeader) {
            var url = '' + obexConstant.urlTripFieldOptions;
            var postData = {
              Id: tripFieldOptionList.Id,
              Name: tripFieldOption.Name,
              TripFieldId: tripFieldId
            };
            return $http.post(url, postData, {
              headers: authHeader
            });
          });
        });
        return $q.all(promises);
      },
      updateTripField: function updateTripField(id, tripField) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTripField + '/' + id;
          var putData = {
            Id: tripField.Id,
            Name: tripField.Name,
            OrganizationId: tripField.OrganizationId,
            Required: tripField.Required,
            AgencyDefinition: tripField.AgencyDefinition
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      updateTripFieldOption: function updateTripFieldOption(id, tripFieldOptionList) {
        var promises = _.map(tripFieldOptionList, function (tripFieldOption) {
          return authService.getAuthorizationHeader().then(function (authHeader) {
            if (!!tripFieldOption.Id) {
              var url = obexConstant.urlTripFieldOptions + '/' + tripFieldOption.Id;
              var putData = {
                Id: tripFieldOption.Id,
                Name: tripFieldOption.Name,
                TripFieldId: tripFieldOption.TripFieldId
              };
              return $http.put(url, putData, {
                headers: authHeader
              });
            } else {
              var _url = obexConstant.urlTripFieldOptions + '/';
              var postData = {
                Id: tripFieldOption.Id,
                Name: tripFieldOption.Name,
                TripFieldId: tripFieldOption.TripFieldId
              };
              return $http.post(_url, postData, {
                headers: authHeader
              });
            }
          });
        });
        return $q.all(promises);
      },
      deleteTripField: function deleteTripField(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTripField + '/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      },
      deleteTripFieldOption: function deleteTripFieldOption(id) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTripFieldOptions + '/' + id;
          return $http.delete(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file is used for maintain and manage API services.
;(function () {
  'use strict';

  angular.module('obex').factory('tripsDashBoard', ['$http', '$q', 'obexConstant', 'authService', function ($http, $q, obexConstant, authService) {
    return {
      getTripsDash: function getTripsDash(fromDate, toDate, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTrips + '/admin/' + fromDate + '/' + toDate + '/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getFlightsDash: function getFlightsDash(fromDate, toDate, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlFlights + '/admin/' + fromDate + '/' + toDate + '/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getHotelsDash: function getHotelsDash(fromDate, toDate, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlHotels + '/admin/' + fromDate + '/' + toDate + '/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getCarsDash: function getCarsDash(fromDate, toDate, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlCars + '/admin/' + fromDate + '/' + toDate + '/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getLimosDash: function getLimosDash(fromDate, toDate, orgId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlLimos + '/admin/' + fromDate + '/' + toDate + '/' + orgId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getTripsDashbyId: function getTripsDashbyId(tripId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlTrips + '/admin/' + tripId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getFlightsDashById: function getFlightsDashById(flightId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlFlights + '/admin/' + flightId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getHotelsDashById: function getHotelsDashById(hotelId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlHotels + '/admin/' + hotelId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getCarsDashById: function getCarsDashById(carId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlCars + '/admin/' + carId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      getLimosDashById: function getLimosDashById(limoId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlLimos + '/admin/' + limoId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      },
      updateFlightStatus: function updateFlightStatus(flightId, flight) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlFlights + '/agent/' + flightId;
          var putData = {
            Id: flight.Id,
            NewAgentNote: flight.NewAgentNote
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      updateCarStatus: function updateCarStatus(carId, car) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlCars + '/agent/' + carId;
          var putData = {
            Id: car.Id,
            NewAgentNote: car.NewAgentNote
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      updateHotelStatus: function updateHotelStatus(hotelId, hotel) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlHotels + '/agent/' + hotelId;
          var putData = {
            Id: hotel.Id,
            NewAgentNote: hotel.NewAgentNote
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      updateLimoStatus: function updateLimoStatus(limoId, limo) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlLimos + '/agent/' + limoId;
          var putData = {
            Id: limo.Id,
            NewAgentNote: limo.NewAgentNote
          };
          return $http.put(url, putData, {
            headers: authHeader
          });
        });
      },
      getVirtualCardImage: function getVirtualCardImage(deploymentId, organizationId) {
        return authService.getAuthorizationHeader().then(function (authHeader) {
          var url = obexConstant.urlVirtualCardImage + '/' + deploymentId + '/organizationid/' + organizationId;
          return $http.get(url, {
            headers: authHeader
          });
        });
      }
    };
  }]);
})();

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Constants = __webpack_require__(227)

// This (Constant.js) file is used for maintaining constants variable through out the application
;(function (module) {
  'use strict';

  var apiUrl = 'https://obexwebtest.azurewebsites.net/',
      tenant = 'obex.onmicrosoft.com'; //'cb454b68-a036-4dd5-a134-ebd4cdad4fe2'
  module.constant('obexConstant', {
    urlActivation: apiUrl + 'activations',
    urlCompleteActivation: apiUrl + 'activations/completerequest',
    urlOrganization: apiUrl + 'organizations',
    urlAccount: apiUrl + 'Members',
    urlBaseUrl: apiUrl,
    oauth2EndPoint: Constants.AUTH_TOKEN_URI,
    urlAgentPortal: 'https://us-sc-dev-agentportal-app.azurewebsites.net',
    obexWebResourceUri: 'http://obexweb.azurewebsites.net',
    clientId: 'd161d8a4-d704-4be6-82ba-3f5a14a306d5',
    urlTrips: apiUrl + 'trips',
    urlHotels: apiUrl + 'hotels',
    urlLimos: apiUrl + 'limos',
    urlGdsSettings: apiUrl + 'GdsSettings',
    urlGdsSettingsV2: apiUrl + 'v2/GdsSettings',
    urlCars: apiUrl + 'cars',
    urlFlights: apiUrl + 'flights',
    urlProfiles: apiUrl + 'profiles',
    urlTravelerTrack: apiUrl + 'TravelerTrack',
    urlTravelerCities: apiUrl + 'travelers',
    permissions: ['User', 'TravelAgent', 'TravelAgencyAdmin', 'TravelManager', 'ObexAdmin'],
    urlTravelAgentOrganizations: apiUrl + 'TravelAgentOrganizations',
    urlTravelManagerOrganizations: apiUrl + 'TravelManagerOrganizations',
    urlSmsHistory: apiUrl + 'ChatMessages',
    urlPhoneHistory: apiUrl + 'PhoneLogs',
    urlTravelSpend: apiUrl + 'Reports',
    urlProvider: apiUrl + 'providers',
    urlCategory: apiUrl + 'v2/categories',
    urlApp: apiUrl + 'v2/apps',
    urlTripField: apiUrl + 'TripFields',
    urlAllowIntegrations: apiUrl + 'v2/allowintegrations',
    urlTripFieldOptions: apiUrl + 'TripFieldOptions',
    urlProfileFields: apiUrl + 'profilefields',
    urlProfileFieldOptions: apiUrl + 'ProfileFieldOptions',
    urlTravelers: apiUrl + 'members/travelers/',
    urlClients: apiUrl + 'organizations/clients',
    urlAgenciesClients: apiUrl + 'organizationchatapps/chatApp/OWA/travelAgencyid',
    urlAgencies: apiUrl + 'organizations/travelagencies',
    urlClientsFromAgency: apiUrl + 'organizations/travelagencyclients',
    urlCustomerAccount: apiUrl + 'CustomerAccounts',
    urlSsoOrganization: apiUrl + 'v2/ssoorganizations',
    urlSingleSignOn: apiUrl + 'v2/sso',
    urlWindowsTimeZones: apiUrl + 'windowstimezones',
    urlOrganizationProviders: apiUrl + 'OrganizationProviders',
    urlProcessPnr: apiUrl + 'v2/sabre',
    urlVirtualCardImage: apiUrl + 'conferma/deploymentid',
    urlGetConversation: apiUrl + 'v2/conversations',
    urlGetTopic: apiUrl + 'v2/topics/email',
    urlResetPassword: apiUrl + 'Activations/resetpassword/email',
    urlCsrfToken: apiUrl + 'csrf/csrftoken'
  }).constant('obexRoles', {
    roleUser: 0,
    roleTravelAgent: 1,
    roleTravelAgencyAdmin: 2,
    roleTravelManager: 3,
    roleObexAdmin: 4
  }).constant('smsStatus', {
    Live: 0,
    FollowUp: 1,
    Transfer: 2,
    Finished: 3
  });
})(angular.module('obex'));

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {const env = {
  LOGIN_WINDOWS_NET: process.env.LOGIN_WINDOWS_NET,
  AUTH_TOKEN_URI: process.env.AUTH_TOKEN_URI,
  REFRESH_TOKEN_URI: process.env.REFRESH_TOKEN_URI,
  OBEX_RESOURCE_URI: process.env.OBEX_RESOURCE_URI,
  OBEX_WEBSERVICE_URI: process.env.OBEX_WEBSERVICE_URI,
  OBEX_TENANT: process.env.OBEX_TENANT,
  OBEX_CLIENT_ID: process.env.OBEX_CLIENT_ID,
  OBEX_NODEJS_USERNAME: process.env.OBEX_NODEJS_USERNAME,
  OBEX_NODEJS_PASSWORD: process.env.OBEX_NODEJS_PASSWORD,
  OBEX_NOTIFICATION_USERNAME: process.env.OBEX_NOTIFICATION_USERNAME,
  OBEX_NOTIFICATION_PASSWORD: process.env.OBEX_NOTIFICATION_PASSWORD,
  OBEX_NOTIFICATION_URI: process.env.OBEX_NOTIFICATION_URI,
  TWILIO_SID: process.env.TWILIO_SID,
  TWILIO_TOKEN: process.env.TWILIO_TOKEN,
  TWILIO_NUMBER: process.env.TWILIO_NUMBER,
  INDEX_FILE: process.env.INDEX_FILE,
  APNS_PROD: process.env.APNS_PROD,
  FB_PAGE_ACCESS_TOKEN: process.env.FB_PAGE_ACCESS_TOKEN,
  API_AI_ACCESS_TOKEN: process.env.API_AI_ACCESS_TOKEN,
  WEBHOOK_HOSTNAME: process.env.WEBHOOK_HOSTNAME,
  BASIC_AUTH: process.env.BASIC_AUTH,
  AGENT_PORTAL_URL: process.env.AGENT_PORTAL_URL
};

module.exports = Object.freeze(env);

//OBEX_TENANT: 'cb454b68-a036-4dd5-a134-ebd4cdad4fe2',
//OBEX_WEBSERVICE_URI: 'https://api.obexsolutions.com',

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(228)))

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle/bundle-stage.js